const objlist = {
    "root":
    {
        "$":
        {
            "id": "0",
            "o": "3DBodyMain",
            "c": "系统解剖",
            "enName": "3DBody"
        },
        "ch":
        {
            "sub": [
            {
                "$":
                {
                    "o": "003Muscular system",
                    "c": "肌肉系统Muscular system"
                },
                "ch":
                {
                    "sub": [
                    {
                        "$":
                        {
                            "o": "01Muscle of head",
                            "c": "头肌Muscle of head"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "01Facial muscle",
                                    "c": "面肌Facial muscle"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Facial muscle,L",
                                            "c": "左面肌Facial muscle,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Buccinator,L",
                                                    "layer": "2",
                                                    "c": "颊肌Buccinator,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：面颊深层 止点：口角 主要作用：使唇颊紧贴牙齿、帮助咀嚼和吮吸，牵口角向外 神经支配：颊支（Ⅶ）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Corrugator supercilii,L",
                                                    "layer": "2",
                                                    "c": "皱眉肌Corrugator supercilii,L"
                                                },
                                                "t":
                                                {
                                                    "s": "皱眉肌：位于眼轮匝肌眶部及枕额肌额腹深面、两侧眉弓之间的肌。起自额骨鼻部，肌纤维斜向上外，止于眉部皮肤，收缩时牵眉向内下，使鼻根部皮肤产生纵沟，出现皱眉的表情。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Depressor anguli oris(triangularis),L",
                                                    "layer": "1",
                                                    "c": "降口角肌Depressor anguli oris,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：下唇下方 止点：口角 主要作用：降口角与下唇 神经支配：下颌缘支（Ⅶ）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Depressor labii inferioris,L",
                                                    "layer": "2",
                                                    "c": "降下唇肌Depressor labii inferioris,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：下唇下方 止点：口角 主要作用：降口角与下唇 神经支配：颊支（Ⅶ）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Depressor septi,L",
                                                    "layer": "1",
                                                    "c": "降鼻中膈肌Depressor septi,L"
                                                },
                                                "t":
                                                {
                                                    "s": "降鼻中膈肌：分深、浅两部。浅部起自口轮匝肌，深部起自上颌骨中切牙的牙槽轭，止于鼻中隔软骨下面。可牵引鼻中隔向下。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Depressor supercilii,L",
                                                    "layer": "1",
                                                    "c": "降眉肌Depressor supercilii,L"
                                                },
                                                "t":
                                                {
                                                    "s": "降眉肌：枕额肌额腹的延续部分。起自鼻根部，向上止于眉间部皮肤，牵引眉肩部皮肤向下，使鼻根部皮肤产生横纹。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Levator anguli oris,L",
                                                    "layer": "2",
                                                    "c": "提口角肌Levator anguli oris,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：上唇上方 止点：口角 主要作用：提口角与上唇 神经支配：颊支（Ⅶ）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Levator labii superioris alaeque nasi,L",
                                                    "layer": "1",
                                                    "c": "提上唇鼻翼肌Levator labii superioris alaeque nasi,L"
                                                },
                                                "t":
                                                {
                                                    "s": "提上唇鼻翼肌：起自上颌骨额突，向下外斜行，附着于鼻翼的肌性部分。可使上唇上提，使鼻唇沟上升和加深。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Levator labii superioris,L",
                                                    "layer": "1",
                                                    "c": "提上唇肌Levator labii superioris,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：上唇上方 止点：口角 主要作用：提口角与上唇 神经支配：颧支、颊支（Ⅶ）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Mentalis,L",
                                                    "layer": "2",
                                                    "c": "颏肌Mentalis,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：下颌骨侧切牙和中切骨的牙槽突 止点：颏部皮肤 主要作用：上提颏部皮肤，使下唇前送 神经支配：下颌缘支（Ⅶ）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Nasalis,alar portion,L",
                                                    "layer": "1",
                                                    "c": "鼻肌翼部Nasalis,alar portion,L"
                                                },
                                                "t":
                                                {
                                                    "s": "鼻肌翼部：起自横部上方的上颌骨，止于鼻翼软骨的肌。收缩时牵引鼻翼向下外方扇动，并能使鼻孔扩大。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Nasalis,transverse portion,L",
                                                    "layer": "1",
                                                    "c": "鼻肌横部Nasalis,transverse portion,L"
                                                },
                                                "t":
                                                {
                                                    "s": "鼻肌横部：位于外鼻下部的两侧皮下，在提上唇肌深面。起自上颌骨尖牙及侧切牙的牙槽，肌纤维先斜向上外方，然后绕过鼻翼逐渐增宽，弯向内方，在鼻背与对侧者借腱膜相连，收缩时使鼻孔缩小。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Occipitofrontalis(epicranius),L",
                                                    "layer": "1",
                                                    "c": "枕额肌Occipitofrontalis(epicranius),L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：额腹：帽状腱膜；枕腹：枕骨上项线 止点：眉部皮肤；帽状腱膜 主要作用：提眉、下牵皮肤；后牵头皮 神经支配：颞支（Ⅶ）；耳支（Ⅶ）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Orbicularis oculi,L",
                                                    "layer": "1",
                                                    "c": "眼轮匝肌Orbicularis oculi,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：环绕睑裂周围 止点：环绕睑裂周围 主要作用：眨眼、闭眼、扩大泪囊使泪液流通 神经支配：面神经颞支、颧支"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Procerus,L",
                                                    "layer": "1",
                                                    "c": "降眉间肌Procerus,L"
                                                },
                                                "t":
                                                {
                                                    "s": "降眉间肌：位于前额下部，额肌与眼轮匝肌眶部深面以及两眉之间的小块肌肉。作用为降眉间部。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Risorius,L",
                                                    "layer": "2",
                                                    "c": "笑肌Risorius,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：腮腺咬肌筋膜 止点：口角部皮肤 主要作用：牵拉口角向外侧 神经支配：面神经"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Zygomaticus major,L",
                                                    "layer": "1",
                                                    "c": "颧大肌Zygomaticus major,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：颧骨颧颞缝前方 止点：口角和上唇皮肤并加入口轮匝肌 主要作用：牵口角向外上方 神经支配：颧支"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Zygomaticus minor,L",
                                                    "layer": "1",
                                                    "c": "颧小肌Zygomaticus minor,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：颧骨外侧面的颧颌缝 止点：口角内侧和上唇外侧皮肤 主要作用：牵拉口角向外上方，参与鼻唇沟的加深 神经支配：颧支"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Facial muscle,R",
                                            "c": "右面肌Facial muscle,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Buccinator,R",
                                                    "layer": "2",
                                                    "c": "颊肌Buccinator,R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：面颊深层 止点：口角 主要作用：使唇颊紧贴牙齿、帮助咀嚼和吮吸，牵口角向外 神经支配：颊支（Ⅶ）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Corrugator supercilii,R",
                                                    "layer": "2",
                                                    "c": "皱眉肌Corrugator supercilii,R"
                                                },
                                                "t":
                                                {
                                                    "s": "皱眉肌：位于眼轮匝肌眶部及枕额肌额腹深面、两侧眉弓之间的肌。起自额骨鼻部，肌纤维斜向上外，止于眉部皮肤，收缩时牵眉向内下，使鼻根部皮肤产生纵沟，出现皱眉的表情。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Depressor anguli oris(triangularis),R",
                                                    "layer": "1",
                                                    "c": "降口角肌Depressor anguli oris(triangularis),R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：下唇下方 止点：口角 主要作用：降口角与下唇 神经支配：下颌缘支（Ⅶ）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Depressor labii inferioris,R",
                                                    "layer": "2",
                                                    "c": "降下唇肌Depressor labii inferioris,R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：下唇下方 止点：口角 主要作用：降口角与下唇 神经支配：颊支（Ⅶ）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Depressor septi,R",
                                                    "layer": "1",
                                                    "c": "降鼻中膈肌Depressor septi,R"
                                                },
                                                "t":
                                                {
                                                    "s": "降鼻中膈肌：分深、浅两部。浅部起自口轮匝肌，深部起自上颌骨中切牙的牙槽轭，止于鼻中隔软骨下面。可牵引鼻中隔向下。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Depressor supercilii,R",
                                                    "layer": "1",
                                                    "c": "降眉肌Depressor supercilii,R"
                                                },
                                                "t":
                                                {
                                                    "s": "降眉肌：枕额肌额腹的延续部分。起自鼻根部，向上止于眉间部皮肤，牵引眉肩部皮肤向下，使鼻根部皮肤产生横纹。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Levator anguli oris,R",
                                                    "layer": "2",
                                                    "c": "提口角肌Levator anguli oris,R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：上唇上方 止点：口角 主要作用：提口角与上唇 神经支配：颊支（Ⅶ）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Levator labii superioris alaeque nasi,R",
                                                    "layer": "1",
                                                    "c": "提上唇鼻翼肌Levator labii superioris alaeque nasi,R"
                                                },
                                                "t":
                                                {
                                                    "s": "提上唇鼻翼肌：起自上颌骨额突，向下外斜行，附着于鼻翼的肌性部分。可使上唇上提，使鼻唇沟上升和加深。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Levator labii superioris,R",
                                                    "layer": "1",
                                                    "c": "提上唇肌Levator labii superioris,R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：上唇上方 止点：口角 主要作用：提口角与上唇 神经支配：颧支、颊支（Ⅶ）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Mentalis,R",
                                                    "layer": "2",
                                                    "c": "颏肌Mentalis,R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：下颌骨侧切牙和中切骨的牙槽突 止点：颏部皮肤 主要作用：上提颏部皮肤，使下唇前送 神经支配：下颌缘支（Ⅶ）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Nasalis,alar portion,R",
                                                    "layer": "1",
                                                    "c": "鼻肌翼部Nasalis,alar portion,R"
                                                },
                                                "t":
                                                {
                                                    "s": "鼻肌翼部：起自横部上方的上颌骨，止于鼻翼软骨的肌。收缩时牵引鼻翼向下外方扇动，并能使鼻孔扩大。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Nasalis,transverse portion,R",
                                                    "layer": "1",
                                                    "c": "鼻肌横部Nasalis,transverse portion,R"
                                                },
                                                "t":
                                                {
                                                    "s": "鼻肌横部：位于外鼻下部的两侧皮下，在提上唇肌深面。起自上颌骨尖牙及侧切牙的牙槽，肌纤维先斜向上外方，然后绕过鼻翼逐渐增宽，弯向内方，在鼻背与对侧者借腱膜相连，收缩时使鼻孔缩小。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Occipitofrontalis(epicranius),R",
                                                    "layer": "1",
                                                    "c": "枕额肌Occipitofrontalis(epicranius),R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：额腹：帽状腱膜；枕腹：枕骨上项线 止点：眉部皮肤；帽状腱膜 主要作用：提眉、下牵皮肤；后牵头皮 神经支配：颞支（Ⅶ）；耳支（Ⅶ）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Orbicularis oculi,R",
                                                    "layer": "1",
                                                    "c": "眼轮匝肌Orbicularis oculi,R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：环绕睑裂周围 止点：环绕睑裂周围 主要作用：眨眼、闭眼、扩大泪囊使泪液流通 神经支配：面神经颞支、颧支"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Procerus,R",
                                                    "layer": "1",
                                                    "c": "降眉间肌Procerus,R"
                                                },
                                                "t":
                                                {
                                                    "s": "降眉间肌：位于前额下部，额肌与眼轮匝肌眶部深面以及两眉之间的小块肌肉。作用为降眉间部。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Risorius,R",
                                                    "layer": "2",
                                                    "c": "笑肌Risorius,R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：腮腺咬肌筋膜 止点：口角部皮肤 主要作用：牵拉口角向外侧 神经支配：面神经"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Zygomaticus major,R",
                                                    "layer": "1",
                                                    "c": "颧大肌Zygomaticus major,R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：颧骨颧颞缝前方 止点：口角和上唇皮肤并加入口轮匝肌 主要作用：牵口角向外上方 神经支配：颧支"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Zygomaticus minor,R",
                                                    "layer": "1",
                                                    "c": "颧小肌Zygomaticus minor,R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：颧骨外侧面的颧颌缝 止点：口角内侧和上唇外侧皮肤 主要作用：牵拉口角向外上方，参与鼻唇沟的加深 神经支配：颧支"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Orbicularis oris",
                                            "layer": "1",
                                            "c": "口轮匝肌Orbicularis oris"
                                        },
                                        "t":
                                        {
                                            "s": "起点：环绕口裂周围 止点：环绕口裂周围 主要作用：闭合口裂 神经支配：面神经"
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "02Masticatory muscle",
                                    "c": "咀嚼肌Masticatory muscle"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Masticatory muscle,L",
                                            "c": "左咀嚼肌Masticatory muscle,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Lateral pterygoid(inferior head),L",
                                                    "layer": "2",
                                                    "c": "翼外肌(下头)Lateral pterygoid(inferior head),L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：翼突外侧板 止点：下颌骨髁突翼肌凹及关节囊 主要作用：两侧收缩拉下下颌向前（张口），单侧收缩拉下颌骨向对侧 神经支配：翼外肌神经"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Lateral pterygoid(superior head),L",
                                                    "layer": "2",
                                                    "c": "翼外肌(上头)Lateral pterygoid(superior head),L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：蝶骨大翼的颞下窝和颞下棘 止点：下颌骨髁突翼肌凹及关节囊 主要作用：两侧收缩拉下下颌向前（张口），单侧收缩拉下颌骨向对侧 神经支配：翼外肌神经"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Masseter,deep,L",
                                                    "layer": "2",
                                                    "c": "咬肌深部Masseter,deep,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：颧弓后1/3 止点：咬肌粗隆 主要作用：上提下颌骨（闭口） 神经支配：咬肌神经"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Masseter,superficial,L",
                                                    "layer": "2",
                                                    "c": "咬肌浅部Masseter,superficial,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：颧弓前2/3 止点：咬肌粗隆 主要作用：上提下颌骨（闭口） 神经支配：咬肌神经"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Medial pterygoid,L",
                                                    "layer": "2",
                                                    "c": "翼内肌Medial pterygoid,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：翼窝，上颌结节 止点：翼肌粗隆 主要作用：上提下颌骨，并向前 神经支配：翼内肌神经"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Temporal fascia,L",
                                                    "layer": "1",
                                                    "c": "颞筋膜Temporal fascia,L"
                                                },
                                                "t":
                                                {
                                                    "s": "颞筋膜：覆盖在颞肌表面的一层坚韧的纤维性膜。上方附着于颞上线，向下分为浅、深两层，分别附着于颧弓的外面和内面。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Temporalis,L",
                                                    "layer": "2",
                                                    "c": "颞肌Temporalis,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：颞窝，颞筋膜深面 止点：下颌骨冠突 主要作用：前部：提下颌骨（闭口）；后部：拉下颌骨向后 神经支配：颞深神经"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Masticatory muscle,R",
                                            "c": "右咀嚼肌Masticatory muscle,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Lateral pterygoid(inferior head),R",
                                                    "layer": "2",
                                                    "c": "翼外肌(下头)Lateral pterygoid(inferior head),R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：翼突外侧板 止点：下颌骨髁突翼肌凹及关节囊 主要作用：两侧收缩拉下下颌向前（张口），单侧收缩拉下颌骨向对侧 神经支配：翼外肌神经"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Lateral pterygoid(superior head),R",
                                                    "layer": "2",
                                                    "c": "翼外肌(上头)Lateral pterygoid(superior head),R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：蝶骨大翼的颞下窝和颞下棘 止点：下颌骨髁突翼肌凹及关节囊 主要作用：两侧收缩拉下下颌向前（张口），单侧收缩拉下颌骨向对侧 神经支配：翼外肌神经"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Masseter,deep,R",
                                                    "layer": "2",
                                                    "c": "咬肌深部Masseter,deep,R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：颧弓后1/3 止点：咬肌粗隆 主要作用：上提下颌骨（闭口） 神经支配：咬肌神经"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Masseter,superficial,R",
                                                    "layer": "2",
                                                    "c": "咬肌浅部Masseter,superficial,R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：颧弓前2/3 止点：咬肌粗隆 主要作用：上提下颌骨（闭口） 神经支配：咬肌神经"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Medial pterygoid,R",
                                                    "layer": "2",
                                                    "c": "翼内肌Medial pterygoid,R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：翼窝，上颌结节 止点：翼肌粗隆 主要作用：上提下颌骨，并向前 神经支配：翼内肌神经"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Temporal fascia,R",
                                                    "layer": "1",
                                                    "c": "颞筋膜Temporal fascia,R"
                                                },
                                                "t":
                                                {
                                                    "s": "颞筋膜：覆盖在颞肌表面的一层坚韧的纤维性膜。上方附着于颞上线，向下分为浅、深两层，分别附着于颧弓的外面和内面。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Temporalis,R",
                                                    "layer": "2",
                                                    "c": "颞肌Temporalis,R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：颞窝，颞筋膜深面 止点：下颌骨冠突 主要作用：前部：提下颌骨（闭口）；后部：拉下颌骨向后 神经支配：颞深神经"
                                                }
                                            }]
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Ocular muscles",
                                    "c": "眼球外肌Ocular muscles"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Ocular muscles,L",
                                            "c": "左眼球外肌Ocular muscles,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Common tendinous ring(annulus of Zinn),L",
                                                    "layer": "2",
                                                    "c": "总腱环Common tendinous ring(annulus of Zinn),L"
                                                },
                                                "t":
                                                {
                                                    "s": "总腱环：位于视神经管周围和眶上裂内侧的结缔组织环。是眼球各直肌和上睑提肌的起点。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Inferior oblique,L",
                                                    "layer": "2",
                                                    "c": "下斜肌Inferior oblique,L"
                                                },
                                                "t":
                                                {
                                                    "s": "下斜肌：位于眶下壁与下直肌之间，起自眶下壁的内侧份近前侧缘处，向后外止于眼球下面中纬线后方的巩膜。该肌可使瞳孔转向上外方，由动眼神经支配。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Inferior rectus,L",
                                                    "layer": "2",
                                                    "c": "下直肌Inferior rectus,L"
                                                },
                                                "t":
                                                {
                                                    "s": "下直肌：在眼球的下方，止于眼球下部赤道以前的巩膜。该肌收缩可使瞳孔转向下内方，该肌受动眼神经支配。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Lateral rectus,L",
                                                    "layer": "2",
                                                    "c": "外直肌Lateral rectus,L"
                                                },
                                                "t":
                                                {
                                                    "s": "外直肌：位于眼球外侧，止于眼球外侧部赤道以前的巩膜。该肌收缩，使瞳孔转向外侧，该肌受展神经支配。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Levator palpebrae superioris,L",
                                                    "layer": "2",
                                                    "c": "上提睑肌Levator palpebrae superioris,L"
                                                },
                                                "t":
                                                {
                                                    "s": "上提睑肌：为一三角形薄肌，起自视神经管前上方的眶壁，在上直肌上方向前走行。前端明显增宽成为腱膜，止于上眼睑的皮肤和上睑板。此肌收缩可上提上睑，开大眼裂，受动眼神经支配。该肌瘫痪可导致上睑下垂。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Medial rectus,L",
                                                    "layer": "2",
                                                    "c": "内直肌Medial rectus,L"
                                                },
                                                "t":
                                                {
                                                    "s": "内直肌：位于眼球内侧，止于眼球内侧部赤道以前的巩膜。该肌可使瞳孔转向内侧，该肌受动眼神经支配。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Superior oblique,L",
                                                    "layer": "2",
                                                    "c": "上斜肌Superior oblique,L"
                                                },
                                                "t":
                                                {
                                                    "s": "上斜肌：位于上直肌与内直肌之间，起于蝶骨体，以纤细的肌腱通过附于眶内侧壁前上方的滑车，经上直肌的下方转向后外，在上直肌与外直肌之间止于眼球后外侧赤道后方的巩膜。该肌收缩可使瞳孔转向下外方，由滑车神经支配。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Superior rectus,L",
                                                    "layer": "2",
                                                    "c": "上直肌Superior rectus,L"
                                                },
                                                "t":
                                                {
                                                    "s": "上直肌：位于上睑提肌下方，眼球的上方，与眼轴约呈23°角，止于眼球上方赤道前方的巩膜，收缩使瞳孔转向上内方，该肌受动眼神经支配。"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Ocular muscles,R",
                                            "c": "右眼球外肌Ocular muscles,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Common tendinous ring(annulus of Zinn),R",
                                                    "layer": "2",
                                                    "c": "总腱环Common tendinous ring(annulus of Zinn),R"
                                                },
                                                "t":
                                                {
                                                    "s": "总腱环：位于视神经管周围和眶上裂内侧的结缔组织环。是眼球各直肌和上睑提肌的起点。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Inferior oblique,R",
                                                    "layer": "2",
                                                    "c": "下斜肌Inferior oblique,R"
                                                },
                                                "t":
                                                {
                                                    "s": "下斜肌：位于眶下壁与下直肌之间，起自眶下壁的内侧份近前侧缘处，向后外止于眼球下面中纬线后方的巩膜。该肌可使瞳孔转向上外方，由动眼神经支配。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Inferior rectus,R",
                                                    "layer": "2",
                                                    "c": "下直肌Inferior rectus,R"
                                                },
                                                "t":
                                                {
                                                    "s": "下直肌：在眼球的下方，止于眼球下部赤道以前的巩膜。该肌收缩可使瞳孔转向下内方，该肌受动眼神经支配。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Lateral rectus,R",
                                                    "layer": "2",
                                                    "c": "外直肌Lateral rectus,R"
                                                },
                                                "t":
                                                {
                                                    "s": "外直肌：位于眼球外侧，止于眼球外侧部赤道以前的巩膜。该肌收缩，使瞳孔转向外侧，该肌受展神经支配。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Levator palpebrae superioris,R",
                                                    "layer": "2",
                                                    "c": "上提睑肌Levator palpebrae superioris,R"
                                                },
                                                "t":
                                                {
                                                    "s": "上提睑肌：为一三角形薄肌，起自视神经管前上方的眶壁，在上直肌上方向前走行。前端明显增宽成为腱膜，止于上眼睑的皮肤和上睑板。此肌收缩可上提上睑，开大眼裂，受动眼神经支配。该肌瘫痪可导致上睑下垂。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Medial rectus,R",
                                                    "layer": "2",
                                                    "c": "内直肌Medial rectus,R"
                                                },
                                                "t":
                                                {
                                                    "s": "内直肌：位于眼球内侧，止于眼球内侧部赤道以前的巩膜。该肌可使瞳孔转向内侧，该肌受动眼神经支配。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Superior oblique,R",
                                                    "layer": "2",
                                                    "c": "上斜肌Superior oblique,R"
                                                },
                                                "t":
                                                {
                                                    "s": "上斜肌：位于上直肌与内直肌之间，起于蝶骨体，以纤细的肌腱通过附于眶内侧壁前上方的滑车，经上直肌的下方转向后外，在上直肌与外直肌之间止于眼球后外侧赤道后方的巩膜。该肌收缩可使瞳孔转向下外方，由滑车神经支配。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Superior rectus,R",
                                                    "layer": "2",
                                                    "c": "上直肌Superior rectus,R"
                                                },
                                                "t":
                                                {
                                                    "s": "上直肌：位于上睑提肌下方，眼球的上方，与眼轴约呈23°角，止于眼球上方赤道前方的巩膜，收缩使瞳孔转向上内方，该肌受动眼神经支配。"
                                                }
                                            }]
                                        }
                                    }]
                                }
                            }]
                        }
                    },
                    {
                        "$":
                        {
                            "o": "02Muscle of neck",
                            "c": "颈肌Muscle of neck"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "Muscle of neck,L",
                                    "c": "左颈肌Muscle of neck,L"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "01Superficial neck muscle,L",
                                            "c": "左颈浅肌Superficial neck muscle,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Platysma,L",
                                                    "layer": "1",
                                                    "c": "颈阔肌Platysma,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：三角肌筋膜、胸大肌筋膜 止点：下颌骨下缘、腮腺咬肌筋膜 主要作用：紧张颈部皮肤 神经支配：面神经颈支"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Sternocleidomastoid,L",
                                                    "layer": "2",
                                                    "c": "胸锁乳突肌Sternocleidomastoid,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：胸骨柄前面、锁骨内1/3上缘 止点：颞骨乳突外面，上项线外1/3 主要作用：一侧收缩使头转向对侧，双侧收缩头向后仰 神经支配：副神经及颈2-3神经前支"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "02Anterior neck muscle,L",
                                            "c": "颈前肌Anterior neck muscle,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Suprahyoid muscles,L",
                                                    "c": "左舌骨上肌群Suprahyoid muscles,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Digastric fibrous loop,L",
                                                            "layer": "4",
                                                            "c": "二腹肌纤维环Digastric fibrous loop,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "二腹肌纤维环：二腹肌在下颌骨的下方，有前、后二腹。前腹起自下颌骨二腹肌窝，斜向后下方；后腹起自乳突内侧，斜向前下；两个肌腹以中间腱相连，中间腱借筋膜形成滑车系于舌骨。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Digastric,L",
                                                            "layer": "4",
                                                            "c": "二腹肌Digastric,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：前腹：下颌骨二腹肌窝；后腹：乳突切迹 止点：中间腱附舌骨体 主要作用：上提舌骨，降下颌骨 神经支配：前腹：三叉神经；后腹：面神经"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Geniohyoid,L",
                                                            "layer": "5",
                                                            "c": "颏舌骨肌Geniohyoid,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：下颌骨颏棘 止点：舌骨体 主要作用：上提舌骨 神经支配：舌下神经"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Mylohyoid,L",
                                                            "layer": "5",
                                                            "c": "下颌舌骨肌Mylohyoid,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：下颌体内面，颌舌线 止点：下颌舌骨肌缝、舌骨体 主要作用：拉舌骨向前上 神经支配：下颌舌骨肌神经（三叉神经）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Stylohyoid,L",
                                                            "layer": "4",
                                                            "c": "茎突舌骨肌Stylohyoid,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：茎突根部。 止点：舌骨大角基部 主要作用：拉舌骨向后上。 神经支配：面神经"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Infrahyoid muscles,L",
                                                    "c": "左舌骨下肌群Infrahyoid muscles,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Omohyoid,L",
                                                            "layer": "3",
                                                            "c": "肩胛舌骨肌Omohyoid,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：肩胛骨上缘、肩胛横韧带 止点：舌骨体外侧半 主要作用：下降舌骨 神经支配：颈袢（C1-3）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Sternohyoid,L",
                                                            "layer": "3",
                                                            "c": "胸骨舌骨肌Sternohyoid,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：胸骨柄及锁骨内侧端后面 止点：舌骨体内侧半 主要作用：下拉舌骨 神经支配：颈袢（C1-3）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Sternothyroid,L",
                                                            "layer": "4",
                                                            "c": "胸骨甲状肌Sternothyroid,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：胸骨柄、第一肋后面 止点：甲状软骨板斜线 主要作用：下拉甲状软骨 神经支配：颈袢（C1-3）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Thyrohyoid,L",
                                                            "layer": "4",
                                                            "c": "甲状舌骨肌Thyrohyoid,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：甲状软骨板斜线 止点：舌骨体与舌骨大角交界处 主要作用：下拉舌骨 神经支配：舌下神经（C1-3）"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "03Deep neck muscle,L",
                                            "c": "左颈深肌Deep neck muscle,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Anterior vertebral muscle,L",
                                                    "c": "左椎前肌Anterior vertebral muscle,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Rectus capitis anterior,L",
                                                            "layer": "5",
                                                            "c": "头前直肌Rectus capitis anterior,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：寰椎横突 止点：枕骨底下面，枕骨大孔前面 主要作用：低头，侧屈 神经支配：颈神经前支(C1-2)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Rectus capitis lateralis,L",
                                                            "layer": "5",
                                                            "c": "头外侧直肌Rectus capitis lateralis,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：寰椎横突 止点：枕骨外侧部 主要作用：低头，侧屈 神经支配：颈神经前支(C1-2)"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Scalenus anterior,L",
                                                    "layer": "4",
                                                    "c": "前斜角肌Scalenus anterior,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：第3-6颈椎横突前结节 止点：第1肋斜角肌结节 主要作用：一侧收缩使颈侧屈、旋转，两侧收缩使颈前屈，上提第1、2肋助吸气 神经支配：颈神经前支（C5-6）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Scalenus medius,L",
                                                    "layer": "4",
                                                    "c": "中斜角肌Scalenus medius,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：第2-7颈椎横突后结节 止点：第1肋上面中份 主要作用：一侧收缩使颈侧屈、旋转，两侧收缩使颈前屈，上提第1、2肋助吸气 神经支配：颈神经前支（C5-6）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Scalenus posterior,L",
                                                    "layer": "4",
                                                    "c": "后斜角肌Scalenus posterior,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：第4-6颈椎横突后结节 止点：第2肋 主要作用：一侧收缩使颈侧屈、旋转，两侧收缩使颈前屈，上提第1、2肋助吸气 神经支配：颈神经前支（C5-6）"
                                                }
                                            }]
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Muscle of neck,R",
                                    "c": "右颈肌Muscle of neck,R"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "01Superficial neck muscle,R",
                                            "c": "右颈浅肌Superficial neck muscle,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Platysma,R",
                                                    "layer": "1",
                                                    "c": "颈阔肌Platysma,R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：三角肌筋膜、胸大肌筋膜 止点：下颌骨下缘、腮腺咬肌筋膜 主要作用：紧张颈部皮肤 神经支配：面神经颈支"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Sternocleidomastoid,R",
                                                    "layer": "2",
                                                    "c": "胸锁乳突肌Sternocleidomastoid,R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：胸骨柄前面、锁骨内1/3上缘 止点：颞骨乳突外面，上项线外1/3 主要作用：一侧收缩使头转向对侧，双侧收缩头向后仰 神经支配：副神经及颈2-3神经前支"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "02Anterior neck muscle,R",
                                            "c": "颈前肌Anterior neck muscle,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Suprahyoid muscles,R",
                                                    "c": "右舌骨上肌群Suprahyoid muscles,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Digastric fibrous loop,R",
                                                            "layer": "4",
                                                            "c": "二腹肌纤维环Digastric fibrous loop,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "二腹肌纤维环：二腹肌在下颌骨的下方，有前、后二腹。前腹起自下颌骨二腹肌窝，斜向后下方；后腹起自乳突内侧，斜向前下；两个肌腹以中间腱相连，中间腱借筋膜形成滑车系于舌骨。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Digastric,R",
                                                            "layer": "4",
                                                            "c": "二腹肌Digastric,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：前腹：下颌骨二腹肌窝；后腹：乳突切迹 止点：中间腱附舌骨体 主要作用：上提舌骨，降下颌骨 神经支配：前腹：三叉神经；后腹：面神经"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Geniohyoid,R",
                                                            "layer": "5",
                                                            "c": "颏舌骨肌Geniohyoid,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：下颌骨颏棘 止点：舌骨体 主要作用：上提舌骨 神经支配：舌下神经"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Mylohyoid,R",
                                                            "layer": "5",
                                                            "c": "下颌舌骨肌Mylohyoid,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：下颌体内面，颌舌线 止点：下颌舌骨肌缝、舌骨体 主要作用：拉舌骨向前上 神经支配：下颌舌骨肌神经（三叉神经）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Stylohyoid,R",
                                                            "layer": "4",
                                                            "c": "茎突舌骨肌Stylohyoid,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：茎突根部。 止点：舌骨大角基部 主要作用：拉舌骨向后上。 神经支配：面神经"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Infrahyoid muscles,R",
                                                    "c": "右舌骨下肌群Infrahyoid muscles,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Omohyoid,R",
                                                            "layer": "3",
                                                            "c": "肩胛舌骨肌Omohyoid,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：肩胛骨上缘、肩胛横韧带 止点：舌骨体外侧半 主要作用：下降舌骨 神经支配：颈袢（C1-3）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Sternohyoid,R",
                                                            "layer": "3",
                                                            "c": "胸骨舌骨肌Sternohyoid,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：胸骨柄及锁骨内侧端后面 止点：舌骨体内侧半 主要作用：下拉舌骨 神经支配：颈袢（C1-3）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Sternothyroid,R",
                                                            "layer": "4",
                                                            "c": "胸骨甲状肌Sternothyroid,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：胸骨柄、第一肋后面 止点：甲状软骨板斜线 主要作用：下拉甲状软骨 神经支配：颈袢（C1-3）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Thyrohyoid,R",
                                                            "layer": "4",
                                                            "c": "甲状舌骨肌Thyrohyoid,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：甲状软骨板斜线 止点：舌骨体与舌骨大角交界处 主要作用：下拉舌骨 神经支配：舌下神经（C1-3）"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "03Deep neck muscle,R",
                                            "c": "右颈深肌Deep neck muscle,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Anterior vertebral muscle,R",
                                                    "c": "右椎前肌Anterior vertebral muscle,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Rectus capitis anterior,R",
                                                            "layer": "5",
                                                            "c": "头前直肌Rectus capitis anterior,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：寰椎横突 止点：枕骨底下面，枕骨大孔前面 主要作用：低头，侧屈 神经支配：颈神经前支(C1-2)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Rectus capitis lateralis,R",
                                                            "layer": "5",
                                                            "c": "头外侧直肌Rectus capitis lateralis,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：寰椎横突 止点：枕骨外侧部 主要作用：低头，侧屈 神经支配：颈神经前支(C1-2)"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Scalenus anterior,R",
                                                    "layer": "4",
                                                    "c": "前斜角肌Scalenus anterior,R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：第3-6颈椎横突前结节 止点：第1肋斜角肌结节 主要作用：一侧收缩使颈侧屈、旋转，两侧收缩使颈前屈，上提第1、2肋助吸气 神经支配：颈神经前支（C5-6）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Scalenus medius,R",
                                                    "layer": "4",
                                                    "c": "中斜角肌Scalenus medius,R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：第2-7颈椎横突后结节 止点：第1肋上面中份 主要作用：一侧收缩使颈侧屈、旋转，两侧收缩使颈前屈，上提第1、2肋助吸气 神经支配：颈神经前支（C5-6）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Scalenus posterior,R",
                                                    "layer": "5",
                                                    "c": "后斜角肌Scalenus posterior,R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：第4-6颈椎横突后结节 止点：第2肋 主要作用：一侧收缩使颈侧屈、旋转，两侧收缩使颈前屈，上提第1、2肋助吸气 神经支配：颈神经前支（C5-6）"
                                                }
                                            }]
                                        }
                                    }]
                                }
                            }]
                        }
                    },
                    {
                        "$":
                        {
                            "o": "03Muscle of trunk",
                            "c": "躯干肌Muscle of trunk"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "01Muscle of bac k",
                                    "c": "背肌Muscle of back"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Muscle of back,L",
                                            "c": "左背肌Muscle of back,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Superficial back muscle,L",
                                                    "c": "左背浅肌Superficial back muscle,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Levator scapulae,L",
                                                            "layer": "3",
                                                            "c": "肩胛提肌Levator scapulae,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：上位颈椎横突 止点：肩胛骨内侧角 主要作用：上提肩胛骨 神经支配：肩胛背神经（C4-6）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Latissimus dorsi,L",
                                                            "layer": "1",
                                                            "c": "背阔肌Latissimus dorsi,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：下6个胸椎棘突、全部腰椎棘突、髂嵴 止点：肱骨小结节嵴 主要作用：肩关节后伸、内收及内旋 神经支配：胸背神经（C6-8）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Rhomboideus major,L",
                                                            "layer": "2",
                                                            "c": "大菱形肌Rhomboideus major,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：下位颈椎和上位胸椎棘突 止点：肩胛骨内侧缘 主要作用：上提和内牵肩胛骨 神经支配：肩胛背神经（C4-6）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Rhomboideus minor,L",
                                                            "layer": "2",
                                                            "c": "小菱形肌Rhomboideus minor,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：下位颈椎和上位胸椎棘突 止点：肩胛骨内侧缘 主要作用：上提和内牵肩胛骨 神经支配：肩胛背神经（C4-6）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Serratus posterior inferior,L",
                                                            "layer": "2",
                                                            "c": "下后锯肌Serratus posterior inferior,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：下两个胸椎和上两个腰椎棘突 止点：第9-12肋骨角的外方 主要作用：降肋 神经支配：肋间神经（T9-12）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Serratus posterior superior,L",
                                                            "layer": "3",
                                                            "c": "上后锯肌Serratus posterior superior,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：下两个颈椎和上两个胸椎棘突 止点：第2-5肋骨角的外方 主要作用：提肋 神经支配：肋间神经（T1-4）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Trapezius,L",
                                                            "layer": "1",
                                                            "c": "斜方肌Trapezius,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：上项线、枕外隆凸、项韧带、全部胸椎棘突 止点：锁骨外1/3、肩峰、肩胛冈 主要作用：拉肩胛骨向中线靠拢，上部纤维提肩胛骨，下部纤维降肩胛骨 神经支配：副神经"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Deep back muscle,L",
                                                    "c": "左背深肌Deep back muscle,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "01Splenius,L",
                                                            "c": "左夹肌Splenius,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Splenius capitis,L",
                                                                    "layer": "4",
                                                                    "c": "头夹肌Splenius capitis,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：项韧带下部第七颈椎和T1-3棘突 止点：颞骨乳突及枕骨上项线外侧1/3下方的部分 主要作用：双侧收缩时，使头颈伸直；单侧收缩时，使头颈向同侧侧屈和回旋 神经支配：颈神经后支"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Splenius cervicis,L",
                                                                    "layer": "4",
                                                                    "c": "颈夹肌Splenius cervicis,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：T3-6棘突 止点：C1-3横突 主要作用：双侧收缩时，使头颈伸直；单侧收缩时，使头颈向同侧侧屈和回旋 神经支配：颈神经后支"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "02Erector spinae,L",
                                                            "c": "左竖脊肌Erector spinae,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Iliocostalis,L",
                                                                    "c": "左髂肋肌Iliocostalis,L"
                                                                },
                                                                "t": ""
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Longissimus,L",
                                                                    "c": "左最长肌Longissimus,L"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Longissimus capitis,L",
                                                                            "layer": "5",
                                                                            "c": "头最长肌Longissimus capitis,L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "起点：中下颈椎的横突和小关节突、上胸椎的横突 止点：颞骨乳突的后面 主要作用：双侧收缩时，后伸脊柱，维持人体的直立躯体姿势，在脊柱屈曲时起稳定作用，来对抗腹肌和重力的作用；单侧收缩时，使脊柱向同侧侧屈，使脊柱向同侧旋转，对抗离心力以维持稳定 神经支配：脊神经后支"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Longissimus cervicis,L",
                                                                            "layer": "5",
                                                                            "c": "颈最长肌Longissimus cervicis,L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "起点：T1-5（6）的横突 止点：C2-6的横突 主要作用：双侧收缩时，后伸脊柱，维持人体的直立躯体姿势，在脊柱屈曲时起稳定作用，来对抗腹肌和重力的作用；单侧收缩时，使脊柱向同侧侧屈，使脊柱向同侧旋转，对抗离心力以维持稳定 神经支配：脊神经后支"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "M_Longissimus thoracis,L",
                                                                            "layer": "4",
                                                                            "c": "胸最长肌Longissimus thoracis,L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "起点：骶骨、髂嵴、下胸椎和全部腰椎的棘突 止点：全部胸椎的横突、肋角和肋结节之间、上腰椎的横突 主要作用：双侧收缩时，后伸脊柱，维持人体的直立躯体姿势，在脊柱屈曲时起稳定作用，来对抗腹肌和重力的作用；单侧收缩时，使脊柱向同侧侧屈，使脊柱向同侧旋转，对抗离心力以维持稳定 神经支配：脊神经后支"
                                                                        }
                                                                    }]
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Spinalis,L",
                                                                    "c": "左棘肌Spinalis,L"
                                                                },
                                                                "t": ""
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "03Transversospinale,L",
                                                            "c": "左横突棘肌Transversospinale,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "M_Multifidus,L",
                                                                    "layer": "5",
                                                                    "c": "多裂肌Multifidus,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：骶骨背面，腰、胸椎横突和第4-7颈椎关节突 止点：L5-C2棘突 主要作用：双侧收缩时，可使脊柱后伸，特别是头颈部；控制向收缩侧的屈曲；单侧收缩时向对侧旋转椎体 神经支配：脊神经后支"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Rotatore,L",
                                                                    "c": "左回旋肌Rotatore,L"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Rotatores thoracis breves,L",
                                                                            "layer": "5",
                                                                            "c": "胸回旋短肌Rotatores thoracis breves,L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "起点：椎体的横突 止点：上一个椎体棘突的基底部 主要作用：单侧收缩使脊柱转向对侧；双侧收缩使脊柱伸直 神经支配：脊神经后支"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Rotatores thoracis longi,L",
                                                                            "layer": "5",
                                                                            "c": "胸回旋长肌Rotatores thoracis longi,L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "起点：椎体的横突 止点：向上跨越一个椎体后，止于棘突的基底部 主要作用：单侧收缩使脊柱转向对侧；双侧收缩使脊柱伸直 神经支配：脊神经后支"
                                                                        }
                                                                    }]
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Semispinalis,L",
                                                                    "c": "左半棘肌Semispinalis,L"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Semispinalis capitis,L",
                                                                            "layer": "5",
                                                                            "c": "头半棘肌Semispinalis capitis,L"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Semispinalis cervicis,L",
                                                                            "layer": "5",
                                                                            "c": "颈半棘肌Semispinalis cervicis,L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "起点：T1-6的横突 止点：C2-T7的棘突 主要作用：双侧收缩时，可使脊柱后伸，特别是头颈部；控制向收缩侧的屈曲；维持头的躯体姿势 神经支配：脊神经后支"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Semispinalis thoracis,L",
                                                                            "layer": "5",
                                                                            "c": "胸半棘肌Semispinalis thoracis,L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "起点：T6-12的横突 止点：上胸椎和下颈椎的棘突 主要作用：双侧收缩时，可使脊柱后伸，特别是头颈部；控制向收缩侧的屈曲；维持头的躯体姿势 神经支配：脊神经后支"
                                                                        }
                                                                    }]
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "04Interspinale,L",
                                                            "c": "棘间肌Interspinale,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Interspinales cervicis,L",
                                                                    "layer": "5",
                                                                    "c": "颈棘间肌Interspinales cervicis,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：椎体的棘突 止点：上一个椎体棘突 主要作用：后伸脊柱节段 神经支配：脊神经后支"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "M_Interspinales lumborum,L",
                                                                    "layer": "5",
                                                                    "c": "腰棘间肌Interspinales lumborum,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：椎体的棘突 止点：上一个椎体棘突 主要作用：后伸脊柱节段 神经支配：脊神经后支"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "05Intertransversarii,L",
                                                            "c": "左横突间肌Intertransversarii,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Intertransversarii anteriores cervicis,L",
                                                                    "layer": "5",
                                                                    "c": "颈横突间前肌Intertransversarii anteriores cervicis,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：颈部：横突的前结节，横突的后结节；胸部：发育不良；腰部横突的侧面，乳突 止点：颈部：上一横突的前后结节；胸部：发育不良；腰部：上一横突的侧面，乳突 主要作用：使相邻的脊椎侧屈；对抗离心力维持稳定 神经支配：脊神经后支"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Intertransversarii posteriores cervicis,L",
                                                                    "layer": "5",
                                                                    "c": "颈横突间后肌Intertransversarii posteriores cervicis,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：颈部：横突的前结节，横突的后结节；胸部：发育不良；腰部横突的侧面，副突 止点：颈部：上一横突的前后结节；胸部：发育不良；腰部：上一横突的侧面，副突 主要作用：使相邻的脊椎侧屈；对抗离心力维持稳定 神经支配：脊神经后支"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Intertransversarii thoracis,L",
                                                                    "layer": "5",
                                                                    "c": "胸横突间肌Intertransversarii thoracis,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "胸横突间肌：相邻胸椎横突之间的小肌。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "M_Intertransversarii laterales lumborum,L",
                                                                    "layer": "5",
                                                                    "c": "腰横突间外侧肌Intertransversarii laterales lumborum,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：颈部：横突的前结节，横突的后结节；胸部：发育不良；腰部横突的侧面，副突 止点：颈部：上一横突的前后结节；胸部：发育不良；腰部：上一横突的侧面，副突 主要作用：使相邻的脊椎侧屈；对抗离心力维持稳定 神经支配：脊神经后支"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "M_Intertransversarii mediales lumborum,L",
                                                                    "layer": "5",
                                                                    "c": "腰横突间内侧肌Intertransversarii mediales lumborum,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：颈部：横突的前结节，横突的后结节；胸部：发育不良；腰部横突的侧面，副突 止点：颈部：上一横突的前后结节；胸部：发育不良；腰部：上一横突的侧面，副突 主要作用：使相邻的脊椎侧屈；对抗离心力维持稳定 神经支配：脊神经后支"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "06Suboccipitalis,L",
                                                            "c": "枕下肌Suboccipitalis,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Obliquus capitis inferior,L",
                                                                    "layer": "5",
                                                                    "c": "头下斜肌Obliquus capitis inferior,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "枕下肌：又名椎枕肌，包括4对连接于第1、2颈椎与枕骨之间发育良好的短肌，即头后小直肌、头后大直肌、头上斜肌、头下斜肌，其中后三者构成枕下三角。头后大直肌呈三角形，起自枢椎棘突，止于下项线的外侧部。头后小直肌亦呈三角形，较小，居内侧，起自寰椎后结节，止于下项线内侧部。两肌作用相同，一侧收缩头转向对侧，两侧收缩使头后仰。头上斜肌起自寰椎横突，斜向内上方，止于枕骨下项线上方的骨面，一侧收缩使头转向对侧并向同侧侧屈，两侧收缩使头后仰。头下斜肌起自枢椎棘突，斜向外上方，止于寰椎横突。一侧收缩使头转向同侧并屈；两侧收缩使头后仰。椎枕肌受枕下神经（第1颈神经后支）支配。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Obliquus capitis superior,L",
                                                                    "layer": "5",
                                                                    "c": "头上斜肌Obliquus capitis superior,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "枕下肌：又名椎枕肌，包括4对连接于第1、2颈椎与枕骨之间发育良好的短肌，即头后小直肌、头后大直肌、头上斜肌、头下斜肌，其中后三者构成枕下三角。头后大直肌呈三角形，起自枢椎棘突，止于下项线的外侧部。头后小直肌亦呈三角形，较小，居内侧，起自寰椎后结节，止于下项线内侧部。两肌作用相同，一侧收缩头转向对侧，两侧收缩使头后仰。头上斜肌起自寰椎横突，斜向内上方，止于枕骨下项线上方的骨面，一侧收缩使头转向对侧并向同侧侧屈，两侧收缩使头后仰。头下斜肌起自枢椎棘突，斜向外上方，止于寰椎横突。一侧收缩使头转向同侧并屈；两侧收缩使头后仰。椎枕肌受枕下神经（第1颈神经后支）支配。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Rectus capitis posterior major,L",
                                                                    "layer": "5",
                                                                    "c": "头后大直肌Rectus capitis posterior major,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "枕下肌：又名椎枕肌，包括4对连接于第1、2颈椎与枕骨之间发育良好的短肌，即头后小直肌、头后大直肌、头上斜肌、头下斜肌，其中后三者构成枕下三角。头后大直肌呈三角形，起自枢椎棘突，止于下项线的外侧部。头后小直肌亦呈三角形，较小，居内侧，起自寰椎后结节，止于下项线内侧部。两肌作用相同，一侧收缩头转向同侧，两侧收缩使头后仰。头上斜肌起自寰椎横突，斜向内上方，止于枕骨下项线上方的骨面，一侧收缩使头转向对侧并向同侧侧屈，两侧收缩使头后仰。头下斜肌起自枢椎棘突，斜向外上方，止于寰椎横突。一侧收缩使头转向同侧并屈；两侧收缩使头后仰。椎枕肌受枕下神经（第1颈神经后支）支配。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Rectus capitis posterior minor,L",
                                                                    "layer": "5",
                                                                    "c": "头后小直肌Rectus capitis posterior minor,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "枕下肌：又名椎枕肌，包括4对连接于第1、2颈椎与枕骨之间发育良好的短肌，即头后小直肌、头后大直肌、头上斜肌、头下斜肌，其中后三者构成枕下三角。头后大直肌呈三角形，起自枢椎棘突，止于下项线的外侧部。头后小直肌亦呈三角形，较小，居内侧，起自寰椎后结节，止于下项线内侧部。两肌作用相同，一侧收缩头转向对侧，两侧收缩使头后仰。头上斜肌起自寰椎横突，斜向内上方，止于枕骨下项线上方的骨面，一侧收缩使头转向对侧并向同侧侧屈，两侧收缩使头后仰。头下斜肌起自枢椎棘突，斜向外上方，止于寰椎横突。一侧收缩使头转向同侧并屈；两侧收缩使头后仰。椎枕肌受枕下神经（第1颈神经后支）支配。"
                                                                }
                                                            }]
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Muscle of back,R",
                                            "c": "右背肌Muscle of back,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Superficial back muscle,R",
                                                    "c": "右背浅肌Superficial back muscle,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Levator scapulae,R",
                                                            "layer": "3",
                                                            "c": "肩胛提肌Levator scapulae,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：上位颈椎横突 止点：肩胛骨内侧角 主要作用：上提肩胛骨 神经支配：肩胛背神经（C4-6）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Latissimus dorsi,R",
                                                            "layer": "1",
                                                            "c": "背阔肌Latissimus dorsi,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：下6个胸椎棘突、全部腰椎棘突、髂嵴 止点：肱骨小结节嵴 主要作用：肩关节后伸、内收及内旋 神经支配：胸背神经（C6-8）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Rhomboideus major,R",
                                                            "layer": "2",
                                                            "c": "大菱形肌Rhomboideus major,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：下位颈椎和上位胸椎棘突 止点：肩胛骨内侧缘 主要作用：上提和内牵肩胛骨 神经支配：肩胛背神经（C4-6）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Rhomboideus minor,R",
                                                            "layer": "2",
                                                            "c": "小菱形肌Rhomboideus minor,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：下位颈椎和上位胸椎棘突 止点：肩胛骨内侧缘 主要作用：上提和内牵肩胛骨 神经支配：肩胛背神经（C4-6）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Serratus posterior inferior,R",
                                                            "layer": "2",
                                                            "c": "下后锯肌Serratus posterior inferior,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：下两个胸椎和上两个腰椎棘突 止点：第9-12肋骨角的外方 主要作用：降肋 神经支配：肋间神经（T9-12）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Serratus posterior superior,R",
                                                            "layer": "3",
                                                            "c": "上后锯肌Serratus posterior superior,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：下两个颈椎和上两个胸椎棘突 止点：第2-5肋骨角的外方 主要作用：提肋 神经支配：肋间神经（T1-4）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Trapezius,R",
                                                            "layer": "1",
                                                            "c": "斜方肌Trapezius,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：上项线、枕外隆凸、项韧带、全部胸椎棘突 止点：锁骨外1/3、肩峰、肩胛冈 主要作用：拉肩胛骨向中线靠拢，上部纤维提肩胛骨，下部纤维降肩胛骨 神经支配：副神经"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Deep back muscle,R",
                                                    "c": "右背深肌Deep back muscle,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "01Splenius,R",
                                                            "c": "右夹肌Splenius,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Splenius capitis,R",
                                                                    "layer": "4",
                                                                    "c": "头夹肌Splenius capitis,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：项韧带下部第7颈椎和T1-3棘突 止点：颞骨乳突及枕骨上项线外侧1/3下方的部分 主要作用：双侧收缩时，使头颈伸直；单侧收缩时，使头颈向同侧侧屈和回旋 神经支配：颈神经后支"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Splenius cervicis,R",
                                                                    "layer": "4",
                                                                    "c": "颈夹肌Splenius cervicis,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：T3-6棘突 止点：C1-3横突 主要作用：双侧收缩时，使头颈伸直；单侧收缩时，使头颈向同侧侧屈和回旋 神经支配：颈神经后支"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "02Erector spinae,R",
                                                            "c": "右竖脊肌Erector spinae,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Iliocostalis,R",
                                                                    "c": "右髂肋肌Iliocostalis,R"
                                                                },
                                                                "t": ""
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Longissimus,R",
                                                                    "c": "右最长肌Longissimus,R"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Longissimus capitis,R",
                                                                            "layer": "5",
                                                                            "c": "头最长肌Longissimus capitis,R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "起点：中下颈椎的横突和小关节突、上胸椎的横突 止点：颞骨乳突的后面 主要作用：双侧收缩时，后伸脊柱，维持人体的直立躯体姿势，在脊柱屈曲时起稳定作用，来对抗腹肌和重力的作用；单侧收缩时，使脊柱向同侧侧屈，使脊柱向同侧旋转，对抗离心力以维持稳定 神经支配：脊神经后支"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Longissimus cervicis,R",
                                                                            "layer": "5",
                                                                            "c": "颈最长肌Longissimus cervicis,R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "起点：T1-5（6）的横突 止点：C2-6的横突 主要作用：双侧收缩时，后伸脊柱，维持人体的直立躯体姿势，在脊柱屈曲时起稳定作用，来对抗腹肌和重力的作用；单侧收缩时，使脊柱向同侧侧屈，使脊柱向同侧旋转，对抗离心力以维持稳定 神经支配：脊神经后支"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "M_Longissimus thoracis,R",
                                                                            "layer": "4",
                                                                            "c": "胸最长肌Longissimus thoracis,R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "起点：骶骨、髂嵴、下胸椎和全部腰椎的棘突 止点：全部胸椎的横突、肋角和肋结节之间、上腰椎的横突 主要作用：双侧收缩时，后伸脊柱，维持人体的直立躯体姿势，在脊柱屈曲时起稳定作用，来对抗腹肌和重力的作用；单侧收缩时，使脊柱向同侧侧屈，使脊柱向同侧旋转，对抗离心力以维持稳定 神经支配：脊神经后支"
                                                                        }
                                                                    }]
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Spinalis,R",
                                                                    "c": "右棘肌Spinalis,R"
                                                                },
                                                                "t": ""
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "03Transversospinale,R",
                                                            "c": "右横突棘肌Transversospinale,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "M_Multifidus,R",
                                                                    "layer": "5",
                                                                    "c": "多裂肌Multifidus,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：骶骨背面，腰、胸椎横突和第4-7颈椎关节突 止点：L5-C2棘突 主要作用：双侧收缩时，可使脊柱后伸，特别是头颈部；控制向收缩侧的屈曲；单侧收缩时向对侧旋转椎体 神经支配：脊神经后支"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Rotatore,R",
                                                                    "c": "右回旋肌Rotatore,R"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Rotatores thoracis breves,R",
                                                                            "layer": "5",
                                                                            "c": "胸回旋短肌Rotatores thoracis breves,R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "起点：椎体的横突 止点：上一个椎体棘突的基底部 主要作用：单侧收缩使脊柱转向对侧；双侧收缩使脊柱伸直 神经支配：脊神经后支"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Rotatores thoracis longi,R",
                                                                            "layer": "5",
                                                                            "c": "胸回旋长肌Rotatores thoracis longi,R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "起点：椎体的横突 止点：向上跨越一个椎体后，止于棘突的基底部 主要作用：单侧收缩使脊柱转向对侧；双侧收缩使脊柱伸直 神经支配：脊神经后支"
                                                                        }
                                                                    }]
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Semispinalis,R",
                                                                    "c": "右半棘肌Semispinalis,R"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Semispinalis capitis,R",
                                                                            "layer": "5",
                                                                            "c": "头半棘肌Semispinalis capitis,R"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Semispinalis cervicis,R",
                                                                            "layer": "5",
                                                                            "c": "颈半棘肌Semispinalis cervicis,R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "起点：T1-6的横突 止点：C2-T7的棘突 主要作用：双侧收缩时，可使脊柱后伸，特别是头颈部；控制向收缩侧的屈曲；维持头的躯体姿势 神经支配：脊神经后支"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Semispinalis thoracis,R",
                                                                            "layer": "5",
                                                                            "c": "胸半棘肌Semispinalis thoracis,R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "起点：T6-12的横突 止点：上胸椎和下颈椎的棘突 主要作用：双侧收缩时，可使脊柱后伸，特别是头颈部；控制向收缩侧的屈曲；维持头的躯体姿势 神经支配：脊神经后支"
                                                                        }
                                                                    }]
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "04Interspinale,R",
                                                            "c": "右棘间肌Interspinale,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Interspinales cervicis,R",
                                                                    "layer": "5",
                                                                    "c": "颈棘间肌Interspinales cervicis,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：椎体的棘突 止点：上一个椎体棘突 主要作用：后伸脊柱节段 神经支配：脊神经后支"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "M_Interspinales lumborum,R",
                                                                    "layer": "5",
                                                                    "c": "腰棘间肌Interspinales lumborum,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：椎体的棘突 止点：上一个椎体棘突 主要作用：后伸脊柱节段 神经支配：脊神经后支"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "05Intertransversarii,R",
                                                            "c": "右横突间肌Intertransversarii,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Intertransversarii anteriores cervicis,R",
                                                                    "layer": "5",
                                                                    "c": "颈横突间前肌Intertransversarii anteriores cervicis,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：颈部：横突的前结节，横突的后结节；胸部：发育不良；腰部横突的侧面，乳突 止点：颈部：上一横突的前后结节；胸部：发育不良；腰部：上一横突的侧面，乳突 主要作用：使相邻的脊椎侧屈；对抗离心力维持稳定 神经支配：脊神经后支"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Intertransversarii posteriores cervicis,R",
                                                                    "layer": "5",
                                                                    "c": "颈横突间后肌Intertransversarii posteriores cervicis,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：颈部：横突的前结节，横突的后结节；胸部：发育不良；腰部横突的侧面，副突 止点：颈部：上一横突的前后结节；胸部：发育不良；腰部：上一横突的侧面，副突 主要作用：使相邻的脊椎侧屈；对抗离心力维持稳定 神经支配：脊神经后支"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Intertransversarii thoracis,R",
                                                                    "layer": "5",
                                                                    "c": "胸横突间肌Intertransversarii thoracis,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "胸横突间肌：相邻胸椎横突之间的小肌。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "M_Intertransversarii laterales lumborum,R",
                                                                    "layer": "5",
                                                                    "c": "腰横突间外侧肌Intertransversarii laterales lumborum,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：颈部：横突的前结节，横突的后结节；胸部：发育不良；腰部横突的侧面，副突 止点：颈部：上一横突的前后结节；胸部：发育不良；腰部：上一横突的侧面，副突 主要作用：使相邻的脊椎侧屈；对抗离心力维持稳定 神经支配：脊神经后支"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "M_Intertransversarii mediales lumborum,R",
                                                                    "layer": "5",
                                                                    "c": "腰横突间内侧肌Intertransversarii mediales lumborum,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：颈部：横突的前结节，横突的后结节；胸部：发育不良；腰部横突的侧面，副突 止点：颈部：上一横突的前后结节；胸部：发育不良；腰部：上一横突的侧面，副突 主要作用：使相邻的脊椎侧屈；对抗离心力维持稳定 神经支配：脊神经后支"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "06Suboccipital muscle,R",
                                                            "c": "右枕下肌Suboccipital muscle,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Obliquus capitis inferior,R",
                                                                    "layer": "5",
                                                                    "c": "头下斜肌Obliquus capitis inferior,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "枕下肌：又名椎枕肌，包括4对连接于第1、2颈椎与枕骨之间发育良好的短肌，即头后小直肌、头后大直肌、头上斜肌、头下斜肌，其中后三者构成枕下三角。头后大直肌呈三角形，起自枢椎棘突，止于下项线的外侧部。头后小直肌亦呈三角形，较小，居内侧，起自寰椎后结节，止于下项线内侧部。两肌作用相同，一侧收缩头转向对侧，两侧收缩使头后仰。头上斜肌起自寰椎横突，斜向内上方，止于枕骨下项线上方的骨面，一侧收缩使头转向对侧并向同侧侧屈，两侧收缩使头后仰。头下斜肌起自枢椎棘突，斜向外上方，止于寰椎横突。一侧收缩使头转向同侧并屈；两侧收缩使头后仰。椎枕肌受枕下神经（第1颈神经后支）支配。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Obliquus capitis superior,R",
                                                                    "layer": "5",
                                                                    "c": "头上斜肌Obliquus capitis superior,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "枕下肌：又名椎枕肌，包括4对连接于第1、2颈椎与枕骨之间发育良好的短肌，即头后小直肌、头后大直肌、头上斜肌、头下斜肌，其中后三者构成枕下三角。头后大直肌呈三角形，起自枢椎棘突，止于下项线的外侧部。头后小直肌亦呈三角形，较小，居内侧，起自寰椎后结节，止于下项线内侧部。两肌作用相同，一侧收缩头转向对侧，两侧收缩使头后仰。头上斜肌起自寰椎横突，斜向内上方，止于枕骨下项线上方的骨面，一侧收缩使头转向对侧并向同侧侧屈，两侧收缩使头后仰。头下斜肌起自枢椎棘突，斜向外上方，止于寰椎横突。一侧收缩使头转向同侧并屈；两侧收缩使头后仰。椎枕肌受枕下神经（第1颈神经后支）支配。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Rectus capitis posterior major,R",
                                                                    "layer": "5",
                                                                    "c": "头后大直肌Rectus capitis posterior major,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "枕下肌：又名椎枕肌，包括4对连接于第1、2颈椎与枕骨之间发育良好的短肌，即头后小直肌、头后大直肌、头上斜肌、头下斜肌，其中后三者构成枕下三角。头后大直肌呈三角形，起自枢椎棘突，止于下项线的外侧部。头后小直肌亦呈三角形，较小，居内侧，起自寰椎后结节，止于下项线内侧部。两肌作用相同，一侧收缩头转向同侧，两侧收缩使头后仰。头上斜肌起自寰椎横突，斜向内上方，止于枕骨下项线上方的骨面，一侧收缩使头转向对侧并向同侧侧屈，两侧收缩使头后仰。头下斜肌起自枢椎棘突，斜向外上方，止于寰椎横突。一侧收缩使头转向同侧并屈；两侧收缩使头后仰。椎枕肌受枕下神经（第1颈神经后支）支配。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Rectus capitis posterior minor,R",
                                                                    "layer": "5",
                                                                    "c": "头后小直肌Rectus capitis posterior minor,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "枕下肌：又名椎枕肌，包括4对连接于第1、2颈椎与枕骨之间发育良好的短肌，即头后小直肌、头后大直肌、头上斜肌、头下斜肌，其中后三者构成枕下三角。头后大直肌呈三角形，起自枢椎棘突，止于下项线的外侧部。头后小直肌亦呈三角形，较小，居内侧，起自寰椎后结节，止于下项线内侧部。两肌作用相同，一侧收缩头转向对侧，两侧收缩使头后仰。头上斜肌起自寰椎横突，斜向内上方，止于枕骨下项线上方的骨面，一侧收缩使头转向对侧并向同侧侧屈，两侧收缩使头后仰。头下斜肌起自枢椎棘突，斜向外上方，止于寰椎横突。一侧收缩使头转向同侧并屈；两侧收缩使头后仰。椎枕肌受枕下神经（第1颈神经后支）支配。"
                                                                }
                                                            }]
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "02Muscle of thorax",
                                    "c": "胸肌Muscle of thorax"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Muscle of thorax,L",
                                            "c": "左胸肌Muscle of thorax,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Thoracic upper limb muscle,L",
                                                    "c": "左胸上肢肌Thoracic upper limb muscle,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Pectoralis major,L",
                                                            "layer": "1",
                                                            "c": "胸大肌Pectoralis major,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：锁骨内侧半、胸骨、第1-6肋软骨 止点：肱骨大结节嵴 主要作用：内收、内旋及屈肩关节 神经支配：胸外侧神经（C5-T1）、胸内侧神经（C7-T1）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Pectoralis minor,L",
                                                            "layer": "2",
                                                            "c": "胸小肌Pectoralis minor,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：第3-5肋骨或(第2-5肋骨变异) 止点：肩胛骨喙突 主要作用：拉肩胛骨向下,肩胛骨固定时可提肋助吸气 神经支配：胸内侧神经"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Serratus anterior,L",
                                                            "layer": "2",
                                                            "c": "前锯肌Serratus anterior,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：第1-8(9)肋骨外侧面 止点：肩胛骨内侧缘及下角 主要作用：拉肩胛骨向前 神经支配：胸长神经（C5-7）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Subclavius,L",
                                                            "layer": "2",
                                                            "c": "锁骨下肌Subclavius,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：第1肋软骨上面 止点：锁骨肩峰端 主要作用：拉锁骨向内下 神经支配：锁骨下神经（C4-6）"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Proper thoracic muscle,L",
                                                    "c": "左胸固有肌Proper thoracic muscle,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "External intercostal,L",
                                                            "layer": "3",
                                                            "c": "肋间外肌External intercostal,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：上位肋骨下缘 止点：下位肋骨上缘 主要作用：提肋助吸气 神经支配：肋间神经（T1-12）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Internal intercostal,L",
                                                            "layer": "4",
                                                            "c": "肋间内肌Internal intercostal,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：下位肋骨上缘 止点：上位肋骨下缘 主要作用：降肋助呼气 神经支配：肋间神经（T1-12）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Levatores costarum(breves),L",
                                                            "layer": "5",
                                                            "c": "肋短提肌Levatores costarum (breves),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肋短提肌：上8对肋提肌。止于邻近肋骨。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Levatores costarum(longi),L",
                                                            "layer": "5",
                                                            "c": "肋长提肌Levatores costarum (longi),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肋长提肌：肌束较长的下4对肋提肌。越过上位肋骨止于下位肋骨。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Subcostale,L",
                                                            "layer": "5",
                                                            "c": "肋下肌Subcostale,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肋下肌:胸后壁的下部，跨过一位以上肋的肋间最内肌。作用为降肋助呼气。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Transversus thoracis,L",
                                                            "layer": "5",
                                                            "c": "胸横肌Transversus thoracis,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：胸骨内部下面 止点：第2-6肋骨的内面 主要作用：拉肋向下助呼气 神经支配：肋间神经"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Muscle of thorax,R",
                                            "c": "右胸肌Muscle of thorax,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Thoracic upper limb muscle,R",
                                                    "c": "右胸上肢肌Thoracic upper limb muscle,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Pectoralis major,R",
                                                            "layer": "1",
                                                            "c": "胸大肌Pectoralis major,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：锁骨内侧半、胸骨、第1-6肋软骨 止点：肱骨大结节嵴 主要作用：内收、内旋及屈肩关节 神经支配：胸外侧神经（C5-T1）、胸内侧神经（C7-T1）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Pectoralis minor,R",
                                                            "layer": "2",
                                                            "c": "胸小肌Pectoralis minor,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：第3-5肋骨或(第2-5肋骨变异) 止点：肩胛骨喙突 主要作用：拉肩胛骨向下,肩胛骨固定时可提肋助吸气 神经支配：胸内侧神经"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Serratus anterior,R",
                                                            "layer": "2",
                                                            "c": "前锯肌Serratus anterior,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：第1-8(9)肋骨外侧面 止点：肩胛骨内侧缘及下角 主要作用：拉肩胛骨向前 神经支配：胸长神经（C5-7）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Subclavius,R",
                                                            "layer": "2",
                                                            "c": "锁骨下肌Subclavius,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：第1肋软骨上面 止点：锁骨肩峰端 主要作用：拉锁骨向内下 神经支配：锁骨下神经（C4-6）"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Proper thoracic muscle,R",
                                                    "c": "右胸固有肌Proper thoracic muscle,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "External intercostal,R",
                                                            "layer": "3",
                                                            "c": "肋间外肌External intercostal,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：上位肋骨下缘 止点：下位肋骨上缘 主要作用：提肋助吸气 神经支配：肋间神经（T1-12）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Internal intercostal,R",
                                                            "layer": "4",
                                                            "c": "肋间内肌Internal intercostal,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：下位肋骨上缘 止点：上位肋骨下缘 主要作用：降肋助呼气 神经支配：肋间神经（T1-12）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Levatores costarum(breves),R",
                                                            "layer": "5",
                                                            "c": "肋短提肌Levatores costarum (breves),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肋短提肌：上8对肋提肌。止于邻近肋骨。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Levatores costarum(longi),R",
                                                            "layer": "5",
                                                            "c": "肋长提肌Levatores costarum (longi),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肋长提肌：肌束较长的下4对肋提肌。越过上位肋骨止于下位肋骨。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Subcostale,R",
                                                            "layer": "5",
                                                            "c": "肋下肌Subcostale,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肋下肌:胸后壁的下部，跨过一位以上肋的肋间最内肌。作用为降肋助呼气。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Transversus thoracis,R",
                                                            "layer": "5",
                                                            "c": "胸横肌Transversus thoracis,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：胸骨内部下面 止点：第2-6肋骨的内面 主要作用：拉肋向下助呼气 神经支配：肋间神经"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "03Diaphragm",
                                    "layer": "5",
                                    "c": "膈肌Diaphragm"
                                },
                                "t":
                                {
                                    "s": "膈是分隔胸、腹腔的扁肌，呈穹隆形，其隆凸的上面朝向胸腔，凹陷的下面朝向腹腔。 膈的肌纤维起自胸廓下口的周缘和腰椎前面，可分为3部：胸骨部起自剑突后面；肋部起自下6对肋骨和肋软骨；腰部以左、右两个膈脚起自上2-3个腰椎，并起自腰大肌表面的腱性组织内侧弓状韧带和腰方肌表面的腱性组织外侧弓状韧带。各部肌纤维向中央移行于中心腱。\r\n                                    膈上有3个裂孔：在第12胸椎前方，左右两个膈脚与脊柱之间有主动脉裂孔，有主动脉和胸导管通过；主动脉裂孔的左前上方，约在第10胸椎水平，有食管裂孔，有食管和迷走神经通过；在食管裂孔的右前上方的中心腱内有腔静脉孔，约在第8胸椎水平，有下腔静脉通过。 作用：膈为主要的呼吸肌，收缩时，膈穹隆下降，胸腔容积扩大，以助吸气；松弛时，膈穹隆上升恢复原位，胸腔容积减小，以助呼气。膈与腹肌同时收缩，则能增加腹压，协助排便、呕吐、咳嗽、喷嚏及分娩等活动。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "04Muscle of abdomen",
                                    "c": "腹肌Muscle of abdomen"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "M_Linea alba",
                                            "layer": "1",
                                            "c": "白线Linea alba"
                                        },
                                        "t":
                                        {
                                            "s": "白线：位于腹前正中线上，是从剑突到耻骨联合和耻骨嵴的腱性结构。位于两侧腹直肌之间，由两侧腹直肌鞘纤维彼此交织而成。在脐以下，白线变窄，与两侧腹直肌间的间隔相一致。\r\n                                            在脐以上，白线相应加宽，可看到表面有一浅沟。白线下端止于两处：浅部纤维越过腹直肌前面止于耻骨联合，深部纤维形成一三角形，在腹直肌后方止于两侧耻骨嵴的后面。从腹壁仅有很少小血管进入白线。腹内压增高时，脐下白线会增宽，造成结缔组织纤维之间形成一些小孔，腹膜外脂肪组织等可由此突出至皮下，称为白线疝。经白线作腹正中切口剖腹时，出血少，易入腹腔，但血供差，切口愈合慢且形成的瘢痕不牢固。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Muscle of abdomen,L",
                                            "c": "左腹肌Muscle of abdomen,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Anterolateral group (abdomen),L",
                                                    "c": "左腹肌前外侧群Anterolateral group (abdomen),L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_External oblique,L",
                                                            "layer": "1",
                                                            "c": "腹外斜肌External oblique,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：下位8肋外面 止点：借腱膜止于白线、髂嵴前部，并形成腹股沟韧带 主要作用：增加腹压，脊柱前屈、侧屈、旋转，降肋助呼气 神经支配：第5-11肋间神经及肋下神经、髂腹下神经、髂腹股沟神经"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Internal oblique,L",
                                                            "layer": "2",
                                                            "c": "腹内斜肌Internal oblique,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：胸腰筋膜、髂嵴、腹股沟韧带外侧1/2 止点：借腱膜止于白线和下3肋、耻骨梳 主要作用：增加腹压，脊柱前屈、侧屈、旋转，降肋助呼气 神经支配：第5-11肋间神经及肋下神经、髂腹下神经、髂腹股沟神经"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Pyramidalis,L",
                                                            "layer": "2",
                                                            "c": "锥状肌Pyramidalis,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "锥状肌位于腹直肌鞘内，是腹直肌下部前面的三角形肌。以腱性纤维起于耻骨前面及耻骨联合前韧带性纤维上。该肌愈向上愈小，以点状末端止于白线，常达脐与耻骨联合的中点。该肌大小不一，可一侧较大，也可一侧或两侧缺如。锥状肌由肋下神经支配。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Rectus abdominis,L",
                                                            "layer": "2",
                                                            "c": "腹直肌Rectus abdominis,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：耻骨联合上缘与耻骨嵴 止点：第5-7肋软骨外面及剑突前面 主要作用：前屈脊柱、降胸廓、增加腹压 神经支配：第5-11肋间神经及肋下神经"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Transversus abdominis,L",
                                                            "layer": "3",
                                                            "c": "腹横肌Transversus abdominis,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：下位6肋软骨内面、胸腰筋膜、髂嵴、腹股沟韧带外侧1/3 止点：白线、耻骨梳 主要作用：增加腹压，脊柱前屈、侧屈、旋转，降肋助呼气 神经支配：第5-11肋间神经及肋下神经、髂腹下神经、髂腹股沟神经"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Posterior group (abdomen),L",
                                                    "c": "左腹肌后群Posterior group (abdomen),L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Quadratus lumborum,L",
                                                            "layer": "4",
                                                            "c": "腰方肌Quadratus lumborum,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：髂嵴 止点：第12肋、第1-4腰椎横突 主要作用：降第12肋，脊柱腰部侧屈 神经支配：腰神经前支(T12-L3)"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Muscle of abdomen,R",
                                            "c": "右腹肌Muscle of abdomen,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Anterolateral group (abdomen),R",
                                                    "c": "右腹肌前外侧群Anterolateral group (abdomen),R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_External oblique,R",
                                                            "layer": "1",
                                                            "c": "腹外斜肌External oblique,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：下位8肋外面 止点：借腱膜止于白线、髂嵴前部，并形成腹股沟韧带 主要作用：增加腹压，脊柱前屈、侧屈、旋转，降肋助呼气 神经支配：第5-11肋间神经及肋下神经、髂腹下神经、髂腹股沟神经"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Internal oblique,R",
                                                            "layer": "2",
                                                            "c": "腹内斜肌Internal oblique,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：胸腰筋膜、髂嵴、腹股沟韧带外侧1/2 止点：借腱膜止于白线和下3肋、耻骨梳 主要作用：增加腹压，脊柱前屈、侧屈、旋转，降肋助呼气 神经支配：第5-11肋间神经及肋下神经、髂腹下神经、髂腹股沟神经"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Pyramidalis,R",
                                                            "layer": "2",
                                                            "c": "锥状肌Pyramidalis,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "锥状肌位于腹直肌鞘内，是腹直肌下部前面的三角形肌。以腱性纤维起于耻骨前面及耻骨联合前韧带性纤维上。该肌愈向上愈小，以点状末端止于白线，常达脐与耻骨联合的中点。该肌大小不一，可一侧较大，也可一侧或两侧缺如。锥状肌由肋下神经支配。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Rectus abdominis,R",
                                                            "layer": "2",
                                                            "c": "腹直肌Rectus abdominis,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：耻骨联合上缘与耻骨嵴 止点：第5-7肋软骨外面及剑突前面 主要作用：前屈脊柱、降胸廓、增加腹压 神经支配：第5-11肋间神经及肋下神经"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Transversus abdominis,R",
                                                            "layer": "3",
                                                            "c": "腹横肌Transversus abdominis,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：下位6肋软骨内面、胸腰筋膜、髂嵴、腹股沟韧带外侧1/3 止点：白线、耻骨梳 主要作用：增加腹压，脊柱前屈、侧屈、旋转，降肋助呼气 神经支配：第5-11肋间神经及肋下神经、髂腹下神经、髂腹股沟神经"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Posterior group (abdomen),R",
                                                    "c": "右腹肌后群Posterior group (abdomen),R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Quadratus lumborum,R",
                                                            "layer": "4",
                                                            "c": "腰方肌Quadratus lumborum,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：髂嵴 止点：第12肋、第1-4腰椎横突 主要作用：降第12肋，脊柱腰部侧屈 神经支配：腰神经前支(T12-L3)"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    }]
                                }
                            }]
                        }
                    },
                    {
                        "$":
                        {
                            "o": "04Muscle of upper limb",
                            "c": "上肢肌Muscle of upper limb"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "Muscle of upper limb,L",
                                    "c": "左上肢肌Muscle of upper limb,L"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "01Muscle of shoulder girdle,L",
                                            "c": "上肢带肌Muscle of shoulder girdle,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Deltoid,anterior head,L",
                                                    "layer": "1",
                                                    "c": "三角肌前束Deltoid,anterior head,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：锁骨外侧1/3、肩峰、肩胛冈 止点：肱骨三角肌粗隆 主要作用：肩关节外展、前屈和旋内（前部肌束）、后伸和旋外（后部肌束） 神经支配：腋神经（C5-7）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Deltoid,middle head,L",
                                                    "layer": "1",
                                                    "c": "三角肌中束Deltoid,middle head,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：锁骨外侧1/3、肩峰、肩胛冈 止点：肱骨三角肌粗隆 主要作用：肩关节外展、前屈和旋内（前部肌束）、后伸和旋外（后部肌束） 神经支配：腋神经（C5-7）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Deltoid,posterior head,L",
                                                    "layer": "1",
                                                    "c": "三角肌后束Deltoid,posterior head,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：锁骨外侧1/3、肩峰、肩胛冈 止点：肱骨三角肌粗隆 主要作用：肩关节外展、前屈和旋内（前部肌束）、后伸和旋外（后部肌束） 神经支配：腋神经（C5-7）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Infraspinatus,L",
                                                    "layer": "2",
                                                    "c": "冈下肌Infraspinatus,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：肩胛骨冈下窝 止点：肱骨大结节中部 主要作用：肩关节旋外 神经支配：肩胛上神经（C5-6）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Subscapularis,L",
                                                    "layer": "3",
                                                    "c": "肩胛下肌Subscapularis,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：肩胛下窝 止点：肱骨小结节 主要作用：肩关节内收、旋内 神经支配：肩胛下神经（C5-6）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Supraspinatus,L",
                                                    "layer": "1",
                                                    "c": "冈上肌Supraspinatus,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：肩胛骨冈上窝 止点：肱骨大结节上部 主要作用：肩关节外展 神经支配：肩胛上神经（C5-6）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Teres major,L",
                                                    "layer": "2",
                                                    "c": "大圆肌Teres major,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：肩胛骨下角背面 止点：肱骨小结节嵴 主要作用：肩关节后伸、内收及旋内 神经支配：肩胛下神经（C5-6）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Teres minor,L",
                                                    "layer": "2",
                                                    "c": "小圆肌Teres minor,L"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：肩胛骨外侧缘背面 止点：肱骨大结节下部 主要作用：肩关节旋外 神经支配：腋神经（C5-7）"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "02Muscle of arm,L",
                                            "c": "左臂肌Muscle of arm,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Anterior group (arm),L",
                                                    "c": "左臂肌前群Anterior group (arm),L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Biceps brachii,long head,L",
                                                            "layer": "1",
                                                            "c": "肱二头肌长头Biceps brachii,long head,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：肩胛骨盂上结节 止点：桡骨粗隆 主要作用：屈肘关节、前臂旋后 神经支配：肌皮神经(C5-7)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Biceps brachii,short head,L",
                                                            "layer": "1",
                                                            "c": "肱二头肌短头Biceps brachii,short head,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：肩胛骨喙突 止点：桡骨粗隆 主要作用：屈肘关节、前臂旋后 神经支配：肌皮神经(C5-7)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Bicipital aponeurosis,L",
                                                            "layer": "1",
                                                            "c": "肱二头肌腱膜Bicipital aponeurosis,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肱二头肌腱内侧的肱二头肌腱膜斜向内下方与深筋膜愈着。肱二头肌腱与腱膜的交角处是触及肱动脉搏动和测量血压的听诊部位。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Brachialis,L",
                                                            "layer": "2",
                                                            "c": "肱肌Brachialis,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：肱骨前面下半 止点：尺骨粗隆 主要作用：屈肘关节 神经支配：肌皮神经(C5-7)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Coracobrachialis,L",
                                                            "layer": "2",
                                                            "c": "喙肱肌Coracobrachialis,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：肩胛骨喙突 止点：肱骨中部，内侧 主要作用：屈肩及上臂内收 神经支配：肌皮神经(C5-7)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Intertubercular tendon sheath,L",
                                                            "layer": "1",
                                                            "c": "结节间腱鞘Intertubercular tendon sheath,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "结节间腱鞘：与肩关节囊相通，由肩关节囊的滑膜突出而成的结构。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Posterior group (arm),L",
                                                    "c": "左臂肌后群Posterior group (arm),L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Anconeus,L",
                                                            "layer": "2",
                                                            "c": "肘肌Anconeus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：肱骨外上踝 止点：鹰嘴、尺骨后面上部 主要作用：伸肘关节 神经支配：桡神经(C5-8)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Triceps brachii,medial head,L",
                                                            "layer": "1",
                                                            "c": "肱三头肌内侧头Triceps brachii,medial head,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：桡神经沟内下方的骨面 止点：尺骨鹰嘴 主要作用：伸肘关节，助肩关节伸及内收（长头） 神经支配：桡神经(C5-T1)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Triceps brachii,lateral head,L",
                                                            "layer": "1",
                                                            "c": "肱三头肌外侧头Triceps brachii,lateral head,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：桡神经沟外上方的骨面 止点：尺骨鹰嘴 主要作用：伸肘关节，助肩关节伸及内收（长头） 神经支配：桡神经(C5-T1)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Triceps brachii,long head,L",
                                                            "layer": "2",
                                                            "c": "肱三头肌长头Triceps brachii,long head,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：肩胛骨盂下结节 止点：尺骨鹰嘴 主要作用：伸肘关节，助肩关节伸及内收（长头） 神经支配：桡神经(C5-T1)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Triceps brachii,tendon,L",
                                                            "layer": "1",
                                                            "c": "肱三头肌腱Triceps brachii,tendon,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肱三头肌腱附着于尺骨鹰嘴。在肌腱与鹰嘴之间有鹰嘴腱下囊。肌腱的外侧有起于外上髁的前臂伸肌群。"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "03Muscle of forearm,L",
                                            "c": "左前臂肌Muscle of forearm,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Anterior group (forearm),L",
                                                    "c": "左前臂肌前群Anterior group (forearm),L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "01First layer,L",
                                                            "c": "左第一层First layer,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Brachioradialis,L",
                                                                    "layer": "1",
                                                                    "c": "肱桡肌Brachioradialis,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：肱骨外上髁上方 止点：桡骨茎突 主要作用：屈肘 神经支配：桡神经(C5-6)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Flexor carpi radialis,L",
                                                                    "layer": "2",
                                                                    "c": "桡侧腕屈肌Flexor carpi radialis,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：肱骨内上髁、前臂筋膜 止点：第2掌骨底前面 主要作用：屈肘、屈腕、手外展 神经支配：正中神经(C6-7)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Flexor carpi ulnaris,L",
                                                                    "layer": "2",
                                                                    "c": "尺侧腕屈肌Flexor carpi ulnaris,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：肱骨内上髁、前臂筋膜 止点：豌豆骨 主要作用：屈腕、手内收 神经支配：尺神经(C8-T1)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Palmaris longus,L",
                                                                    "layer": "1",
                                                                    "c": "掌长肌Palmaris longus,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：肱骨内上髁；前臂筋膜 止点：掌腱膜 主要作用：屈腕、紧张掌腱膜 神经支配：正中神经(C6-7)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Pronator teres,L",
                                                                    "layer": "2",
                                                                    "c": "旋前圆肌Pronator teres,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：肱骨内上髁、前臂筋膜 止点：桡骨中部外、后面 主要作用：屈肘、前臂旋前 神经支配：正中神经(C6-7)"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "02Second layer,L",
                                                            "c": "左第二层Second layer,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub":
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Flexor digitorum superficialis,L",
                                                                    "layer": "1",
                                                                    "c": "指浅屈肌Flexor digitorum superficialis,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：肱骨内上髁，前臂筋膜 止点：第2-5指的中节指骨底 主要作用：屈近侧指骨间关节、掌指关节、腕 神经支配：正中神经（C6-T1）"
                                                                }
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "03Third layer,L",
                                                            "c": "左第三层Third layer,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Flexor digitorum profundus,L",
                                                                    "layer": "1",
                                                                    "c": "指深屈肌Flexor digitorum profundus,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：尺骨及骨间膜前面 止点：第2-5指远节指骨底 主要作用：屈远侧指骨间关节、掌指关节、腕 神经支配：正中神经（C6-T1）、尺神经"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Flexor pollicis longus,L",
                                                                    "layer": "3",
                                                                    "c": "拇长屈肌Flexor pollicis longus,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：桡骨中1/3、骨间膜前面 止点：拇指远节指骨底 主要作用：屈拇指 神经支配：正中神经（C6-T1）、尺神经"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "04Fourth layer,L",
                                                            "c": "左第四层Fourth layer,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub":
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Pronator quadratus,L",
                                                                    "layer": "2",
                                                                    "c": "旋前方肌Pronator quadratus,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：尺骨远端1/4前面 止点：桡骨远端1/4前面 主要作用：前臂旋前 神经支配：正中神经（C6-T1）"
                                                                }
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Common flexor sheath,L",
                                                            "layer": "1",
                                                            "c": "屈肌总腱鞘Common flexor sheath,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "屈肌总腱鞘：包绕指浅屈肌腱和指深屈肌腱的腱鞘。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Tendinous sheath of flexor pollicis longus,L",
                                                            "layer": "3",
                                                            "c": "拇长屈肌腱鞘Tendinous sheath of flexor pollicis longus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "拇长屈肌腱鞘：包绕拇长屈肌腱的腱鞘。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Posterior group (forearm),L",
                                                    "c": "左前臂肌后群Posterior group (forearm),L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "01Superficial layer,L",
                                                            "c": "左前臂肌后群浅层Superficial layer,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Extensor carpi radialis brevis,L",
                                                                    "layer": "1",
                                                                    "c": "桡侧腕短伸肌Extensor carpi radialis brevis,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：肱骨外上髁 止点：第3掌骨底背面 主要作用：伸桡腕关节 神经支配：桡神经(C6-8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Extensor carpi radialis longus,L",
                                                                    "layer": "1",
                                                                    "c": "桡侧腕长伸肌Extensor carpi radialis longus,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：肱骨外上髁 止点：第2掌骨底背面 主要作用：伸、外展桡腕关节 神经支配：桡神经(C6-8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Extensor carpi ulnaris,L",
                                                                    "layer": "1",
                                                                    "c": "尺侧腕伸肌Extensor carpi ulnaris,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：肱骨外上髁 止点：第5掌骨底 主要作用：伸、内收桡腕关节 神经支配：桡神经(C6-8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Extensor digiti minimi,L",
                                                                    "layer": "1",
                                                                    "c": "小指伸肌Extensor digiti minimi,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：肱骨外上髁 止点：小指指背腱膜 主要作用：伸小指、伸腕 神经支配：桡神经(C6-8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Extensor digitorum,L",
                                                                    "layer": "1",
                                                                    "c": "指伸肌Extensor digitorum,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：肱骨外上髁 止点：第2-5指中节和远节指骨底 主要作用：伸指、伸腕 神经支配：桡神经(C6-8）"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Arm Deep layer,L",
                                                            "c": "左前臂肌后群深层Deep layer,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Abductor pollicis longus,L",
                                                                    "layer": "2",
                                                                    "c": "拇长展肌Abductor pollicis longus,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：桡、尺骨背面、骨间膜背面 止点：第一掌骨底外侧 主要作用：拇指外展 神经支配：桡神经(C6-8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Extensor indicis,L",
                                                                    "layer": "3",
                                                                    "c": "示指伸肌Extensor indicis,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：桡、尺骨和骨间膜背面 止点：示指的指背腱膜 主要作用：伸示指 神经支配：桡神经(C6-8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Extensor pollicis brevis,L",
                                                                    "layer": "3",
                                                                    "c": "拇短伸肌Extensor pollicis brevis,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：桡、尺骨背面 止点：拇指近节指骨底 主要作用：伸拇掌指关节 神经支配：桡神经(C6-8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Extensor pollicis longus,L",
                                                                    "layer": "2",
                                                                    "c": "拇长伸肌Extensor pollicis longus,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：桡、尺骨背面 止点：拇指远节指骨底 主要作用：伸拇指 神经支配：桡神经(C6-8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Supinator,L",
                                                                    "layer": "2",
                                                                    "c": "旋后肌Supinator,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：肱骨外上髁、尺骨 止点：桡骨前面上1/3 主要作用：前臂旋后 神经支配：桡神经(C6-8)"
                                                                }
                                                            }]
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "04Muscle of hand,L",
                                            "c": "左手肌Muscle of hand,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Lateral group (hand),L",
                                                    "c": "左手肌外侧群Lateral group (hand),L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Abductor pollicis brevis,L",
                                                            "layer": "1",
                                                            "c": "拇短展肌Abductor pollicis brevis,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：屈肌支持带和舟骨 止点：拇指近节指骨底 主要作用：外展拇指 神经支配：正中神经(C6-7)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Adductor pollicis,L",
                                                            "layer": "3",
                                                            "c": "拇收肌Adductor pollicis,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：斜头：头状骨、腕横韧带；横头：第3掌骨前面 止点：拇指近节指骨底 主要作用：拇指内收、屈曲 神经支配：尺神经(C8)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Flexor pollicis brevis,L",
                                                            "layer": "2",
                                                            "c": "拇短屈肌Flexor pollicis brevis,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：屈肌支持带和大多角骨 止点：拇指近节指骨底 主要作用：屈拇指近节指骨 神经支配：正中神经(C6-7)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Opponens pollicis,L",
                                                            "layer": "2",
                                                            "c": "拇对掌肌Opponens pollicis,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：腕横韧带和大多角骨 止点：第1掌骨桡侧缘 主要作用：拇指对掌（屈+旋前） 神经支配：正中神经(C6-7)"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Medial group (hand),L",
                                                    "c": "左手肌内侧群Medial group (hand),L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Abductor digiti minimi(hand),L",
                                                            "layer": "2",
                                                            "c": "小指展肌Abductor digiti minimi(hand),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：豌豆骨和屈肌支持带 止点：小指近节指骨底 主要作用：外展小指 神经支配：尺神经深支(C8)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Flexor digiti minimi brevis(hand),L",
                                                            "layer": "2",
                                                            "c": "小指短屈肌Flexor digiti minimi brevis(hand),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：钩骨及腕横韧带 止点：小指近节指骨底尺侧缘 主要作用：屈小指关节 神经支配：尺神经深支(C8)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Opponens digiti minimi(hand),L",
                                                            "layer": "3",
                                                            "c": "小指对掌肌Opponens digiti minimi(hand),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：钩骨及腕横韧带 止点：第5掌骨尺侧缘 主要作用：小指对掌 神经支配：尺神经深支(C8)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Palmaris brevis,L",
                                                            "layer": "1",
                                                            "c": "掌短肌Palmaris brevis,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "掌短肌：属于退化的皮肌，位于小鱼际近侧部的浅筋膜内，对浅筋膜有固定作用，并可保护其深面的尺神经和血管。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "03Intermediate group (hand),L",
                                                    "c": "左手肌中间群Intermediate group (hand),L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Dorsal interossei,L",
                                                            "c": "左骨间背侧肌Dorsal interossei,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Dorsal interosseous 1st,L",
                                                                    "layer": "3",
                                                                    "c": "第一骨间背侧肌Dorsal interosseous 1st,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：第1-5掌骨对缘 止点：第2、3桡侧止于近节指骨底和指背腱膜 主要作用：2、4指外展，屈掌指关节、伸指骨间关节 神经支配：尺神经深支(C8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Dorsal interosseous 2nd,L",
                                                                    "layer": "3",
                                                                    "c": "第二骨间背侧肌Dorsal interosseous 2nd,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：第1-5掌骨对缘 止点：第2-4指近节指骨和指背腱膜 主要作用：第2、4、5指外展，屈掌指关节、伸指骨间关节 神经支配：尺神经深支(C8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Dorsal interosseous 3rd,L",
                                                                    "layer": "3",
                                                                    "c": "第三骨间背侧肌Dorsal interosseous 3rd,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：第1-5掌骨对缘 止点：第2-4指近节指骨和指背腱膜 主要作用：第2、4、5指外展，屈掌指关节、伸指骨间关节 神经支配：尺神经深支(C8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Dorsal interosseous 4th,L",
                                                                    "layer": "3",
                                                                    "c": "第四骨间背侧肌Dorsal interosseous 4th,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：第1-5掌骨对缘 止点：第2-4指近节指骨和指背腱膜 主要作用：第2、4、5指外展，屈掌指关节、伸指骨间关节 神经支配：尺神经深支(C8)"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Lumbricales,L",
                                                            "c": "左蚓状肌Lumbricales,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Lumbrical 1st,L",
                                                                    "layer": "2",
                                                                    "c": "第一蚓状肌Lumbrical 1st,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：指深屈肌腱桡侧 止点：第2-5指近节指骨背面及指背腱膜 主要作用：屈掌指关节和伸指骨间关节 神经支配：正中神经(C6-7)，尺神经深支(C8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Lumbrical 2nd,L",
                                                                    "layer": "2",
                                                                    "c": "第二蚓状肌Lumbrical 2nd,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：指深屈肌腱桡侧 止点：第2-5指近节指骨背面及指背腱膜 主要作用：屈掌指关节和伸指骨间关节 神经支配：正中神经(C6-7)，尺神经深支(C8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Lumbrical 3rd,L",
                                                                    "layer": "2",
                                                                    "c": "第三蚓状肌Lumbrical 3rd,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：指深屈肌腱桡侧 止点：第2-5指近节指骨背面及指背腱膜 主要作用：屈掌指关节和伸指骨间关节 神经支配：正中神经(C6-7)，尺神经深支(C8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Lumbrical 4th,L",
                                                                    "layer": "2",
                                                                    "c": "第四蚓状肌Lumbrical 4th,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：指深屈肌腱桡侧 止点：第2-5指近节指骨背面及指背腱膜 主要作用：屈掌指关节和伸指骨间关节 神经支配：正中神经(C6-7)，尺神经深支(C8)"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Palmar interossei,L",
                                                            "c": "左骨间掌侧肌Palmar interossei,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Palmar interosseous 1st,L",
                                                                    "layer": "3",
                                                                    "c": "第一骨间掌侧肌Palmar interosseous 1st,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：第2掌骨尺侧缘 止点：经示指尺侧止于指背腱膜 主要作用：2、4、5指内收，屈掌指关节、伸指骨间关节 神经支配：尺神经深支(C8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Palmar interosseous 2nd,L",
                                                                    "layer": "3",
                                                                    "c": "第二骨间掌侧肌Palmar interosseous 2nd,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：第4掌骨桡侧缘 止点：经4指桡侧止于指背腱膜 主要作用：2、4、5指内收，屈掌指关节、伸指骨间关节 神经支配：尺神经深支(C8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Palmar interosseous 3rd,L",
                                                                    "layer": "3",
                                                                    "c": "第三骨间掌侧肌Palmar interosseous 3rd,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：第5掌骨桡侧缘 止点：经5指桡侧止于指背腱膜 主要作用：2、4、5指内收，屈掌指关节、伸指骨间关节 神经支配：尺神经深支(C8)"
                                                                }
                                                            }]
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Muscle of upper limb,R",
                                    "c": "右上肢肌Muscle of upper limb,R"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "01Muscle of shoulder girdle,R",
                                            "c": "右上肢带肌Muscle of shoulder girdle,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Deltoid,anterior head,R",
                                                    "layer": "1",
                                                    "c": "三角肌前束Deltoid,anterior head,R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：锁骨外侧1/3、肩峰、肩胛冈 止点：肱骨三角肌粗隆 主要作用：肩关节外展、前屈和旋内（前部肌束）、后伸和旋外（后部肌束） 神经支配：腋神经（C5-7）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Deltoid,middle head,R",
                                                    "layer": "1",
                                                    "c": "三角肌中束Deltoid,middle head,R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：锁骨外侧1/3、肩峰、肩胛冈 止点：肱骨三角肌粗隆 主要作用：肩关节外展、前屈和旋内（前部肌束）、后伸和旋外（后部肌束） 神经支配：腋神经（C5-7）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Deltoid,posterior head,R",
                                                    "layer": "1",
                                                    "c": "三角肌后束Deltoid,posterior head,R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：锁骨外侧1/3、肩峰、肩胛冈 止点：肱骨三角肌粗隆 主要作用：肩关节外展、前屈和旋内（前部肌束）、后伸和旋外（后部肌束） 神经支配：腋神经（C5-7）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Infraspinatus,R",
                                                    "layer": "2",
                                                    "c": "冈下肌Infraspinatus,R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：肩胛骨冈下窝 止点：肱骨大结节中部 主要作用：肩关节旋外 神经支配：肩胛上神经（C5-6）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Subscapularis,R",
                                                    "layer": "3",
                                                    "c": "肩胛下肌Subscapularis,R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：肩胛下窝 止点：肱骨小结节 主要作用：肩关节内收、旋内 神经支配：肩胛下神经（C5-6）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Supraspinatus,R",
                                                    "layer": "1",
                                                    "c": "冈上肌Supraspinatus,R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：肩胛骨冈上窝 止点：肱骨大结节上部 主要作用：肩关节外展 神经支配：肩胛上神经（C5-6）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Teres major,R",
                                                    "layer": "2",
                                                    "c": "大圆肌Teres major,R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：肩胛骨下角背面 止点：肱骨小结节嵴 主要作用：肩关节后伸、内收及旋内 神经支配：肩胛下神经（C5-6）"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Teres minor,R",
                                                    "layer": "2",
                                                    "c": "小圆肌Teres minor,R"
                                                },
                                                "t":
                                                {
                                                    "s": "起点：肩胛骨外侧缘背面 止点：肱骨大结节下部 主要作用：肩关节旋外 神经支配：腋神经（C5-7）"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "02Muscle of arm,R",
                                            "c": "右臂肌Muscle of arm,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Anterior group (arm),R",
                                                    "c": "右臂肌前群Anterior group (arm),R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Biceps brachii,long head,R",
                                                            "layer": "1",
                                                            "c": "肱二头肌长头Biceps brachii,long head,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：肩胛骨盂上结节 止点：桡骨粗隆 主要作用：屈肘关节、前臂旋后 神经支配：肌皮神经(C5-7)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Biceps brachii,short head,R",
                                                            "layer": "1",
                                                            "c": "肱二头肌短头Biceps brachii,short head,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：肩胛骨喙突 止点：桡骨粗隆 主要作用：屈肘关节、前臂旋后 神经支配：肌皮神经(C5-7)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Bicipital aponeurosis,R",
                                                            "layer": "1",
                                                            "c": "肱二头肌腱膜Bicipital aponeurosis,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肱二头肌腱内侧的肱二头肌腱膜斜向内下方与深筋膜愈着。肱二头肌腱与腱膜的交角处是触及肱动脉搏动和测量血压的听诊部位。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Brachialis,R",
                                                            "layer": "2",
                                                            "c": "肱肌Brachialis,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：肱骨前面下半 止点：尺骨粗隆 主要作用：屈肘关节 神经支配：肌皮神经(C5-7)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Coracobrachialis,R",
                                                            "layer": "2",
                                                            "c": "喙肱肌Coracobrachialis,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：肩胛骨喙突 止点：肱骨中部，内侧 主要作用：屈肩及上臂内收 神经支配：肌皮神经(C5-7)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Intertubercular tendon sheath,R",
                                                            "layer": "1",
                                                            "c": "结节间腱鞘Intertubercular tendon sheath,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "结节间腱鞘：与肩关节囊相通，由肩关节囊的滑膜突出而成的结构。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Posterior group (arm),R",
                                                    "c": "右臂肌后群Posterior group (arm),R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Anconeus,R",
                                                            "layer": "2",
                                                            "c": "肘肌Anconeus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：肱骨外上踝 止点：鹰嘴、尺骨后面上部 主要作用：伸肘关节 神经支配：桡神经(C5-8)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Triceps brachii,medial head,R",
                                                            "layer": "1",
                                                            "c": "肱三头肌内侧头Triceps brachii,medial head,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：桡神经沟内下方的骨面 止点：尺骨鹰嘴 主要作用：伸肘关节，助肩关节伸及内收（长头） 神经支配：桡神经(C5-T1)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Triceps brachii,lateral head,R",
                                                            "layer": "1",
                                                            "c": "肱三头肌外侧头Triceps brachii,lateral head,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：桡神经沟外上方的骨面 止点：尺骨鹰嘴 主要作用：伸肘关节，助肩关节伸及内收（长头） 神经支配：桡神经(C5-T1)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Triceps brachii,long head,R",
                                                            "layer": "2",
                                                            "c": "肱三头肌长头Triceps brachii,long head,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：肩胛骨盂下结节 止点：尺骨鹰嘴 主要作用：伸肘关节，助肩关节伸及内收（长头） 神经支配：桡神经(C5-T1)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Triceps brachii,tendon,R",
                                                            "layer": "1",
                                                            "c": "肱三头肌腱Triceps brachii,tendon,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肱三头肌腱附着于尺骨鹰嘴。在肌腱与鹰嘴之间有鹰嘴腱下囊。肌腱的外侧有起于外上髁的前臂伸肌群。"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "03Muscle of forearm,R",
                                            "c": "右前臂肌Muscle of forearm,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Anterior group (forearm),R",
                                                    "c": "右前臂肌前群Anterior group (forearm),R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "01First layer,R",
                                                            "c": "右第一层First layer,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Brachioradialis,R",
                                                                    "layer": "1",
                                                                    "c": "肱桡肌Brachioradialis,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：肱骨外上髁上方 止点：桡骨茎突 主要作用：屈肘 神经支配：桡神经(C5-6)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Flexor carpi radialis,R",
                                                                    "layer": "2",
                                                                    "c": "桡侧腕屈肌Flexor carpi radialis,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：肱骨内上髁、前臂筋膜 止点：第2掌骨底前面 主要作用：屈肘、屈腕、手外展 神经支配：正中神经(C6-7)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Flexor carpi ulnaris,R",
                                                                    "layer": "2",
                                                                    "c": "尺侧腕屈肌Flexor carpi ulnaris,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：肱骨内上髁、前臂筋膜 止点：豌豆骨 主要作用：屈腕、手内收 神经支配：尺神经(C8-T1)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Palmaris longus,R",
                                                                    "layer": "1",
                                                                    "c": "掌长肌Palmaris longus,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：肱骨内上髁；前臂筋膜 止点：掌腱膜 主要作用：屈腕、紧张掌腱膜 神经支配：正中神经(C6-7)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Pronator teres,R",
                                                                    "layer": "2",
                                                                    "c": "旋前圆肌Pronator teres,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：肱骨内上髁、前臂筋膜 止点：桡骨中部外、后面 主要作用：屈肘、前臂旋前 神经支配：正中神经(C6-7)"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "02Second layer,R",
                                                            "c": "右第二层Second layer,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub":
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Flexor digitorum superficialis,R",
                                                                    "layer": "1",
                                                                    "c": "指浅屈肌Flexor digitorum superficialis,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：肱骨内上髁，前臂筋膜 止点：第2-5指的中节指骨底 主要作用：屈近侧指骨间关节、掌指关节、腕 神经支配：正中神经（C6-T1）"
                                                                }
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "03Third layer,R",
                                                            "c": "右第三层Third layer,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Flexor digitorum profundus,R",
                                                                    "layer": "1",
                                                                    "c": "指深屈肌Flexor digitorum profundus,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：尺骨及骨间膜前面 止点：第2-5指远节指骨底 主要作用：屈远侧指骨间关节、掌指关节、腕 神经支配：正中神经（C6-T1）、尺神经"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Flexor pollicis longus,R",
                                                                    "layer": "3",
                                                                    "c": "拇长屈肌Flexor pollicis longus,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：桡骨中1/3、骨间膜前面 止点：拇指远节指骨底 主要作用：屈拇指 神经支配：正中神经（C6-T1）、尺神经"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "04Fourth layer,R",
                                                            "c": "右第四层Fourth layer,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub":
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Pronator quadratus,R",
                                                                    "layer": "2",
                                                                    "c": "旋前方肌Pronator quadratus,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：尺骨远端1/4前面 止点：桡骨远端1/4前面 主要作用：前臂旋前 神经支配：正中神经（C6-T1）"
                                                                }
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Common flexor sheath,R",
                                                            "layer": "1",
                                                            "c": "屈肌总腱鞘Common flexor sheath,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "屈肌总腱鞘：包绕指浅屈肌腱和指深屈肌腱的腱鞘。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Tendinous sheath of flexor pollicis longus,R",
                                                            "layer": "3",
                                                            "c": "拇长屈肌腱鞘Tendinous sheath of flexor pollicis longus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "拇长屈肌腱鞘：包绕拇长屈肌腱的腱鞘。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Posterior group (forearm),R",
                                                    "c": "右前臂肌后群Posterior group (forearm),R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "01Superficial layer,R",
                                                            "c": "右前臂肌后群浅层Superficial layer,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Extensor carpi radialis brevis,R",
                                                                    "layer": "1",
                                                                    "c": "桡侧腕短伸肌Extensor carpi radialis brevis,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：肱骨外上髁 止点：第3掌骨底背面 主要作用：伸桡腕关节 神经支配：桡神经(C6-8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Extensor carpi radialis longus,R",
                                                                    "layer": "1",
                                                                    "c": "桡侧腕长伸肌Extensor carpi radialis longus,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：肱骨外上髁 止点：第2掌骨底背面 主要作用：伸、外展桡腕关节 神经支配：桡神经(C6-8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Extensor carpi ulnaris,R",
                                                                    "layer": "1",
                                                                    "c": "尺侧腕伸肌Extensor carpi ulnaris,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：肱骨外上髁 止点：第5掌骨底 主要作用：伸、内收桡腕关节 神经支配：桡神经(C6-8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Extensor digiti minimi,R",
                                                                    "layer": "1",
                                                                    "c": "小指伸肌Extensor digiti minimi,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：肱骨外上髁 止点：小指指背腱膜 主要作用：伸小指、伸腕 神经支配：桡神经(C6-8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Extensor digitorum,R",
                                                                    "layer": "1",
                                                                    "c": "指伸肌Extensor digitorum,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：肱骨外上髁 止点：第2-5指中节和远节指骨底 主要作用：伸指、伸腕 神经支配：桡神经(C6-8）"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Arm Deep layer,R",
                                                            "c": "右前臂肌后群深层Deep layer,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Abductor pollicis longus,R",
                                                                    "layer": "2",
                                                                    "c": "拇长展肌Abductor pollicis longus,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：桡、尺骨背面、骨间膜背面 止点：第一掌骨底外侧 主要作用：拇指外展 神经支配：桡神经(C6-8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Extensor indicis,R",
                                                                    "layer": "3",
                                                                    "c": "示指伸肌Extensor indicis,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：桡、尺骨和骨间膜背面 止点：示指的指背腱膜 主要作用：伸示指 神经支配：桡神经(C6-8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Extensor pollicis brevis,R",
                                                                    "layer": "3",
                                                                    "c": "拇短伸肌Extensor pollicis brevis,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：桡、尺骨背面 止点：拇指近节指骨底 主要作用：伸拇掌指关节 神经支配：桡神经(C6-8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Extensor pollicis longus,R",
                                                                    "layer": "2",
                                                                    "c": "拇长伸肌Extensor pollicis longus,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：桡、尺骨背面 止点：拇指远节指骨底 主要作用：伸拇指 神经支配：桡神经(C6-8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Supinator,R",
                                                                    "layer": "2",
                                                                    "c": "旋后肌Supinator,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：肱骨外上髁、尺骨 止点：桡骨前面上1/3 主要作用：前臂旋后 神经支配：桡神经(C6-8)"
                                                                }
                                                            }]
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "04Muscle of hand,R",
                                            "c": "右手肌Muscle of hand,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Lateral group (hand),R",
                                                    "c": "右手肌外侧群Lateral group (hand),R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Abductor pollicis brevis,R",
                                                            "layer": "1",
                                                            "c": "拇短展肌Abductor pollicis brevis,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：屈肌支持带和舟骨 止点：拇指近节指骨底 主要作用：外展拇指 神经支配：正中神经(C6-7)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Adductor pollicis,R",
                                                            "layer": "3",
                                                            "c": "拇收肌Adductor pollicis,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：斜头：头状骨、腕横韧带；横头：第3掌骨前面 止点：拇指近节指骨底 主要作用：拇指内收、屈曲 神经支配：尺神经(C8)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Flexor pollicis brevis,R",
                                                            "layer": "3",
                                                            "c": "拇短屈肌Flexor pollicis brevis,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：屈肌支持带和大多角骨 止点：拇指近节指骨底 主要作用：屈拇指近节指骨 神经支配：正中神经(C6-7)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Opponens pollicis,R",
                                                            "layer": "3",
                                                            "c": "拇对掌肌Opponens pollicis,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：腕横韧带和大多角骨 止点：第1掌骨桡侧缘 主要作用：拇指对掌（屈+旋前） 神经支配：正中神经(C6-7)"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Medial group (hand),R",
                                                    "c": "右手肌内侧群Medial group (hand),R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Abductor digiti minimi(hand),R",
                                                            "layer": "3",
                                                            "c": "小指展肌Abductor digiti minimi(hand),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：豌豆骨和屈肌支持带 止点：小指近节指骨底 主要作用：外展小指 神经支配：尺神经深支(C8)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Flexor digiti minimi brevis(hand),R",
                                                            "layer": "3",
                                                            "c": "小指短屈肌Flexor digiti minimi brevis(hand),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：钩骨及腕横韧带 止点：小指近节指骨底尺侧缘 主要作用：屈小指关节 神经支配：尺神经深支(C8)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Opponens digiti minimi(hand),R",
                                                            "layer": "3",
                                                            "c": "小指对掌肌Opponens digiti minimi(hand),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：钩骨及腕横韧带 止点：第5掌骨尺侧缘 主要作���：小指对掌 神经支配：尺神经深支(C8)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Palmaris brevis,R",
                                                            "layer": "1",
                                                            "c": "掌短肌Palmaris brevis,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "掌短肌：属于退化的皮肌，位于小鱼际近侧部的浅筋膜内，对浅筋膜有固定作用，并可保护其深面的尺神经和血管。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "03Intermediate group (hand),R",
                                                    "c": "右手肌中间群Intermediate group (hand),R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Dorsal interossei,R",
                                                            "c": "右骨间背侧肌Dorsal interossei,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Dorsal interosseous 1st,R",
                                                                    "layer": "3",
                                                                    "c": "第一骨间背侧肌Dorsal interosseous 1st,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：第1-5掌骨对缘 止点：第2、3桡侧止于近节指骨底和指背腱膜 主要作用：2、4指外展，屈掌指关节、伸指骨间关节 神经支配：尺神经深支(C8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Dorsal interosseous 2nd,R",
                                                                    "layer": "3",
                                                                    "c": "第二骨间背侧肌Dorsal interosseous 2nd,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：第1-5掌骨对缘 止点：第2-4指近节指骨和指背腱膜 主要作用：第2、4、5指外展，屈掌指关节、伸指骨间关节 神经支配：尺神经深支(C8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Dorsal interosseous 3rd,R",
                                                                    "layer": "3",
                                                                    "c": "第三骨间背侧肌Dorsal interosseous 3rd,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：第1-5掌骨对缘 止点：第2-4指近节指骨和指背腱膜 主要作用：第2、4、5指外展，屈掌指关节、伸指骨间关节 神经支配：尺神经深支(C8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Dorsal interosseous 4th,R",
                                                                    "layer": "3",
                                                                    "c": "第四骨间背侧肌Dorsal interosseous 4th,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：第1-5掌骨对缘 止点：第2-4指近节指骨和指背腱膜 主要作用：第2、4、5指外展，屈掌指关节、伸指骨间关节 神经支配：尺神经深支(C8)"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Lumbricales,R",
                                                            "c": "右蚓状肌Lumbricales,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Lumbrical 1st,R",
                                                                    "layer": "2",
                                                                    "c": "第一蚓状肌Lumbrical 1st,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：指深屈肌腱桡侧 止点：第2-5指近节指骨背面及指背腱膜 主要作用：屈掌指关节和伸指骨间关节 神经支配：正中神经(C6-7)，尺神经深支(C8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Lumbrical 2nd,R",
                                                                    "layer": "2",
                                                                    "c": "第二蚓状肌Lumbrical 2nd,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：指深屈肌腱桡侧 止点：第2-5指近节指骨背面及指背腱膜 主要作用：屈掌指关节和伸指骨间关节 神经支配：正中神经(C6-7)，尺神经深支(C8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Lumbrical 3rd,R",
                                                                    "layer": "2",
                                                                    "c": "第三蚓状肌Lumbrical 3rd,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：指深屈肌腱桡侧 止点：第2-5指近节指骨背面及指背腱膜 主要作用：屈掌指关节和伸指骨间关节 神经支配：正中神经(C6-7)，尺神经深支(C8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Lumbrical 4th,R",
                                                                    "layer": "2",
                                                                    "c": "第四蚓状肌Lumbrical 4th,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：指深屈肌腱桡侧 止点：第2-5指近节指骨背面及指背腱膜 主要作用：屈掌指关节和伸指骨间关节 神经支配：正中神经(C6-7)，尺神经深支(C8)"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Palmar interossei,R",
                                                            "c": "右骨间掌侧肌Palmar interossei,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Palmar interosseous 1st,R",
                                                                    "layer": "3",
                                                                    "c": "第一骨间掌侧肌Palmar interosseous 1st,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：第2掌骨尺侧缘 止点：经示指尺侧止于指背腱膜 主要作用：2、4、5指内收，屈掌指关节、伸指骨间关节 神经支配：尺神经深支(C8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Palmar interosseous 2nd,R",
                                                                    "layer": "3",
                                                                    "c": "第二骨间掌侧肌Palmar interosseous 2nd,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：第4掌骨桡侧缘 止点：经4指桡侧止于指背腱膜 主要作用：2、4、5指内收，屈掌指关节、伸指骨间关节 神经支配：尺神经深支(C8)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Palmar interosseous 3rd,R",
                                                                    "layer": "3",
                                                                    "c": "第三骨间掌侧肌Palmar interosseous 3rd,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：第5掌骨桡侧缘 止点：经5指桡侧止于指背腱膜 主要作用：2、4、5指内收，屈掌指关节、伸指骨间关节 神经支配：尺神经深支(C8)"
                                                                }
                                                            }]
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    }]
                                }
                            }]
                        }
                    },
                    {
                        "$":
                        {
                            "o": "05Muscle of lower limb",
                            "c": "下肢肌Muscle of lower limb"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "Muscle of lower limb,L",
                                    "c": "左下肢肌Muscle of lower limb,L"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "01Muscle of hip,L",
                                            "c": "左髋肌Muscle of hip,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Anterior group (hip),L",
                                                    "c": "左髋肌前群Anterior group (hip),L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Iliopsoas,L",
                                                            "c": "左髂腰肌Iliopsoas,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "M_Iliacus,L",
                                                                    "layer": "5",
                                                                    "c": "髂肌Iliacus,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：髂窝 止点：股骨小转子 主要作用：前屈、外旋髋关节 神经支配：腰丛分支（L1-4）"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "M_Psoas major,L",
                                                                    "layer": "5",
                                                                    "c": "腰大肌Psoas major,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：腰椎体侧面和横突 止点：股骨小转子 主要作用：髋关节前屈和旋外，下肢固定时，使躯干和骨盆前屈 神经支配：腰丛神经分支"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Iliotibial tract,L",
                                                            "layer": "1",
                                                            "c": "髂胫束Iliotibial tract,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "髂胫束是包绕大腿的深筋膜-阔筋膜的外侧增厚部分。起自髂嵴前份的外侧缘，其上分为两层，包裹阔筋膜张肌，并与之紧密结合不宜分离。下部的纵行纤维明显增厚呈扁带状，后缘于臀大肌肌腱相延续。髂胫束下端附着于胫骨外侧髁、腓骨头和膝关节囊。临床上常用髂胫束作为体壁缺损、薄弱部或膝关节交叉韧带损伤等修补重建的材料。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Psoas minor,L",
                                                            "layer": "5",
                                                            "c": "腰小肌Psoas minor,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腰小肌：在人类出现率约占50%，起自第12胸椎，止于髂耻隆起。作用为紧张髂筋膜。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Tensor fasciae latae,L",
                                                            "layer": "1",
                                                            "c": "阔筋膜张肌Tensor fasciae latae,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：髂前上棘，髂嵴的一部分 止点：经髂胫束至胫骨外侧髁 主要作用：紧张阔筋膜并屈髋关节 神经支配：臀上神经（L4-S1）"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Posterior group (hip),L",
                                                    "c": "左髋肌后群Posterior group (hip),L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Gluteus maximus,L",
                                                            "layer": "1",
                                                            "c": "臀大肌Gluteus maximus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：髂骨翼外面后部、骶骨背面、骶结节韧带 止点：臀肌粗隆及髂胫束 主要作用：髋关节伸及外旋 神经支配：臀下神经及坐骨神经分支（L4-S2）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Gluteus medius,L",
                                                            "layer": "1",
                                                            "c": "臀中肌Gluteus medius,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：髂骨翼外面 止点：股骨大转子 主要作用：外展髋关节，前部肌束内旋髋关节，后部肌束外旋髋关节 神经支配：臀上神经（L4-S1）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Gluteus minimus,L",
                                                            "layer": "2",
                                                            "c": "臀小肌Gluteus minimus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：髂骨翼外面 止点：股骨大转子前缘 主要作用：外展髋关节，前部肌束内旋髋关节，后部肌束外旋髋关节 神经支配：臀上神经（L4-S1）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Inferior gemellus,L",
                                                            "layer": "2",
                                                            "c": "下孖肌Inferior gemellus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：坐骨小切迹邻近骨面 止点：股骨转子窝 主要作用：外旋髋关节 神经支配：骶丛分支（L4-S2）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Obturator externus,L",
                                                            "layer": "2",
                                                            "c": "闭孔外肌Obturator externus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：闭孔膜外面及其周围骨面 止点：股骨转子窝 主要作用：外旋髋关节 神经支配：闭孔神经及骶丛分支（L2-S5）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Obturator internus,L",
                                                            "layer": "2",
                                                            "c": "闭孔内肌Obturator internus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：闭孔膜内面及其周围骨面 止点：股骨转子窝 主要作用：外旋髋关节 神经支配：闭孔内肌神经（L5-S2）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Piriformis,L",
                                                            "layer": "2",
                                                            "c": "梨状肌Piriformis,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：第2-4骶椎前面的骶前孔两侧 止点：股骨大转子 主要作用：外展、外旋髋关节 神经支配：梨状肌神经（S1-2）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Quadratus femoris,L",
                                                            "layer": "2",
                                                            "c": "股方肌Quadratus femoris,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：坐骨结节 止点：转子间嵴 主要作用：外旋髋关节 神经支配：骶丛分支"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Superior gemellus,L",
                                                            "layer": "2",
                                                            "c": "上孖肌Superior gemellus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：坐骨小切迹邻近的骨面 止点：股骨转子窝 主要作用：外旋髋关节 神经支配：骶丛分支（L4-S2）"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "02Muscle of thigh,L",
                                            "c": "左大腿肌Muscle of thigh,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Anterior group (thigh),L",
                                                    "c": "左大腿肌前群Anterior group (thigh),L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Articularis genu,L",
                                                            "layer": "3",
                                                            "c": "膝关节肌Articularis genu,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "膝关节肌：起于股骨体下份前面，向下止于膝关节近侧端滑膜反折处的一小肌。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Sartorius,L",
                                                            "layer": "1",
                                                            "c": "缝匠肌Sartorius,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：髂前上棘 止点：胫骨体上端内侧面 主要作用：屈髋关节、内收外旋髋关节；屈并内旋膝关节 神经支配：股神经(L2-3)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Quadriceps femoris,L",
                                                            "c": "左股四头肌Quadriceps femoris,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "M_Rectus femoris,L",
                                                                    "layer": "1",
                                                                    "c": "股直肌Rectus femoris,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：髂前下棘及髋臼上缘 止点：四个头向下形成一个腱，包绕髌骨前面和两侧，向下延为髌韧带，止于胫骨粗隆 主要作用：伸膝关节，股直肌并可协助腰大肌屈膝关节 神经支配：股神经(L2-4)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Vastus intermedius,L",
                                                                    "layer": "2",
                                                                    "c": "股中间肌Vastus intermedius,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：股骨体前外侧面上3/4 止点：四个头向下形成一个腱，包绕髌骨前面和两侧，向下延为髌韧带，止于胫骨粗隆 主要作用：伸膝关节，股直肌并可协助腰大肌屈髋关节 神经支配：股神经(L2-4)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Vastus lateralis,L",
                                                                    "layer": "2",
                                                                    "c": "股外侧肌Vastus lateralis,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：股骨粗线外侧唇和转子间线 止点：四个头向下形成一个腱，包绕髌骨前面和两侧，向下延为髌韧带，止于胫骨粗隆 主要作用：伸膝关节，股直肌并可协助腰大肌屈髋关节 神经支配：股神经(L2-4)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Vastus medialis,L",
                                                                    "layer": "2",
                                                                    "c": "股内侧肌Vastus medialis,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：股骨粗线内侧唇和转子间线 止点：四个头向下形成一个腱，包绕髌骨前面和两侧，向下延为髌韧带，止于胫骨粗隆 主要作用：伸膝关节，股直肌并可协助腰大肌屈髋关节 神经支配：股神经(L2-4)"
                                                                }
                                                            }]
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Medial group (thigh),L",
                                                    "c": "左大腿肌内侧群Medial group (thigh),L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Adductor brevis,L",
                                                            "layer": "4",
                                                            "c": "短收肌Adductor brevis,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：耻骨下支 止点：股骨粗线内侧唇上部和耻骨肌线 主要作用：内收、外旋、微屈髋关节 神经支配：闭孔神经(L2-4)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Adductor longus,L",
                                                            "layer": "3",
                                                            "c": "长收肌Adductor longus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：耻骨上支前面、耻骨嵴下方 止点：股骨粗线内侧唇中1/3部 主要作用：内收、外旋、微屈髋关节 神经支配：闭孔神经(L2-4)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Adductor magnus,L",
                                                            "layer": "3",
                                                            "c": "大收肌Adductor magnus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：闭孔前下缘及坐骨结节 止点：股骨粗线内侧唇上2/3部，收肌结节 主要作用：内收、微屈髋关节 神经支配：闭孔神经(L2-4)、坐骨神经内侧支"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Gracilis,L",
                                                            "layer": "2",
                                                            "c": "股薄肌Gracilis,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：耻骨下支前面 止点：胫骨粗隆内侧 主要作用：内收髋关节，屈膝关节；协助内旋小腿 神经支配：闭孔神经(L2-4)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Pectineus,L",
                                                            "layer": "3",
                                                            "c": "耻骨肌Pectineus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：耻骨上支，耻骨梳附近 止点：股骨体的耻骨肌线小转子下方 主要作用：内收、外旋、微屈髋关节 神经支配：闭孔神经(L2-4)"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "03Posterior group (thigh),L",
                                                    "c": "左大腿肌后群Posterior group (thigh),L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Biceps femoris,short head,L",
                                                            "layer": "2",
                                                            "c": "股二头肌短头Biceps femoris,short head,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：股骨粗线外侧唇 止点：腓骨头外侧 主要作用：屈膝关节并使小腿微旋外 神经支配：坐骨神经（L5-S2）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Biceps femoris,long head,L",
                                                            "layer": "1",
                                                            "c": "股二头肌长头Biceps femoris,long head,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：坐骨结节 止点：腓骨头外侧 主要作用：伸髋关节、屈膝关节并使小腿微外旋 神经支配：坐骨神经（L5-S2）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Semimembranosus,L",
                                                            "layer": "2",
                                                            "c": "半膜肌Semimembranosus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：坐骨结节 止点：胫骨内侧髁后下面 主要作用：伸髋关节、屈膝关节，并使小腿微内旋 神经支配：坐骨神经（L5-S2）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Semitendinosus,L",
                                                            "layer": "1",
                                                            "c": "半腱肌Semitendinosus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：坐骨结节 止点：胫骨粗隆内侧 主要作用：伸髋关节、屈膝关节，并使小腿微内旋 神经支配：坐骨神经（L5-S2）"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "03Muscle of leg,L",
                                            "c": "左小腿肌Muscle of leg,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Anterior group (leg),L",
                                                    "c": "左小腿肌前群Anterior group (leg),L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Extensor digitorum longus,L",
                                                            "layer": "1",
                                                            "c": "趾长伸肌Extensor digitorum longus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：胫、腓骨上端骨间膜前面 止点：第2-5趾趾背腱膜，止于第5跖骨底者为第3腓骨肌 主要作用：伸第2-5趾、足背屈 神经支配：腓深神经（L4-S2）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Extensor hallucis longus,L",
                                                            "layer": "1",
                                                            "c": "拇长伸肌Extensor hallucis longus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：胫、腓骨上端骨间膜前面 止点：拇趾末节趾骨底 主要作用：伸拇指、足背屈 神经支配：腓深神经（L4-S2）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Fibularis(peroneus) tertius,L",
                                                            "layer": "3",
                                                            "c": "第三腓骨肌Fibularis (peroneus) tertius,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：腓骨前面下1/3部及骨间膜 止点：第5跖骨底背面 主要作用：协助背屈踝关节及足外翻 神经支配：腓深神经（L4-S2）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Tibialis anterior,L",
                                                            "layer": "1",
                                                            "c": "胫骨前肌Tibialis anterior,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：胫腓骨上端骨间膜前面 止点：内侧楔骨内面、第1跖骨底 主要作用：足背屈、内翻 神经支配：腓深神经（L4-S2）"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Lateral group (leg),L",
                                                    "c": "左小腿肌外侧群Lateral group (leg),L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Peroneus brevis,L",
                                                            "layer": "2",
                                                            "c": "腓骨短肌Peroneus brevis,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：腓骨外侧面下1/3部 止点：第5跖骨粗隆 主要作用：跖屈踝关节、足外翻 神经支配：腓浅神经（L5-S1）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Peroneus longus,L",
                                                            "layer": "2",
                                                            "c": "腓骨长肌Peroneus longus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：腓骨外侧面上2/3部 止点：内侧楔骨及第1跖骨底 主要作用：跖屈踝关节、足外翻 神经支配：腓浅神经（L5-S1）"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "03Posterior group (leg),L",
                                                    "c": "左小腿肌后群Posterior group (leg),L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "01Superficial layer,L",
                                                            "c": "左小腿肌后群浅层Superficial layer,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub":
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Triceps surae,L",
                                                                    "c": "左小腿三头肌Triceps surae,L"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Achilles tendon (tendo calcaneus),L",
                                                                            "layer": "1",
                                                                            "c": "跟腱Achilles tendon (tendo calcaneus),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "跟腱：腓肠肌和比目鱼肌共同构成全身最强大的腱。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Gastrocnemius(triceps surae,part),L",
                                                                            "layer": "1",
                                                                            "c": "腓肠肌Gastrocnemius (triceps surae,part),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "起点：内侧头：股骨内上髁；外侧头：股骨外上髁 止点：跟骨结节 主要作用：屈膝关节、足跖屈 神经支配：胫神经(L4-S3)"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Plantaris,L",
                                                                            "layer": "2",
                                                                            "c": "跖肌Plantaris,L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "起点：股骨外上髁、膝关节囊 止点：跟骨结节 主要作用：足跖屈 神经支配：胫神经（L4-S3）"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Soleus(triceps surae,part),L",
                                                                            "layer": "2",
                                                                            "c": "比目鱼肌Soleus (triceps surae,part),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "起点：腓骨上部后面、胫骨比目鱼肌线 止点：以跟腱止于跟骨结节 主要作用：跖屈踝关节 神经支配：胫神经（L4-S3）"
                                                                        }
                                                                    }]
                                                                }
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Leg Deep layer,L",
                                                            "c": "左小腿肌后群深层Deep layer,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Flexor digitorum longus,L",
                                                                    "layer": "3",
                                                                    "c": "趾长屈肌Flexor digitorum longus,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：胫、腓骨后面及骨间膜 止点：第2-5趾远节趾骨底 主要作用：屈第2-5趾、足跖屈 神经支配：胫神经（L4-S3）"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Flexor hallucis longus,L",
                                                                    "layer": "3",
                                                                    "c": "拇长屈肌Flexor hallucis longus,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：胫、腓骨后面及骨间膜 止点：拇指远节趾骨 主要作用：屈拇趾、足跖屈 神经支配：胫神经（L4-S3）"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Popliteus,L",
                                                                    "layer": "3",
                                                                    "c": "腘肌Popliteus,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：股骨外侧髁的外侧面上缘 止点：胫骨比目鱼肌线以上骨面 主要作用：屈膝关节、内旋小腿 神经支配：胫神经（L4-S3）"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Tibialis posterior,L",
                                                                    "layer": "3",
                                                                    "c": "胫骨后肌Tibialis posterior,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：胫、腓骨后面及骨间膜 止点���足舟骨粗隆，内侧、中间和外侧楔骨 主要作用：足内翻、跖屈 神经支配：胫神经（L4-S3）"
                                                                }
                                                            }]
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "04Muscle of foot,L",
                                            "c": "左足肌Muscle of foot,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Dorsum (foot),L",
                                                    "c": "左足背肌Dorsum (foot),L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Extensor digitorum brevis,L",
                                                            "layer": "2",
                                                            "c": "趾短伸肌Extensor digitorum brevis,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：跟骨前端的上面和外侧面 止点：第2-4趾近节趾骨底 主要作用：伸第2-4趾 神经支配：腓深神经（L4-S2）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Extensor hallucis brevis,L",
                                                            "layer": "2",
                                                            "c": "拇短伸肌Extensor hallucis brevis,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：跟骨前端的上面和外侧面 止点：拇趾近节趾骨底 主要作用：伸拇趾 神经支配：腓深神经（L4-S2）"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Plantar (foot),L",
                                                    "c": "左足底肌Plantar (foot),L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "01Medial group (plantar),L",
                                                            "c": "左足底肌内侧群Medial group (plantar),L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Abductor hallucis,L",
                                                                    "layer": "3",
                                                                    "c": "拇展肌Abductor hallucis,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：跟骨、足舟骨 止点：拇趾近节趾骨底 主要作用：外展拇趾 神经支配：足底内侧神经（S1-2）"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Adductor hallucis(oblique head),L",
                                                                    "layer": "5",
                                                                    "c": "拇收肌斜头Adductor hallucis (oblique head),L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：第2-4跖骨底面 止点：拇趾近节趾骨底 主要作用：内收和屈拇趾 神经支配：足底外侧神经(S2-3)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Adductor hallucis(transverse head),L",
                                                                    "layer": "5",
                                                                    "c": "拇收肌横头Adductor hallucis (transverse head),L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：第2-4跖骨底面 止点：拇趾近节趾骨底 主要作用：内收和屈拇趾 神经支配：足底外侧神经(S2-3)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Flexor hallucis brevis,L",
                                                                    "layer": "5",
                                                                    "c": "拇短屈肌Flexor hallucis brevis,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：内侧楔骨 止点：拇趾近节趾骨底 主要作用：屈拇趾 神经支配：足底内侧神经（S1-2）"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "02Lateral group (plantar),L",
                                                            "c": "左足底肌外侧群Lateral group (plantar),L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Abductor digiti minimi(foot),L",
                                                                    "layer": "3",
                                                                    "c": "小趾展肌Abductor digiti minimi(foot),L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：跟骨 止点：小趾近节趾骨底 主要作用：屈和外展小趾 神经支配：足底外侧神经（S2-3）"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Flexor digiti minimi brevis(foot),L",
                                                                    "layer": "5",
                                                                    "c": "小趾短屈肌Flexor digiti minimi brevis(foot),L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：第5跖骨底 止点：小趾近节趾骨底 主要作用：屈小趾 神经支配：足底外侧神经（S2-3）"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Opponens digiti minimi(foot),L",
                                                                    "layer": "5",
                                                                    "c": "小趾对跖肌Opponens digiti minimi(foot),L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：跖骨及跖长韧带 止点：第5跖骨 主要作用：外展、内收及屈小趾 神经支配：足底外侧神经"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "03Intermediate group (plantar),L",
                                                            "c": "左足底肌中间群Intermediate group (plantar),L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Dorsal interossei(foot),L",
                                                                    "layer": "5",
                                                                    "c": "骨间背侧肌Dorsal interossei(foot),L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：跖骨相对缘 止点：第2-4近节趾骨底和趾背腱膜 主要作用：外展2-4趾 神经支配：足底外侧神经"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Flexor digitorum brevis,L",
                                                                    "layer": "3",
                                                                    "c": "趾短屈肌Flexor digitorum brevis,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：跟骨 止点：第2-5中节趾骨底 主要作用：屈第2-5趾 神经支配：足底内侧神经"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Lumbricals(foot),L",
                                                                    "layer": "4",
                                                                    "c": "蚓状肌Lumbricals(foot),L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：趾长屈肌腱 止点：趾背腱膜 主要作用：屈跖趾关节、伸趾骨间关节 神经支配：足底内、外侧神经"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Plantar interossei,L",
                                                                    "layer": "5",
                                                                    "c": "骨间足底肌Plantar interossei,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：第3-5跖骨内侧半 止点：第3-5近节趾骨底和趾背腱膜 主要作用：内收3-5趾 神经支配：足底外侧神经"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Quadratus plantae,L",
                                                                    "layer": "5",
                                                                    "c": "足底方肌Quadratus plantae,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：跟骨 止点：趾长屈肌腱 主要作用：屈第2-5趾 神经支配：足底外侧神经"
                                                                }
                                                            }]
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Muscle of lower limb,R",
                                    "c": "右下肢肌Muscle of lower limb,R"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "01Muscle of hip,R",
                                            "c": "右髋肌Muscle of hip,R"
                                        },
                                        "ch":
                                        {
                                            "_": "0",
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Anterior group (hip),R",
                                                    "c": "右髋肌前群Anterior group (hip),R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Iliopsoas,R",
                                                            "c": "右髂腰肌Iliopsoas,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "M_Iliacus,R",
                                                                    "layer": "5",
                                                                    "c": "髂肌Iliacus,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：髂窝 止点：股骨小转子 主要作用：前屈、外旋髋关节 神经支配：腰丛分支（L1-4）"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "M_Psoas major,R",
                                                                    "layer": "5",
                                                                    "c": "腰大肌Psoas major,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：腰椎体侧面和横突 止点：股骨小转子 主要作用：髋关节前屈和旋外，下肢固定时，使躯干和骨盆前屈 神经支配：腰丛神经分支"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Iliotibial tract,R",
                                                            "layer": "1",
                                                            "c": "髂胫束Iliotibial tract,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "髂胫束是包绕大腿的深筋膜-阔筋膜的外侧增厚部分。起自髂嵴前份的外侧缘，其上分为两层，包裹阔筋膜张肌，并与之紧密结合不宜分离。下部的纵行纤维明显增厚呈扁带状，后缘于臀大肌肌腱相延续。髂胫束下端附着于胫骨外侧髁、腓骨头和膝关节囊。临床上常用髂胫束作为体壁缺损、薄弱部或膝关节交叉韧带损伤等修补重建的材料。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Psoas minor,R",
                                                            "layer": "5",
                                                            "c": "腰小肌Psoas minor,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腰小肌：在人类出现率约占50%，起自第12胸椎，止于髂耻隆起。作用为紧张髂筋膜。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Tensor fasciae latae,R",
                                                            "layer": "1",
                                                            "c": "阔筋膜张肌Tensor fasciae latae,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：髂前上棘，髂嵴的一部分 止点：经髂胫束至胫骨外侧髁 主要作用：紧张阔筋膜并屈髋关节 神经支配：臀上神经（L4-S1）"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Posterior group (hip),R",
                                                    "c": "右髋肌后群Posterior group (hip),R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Gluteus maximus,R",
                                                            "layer": "1",
                                                            "c": "臀大肌Gluteus maximus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：髂骨翼外面后部、骶骨背面、骶结节韧带 止点：臀肌粗隆及髂胫束 主要作用：髋关节伸及外旋 神经支配：臀下神经及坐骨神经分支（L4-S2）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Gluteus medius,R",
                                                            "layer": "1",
                                                            "c": "臀中肌Gluteus medius,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：髂骨翼外面 止点：股骨大转子 主要作用：外展髋关节，前部肌束内旋髋关节，后部肌束外旋髋关节 神经支配：臀上神经（L4-S1）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Gluteus minimus,R",
                                                            "layer": "2",
                                                            "c": "臀小肌Gluteus minimus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：髂骨翼外面 止点：股骨大转子前缘 主要作用：外展髋关节，前部肌束内旋髋关节，后部肌束外旋髋关节 神经支配：臀上神经（L4-S1）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Inferior gemellus,R",
                                                            "layer": "2",
                                                            "c": "下孖肌Inferior gemellus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：坐骨小切迹邻近骨面 止点：股骨转子窝 主要作用：外旋髋关节 神经支配：骶丛分支（L4-S2）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Obturator externus,R",
                                                            "layer": "4",
                                                            "c": "闭孔外肌Obturator externus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：闭孔膜外面及其周围骨面 止点：股骨转子窝 主要作用：外旋髋关节 神经支配：闭孔神经及骶丛分支（L2-S5）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Obturator internus,R",
                                                            "layer": "2",
                                                            "c": "闭孔内肌Obturator internus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：闭孔膜内面及其周围骨面 止点：股骨转子窝 主要作用：外旋髋关节 神经支配：闭孔内肌神经（L5-S2）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Piriformis,R",
                                                            "layer": "2",
                                                            "c": "梨状肌Piriformis,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：第2-4骶椎前面的骶前孔两侧 止点：股骨大转子 主要作用：外展、外旋髋关节 神经支配：梨状肌神经（S1-2）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Quadratus femoris,R",
                                                            "layer": "2",
                                                            "c": "股方肌Quadratus femoris,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：坐骨结节 止点：转子间嵴 主要作用：外旋髋关节 神经支配：骶丛分支"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Superior gemellus,R",
                                                            "layer": "2",
                                                            "c": "上孖肌Superior gemellus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：坐骨小切迹邻近的骨面 止点：股骨转子窝 主要作用：外旋髋关节 神经支配：骶丛分支（L4-S2）"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "02Muscle of thigh,R",
                                            "c": "右大腿肌Muscle of thigh,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Anterior group (thigh),R",
                                                    "c": "右大腿肌前群Anterior group (thigh),R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Articularis genu,R",
                                                            "layer": "3",
                                                            "c": "膝关节肌Articularis genu,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "膝关节肌：起于股骨体下份前面，向下止于膝关节近侧端滑膜反折处的一小肌。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Sartorius,R",
                                                            "layer": "1",
                                                            "c": "缝匠肌Sartorius,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：髂前上棘 止点：胫骨体上端内侧面 主要作用：屈髋关节、内收外旋髋关节；屈并内旋膝关节 神经支配：股神经(L2-3)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Quadriceps femoris,R",
                                                            "c": "右股四头肌Quadriceps femoris,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "M_Rectus femoris,R",
                                                                    "layer": "1",
                                                                    "c": "股直肌Rectus femoris,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：髂前下棘及髋臼上缘 止点：四个头向下形成一个腱，包绕髌骨前面和两侧，向下延为髌韧带，止于胫骨粗隆 主要作用：伸膝关节，股直肌并可协助腰大肌屈膝关节 神经支配：股神经(L2-4)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Vastus intermedius,R",
                                                                    "layer": "2",
                                                                    "c": "股中间肌Vastus intermedius,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：股骨体前外侧面上3/4 止点：四个头向下形成一个腱，包绕髌骨前面和两侧，向下延为髌韧带，止于胫骨粗隆 主要作用：伸膝关节，股直肌并可协助腰大肌屈髋关节 神经支配：股神经(L2-4)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Vastus lateralis,R",
                                                                    "layer": "2",
                                                                    "c": "股外侧肌Vastus lateralis,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：股骨粗线外侧唇和转子间线 止点：四个头向下形成一个腱，包绕髌骨前面和两侧，向下延为髌韧带，止于胫骨粗隆 主要作用：伸膝关节，股直肌并可协助腰大肌屈髋关节 神经支配：股神经(L2-4)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Vastus medialis,R",
                                                                    "layer": "2",
                                                                    "c": "股内侧肌Vastus medialis,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：股骨粗线内侧唇和转子间线 止点：四个头向下形成一个腱，包绕髌骨前面和两侧，向下延为髌韧带，止于胫骨粗隆 主要作用：伸膝关节，股直肌并可协助腰大肌屈髋关节 神经支配：股神经(L2-4)"
                                                                }
                                                            }]
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Medial group (thigh),R",
                                                    "c": "右大腿肌内侧群Medial group (thigh),R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Adductor brevis,R",
                                                            "layer": "4",
                                                            "c": "短收肌Adductor brevis,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：耻骨下支 止点：股骨粗线内侧唇上部和耻骨肌线 主要作用：内收、外旋、微屈髋关节 神经支配：闭孔神经(L2-4)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Adductor longus,R",
                                                            "layer": "3",
                                                            "c": "长收肌Adductor longus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：耻骨上支前面、耻骨嵴下方 止点：股骨粗线内侧唇中1/3部 主要作用：内收、外旋、微屈髋关节 神经支配：闭孔神经(L2-4)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Adductor magnus,R",
                                                            "layer": "3",
                                                            "c": "大收肌Adductor magnus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：闭孔前下缘及坐骨结节 止点：股骨粗线内侧唇上2/3部，收肌结节 主要作用：内收、微屈髋关节 神经支配：闭孔神经(L2-4)、坐骨神经内侧支"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Gracilis,R",
                                                            "layer": "2",
                                                            "c": "股薄肌Gracilis,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：耻骨下支前面 止点：胫骨粗隆内侧 主要作用：内收髋关节，屈膝关节；协助内旋小腿 神经支配：闭孔神经(L2-4)"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Pectineus,R",
                                                            "layer": "3",
                                                            "c": "耻骨肌Pectineus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：耻骨上支，耻骨梳附近 止点：股骨体的耻骨肌线小转子下方 主要作用：内收、外旋、微屈髋关节 神经支配：闭孔神经(L2-4)"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "03Posterior group (thigh),R",
                                                    "c": "右大腿肌后群Posterior group (thigh),R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Biceps femoris,short head,R",
                                                            "layer": "2",
                                                            "c": "股二头肌短头Biceps femoris,short head,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：股骨粗线外侧唇 止点：腓骨头外侧 主要作用：屈膝关节并使小腿微旋外 神经支配：坐骨神经（L5-S2）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Biceps femoris,long head,R",
                                                            "layer": "1",
                                                            "c": "股二头肌长头Biceps femoris,long head,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：坐骨结节 止点：腓骨头外侧 主要作用：伸髋关节、屈膝关节并使小腿微外旋 神经支配：坐骨神经（L5-S2）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Semimembranosus,R",
                                                            "layer": "2",
                                                            "c": "半膜肌Semimembranosus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：坐骨结节 止点：胫骨内侧髁后下面 主要作用：伸髋关节、屈膝关节，并使小腿微内旋 神经支配：坐骨神经（L5-S2）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Semitendinosus,R",
                                                            "layer": "1",
                                                            "c": "半腱肌Semitendinosus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：坐骨结节 止点：胫骨粗隆内侧 主要作用：伸髋关节、屈膝关节，并使小腿微内旋 神经支配：坐骨神经（L5-S2）"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "03Muscle of leg,R",
                                            "c": "右小腿肌Muscle of leg,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Anterior group (leg),R",
                                                    "c": "右小腿肌前群Anterior group (leg),R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Extensor digitorum longus,R",
                                                            "layer": "1",
                                                            "c": "趾长伸肌Extensor digitorum longus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：胫、腓骨上端骨间膜前面 止点：第2-5趾趾背腱膜，止于第5跖骨底者为第3腓骨肌 主要作用：伸第2-5趾、足背屈 神经支配：腓深神经（L4-S2）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Extensor hallucis longus,R",
                                                            "layer": "1",
                                                            "c": "拇长伸肌Extensor hallucis longus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：胫、腓骨上端骨间膜前面 止点：拇趾末节趾骨底 主要作用：伸拇指、足背屈 神经支配：腓深神经（L4-S2）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Fibularis(peroneus) tertius,R",
                                                            "layer": "3",
                                                            "c": "第三腓骨肌Fibularis (peroneus) tertius,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：腓骨前面下1/3部及骨间膜 止点：第5跖骨底背面 主要作用：协助背屈踝关节及足外翻 神经支配：腓深神经（L4-S2）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Tibialis anterior,R",
                                                            "layer": "1",
                                                            "c": "胫骨前肌Tibialis anterior,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：胫腓骨上端骨间膜前面 止点：内侧楔骨内面、第1跖骨底 主要作用：足背屈、内翻 神经支配：腓深神经（L4-S2）"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Lateral group (leg),R",
                                                    "c": "右小腿肌外侧群Lateral group (leg),R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Peroneus brevis,R",
                                                            "layer": "2",
                                                            "c": "腓骨短肌Peroneus brevis,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：腓骨外侧面下1/3部 止点：第5跖骨粗隆 主要作用：跖屈踝关节、足外翻 神经支配：腓浅神经（L5-S1）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Peroneus longus,R",
                                                            "layer": "2",
                                                            "c": "腓骨长肌Peroneus longus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：腓骨外侧面上2/3部 止点：内侧楔骨及第1跖骨底 主要作用：跖屈踝关节、足外翻 神经支配：腓浅神经（L5-S1）"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "03Posterior group (leg),R",
                                                    "c": "右小腿肌后群Posterior group (leg),R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "01Superficial layer,R",
                                                            "c": "右小腿肌后群浅层Superficial layer,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub":
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Triceps surae,R",
                                                                    "c": "右小腿三头肌Triceps surae,R"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Achilles tendon (tendo calcaneus),R",
                                                                            "layer": "1",
                                                                            "c": "跟腱Achilles tendon (tendo calcaneus),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "跟腱：腓肠肌和比目鱼肌共同构成全身最强大的腱。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Gastrocnemius(triceps surae,part),R",
                                                                            "layer": "1",
                                                                            "c": "腓肠肌Gastrocnemius (triceps surae,part),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "起点：内侧头：股骨内上髁；外侧头：股骨外上髁 止点：跟骨结节 主要作用：屈膝关节、足跖屈 神经支配：胫神经(L4-S3)"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Plantaris,R",
                                                                            "layer": "2",
                                                                            "c": "跖肌Plantaris,R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "起点：股骨外上髁、膝关节囊 止点：跟骨结节 主要作用：足跖屈 神经支配：胫神经（L4-S3）"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Soleus(triceps surae,part),R",
                                                                            "layer": "2",
                                                                            "c": "比目鱼肌Soleus (triceps surae,part),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "起点：腓骨上部后面、胫骨比目鱼肌线 止点：以跟腱止于跟骨结节 主要作用：跖屈踝关节 神经支配：胫神经（L4-S3）"
                                                                        }
                                                                    }]
                                                                }
                                                            }
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Leg Deep layer,R",
                                                            "c": "右小腿肌后群深层Deep layer,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Flexor digitorum longus,R",
                                                                    "layer": "3",
                                                                    "c": "趾长屈肌Flexor digitorum longus,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：胫、腓骨后面及骨间膜 止点：第2-5趾远节趾骨底 主要作用：屈第2-5趾、足跖屈 神经支配：胫神经（L4-S3）"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Flexor hallucis longus,R",
                                                                    "layer": "3",
                                                                    "c": "拇长屈肌Flexor hallucis longus,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：胫、腓骨后面及骨间膜 止点：拇指远节趾骨 主要作用：屈拇趾、足跖屈 神经支配：胫神经（L4-S3）"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Popliteus,R",
                                                                    "layer": "3",
                                                                    "c": "腘肌Popliteus,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：股骨外侧髁的外侧面上缘 止点：胫骨比目鱼肌线以上骨面 主要作用：屈膝关节、内旋小腿 神经支配：胫神经（L4-S3）"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Tibialis posterior,R",
                                                                    "layer": "3",
                                                                    "c": "胫骨后肌Tibialis posterior,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：胫、腓骨后面及骨间膜 止点：足舟骨粗隆，内侧、中间和外侧楔骨 主要作用：足内翻、跖屈 神经支配：胫神经（L4-S3）"
                                                                }
                                                            }]
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "04Muscle of foot,R",
                                            "c": "右足肌Muscle of foot,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Dorsum (foot),R",
                                                    "c": "右足背肌Dorsum (foot),R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Extensor digitorum brevis,R",
                                                            "layer": "2",
                                                            "c": "趾短伸肌Extensor digitorum brevis,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：跟骨前端的上面和外侧面 止点：第2-4趾近节趾骨底 主要作用：伸第2-4趾 神经支配：腓深神经（L4-S2）"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Extensor hallucis brevis,R",
                                                            "layer": "2",
                                                            "c": "拇短伸肌Extensor hallucis brevis,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "起点：跟骨前端的上面和外侧面 止点：拇趾近节趾骨底 主要作用：伸拇趾 神经支配：腓深神经（L4-S2）"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Plantar (foot),R",
                                                    "c": "右足底肌Plantar (foot),R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "01Medial group (plantar),R",
                                                            "c": "右足底肌内侧群Medial group (plantar),R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Abductor hallucis,R",
                                                                    "layer": "3",
                                                                    "c": "拇展肌Abductor hallucis,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：跟骨、足舟骨 止点：拇趾近节趾骨底 主要作用：外展拇趾 神经支配：足底内侧神经（S1-2）"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Adductor hallucis(oblique head),R",
                                                                    "layer": "5",
                                                                    "c": "拇收肌斜头Adductor hallucis(oblique head),R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：第2-4跖骨底面 止点：拇趾近节趾骨底 主要作用：内收和屈拇趾 神经支配：足底外侧神经(S2-3)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Adductor hallucis(transverse head),R",
                                                                    "layer": "5",
                                                                    "c": "拇收肌横头Adductor hallucis (transverse head),R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：第2-4跖骨底面 止点：拇趾近节趾骨底 主要作用：内收和屈拇趾 神经支配：足底外侧神经(S2-3)"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Flexor hallucis brevis,R",
                                                                    "layer": "5",
                                                                    "c": "拇短屈肌Flexor hallucis brevis,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：内侧楔骨 止点：拇趾近节趾骨底 主要作用：屈拇趾 神经支配：足底内侧神经（S1-2）"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "02Lateral group (plantar),R",
                                                            "c": "右足底肌外侧群Lateral group (plantar),R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Abductor digiti minimi(foot),R",
                                                                    "layer": "3",
                                                                    "c": "小趾展肌Abductor digiti minimi(foot),R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：跟骨 止点：小趾近节趾骨底 主要作用：屈和外展小趾 神经支配：足底外侧神经（S2-3）"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Flexor digiti minimi brevis(foot),R",
                                                                    "layer": "5",
                                                                    "c": "小趾短屈肌Flexor digiti minimi brevis(foot),R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：第5跖骨底 止点：小趾近节趾骨底 主要作用：屈小趾 神经支配：足底外侧神经（S2-3）"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Opponens digiti minimi(foot),R",
                                                                    "layer": "5",
                                                                    "c": "小趾对跖肌Opponens digiti minimi(foot),R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：跖骨及跖长韧带 止点：第5跖骨 主要作用：外展、内收及屈小趾 神经支配：足底外侧神经"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "03Intermediate group (plantar),R",
                                                            "c": "右足底肌中间群Intermediate group (plantar),R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Dorsal interossei(foot),R",
                                                                    "layer": "5",
                                                                    "c": "骨间背侧肌Dorsal interossei(foot),R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：跖骨相对缘 止点：第2-4近节趾骨底和趾背腱膜 主要作用：外展2-4趾 神经支配：足底外侧神经"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Flexor digitorum brevis,R",
                                                                    "layer": "3",
                                                                    "c": "趾短屈肌Flexor digitorum brevis,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：跟骨 止点：第2-5中节趾骨底 主要作用：屈第2-5趾 神经支配：足底内侧神经"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Lumbricals(foot),R",
                                                                    "layer": "4",
                                                                    "c": "蚓状肌Lumbricals(foot),R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：趾长屈肌腱 止点：趾背腱膜 主要作用：屈跖趾关节、伸趾骨间关节 神经支配：足底内、外侧神经"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Plantar interossei,R",
                                                                    "layer": "5",
                                                                    "c": "骨间足底肌Plantar interossei,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：第3-5跖骨内侧半 止点：第3-5近节趾骨底和趾背腱膜 主要作用：内收3-5趾 神经支配：足底外侧神经"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Quadratus plantae,R",
                                                                    "layer": "5",
                                                                    "c": "足底方肌Quadratus plantae,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "起点：跟骨 止点：趾长屈肌腱 主要作用：屈第2-5趾 神经支配：足底外侧神经"
                                                                }
                                                            }]
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    }]
                                }
                            }]
                        }
                    },
                    {
                        "$":
                        {
                            "o": "06Perineal muscle",
                            "c": "会阴肌Perineal muscle"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "Anal sphincter,internal,L",
                                    "layer": "4",
                                    "c": "肛门内括约肌Anal sphincter,internal,L"
                                },
                                "t":
                                {
                                    "s": "肛门内括约肌：直肠壁环形肌增厚形成的平滑肌管。环绕肛管上3/4，具有协助排便，但无括约肛门的作用。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Anal sphincter,internal,R",
                                    "layer": "4",
                                    "c": "肛门内括约肌Anal sphincter,internal,R"
                                },
                                "t":
                                {
                                    "s": "肛门内括约肌：直肠壁环形肌增厚形成的平滑肌管。环绕肛管上3/4，具有协助排便，但无括约肛门的作用。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_Anal sphincter,external,L",
                                    "layer": "5",
                                    "c": "肛门外括约肌Anal sphincter,external,L"
                                },
                                "t":
                                {
                                    "s": "肛门外括约肌：为环绕肛门内括约肌周围的横纹肌，按其纤维的位置又可分为：①皮下部：位于肛管下端的皮下、肛门内括约肌的下缘和外括约肌浅部的下方，肌束呈环行，前方附着于会阴中心腱，后方附着于肛尾韧带；②浅部：在皮下部之上，肌束围绕肛门内括约肌下部，前方附着于会阴中心腱，后方附着于尾骨下部及肛尾韧带；③深部：肌束呈厚的环行带，围绕肛门内括约肌上部，其深层纤维与耻骨直肠肌混合而不能分隔。其前方的许多纤维交叉进入会阴浅横肌，后方的纤维多附着于肛尾韧带。肛门外括约肌受意识支配，有较强的控制排便功能。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_Anal sphincter,external,R",
                                    "layer": "5",
                                    "c": "肛门外括约肌Anal sphincter,external,R"
                                },
                                "t":
                                {
                                    "s": "肛门外括约肌：为环绕肛门内括约肌周围的横纹肌，按其纤维的位置又可分为：①皮下部：位于肛管下端的皮下、肛门内括约肌的下缘和外括约肌浅部的下方，肌束呈环行，前方附着于会阴中心腱，后方附着于肛尾韧带；②浅部：在皮下部之上，肌束围绕肛门内括约肌下部，前方附着于会阴中心腱，后方附着于尾骨下部及肛尾韧带；③深部：肌束呈厚的环行带，围绕肛门内括约肌上部，其深层纤维与耻骨直肠肌混合而不能分隔。其前方的许多纤维交叉进入会阴浅横肌，后方的纤维多附着于肛尾韧带。肛门外括约肌受意识支配，有较强的控制排便功能。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_Anococcygeal ligament",
                                    "layer": "5",
                                    "c": "肛尾韧带Anococcygeal ligament"
                                },
                                "t":
                                {
                                    "s": "肛尾韧带:肛管后连接尾骨与肛管之间的结缔组织束。主要由外括约肌的深部和浅部肌纤维组成。在临床上可分隔为肛门后深、浅间隙。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_Perineal central tendon",
                                    "layer": "5",
                                    "c": "会阴中心腱Perineal central tendon"
                                },
                                "t":
                                {
                                    "s": "会阴中心腱：又称会阴体(perineal body)，为纤维肌性组织，男性位于肛门与阴茎根之间，女性位于肛门与阴道前庭后端之间。在矢状位上，呈楔形，尖朝上，底朝下，深约3-4cm。于此处起止的肌有：肛门外括约肌、球海绵体肌、会阴浅横肌、会阴深横肌、尿道阴道括约肌（男性为尿道括约肌）及肛提肌。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_Coccygeus(ischiococcygeus),L",
                                    "layer": "5",
                                    "c": "尾骨肌Coccygeus(ischiococcygeus),L"
                                },
                                "t":
                                {
                                    "s": "尾骨肌：起自坐骨棘，止于骶骨下端和尾骨的外侧缘，覆于骶棘韧带的上面。参与构成盆底，并对骶骨和尾骨有固定作用。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_Coccygeus(ischiococcygeus),R",
                                    "layer": "5",
                                    "c": "尾骨肌Coccygeus(ischiococcygeus),R"
                                },
                                "t":
                                {
                                    "s": "尾骨肌：起自坐骨棘，止于骶骨下端和尾骨的外侧缘，覆于骶棘韧带的上面。参与构成盆底，并对骶骨和尾骨有固定作用。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_Deep transverse perineal,L",
                                    "layer": "4",
                                    "c": "会阴深横肌Deep transverse perineal,L"
                                },
                                "t":
                                {
                                    "s": "会阴深横肌：位于尿生殖膈两层筋膜之间，肌束横行，张于两侧坐骨支之间，肌纤维在中线上互相交织，部分纤维止于会阴中心腱，收缩时可加强会阴中心腱的稳固性。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_Deep transverse perineal,R",
                                    "layer": "4",
                                    "c": "会阴深横肌Deep transverse perineal,R"
                                },
                                "t":
                                {
                                    "s": "会阴深横肌：位于尿生殖膈两层筋膜之间，肌束横行，张于两侧坐骨支之间，肌纤维在中线上互相交织，部分纤维止于会阴中心腱，收缩时可加强会阴中心腱的稳固性。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_Iliococcygeus(part of levator ani),L",
                                    "layer": "5",
                                    "c": "髂尾肌Iliococcygeus(part of levator ani),L"
                                },
                                "t":
                                {
                                    "s": "髂尾肌：起于肛提肌腱弓后份和坐骨棘盆面，止于肛尾韧带以及尾骨侧缘。具有固定直肠的作用。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_Iliococcygeus(part of levator ani),R",
                                    "layer": "5",
                                    "c": "髂尾肌Iliococcygeus(part of levator ani),R"
                                },
                                "t":
                                {
                                    "s": "髂尾肌：起于肛提肌腱弓后份和坐骨棘盆面，止于肛尾韧带以及尾骨侧缘。具有固定直肠的作用。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_Prerectal fibers(part of levator ani),L",
                                    "layer": "5",
                                    "c": "直肠前纤维Prerectal fibers(part of levator ani),L"
                                },
                                "t":
                                {
                                    "s": ""
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_Prerectal fibers(part of levator ani),R",
                                    "layer": "5",
                                    "c": "直肠前纤维Prerectal fibers(part of levator ani),R"
                                },
                                "t":
                                {
                                    "s": ""
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_Pubococcygeus(part of levator ani),L",
                                    "layer": "4",
                                    "c": "耻尾肌Pubococcygeus(part of levator ani),L"
                                },
                                "t":
                                {
                                    "s": "耻尾肌：肛提肌的重要部分，分为提肌板和肛门悬韧带两部分。起于耻骨背面，盆筋膜腱弓前部，两侧束在肛尾缝交叉成一致密的腱膜，对盆腔脏器有坚强的支持作用，少数纤维不交叉直接附着于尾骨尖。耻骨肌纤维在靠近肛管直肠结合处，沿肛管向下延伸，形成肛管的纵肌。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_Pubococcygeus(part of levator ani),R",
                                    "layer": "4",
                                    "c": "耻尾肌Pubococcygeus(part of levator ani),R"
                                },
                                "t":
                                {
                                    "s": "耻尾肌：肛提肌的重要部分，分为提肌板和肛门悬韧带两部分。起于耻骨背面，盆筋膜腱弓前部，两侧束在肛尾缝交叉成一致密的腱膜，对盆腔脏器有坚强的支持作用，少数纤维不交叉直接附着于尾骨尖。耻骨肌纤维在靠近肛管直肠结合处，沿肛管向下延伸，形成肛管的纵肌。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_Puborectalis(part of levator ani),L",
                                    "layer": "5",
                                    "c": "耻骨直肠肌Puborectalis(part of levator ani),L"
                                },
                                "t":
                                {
                                    "s": "耻骨直肠肌：起自耻骨盆面和肛提肌腱弓前份，向后止于肛管侧壁、后壁及会阴中心腱的肌肉。在直肠肛管移行处，两侧肌束构成“U”形袢，是肛直肠环的主要组成部分。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_Puborectalis(part of levator ani),R",
                                    "layer": "5",
                                    "c": "耻骨直肠肌Puborectalis(part of levator ani),R"
                                },
                                "t":
                                {
                                    "s": "耻骨直肠肌：起自耻骨盆面和肛提肌腱弓前份，向后止于肛管侧壁、后壁及会阴中心腱的肌肉。在直肠肛管移行处，两侧肌束构成“U”形袢，是肛直肠环的主要组成部分。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_Superficial transverse perineal,L",
                                    "layer": "5",
                                    "c": "会阴浅横肌Superficial transverse perineal,L"
                                },
                                "t":
                                {
                                    "s": "会阴浅横肌：一条起于坐骨结节，横行向内，止于会阴中心腱的狭窄肌肉。几乎是横向穿过肛管前方的会阴浅间隙。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_Superficial transverse perineal,R",
                                    "layer": "5",
                                    "c": "会阴浅横肌Superficial transverse perineal,R"
                                },
                                "t":
                                {
                                    "s": "会阴浅横肌：一条起于坐骨结节，横行向内，止于会阴中心腱的狭窄肌肉。几乎是横向穿过肛管前方的会阴浅间隙。"
                                }
                            }]
                        }
                    },
                    {
                        "$":
                        {
                            "o": "07Synovial bursa",
                            "c": "滑囊Synovial bursa"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "01Bursae of the shoulder joint,L",
                                    "c": "左肩关节囊Bursae of the shoulder joint,L"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Subacromial bursa,L",
                                            "layer": "5",
                                            "c": "肩峰下囊Subacromial bursa,L"
                                        },
                                        "t":
                                        {
                                            "s": "肩峰下囊：位于肩峰与冈上肌腱之间的滑膜囊，向前可延至喙肩韧带的下方。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Subcoracoid bursa,L",
                                            "layer": "5",
                                            "c": "喙突下囊Subcoracoid bursa,L"
                                        },
                                        "t":
                                        {
                                            "s": "喙突下囊：分为内外两个滑囊，二者相连，外侧滑囊后面是肩胛下肌肌腱，前面有小部分到肱骨小结节，下部由内及外为：喙肱肌、肱二头肌短头、三角肌，上部为：肩胛骨喙突、三角肌、喙肩韧带；内侧滑囊上后壁为肩胛骨喙突，前外侧壁为肩胛下肌上缘。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Subcutaneous acromial bursa,L",
                                            "layer": "5",
                                            "c": "肩峰皮下囊Subcutaneous acromial bursa,L"
                                        },
                                        "t":
                                        {
                                            "s": "肩峰皮下囊：位于皮肤与肩峰背面之间的滑膜囊。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Subdeltoid bursa,L",
                                            "layer": "5",
                                            "c": "三角肌下囊Subdeltoid bursa,L"
                                        },
                                        "t":
                                        {
                                            "s": "三角肌下囊：位于三角肌中部上份与肱骨大结节之间的滑膜囊。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Subscapularis bursa,L",
                                            "layer": "5",
                                            "c": "肩胛下肌囊Subscapularis bursa,L"
                                        },
                                        "t":
                                        {
                                            "s": "肩胛下肌囊：位于肩胛下肌腱和关节囊之间的滑膜囊。"
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "02Bursae of the shoulder joint,R",
                                    "c": "右肩关节囊Bursae of the shoulder joint,R"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Subacromial bursa,R",
                                            "layer": "5",
                                            "c": "肩峰下囊Subacromial bursa,R"
                                        },
                                        "t":
                                        {
                                            "s": "肩峰下囊：位于肩峰与冈上肌腱之间的滑膜囊，向前可延至喙肩韧带的下方。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Subcoracoid bursa,R",
                                            "layer": "5",
                                            "c": "喙突下囊Subcoracoid bursa,R"
                                        },
                                        "t":
                                        {
                                            "s": "喙突下囊：分为内外两个滑囊，二者相连，外侧滑囊后面是肩胛下肌肌腱，前面有小部分到肱骨小结节，下部由内及外为：喙肱肌、肱二头肌短头、三角肌，上部为：肩胛骨喙突、三角肌、喙肩韧带；内侧滑囊上后壁为肩胛骨喙突，前外侧壁为肩胛下肌上缘。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Subcutaneous acromial bursa,R",
                                            "layer": "5",
                                            "c": "肩峰皮下囊Subcutaneous acromial bursa,R"
                                        },
                                        "t":
                                        {
                                            "s": "肩峰皮下囊：位于皮肤与肩峰背面之间的滑膜囊。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Subdeltoid bursa,R",
                                            "layer": "5",
                                            "c": "三角肌下囊Subdeltoid bursa,R"
                                        },
                                        "t":
                                        {
                                            "s": "三角肌下囊：位于三角肌中部上份与肱骨大结节之间的滑膜囊。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Subscapularis bursa,R",
                                            "layer": "5",
                                            "c": "肩胛下肌囊Subscapularis bursa,R"
                                        },
                                        "t":
                                        {
                                            "s": "肩胛下肌囊：位于肩胛下肌腱和关节囊之间的滑膜囊。"
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "03Bursae of the elbow joint,L",
                                    "c": "左肘关节滑囊Bursae of the elbow joint,L"
                                },
                                "ch":
                                {
                                    "sub":
                                    {
                                        "$":
                                        {
                                            "o": "Subcutaneous bursa of olecranon,L",
                                            "layer": "5",
                                            "c": "鹰嘴皮下囊Subcutaneous bursa of olecranon,L"
                                        },
                                        "t":
                                        {
                                            "s": "鹰嘴皮下囊：位于尺骨鹰嘴和皮肤之间的滑膜囊。位置表浅。"
                                        }
                                    }
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "04Bursae of the elbow joint,R",
                                    "c": "右肘关节滑囊Bursae of the elbow joint,R"
                                },
                                "ch":
                                {
                                    "sub":
                                    {
                                        "$":
                                        {
                                            "o": "Subcutaneous bursa of olecranon,R",
                                            "layer": "5",
                                            "c": "鹰嘴皮下囊Subcutaneous bursa of olecranon,R"
                                        },
                                        "t":
                                        {
                                            "s": "鹰嘴皮下囊：位于尺骨鹰嘴和皮肤之间的滑膜囊。位置表浅。"
                                        }
                                    }
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "05Bursae of the hip,L",
                                    "c": "左髋关节滑囊Bursae of the hip,L"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Trochanteric bursa of gluteus medius,L",
                                            "layer": "5",
                                            "c": "臀中肌转子囊Trochanteric bursa of gluteus medius,L"
                                        },
                                        "t":
                                        {
                                            "s": "臀中肌转子囊：位于臀中肌止腱与股骨大转子之间。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Trochanteric bursa of gluteus maximus,L",
                                            "layer": "5",
                                            "c": "臀大肌转子囊Trochanteric bursa of gluteus maximus,L"
                                        },
                                        "t":
                                        {
                                            "s": "臀大肌转子囊：位于臀大肌腱与股骨大转子之间的滑膜囊。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Iliopectineal bursa,L",
                                            "layer": "5",
                                            "c": "髂耻囊Iliopectineal bursa,L"
                                        },
                                        "t":
                                        {
                                            "s": "髂耻囊：位于腰大肌与髂耻隆起和髋关节囊之间的滑膜囊。常与髋关节腔相交通。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Ischiogluteal bursa,L",
                                            "layer": "5",
                                            "c": "坐骨结节囊Ischiogluteal bursa,L"
                                        },
                                        "t":
                                        {
                                            "s": "坐骨结节囊：也称“臀大肌坐骨囊”，位于臀大肌与坐骨结节之间。"
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "06Bursae of the hip,R",
                                    "c": "右髋关节滑囊Bursae of the hip,R"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Trochanteric bursa of gluteus medius,R",
                                            "layer": "5",
                                            "c": "臀中肌转子囊Trochanteric bursa of gluteus medius,R"
                                        },
                                        "t":
                                        {
                                            "s": "臀中肌转子囊：位于臀中肌止腱与股骨大转子之间。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Trochanteric bursa of gluteus maximus,R",
                                            "layer": "5",
                                            "c": "臀大肌转子囊Trochanteric bursa of gluteus maximus,R"
                                        },
                                        "t":
                                        {
                                            "s": "臀大肌转子囊：位于臀大肌腱与股骨大转子之间的滑膜囊。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Iliopectineal bursa,R",
                                            "layer": "5",
                                            "c": "髂耻囊Iliopectineal bursa,R"
                                        },
                                        "t":
                                        {
                                            "s": "髂耻囊：位于腰大肌与髂耻隆起和髋关节囊之间的滑膜囊。常与髋关节腔相交通。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Ischiogluteal bursa,R",
                                            "layer": "5",
                                            "c": "坐骨结节囊Ischiogluteal bursa,R"
                                        },
                                        "t":
                                        {
                                            "s": "坐骨结节囊：也称“臀大肌坐骨囊”，位于臀大肌与坐骨结节之间。"
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "07Bursae of the knee joint,L",
                                    "c": "左膝关节滑囊Bursae of the knee joint,L"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Deep infrapatellar bursa,L",
                                            "layer": "5",
                                            "c": "髌下深囊Deep infrapatellar bursa,L"
                                        },
                                        "t":
                                        {
                                            "s": "髌下深囊：位于髌韧带与胫骨前面之间的滑膜囊。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Inferior subtendinous bursa of biceps femoris,L",
                                            "layer": "5",
                                            "c": "股二头肌下腱下囊Inferior subtendinous bursa of biceps femoris,L"
                                        },
                                        "t":
                                        {
                                            "s": "股二头肌下腱下囊：位于股二头肌腱与膝关节腓侧副韧带之间的滑膜囊。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Fibulopopliteal bursa,L",
                                            "layer": "5",
                                            "c": "腓腘囊Fibulopopliteal bursa,L"
                                        },
                                        "t":
                                        {
                                            "s": "腓腘囊：膝关节腓侧副韧带与腘肌腱之间的滑膜囊。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Subtendinous bursa of lateral head of gastrocnemius,L",
                                            "layer": "5",
                                            "c": "腓肠肌外侧头腱下囊Subtendinous bursa of lateral head of gastrocnemius,L"
                                        },
                                        "t":
                                        {
                                            "s": "腓肠肌外侧头腱下囊：位于腓肠肌外侧头起始腱与膝关节囊之间的滑膜囊。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Subtendinous bursa of medial head of gastrocnemius,L",
                                            "layer": "5",
                                            "c": "腓肠肌内侧头腱下囊Subtendinous bursa of medial head of gastrocnemius,L"
                                        },
                                        "t":
                                        {
                                            "s": "腓肠肌内侧头腱下囊：位于腓肠肌内侧头起始腱与膝关节囊之间的滑膜囊。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Semimembranosus bursa,L",
                                            "layer": "5",
                                            "c": "半膜肌囊Semimembranosus bursa,L"
                                        },
                                        "t":
                                        {
                                            "s": "半膜肌囊：位于半膜肌止腱与膝关节囊之间的滑膜囊。有时与膝关节腔相交通。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Subpopliteal(racess) bursa,L",
                                            "layer": "5",
                                            "c": "腘肌下隐窝Subpopliteal (racess) bursa,L"
                                        },
                                        "t":
                                        {
                                            "s": "腘肌下隐窝：又称“腘肌囊”。位于股骨外侧髁上方，腘肌起始部与膝关节囊之间的滑膜囊。常与膝关节腔相通。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Anserine bursa,L",
                                            "layer": "5",
                                            "c": "鹅足囊Anserine bursa,L"
                                        },
                                        "t":
                                        {
                                            "s": "鹅足囊：位于膝关节内侧，缝匠肌、股薄肌和半腱肌三条肌腱与胫侧副韧带之间的滑膜囊。由于三条肌腱之间有致密纤维膜相连，形似鹅足，故名。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Subcutaneous infrapatellar bursa,L",
                                            "layer": "5",
                                            "c": "髌下皮下囊Subcutaneous infrapatellar bursa,L"
                                        },
                                        "t":
                                        {
                                            "s": "髌下皮下囊：位于胫骨粗隆下部和皮肤之间的滑膜囊。不恒定，与关节腔不相通。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Subcutaneous prepatellar bursa,L",
                                            "layer": "5",
                                            "c": "髌前皮下囊Subcutaneous prepatellar bursa,L"
                                        },
                                        "t":
                                        {
                                            "s": "髌前皮下囊：位于髌骨前面皮下的滑膜囊。较大，与关节腔不相通。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Suprapatellar bursa,L",
                                            "layer": "5",
                                            "c": "髌上囊Suprapatellar bursa,L"
                                        },
                                        "t":
                                        {
                                            "s": "髌上囊：膝部最大的滑膜囊。自关节腔向上呈囊状膨出，位于股骨体下部和股四头肌腱之间。"
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "08Bursae of the knee joint,R",
                                    "c": "右膝关节滑囊Bursae of the knee joint,R"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Deep infrapatellar bursa,R",
                                            "layer": "5",
                                            "c": "髌下深囊Deep infrapatellar bursa,R"
                                        },
                                        "t":
                                        {
                                            "s": "髌下深囊：位于髌韧带与胫骨前面之间的滑膜囊。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Inferior subtendinous bursa of biceps femoris,R",
                                            "layer": "5",
                                            "c": "股二头肌下腱下囊Inferior subtendinous bursa of biceps femoris,R"
                                        },
                                        "t":
                                        {
                                            "s": "股二头肌下腱下囊：位于股二头肌腱与膝关节腓侧副韧带之间的滑膜囊。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Fibulopopliteal bursa,R",
                                            "layer": "5",
                                            "c": "腓腘囊Fibulopopliteal bursa,R"
                                        },
                                        "t":
                                        {
                                            "s": "腓腘囊：膝关节腓侧副韧带与腘肌腱之间的滑膜囊。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Subtendinous bursa of lateral head of gastrocnemius,R",
                                            "layer": "5",
                                            "c": "腓肠肌外侧头腱下囊Subtendinous bursa of lateral head of gastrocnemius,R"
                                        },
                                        "t":
                                        {
                                            "s": "腓肠肌外侧头腱下囊：位于腓肠肌外侧头起始腱与膝关节囊之间的滑膜囊。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Subtendinous bursa of medial head of gastrocnemius,R",
                                            "layer": "5",
                                            "c": "腓肠肌内侧头腱下囊Subtendinous bursa of medial head of gastrocnemius,R"
                                        },
                                        "t":
                                        {
                                            "s": "腓肠肌内侧头腱下囊：位于腓肠肌内侧头起始腱与膝关节囊之间的滑膜囊。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Semimembranosus bursa,R",
                                            "layer": "5",
                                            "c": "半膜肌囊Semimembranosus bursa,R"
                                        },
                                        "t":
                                        {
                                            "s": "半膜肌囊：位于半膜肌止腱与膝关节囊之间的滑膜囊。有时与膝关节腔相交通。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Subpopliteal(racess) bursa,R",
                                            "layer": "5",
                                            "c": "腘肌下隐窝Subpopliteal (racess) bursa,R"
                                        },
                                        "t":
                                        {
                                            "s": "腘肌下隐窝：又称“腘肌囊”。位于股骨外侧髁上方，腘肌起始部与膝关节囊之间的滑膜囊。常与膝关节腔相通。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Anserine bursa,R",
                                            "layer": "5",
                                            "c": "鹅足囊Anserine bursa,R"
                                        },
                                        "t":
                                        {
                                            "s": "鹅足囊：位于膝关节内侧，缝匠肌、股薄肌和半腱肌三条肌腱与胫侧副韧带之间的滑膜囊。由于三条肌腱之间有致密纤维膜相连，形似鹅足，故名。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Subcutaneous infrapatellar bursa,R",
                                            "layer": "5",
                                            "c": "髌下皮下囊Subcutaneous infrapatellar bursa,R"
                                        },
                                        "t":
                                        {
                                            "s": "髌下皮下囊：位于胫骨粗隆下部和皮肤之间的滑膜囊。不恒定，与关节腔不相通。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Subcutaneous prepatellar bursa,R",
                                            "layer": "5",
                                            "c": "髌前皮下囊Subcutaneous prepatellar bursa,R"
                                        },
                                        "t":
                                        {
                                            "s": "髌前皮下囊：位于髌骨前面皮下的滑膜囊。较大，与关节腔不相通。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Suprapatellar bursa,R",
                                            "layer": "5",
                                            "c": "髌上囊Suprapatellar bursa,R"
                                        },
                                        "t":
                                        {
                                            "s": "髌上囊：膝部最大的滑膜囊。自关节腔向上呈囊状膨出，位于股骨体下部和股四头肌腱之间。"
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "09Bursae of the foot,L",
                                    "c": "足部滑囊Bursae of the foot,L"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Calcaneal bursa,L",
                                            "layer": "5",
                                            "c": "跟骨下囊Calcaneal bursa,L"
                                        },
                                        "t":
                                        {
                                            "s": ""
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Bursa of tendo calcaneus,L",
                                            "layer": "5",
                                            "c": "跟腱囊Bursa of tendo calcaneus,L"
                                        },
                                        "t":
                                        {
                                            "s": "跟腱囊：位于跟骨后面与跟腱之间的滑膜囊。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Subcutaneous calcaneal bursa,L",
                                            "layer": "5",
                                            "c": "跟皮下囊Subcutaneous calcaneal bursa,L"
                                        },
                                        "t":
                                        {
                                            "s": "跟皮下囊：位于跟骨后面与皮肤之间的滑膜囊。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Subcutaneous bursa of lateral malleolus,L",
                                            "layer": "5",
                                            "c": "外踝皮下囊Subcutaneous bursa of lateral malleolus,L"
                                        },
                                        "t":
                                        {
                                            "s": "外踝皮下囊：位于外踝与皮肤之间的滑膜囊。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Subcutaneous bursa of medial malleolus,L",
                                            "layer": "5",
                                            "c": "内踝皮下囊Subcutaneous bursa of medial malleolus,L"
                                        },
                                        "t":
                                        {
                                            "s": "内踝皮下囊：位于内踝与皮肤之间的滑膜囊。"
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "10Bursae of the foot,R",
                                    "c": "足部滑囊Bursae of the foot,R"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Calcaneal bursa,R",
                                            "layer": "5",
                                            "c": "跟骨下囊Calcaneal bursa,R"
                                        },
                                        "t":
                                        {
                                            "s": ""
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Bursa of tendo calcaneus,R",
                                            "layer": "5",
                                            "c": "跟腱囊Bursa of tendo calcaneus,R"
                                        },
                                        "t":
                                        {
                                            "s": ""
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Subcutaneous calcaneal bursa,R",
                                            "layer": "5",
                                            "c": "跟皮下囊Subcutaneous calcaneal bursa,R"
                                        },
                                        "t":
                                        {
                                            "s": ""
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Subcutaneous bursa of lateral malleolus,R",
                                            "layer": "5",
                                            "c": "外踝皮下囊Subcutaneous bursa of lateral malleolus,R"
                                        },
                                        "t":
                                        {
                                            "s": ""
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Subcutaneous bursa of medial malleolus,R",
                                            "layer": "5",
                                            "c": "内踝皮下囊Subcutaneous bursa of medial malleolus,R"
                                        },
                                        "t":
                                        {
                                            "s": ""
                                        }
                                    }]
                                }
                            }]
                        }
                    }]
                }
            },
            {
                "$":
                {
                    "o": "004Aticulation",
                    "c": "骨连结Aticulation"
                },
                "ch":
                {
                    "sub": [
                    {
                        "$":
                        {
                            "o": "01Spine",
                            "c": "脊柱连结Spine"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "Alar ligament,L",
                                    "c": "翼状韧带Alar ligament,L"
                                },
                                "t":
                                {
                                    "s": "翼状韧带：强韧的圆索状韧带，左右各一。位于寰椎横韧带上方，起自齿突尖两侧，向外上方止于枕髁内侧面粗糙部。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Alar ligament,R",
                                    "c": "翼状韧带Alar ligament,R"
                                },
                                "t":
                                {
                                    "s": "翼状韧带：强韧的圆索状韧带，左右各一。位于寰椎横韧带上方，起自齿突尖两侧，向外上方止于枕髁内侧面粗糙部。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Anterior atlantoaxial ligament",
                                    "c": "寰枢前韧带Anterior atlantoaxial ligament"
                                },
                                "t":
                                {
                                    "s": ""
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Anterior atlantooccipital membrane",
                                    "c": "寰枕前膜Anterior atlantooccipital membrane"
                                },
                                "t":
                                {
                                    "s": "寰枕前膜：连于枕骨大孔前缘与寰椎前弓上缘之间的纤维膜。较宽阔，多与关节囊愈合。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Apical ligament of the dens",
                                    "c": "齿突尖韧带Apical ligament of the dens"
                                },
                                "t":
                                {
                                    "s": "齿突尖韧带：位于两侧翼状韧带上缘之间，连结齿突尖与枕骨大孔前缘的细小索状纤维束。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Atlanto-axial capsule,L",
                                    "c": "寰枢关节囊Atlanto-axial capsule,L"
                                },
                                "t":
                                {
                                    "s": ""
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Atlanto-axial capsule,R",
                                    "c": "寰枢关节囊Atlanto-axial capsule,R"
                                },
                                "t":
                                {
                                    "s": ""
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Atlanto-occipital capsule,L",
                                    "c": "寰枕关节囊Atlanto-occipital capsule,L"
                                },
                                "t":
                                {
                                    "s": ""
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Atlanto-occipital capsule,R",
                                    "c": "寰枕关节囊Atlanto-occipital capsule,R"
                                },
                                "t":
                                {
                                    "s": ""
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Intertransverse (cervical) ligaments,L",
                                    "c": "横突间韧带（颈部）Intertransverse (cervical) ligaments,L"
                                },
                                "t":
                                {
                                    "s": "横突间韧带：位于相邻椎骨横突间的纤维索，部分与横突间肌混合。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Intertransverse (cervical) ligaments,R",
                                    "c": "横突间韧带（颈部）Intertransverse (cervical) ligaments,R"
                                },
                                "t":
                                {
                                    "s": "横突间韧带：位于相邻椎骨横突间的纤维索，部分与横突间肌混合。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Intertransverse (thoracic) ligaments,L",
                                    "c": "横突间韧带（胸部）Intertransverse (thoracic) ligaments,L"
                                },
                                "t":
                                {
                                    "s": "横突间韧带：位于相邻椎骨横突间的纤维索，部分与横突间肌混合。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Intertransverse (thoracic) ligaments,R",
                                    "c": "横突间韧带（胸部）Intertransverse (thoracic) ligaments,R"
                                },
                                "t":
                                {
                                    "s": "横突间韧带：位于相邻椎骨横突间的纤维索，部分与横突间肌混合。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Intervertebral disc(intervartebral fibrocartilage)",
                                    "c": "椎间盘Intervertebral disc"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "C02-C03 Intervertebral disc(intertebral fibrocartilage)",
                                            "c": "C02-C03椎间盘Intervertebral disc"
                                        },
                                        "t":
                                        {
                                            "s": "椎间盘：是连结相邻两个椎体的纤维软骨盘（第1及第2颈椎之间除外），成人有23个椎间盘。椎间盘由两部分构成，中央部为髓核，是柔软而富有弹性的胶状物质，为胚胎时脊索的残留物。周围部为纤维环，由多层纤维软骨环按同心圆排列组成，牢固连结各椎体上、下面，保护髓核并限制髓核向周围膨出。椎间盘既坚韧，又富弹性，承受压力时被压缩，除去压力后又复原，具有“弹性垫”样作用，可缓冲外力对脊柱的震荡，也可增加脊柱的运动幅度。23个椎间盘的厚薄各不相同，以中胸部较薄，颈部较厚，而腰部最厚，所以颈、腰椎的活动度较大。颈、腰部的椎间盘前厚后薄，胸部的则与此相反。其厚薄和大小可随年龄而有差异。当纤维环破裂时，髓核容易向后外侧脱出，突入椎管或椎间孔，压迫相邻的脊髓或神经根引起放射性痛，临床称为椎间盘脱出症。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "C03-C04 Intervertebral disc(intertebral fibrocartilage)",
                                            "c": "C03-C04椎间盘Intervertebral disc"
                                        },
                                        "t":
                                        {
                                            "s": "椎间盘：是连结相邻两个椎体的纤维软骨盘（第1及第2颈椎之间除外），成人有23个椎间盘。椎间盘由两部分构成，中央部为髓核，是柔软而富有弹性的胶状物质，为胚胎时脊索的残留物。周围部为纤维环，由多层纤维软骨环按同心圆排列组成，牢固连结各椎体上、下面，保护髓核并限制髓核向周围膨出。椎间盘既坚韧，又富弹性，承受压力时被压缩，除去压力后又复原，具有“弹性垫”样作用，可缓冲外力对脊柱的震荡，也可增加脊柱的运动幅度。23个椎间盘的厚薄各不相同，以中胸部较薄，颈部较厚，而腰部最厚，所以颈、腰椎的活动度较大。颈、腰部的椎间盘前厚后薄，胸部的则与此相反。其厚薄和大小可随年龄而有差异。当纤维环破裂时，髓核容易向后外侧脱出，突入椎管或椎间孔，压迫相邻的脊髓或神经根引起放射性痛，临床称为椎间盘脱出症。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "C04-C05 Intervertebral disc(intertebral fibrocartilage)",
                                            "c": "C04-C05椎间盘Intervertebral disc"
                                        },
                                        "t":
                                        {
                                            "s": "椎间盘：是连结相邻两个椎体的纤维软骨盘（第1及第2颈椎之间除外），成人有23个椎间盘。椎间盘由两部分构成，中央部为髓核，是柔软而富有弹性的胶状物质，为胚胎时脊索的残留物。周围部为纤维环，由多层纤维软骨环按同心圆排列组成，牢固连结各椎体上、下面，保护髓核并限制髓核向周围膨出。椎间盘既坚韧，又富弹性，承受压力时被压缩，除去压力后又复原，具有“弹性垫”样作用，可缓冲外力对脊柱的震荡，也可增加脊柱的运动幅度。23个椎间盘的厚薄各不相同，以中胸部较薄，颈部较厚，而腰部最厚，所以颈、腰椎的活动度较大。颈、腰部的椎间盘前厚后薄，胸部的则与此相反。其厚薄和大小可随年龄而有差异。当纤维环破裂时，髓核容易向后外侧脱出，突入椎管或椎间孔，压迫相邻的脊髓或神经根引起放射性痛，临床称为椎间盘脱出症。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "C05-C06 Intervertebral disc(intertebral fibrocartilage)",
                                            "c": "C05-C06椎间盘Intervertebral disc"
                                        },
                                        "t":
                                        {
                                            "s": "椎间盘：是连结相邻两个椎体的纤维软骨盘（第1及第2颈椎之间除外），成人有23个椎间盘。椎间盘由两部分构成，中央部为髓核，是柔软而富有弹性的胶状物质，为胚胎时脊索的残留物。周围部为纤维环，由多层纤维软骨环按同心圆排列组成，牢固连结各椎体上、下面，保护髓核并限制髓核向周围膨出。椎间盘既坚韧，又富弹性，承受压力时被压缩，除去压力后又复原，具有“弹性垫”样作用，可缓冲外力对脊柱的震荡，也可增加脊柱的运动幅度。23个椎间盘的厚薄各不相同，以中胸部较薄，颈部较厚，而腰部最厚，所以颈、腰椎的活动度较大。颈、腰部的椎间盘前厚后薄，胸部的则与此相反。其厚薄和大小可随年龄而有差异。当纤维环破裂时，髓核容易向后外侧脱出，突入椎管或椎间孔，压迫相邻的脊髓或神经根引起放射性痛，临床称为椎间盘脱出症。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "C06-C07 Intervertebral disc(intertebral fibrocartilage)",
                                            "c": "C06-C07椎间盘Intervertebral disc"
                                        },
                                        "t":
                                        {
                                            "s": "椎间盘：是连结相邻两个椎体的纤维软骨盘（第1及第2颈椎之间除外），成人有23个椎间盘。椎间盘由两部分构成，中央部为髓核，是柔软而富有弹性的胶状物质，为胚胎时脊索的残留物。周围部为纤维环，由多层纤维软骨环按同心圆排列组成，牢固连结各椎体上、下面，保护髓核并限制髓核向周围膨出。椎间盘既坚韧，又富弹性，承受压力时被压缩，除去压力后又复原，具有“弹性垫”样作用，可缓冲外力对脊柱的震荡，也可增加脊柱的运动幅度。23个椎间盘的厚薄各不相同，以中胸部较薄，颈部较厚，而腰部最厚，所以颈、腰椎的活动度较大。颈、腰部的椎间盘前厚后薄，胸部的则与此相反。其厚薄和大小可随年龄而有差异。当纤维环破裂时，髓核容易向后外侧脱出，突入椎管或椎间孔，压迫相邻的脊髓或神经根引起放射性痛，临床称为椎间盘脱出症。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "C07-T01 Intervertebral disc(intervartebral fibrocartilage)",
                                            "c": "C07-T01椎间盘Intervertebral disc"
                                        },
                                        "t":
                                        {
                                            "s": "椎间盘：是连结相邻两个椎体的纤维软骨盘（第1及第2颈椎之间除外），成人有23个椎间盘。椎间盘由两部分构成，中央部为髓核，是柔软而富有弹性的胶状物质，为胚胎时脊索的残留物。周围部为纤维环，由多层纤维软骨环按同心圆排列组成，牢固连结各椎体上、下面，保护髓核并限制髓核向周围膨出。椎间盘既坚韧，又富弹性，承受压力时被压缩，除去压力后又复原，具有“弹性垫”样作用，可缓冲外力对脊柱的震荡，也可增加脊柱的运动幅度。23个椎间盘的厚薄各不相同，以中胸部较薄，颈部较厚，而腰部最厚，所以颈、腰椎的活动度较大。颈、腰部的椎间盘前厚后薄，胸部的则与此相反。其厚薄和大小可随年龄而有差异。当纤维环破裂时，髓核容易向后外侧脱出，突入椎管或椎间孔，压迫相邻的脊髓或神经根引起放射性痛，临床称为椎间盘脱出症。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "L01-L02 Intervertebral disc(intervartebral fibrocartilage)",
                                            "c": "L01-L02椎间盘Intervertebral disc"
                                        },
                                        "t":
                                        {
                                            "s": "椎间盘：是连结相邻两个椎体的纤维软骨盘（第1及第2颈椎之间除外），成人有23个椎间盘。椎间盘由两部分构成，中央部为髓核，是柔软而富有弹性的胶状物质，为胚胎时脊索的残留物。周围部为纤维环，由多层纤维软骨环按同心圆排列组成，牢固连结各椎体上、下面，保护髓核并限制髓核向周围膨出。椎间盘既坚韧，又富弹性，承受压力时被压缩，除去压力后又复原，具有“弹性垫”样作用，可缓冲外力对脊柱的震荡，也可增加脊柱的运动幅度。23个椎间盘的厚薄各不相同，以中胸部较薄，颈部较厚，而腰部最厚，所以颈、腰椎的活动度较大。颈、腰部的椎间盘前厚后薄，胸部的则与此相反。其厚薄和大小可随年龄而有差异。当纤维环破裂时，髓核容易向后外侧脱出，突入椎管或椎间孔，压迫相邻的脊髓或神经根引起放射性痛，临床称为椎间盘脱出症。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "L02-L03 Intervertebral disc(intervartebral fibrocartilage)",
                                            "c": "L02-L03椎间盘Intervertebral disc"
                                        },
                                        "t":
                                        {
                                            "s": "椎间盘：是连结相邻两个椎体的纤维软骨盘（第1及第2颈椎之间除外），成人有23个椎间盘。椎间盘由两部分构成，中央部为髓核，是柔软而富有弹性的胶状物质，为胚胎时脊索的残留物。周围部为纤维环，由多层纤维软骨环按同心圆排列组成，牢固连结各椎体上、下面，保护髓核并限制髓核向周围膨出。椎间盘既坚韧，又富弹性，承受压力时被压缩，除去压力后又复原，具有“弹性垫”样作用，可缓冲外力对脊柱的震荡，也可增加脊柱的运动幅度。23个椎间盘的厚薄各不相同，以中胸部较薄，颈部较厚，而腰部最厚，所以颈、腰椎的活动度较大。颈、腰部的椎间盘前厚后薄，胸部的则与此相反。其厚薄和大小可随年龄而有差异。当纤维环破裂时，髓核容易向后外侧脱出，突入椎管或椎间孔，压迫相邻的脊髓或神经根引起放射性痛，临床称为椎间盘脱出症。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "L03-L04 Intervertebral disc(intervartebral fibrocartilage)",
                                            "c": "L03-L04椎间盘Intervertebral disc"
                                        },
                                        "t":
                                        {
                                            "s": "椎间盘：是连结相邻两个椎体的纤维软骨盘（第1及第2颈椎之间除外），成人有23个椎间盘。椎间盘由两部分构成，中央部为髓核，是柔软而富有弹性的胶状物质，为胚胎时脊索的残留物。周围部为纤维环，由多层纤维软骨环按同心圆排列组成，牢固连结各椎体上、下面，保护髓核并限制髓核向周围膨出。椎间盘既坚韧，又富弹性，承受压力时被压缩，除去压力后又复原，具有“弹性垫”样作用，可缓冲外力对脊柱的震荡，也可增加脊柱的运动幅度。23个椎间盘的厚薄各不相同，以中胸部较薄，颈部较厚，而腰部最厚，所以颈、腰椎的活动度较大。颈、腰部的椎间盘前厚后薄，胸部的则与此相反。其厚薄和大小可随年龄而有差异。当纤维环破裂时，髓核容易向后外侧脱出，突入椎管或椎间孔，压迫相邻的脊髓或神经根引起放射性痛，临床称为椎间盘脱出症。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_L04-L05 Intervertebral disc(intervartebral fibrocartilage)",
                                            "c": "L04-L05椎间盘Intervertebral disc"
                                        },
                                        "t":
                                        {
                                            "s": "椎间盘：是连结相邻两个椎体的纤维软骨盘（第1及第2颈椎之间除外），成人有23个椎间盘。椎间盘由两部分构成，中央部为髓核，是柔软而富有弹性的胶状物质，为胚胎时脊索的残留物。周围部为纤维环，由多层纤维软骨环按同心圆排列组成，牢固连结各椎体上、下面，保护髓核并限制髓核向周围膨出。椎间盘既坚韧，又富弹性，承受压力时被压缩，除去压力后又复原，具有“弹性垫”样作用，可缓冲外力对脊柱的震荡，也可增加脊柱的运动幅度。23个椎间盘的厚薄各不相同，以中胸部较薄，颈部较厚，而腰部最厚，所以颈、腰椎的活动度较大。颈、腰部的椎间盘前厚后薄，胸部的则与此相反。其厚薄和大小可随年龄而有差异。当纤维环破裂时，髓核容易向后外侧脱出，突入椎管或椎间孔，压迫相邻的脊髓或神经根引起放射性痛，临床称为椎间盘脱出症。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_L05-S01 Sacral intervertebral disc(intervertabal fibrocartilage)",
                                            "c": "L05-S01椎间盘Sacral intervertebral disc"
                                        },
                                        "t":
                                        {
                                            "s": "椎间盘：是连结相邻两个椎体的纤维软骨盘（第1及第2颈椎之间除外），成人有23个椎间盘。椎间盘由两部分构成，中央部为髓核，是柔软而富有弹性的胶状物质，为胚胎时脊索的残留物。周围部为纤维环，由多层纤维软骨环按同心圆排列组成，牢固连结各椎体上、下面，保护髓核并限制髓核向周围膨出。椎间盘既坚韧，又富弹性，承受压力时被压缩，除去压力后又复原，具有“弹性垫”样作用，可缓冲外力对脊柱的震荡，也可增加脊柱的运动幅度。23个椎间盘的厚薄各不相同，以中胸部较薄，颈部较厚，而腰部最厚，所以颈、腰椎的活动度较大。颈、腰部的椎间盘前厚后薄，胸部的则与此相反。其厚薄和大小可随年龄而有差异。当纤维环破裂时，髓核容易向后外侧脱出，突入椎管或椎间孔，压迫相邻的脊髓或神经根引起放射性痛，临床称为椎间盘脱出症。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "T01-T02 Intervertebral disc(intervartebral fibrocartilage)",
                                            "c": "T01-T02椎间盘Intervertebral disc"
                                        },
                                        "t":
                                        {
                                            "s": "椎间盘：是连结相邻两个椎体的纤维软骨盘（第1及第2颈椎之间除外），成人有23个椎间盘。椎间盘由两部分构成，中央部为髓核，是柔软而富有弹性的胶状物质，为胚胎时脊索的残留物。周围部为纤维环，由多层纤维软骨环按同心圆排列组成，牢固连结各椎体上、下面，保护髓核并限制髓核向周围膨出。椎间盘既坚韧，又富弹性，承受压力时被压缩，除去压力后又复原，具有“弹性垫”样作用，可缓冲外力对脊柱的震荡，也可增加脊柱的运动幅度。23个椎间盘的厚薄各不相同，以中胸部较薄，颈部较厚，而腰部最厚，所以颈、腰椎的活动度较大。颈、腰部的椎间盘前厚后薄，胸部的则与此相反。其厚薄和大小可随年龄而有差异。当纤维环破裂时，髓核容易向后外侧脱出，突入椎管或椎间孔，压迫相邻的脊髓或神经根引起放射性痛，临床称为椎间盘脱出症。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "T02-T03 Intervertebral disc(intervartebral fibrocartilage)",
                                            "c": "T02-T03椎间盘Intervertebral disc"
                                        },
                                        "t":
                                        {
                                            "s": "椎间盘：是连结相邻两个椎体的纤维软骨盘（第1及第2颈椎之间除外），成人有23个椎间盘。椎间盘由两部分构成，中央部为髓核，是柔软而富有弹性的胶状物质，为胚胎时脊索的残留物。周围部为纤维环，由多层纤维软骨环按同心圆排列组成，牢固连结各椎体上、下面，保护髓核并限制髓核向周围膨出。椎间盘既坚韧，又富弹性，承受压力时被压缩，除去压力后又复原，具有“弹性垫”样作用，可缓冲外力对脊柱的震荡，也可增加脊柱的运动幅度。23个椎间盘的厚薄各不相同，以中胸部较薄，颈部较厚，而腰部最厚，所以颈、腰椎的活动度较大。颈、腰部的椎间盘前厚后薄，胸部的则与此相反。其厚薄和大小可随年龄而有差异。当纤维环破裂时，髓核容易向后外侧脱出，突入椎管或椎间孔，压迫相邻的脊髓或神经根引起放射性痛，临床称为椎间盘脱出症。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "T03-T04 Intervertebral disc(intervartebral fibrocartilage)",
                                            "c": "T03-T04椎间盘Intervertebral disc"
                                        },
                                        "t":
                                        {
                                            "s": "椎间盘：是连结相邻两个椎体的纤维软骨盘（第1及第2颈椎之间除外），成人有23个椎间盘。椎间盘由两部分构成，中央部为髓核，是柔软而富有弹性的胶状物质，为胚胎时脊索的残留物。周围部为纤维环，由多层纤维软骨环按同心圆排列组成，牢固连结各椎体上、下面，保护髓核并限制髓核向周围膨出。椎间盘既坚韧，又富弹性，承受压力时被压缩，除去压力后又复原，具有“弹性垫”样作用，可缓冲外力对脊柱的震荡，也可增加脊柱的运动幅度。23个椎间盘的厚薄各不相同，以中胸部较薄，颈部较厚，而腰部最厚，所以颈、腰椎的活动度较大。颈、腰部的椎间盘前厚后薄，胸部的则与此相反。其厚薄和大小可随年龄而有差异。当纤维环破裂时，髓核容易向后外侧脱出，突入椎管或椎间孔，压迫相邻的脊髓或神经根引起放射性痛，临床称为椎间盘脱出症。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "T04-T05 Intervertebral disc(intervartebral fibrocartilage)",
                                            "c": "T04-T05椎间盘Intervertebral disc"
                                        },
                                        "t":
                                        {
                                            "s": "椎间盘：是连结相邻两个椎体的纤维软骨盘（第1及第2颈椎之间除外），成人有23个椎间盘。椎间盘由两部分构成，中央部为髓核，是柔软而富有弹性的胶状物质，为胚胎时脊索的残留物。周围部为纤维环，由多层纤维软骨环按同心圆排列组成，牢固连结各椎体上、下面，保护髓核并限制髓核向周围膨出。椎间盘既坚韧，又富弹性，承受压力时被压缩，除去压力后又复原，具有“弹性垫”样作用，可缓冲外力对脊柱的震荡，也可增加脊柱的运动幅度。23个椎间盘的厚薄各不相同，以中胸部较薄，颈部较厚，而腰部最厚，所以颈、腰椎的活动度较大。颈、腰部的椎间盘前厚后薄，胸部的则与此相反。其厚薄和大小可随年龄而有差异。当纤维环破裂时，髓核容易向后外侧脱出，突入椎管或椎间孔，压迫相邻的脊髓或神经根引起放射性痛，临床称为椎间盘脱出症。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "T05-T06 Intervertebral disc(intervartebral fibrocartilage)",
                                            "c": "T05-T06椎间盘Intervertebral disc"
                                        },
                                        "t":
                                        {
                                            "s": "椎间盘：是连结相邻两个椎体的纤维软骨盘（第1及第2颈椎之间除外），成人有23个椎间盘。椎间盘由两部分构成，中央部为髓核，是柔软而富有弹性的胶状物质，为胚胎时脊索的残留物。周围部为纤维环，由多层纤维软骨环按同心圆排列组成，牢固连结各椎体上、下面，保护髓核并限制髓核向周围膨出。椎间盘既坚韧，又富弹性，承受压力时被压缩，除去压力后又复原，具有“弹性垫”样作用，可缓冲外力对脊柱的震荡，也可增加脊柱的运动幅度。23个椎间盘的厚薄各不相同，以中胸部较薄，颈部较厚，而腰部最厚，所以颈、腰椎的活动度较大。颈、腰部的椎间盘前厚后薄，胸部的则与此相反。其厚薄和大小可随年龄而有差异。当纤维环破裂时，髓核容易向后外侧脱出，突入椎管或椎间孔，压迫相邻的脊髓或神经根引起放射性痛，临床称为椎间盘脱出症。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "T06-T07 Intervertebral disc(intervartebral fibrocartilage)",
                                            "c": "T06-T07椎间盘Intervertebral disc"
                                        },
                                        "t":
                                        {
                                            "s": "椎间盘：是连结相邻两个椎体的纤维软骨盘（第1及第2颈椎之间除外），成人有23个椎间盘。椎间盘由两部分构成，中央部为髓核，是柔软而富有弹性的胶状物质，为胚胎时脊索的残留物。周围部为纤维环，由多层纤维软骨环按同心圆排列组成，牢固连结各椎体上、下面，保护髓核并限制髓核向周围膨出。椎间盘既坚韧，又富弹性，承受压力时被压缩，除去压力后又复原，具有“弹性垫”样作用，可缓冲外力对脊柱的震荡，也可增加脊柱的运动幅度。23个椎间盘的厚薄各不相同，以中胸部较薄，颈部较厚，而腰部最厚，所以颈、腰椎的活动度较大。颈、腰部的椎间盘前厚后薄，胸部的则与此相反。其厚薄和大小可随年龄而有差异。当纤维环破裂时，髓核容易向后外侧脱出，突入椎管或椎间孔，压迫相邻的脊髓或神经根引起放射性痛，临床称为椎间盘脱出症。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "T07-T08 Intervertebral disc(intervartebral fibrocartilage)",
                                            "c": "T07-T08椎间盘Intervertebral disc"
                                        },
                                        "t":
                                        {
                                            "s": "椎间盘：是连结相邻两个椎体的纤维软骨盘（第1及第2颈椎之间除外），成人有23个椎间盘。椎间盘由两部分构成，中央部为髓核，是柔软而富有弹性的胶状物质，为胚胎时脊索的残留物。周围部为纤维环，由多层纤维软骨环按同心圆排列组成，牢固连结各椎体上、下面，保护髓核并限制髓核向周围膨出。椎间盘既坚韧，又富弹性，承受压力时被压缩，除去压力后又复原，具有“弹性垫”样作用，可缓冲外力对脊柱的震荡，也可增加脊柱的运动幅度。23个椎间盘的厚薄各不相同，以中胸部较薄，颈部较厚，而腰部最厚，所以颈、腰椎的活动度较大。颈、腰部的椎间盘前厚后薄，胸部的则与此相反。其厚薄和大小可随年龄而有差异。当纤维环破裂时，髓核容易向后外侧脱出，突入椎管或椎间孔，压迫相邻的脊髓或神经根引起放射性痛，临床称为椎间盘脱出症。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "T08-T09 Intervertebral disc(intervartebral fibrocartilage)",
                                            "c": "T08-T09椎间盘Intervertebral disc"
                                        },
                                        "t":
                                        {
                                            "s": "椎间盘：是连结相邻两个椎体的纤维软骨盘（第1及第2颈椎之间除外），成人有23个椎间盘。椎间盘由两部分构成，中央部为髓核，是柔软而富有弹性的胶状物质，为胚胎时脊索的残留物。周围部为纤维环，由多层纤维软骨环按同心圆排列组成，牢固连结各椎体上、下面，保护髓核并限制髓核向周围膨出。椎间盘既坚韧，又富弹性，承受压力时被压缩，除去压力后又复原，具有“弹性垫”样作用，可缓冲外力对脊柱的震荡，也可增加脊柱的运动幅度。23个椎间盘的厚薄各不相同，以中胸部较薄，颈部较厚，而腰部最厚，所以颈、腰椎的活动度较大。颈、腰部的椎间盘前厚后薄，胸部的则与此相反。其厚薄和大小可随年龄而有差异。当纤维环破裂时，髓核容易向后外侧脱出，突入椎管或椎间孔，压迫相邻的脊髓或神经根引起放射性痛，临床称为椎间盘脱出症。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "T09-T10 Intervertebral disc(intervartebral fibrocartilage)",
                                            "c": "T09-T10椎间盘Intervertebral disc"
                                        },
                                        "t":
                                        {
                                            "s": "椎间盘：是连结相邻两个椎体的纤维软骨盘（第1及第2颈椎之间除外），成人有23个椎间盘。椎间盘由两部分构成，中央部为髓核，是柔软而富有弹性的胶状物质，为胚胎时脊索的残留物。周围部为纤维环，由多层纤维软骨环按同心圆排列组成，牢固连结各椎体上、下面，保护髓核并限制髓核向周围膨出。椎间盘既坚韧，又富弹性，承受压力时被压缩，除去压力后又复原，具有“弹性垫”样作用，可缓冲外力对脊柱的震荡，也可增加脊柱的运动幅度。23个椎间盘的厚薄各不相同，以中胸部较薄，颈部较厚，而腰部最厚，所以颈、腰椎的活动度较大。颈、腰部的椎间盘前厚后薄，胸部的则与此相反。其厚薄和大小可随年龄而有差异。当纤维环破裂时，髓核容易向后外侧脱出，突入椎管或椎间孔，压迫相邻的脊髓或神经根引起放射性痛，临床称为椎间盘脱出症。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "T10-T11 Intervertebral disc(intervartebral fibrocartilage)",
                                            "c": "T10-T11椎间盘Intervertebral disc"
                                        },
                                        "t":
                                        {
                                            "s": "椎间盘：是连结相邻两个椎体的纤维软骨盘（第1及第2颈椎之间除外），成人有23个椎间盘。椎间盘由两部分构成，中央部为髓核，是柔软而富有弹性的胶状物质，为胚胎时脊索的残留物。周围部为纤维环，由多层纤维软骨环按同心圆排列组成，牢固连结各椎体上、下面，保护髓核并限制髓核向周围膨出。椎间盘既坚韧，又富弹性，承受压力时被压缩，除去压力后又复原，具有“弹性垫”样作用，可缓冲外力对脊柱的震荡，也可增加脊柱的运动幅度。23个椎间盘的厚薄各不相同，以中胸部较薄，颈部较厚，而腰部最厚，所以颈、腰椎的活动度较大。颈、腰部的椎间盘前厚后薄，胸部的则与此相反。其厚薄和大小可随年龄而有差异。当纤维环破裂时，髓核容易向后外侧脱出，突入椎管或椎间孔，压迫相邻的脊髓或神经根引起放射性痛，临床称为椎间盘脱出症。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "T11-T12 Intervertebral disc(intervartebral fibrocartilage)",
                                            "c": "T11-T12椎间盘Intervertebral disc"
                                        },
                                        "t":
                                        {
                                            "s": "椎间盘：是连结相邻两个椎体的纤维软骨盘（第1及第2颈椎之间除外），成人有23个椎间盘。椎间盘由两部分构成，中央部为髓核，是柔软而富有弹性的胶状物质，为胚胎时脊索的残留物。周围部为纤维环，由多层纤维软骨环按同心圆排列组成，牢固连结各椎体上、下面，保护髓核并限制髓核向周围膨出。椎间盘既坚韧，又富弹性，承受压力时被压缩，除去压力后又复原，具有“弹性垫”样作用，可缓冲外力对脊柱的震荡，也可增加脊柱的运动幅度。23个椎间盘的厚薄各不相同，以中胸部较薄，颈部较厚，而腰部最厚，所以颈、腰椎的活动度较大。颈、腰部的椎间盘前厚后薄，胸部的则与此相反。其厚薄和大小可随年龄而有差异。当纤维环破裂时，髓核容易向后外侧脱出，突入椎管或椎间孔，压迫相邻的脊髓或神经根引起放射性痛，临床称为椎间盘脱出症。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "T12-L01 Intervertebral disc(intervartebral fibrocartilage)",
                                            "c": "T12-L01椎间盘Intervertebral disc"
                                        },
                                        "t":
                                        {
                                            "s": "椎间盘：是连结相邻两个椎体的纤维软骨盘（第1及第2颈椎之间除外），成人有23个椎间盘。椎间盘由两部分构成，中央部为髓核，是柔软而富有弹性的胶状物质，为胚胎时脊索的残留物。周围部为纤维环，由多层纤维软骨环按同心圆排列组成，牢固连结各椎体上、下面，保护髓核并限制髓核向周围膨出。椎间盘既坚韧，又富弹性，承受压力时被压缩，除去压力后又复原，具有“弹性垫”样作用，可缓冲外力对脊柱的震荡，也可增加脊柱的运动幅度。23个椎间盘的厚薄各不相同，以中胸部较薄，颈部较厚，而腰部最厚，所以颈、腰椎的活动度较大。颈、腰部的椎间盘前厚后薄，胸部的则与此相反。其厚薄和大小可随年龄而有差异。当纤维环破裂时，髓核容易向后外侧脱出，突入椎管或椎间孔，压迫相邻的脊髓或神经根引起放射性痛，临床称为椎间盘脱出症。"
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Ligamenta flava,cervical region",
                                    "c": "黄韧带颈区Ligamenta flava,cervical region"
                                },
                                "t":
                                {
                                    "s": "黄韧带：位于椎管内，连结相邻两椎弓板间的韧带，由黄色的弹性纤维构成。黄韧带协助围成椎管，并有限制脊柱过度前屈的作用。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Ligamenta flava,thoracic region",
                                    "c": "黄韧带胸区Ligamenta flava,thoracic region"
                                },
                                "t":
                                {
                                    "s": "黄韧带：位于椎管内，连结相邻两椎弓板间的韧带，由黄色的弹性纤维构成。黄韧带协助围成椎管，并有限制脊柱过度前屈的作用。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Longitudinal fascicles",
                                    "c": "纵束Longitudinal fascicles"
                                },
                                "t":
                                {
                                    "s": "纵束：寰椎横韧带中部向上、下各发出一条纵行纤维束。向上的末端附于枕骨大孔前缘为上脚，向下的附于枢椎体后面为下脚。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_Anterior longitudinal ligament",
                                    "c": "前纵韧带Anterior longitudinal ligament"
                                },
                                "t":
                                {
                                    "s": "前纵韧带：是椎体前面延伸的一束坚固的纤维束。宽而坚韧，上自枕骨大孔前缘，下达第1或第2骶椎椎体。其纵行的纤维牢固地附着于椎体和椎间盘，有防止脊柱过度后伸和椎间盘向前脱出的作用。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_Intertransverse (lumbar) ligaments,L",
                                    "c": "横突间韧带（腰部）Intertransverse (lumbar) ligaments,L"
                                },
                                "t":
                                {
                                    "s": "横突间韧带：位于相邻椎骨横突间的纤维索，部分与横突间肌混合。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_Intertransverse (lumbar) ligaments,R",
                                    "c": "横突间韧带（腰部）Intertransverse (lumbar) ligaments,R"
                                },
                                "t":
                                {
                                    "s": "横突间韧带：位于相邻椎骨横突间的纤维索，部分与横突间肌混合。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_Ligamenta flava,lumbar region",
                                    "c": "黄韧带腰区Ligamenta flava,lumbar region"
                                },
                                "t":
                                {
                                    "s": "黄韧带：位于椎管内，连结相邻两椎弓板间的韧带，由黄色的弹性纤维构成。黄韧带协助围成椎管，并有限制脊柱过度前屈的作用。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_Posterior longitudinal ligament",
                                    "c": "后纵韧带Posterior longitudinal ligament"
                                },
                                "t":
                                {
                                    "s": "后纵韧带：位于椎管内椎体的后面，窄而坚韧。起自枢椎并与覆盖枢椎椎体的覆膜相续，下达骶骨。与椎间盘纤维环及椎体上下缘紧密连结，而与椎体结合较为疏松，有限制脊柱过度前屈的作用。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_Supraspinous ligament",
                                    "c": "棘上韧带Supraspinous ligament"
                                },
                                "t":
                                {
                                    "s": "棘上韧带：连结胸、腰、骶椎各棘突尖之间的纵行细长韧带，前方与棘间韧带相融合，有限制脊柱前屈的作用。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Nuchal ligament",
                                    "c": "项韧带Nuchal ligament"
                                },
                                "t":
                                {
                                    "s": "项韧带：位于枕外隆凸、枕外嵴、寰椎后结节及第二至第七颈椎棘突之间的三角形弹性纤维膜。后缘游离而肥厚，有肌肉附着。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Posterior atlantooccipital membrane",
                                    "c": "寰枕后膜Posterior atlantooccipital membrane"
                                },
                                "t":
                                {
                                    "s": "寰枕后膜：位于枕骨大孔后缘与寰椎后弓上缘之间。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Posterior atlantoaxial ligament",
                                    "c": "寰枢后韧带Posterior atlantoaxial ligament"
                                },
                                "t":
                                {
                                    "s": ""
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Tectorial membrane of atlanto-axial joint",
                                    "c": "覆膜Tectorial membrane"
                                },
                                "t":
                                {
                                    "s": "覆膜：位于椎管内，坚韧而宽阔的纤维膜。自枕骨斜坡向下沿齿突及其周围韧带后面下降，在枢椎体后面移行为后纵韧带。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Tectorial membrane (deep part),L",
                                    "c": "覆膜深层Tectorial membrane (deep part),L"
                                },
                                "t":
                                {
                                    "s": ""
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Tectorial membrane (deep part),R",
                                    "c": "覆膜深层Tectorial membrane (deep part),R"
                                },
                                "t":
                                {
                                    "s": ""
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Transverse ligament of atlas",
                                    "c": "寰椎横韧带Transverse ligament of atlas"
                                },
                                "t":
                                {
                                    "s": "寰椎横韧带，连结寰椎左、右侧块，防止齿突后退。从韧带中部向上有纤维束附于枕骨大孔前缘，向下有纤维束连结枢椎体后面，因此，寰椎横韧带与其上、下两纵行纤维索，共同构成寰椎十字韧带。"
                                }
                            }]
                        }
                    },
                    {
                        "$":
                        {
                            "o": "02Articulations of cranial bones",
                            "c": "颅骨连结Articulations of cranial bones"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "Articulations of cranial bones,L",
                                    "c": "左颅骨连结Articulations of cranial bones,L"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Auricular(ear)cartilage,L",
                                            "c": "耳软骨Auricular(ear)cartilage,L"
                                        },
                                        "t":
                                        {
                                            "s": ""
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Joint capsule(mandible),L",
                                            "c": "颞下颌关节囊Joint capsule(mandible),L"
                                        },
                                        "t":
                                        {
                                            "s": "颞下颌关节囊：上前方附着于关节结节顶部的前方；上后方附着于鼓鳞裂；前内方与翼外肌上头融合；外侧附着于颧弓、关节窝的边缘和关书后结节；内侧止于蝶骨嵴；下方止于髁突颈部。除内、外侧直接附着于髁突以外，关节盘四周均与关节囊相连，因此将颞下颌关节间隙分为两个互不相通的上、下腔，上腔大而下腔小。关节腔内衬以滑膜。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Lateral ligament(mandible),L",
                                            "c": "颞下颌外侧韧带Lateral ligament(mandible),L"
                                        },
                                        "t":
                                        {
                                            "s": "颞下颌外侧韧带：起自颞骨颧突下缘，止于下颌头和下颌颈，呈三角形的韧带。与关节囊外侧壁愈合，可限制下颌头向前方运动。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Sphenomandibular ligament,L",
                                            "c": "蝶下颌韧带Sphenomandibular ligament,L"
                                        },
                                        "t":
                                        {
                                            "s": "蝶下颌韧带：起于蝶骨角棘，止于下颌小舌。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Stylohyoid ligament,L",
                                            "c": "茎突舌骨韧带Stylohyoid ligament,L"
                                        },
                                        "t":
                                        {
                                            "s": "茎突舌骨韧带：连于颞骨茎突尖端和舌骨小角之间的纤维索。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Stylomandibular ligament,L",
                                            "c": "茎突下颌韧带Stylomandibular ligament,L"
                                        },
                                        "t":
                                        {
                                            "s": "茎突下颌韧带：由颈深筋膜增厚而成，起于颞骨茎突尖部，止于下颌角和下颌支的后缘。"
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Articulations of cranial bones,R",
                                    "c": "右颅骨韧带Articulations of cranial bones,R"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Auricular(ear)cartilage,R",
                                            "c": "耳软骨Auricular(ear)cartilage,R"
                                        },
                                        "t":
                                        {
                                            "s": ""
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Joint capsule(mandible),R",
                                            "c": "颞下颌关节囊Joint capsule(mandible),R"
                                        },
                                        "t":
                                        {
                                            "s": "颞下颌关节囊：上前方附着于关节结节顶部的前方；上后方附着于鼓鳞裂；前内方与翼外肌上头融合；外侧附着于颧弓、关节窝的边缘和关书后结节；内侧止于蝶骨嵴；下方止于髁突颈部。除内、外侧直接附着于髁突以外，关节盘四周均与关节囊相连，因此将颞下颌关节间隙分为两个互不相通的上、下腔，上腔大而下腔小。关节腔内衬以滑膜。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Lateral ligament(mandible),R",
                                            "c": "颞下颌外侧韧带Lateral ligament(mandible),R"
                                        },
                                        "t":
                                        {
                                            "s": "颞下颌外侧韧带：起自颞骨颧突下缘，止于下颌头和下颌颈，呈三角形的韧带。与关节囊外侧壁愈合，可限制下颌头向前方运动。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Sphenomandibular ligament,R",
                                            "c": "蝶下颌韧带Sphenomandibular ligament,R"
                                        },
                                        "t":
                                        {
                                            "s": "蝶下颌韧带：起于蝶骨角棘，止于下颌小舌。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Stylohyoid ligament,R",
                                            "c": "茎突舌骨韧带Stylohyoid ligament,R"
                                        },
                                        "t":
                                        {
                                            "s": "茎突舌骨韧带：连于颞骨茎突尖端和舌骨小角之间的纤维索。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Stylomandibular ligament,R",
                                            "c": "茎突下颌韧带Stylomandibular ligament,R"
                                        },
                                        "t":
                                        {
                                            "s": "茎突下颌韧带：由颈深筋膜增厚而成，起于颞骨茎突尖部，止于下颌角和下颌支的后缘。"
                                        }
                                    }]
                                }
                            }]
                        }
                    },
                    {
                        "$":
                        {
                            "o": "03Articulations of upper limb",
                            "c": "上肢骨连结Articulations of upper limb"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "Articulations of upper limb,L",
                                    "c": "左上肢骨连结Articulations of upper limb,L"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "01Articulations of shoulder girdle,L",
                                            "c": "左上肢带连结Articulations of shoulder girdle,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Shoulder joint,L",
                                                    "c": "左肩关节Shoulder joint,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Acromioclavicular ligament,L",
                                                            "c": "肩锁韧带Acromioclavicular ligament,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肩锁韧带：为肩锁关节囊上部增厚的部分，呈长方形，连结锁骨肩峰端与肩峰的上面之间。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Articular capsule(shoulder),L",
                                                            "c": "肩关节囊Articular capsule(shoulder),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分内、外两层。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Coracoacromial ligament,L",
                                                            "c": "喙肩韧带Coracoacromial ligament,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "喙肩韧带：为三角形的扁韧带，连于肩胛骨的喙突与肩峰之间，它与喙突、肩峰共同构成喙肩弓，架于肩关节上方，有防止肱骨头向上脱位的作用。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Coracoclavicular ligament,conoid portion,L",
                                                            "c": "锥状韧带Coracoclavicular ligament,conoid portion,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "锥状韧带：斜方韧带的后内侧，呈椎状，较厚的韧带。底部连结锁骨下面的后缘，尖部连结喙突根部的内侧缘和后缘，部分与肩胛上横韧带愈合。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Coracoclavicular ligament,trapezoid portion,L",
                                                            "c": "斜方韧带Coracoclavicular ligament,trapezoid portion,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "斜方韧带：连结锁骨下面的喙突粗隆和肩胛骨喙突的韧带。位于喙锁韧带前外侧，呈斜方形。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Coracohumeral ligament,L",
                                                            "c": "喙肱韧带Coracohumeral ligament,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "喙肱韧带：为一宽而强的韧带，起自喙突根部的外侧缘，斜向外下方，达肱骨大结节的前面，与冈上肌腱相愈合。其前缘和上缘游离，后续和下缘与关节囊愈合。此韧带加强关节囊的上部，并能限制肱骨向外侧旋转，还防止肱骨头向上方脱位"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Glenoid labrum,L",
                                                            "c": "盂唇Glenoid labrum,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "盂唇：附着于关节盂周缘的纤维软骨环。主要起加深关节窝、增大关节面的作用。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Inferior glenohumeral ligament,L",
                                                            "c": "盂肱下韧带Inferior glenohumeral ligament,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "盂肱韧带：位于关节囊前壁的内侧面，分上、中、下三部，起于关节盂边缘，止于肱骨小结节至肱骨解剖颈下部的韧带。有加强关节囊前壁的作用。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Middle glenohumeral ligament,L",
                                                            "c": "盂肱中韧带Middle glenohumeral ligament,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "盂肱韧带：位于关节囊前壁的内侧面，分上、中、下三部，起于关节盂边缘，止于肱骨小结节至肱骨解剖颈下部的韧带。有加强关节囊前壁的作用。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Superior glenohumeral ligament,L",
                                                            "c": "盂肱上韧带Superior glenohumeral ligament,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "盂肱韧带：位于关节囊前壁的内侧面，分上、中、下三部，起于关节盂边缘，止于肱骨小结节至肱骨解剖颈下部的韧带。有加强关节囊前壁的作用。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Superior transverse scapular ligament,L",
                                                            "c": "肩胛上横韧带Superior transverse scapular ligament,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肩胛上横韧带：连结肩胛骨背侧面上缘和喙突基底部的韧带。横跨肩胛切迹的上方，与此切迹围成一孔，内有肩胛上神经通过。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Transverse humeral ligament,L",
                                                            "c": "肱横韧带Transverse humeral ligament,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肱横韧带：连于大、小结节之间肱骨的固有韧带。与结节间沟共同围成一管，有肱二头肌长头腱通过。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Sternoclavicular joint,L",
                                                    "c": "胸锁关节Sternoclavicular joint,L"
                                                },
                                                "ch":
                                                {
                                                    "sub":
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Capsule of the sternoclavicular joint,L",
                                                            "c": "胸锁关节囊Capsule of the sternoclavicular joint,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分内、外两层。"
                                                        }
                                                    }
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "02Joints of free upper limb,L",
                                            "c": "左自由上肢骨连结Joints of free upper limb,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Elbow joint,L",
                                                    "c": "左肘关节Elbow joint,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Annular ligament of radius,L",
                                                            "c": "桡骨环状韧带Annular ligament of radius,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "桡骨环状韧带：位于桡骨环状关节面的周围，两端附着于尺骨桡切迹的前、后缘，与尺骨桡切迹共同构成一个上口大、下口小的骨纤维环来容纳桡骨头；防止桡骨头脱出。幼儿4岁以前，桡骨头尚在发育之中，环状韧带松弛，在肘关节伸直位猛力牵拉前臂时，桡骨头易被环状韧带卡住，或环状韧带部分夹在肱桡骨之间，从而发生桡骨小头半脱位。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Articular capsule(elbow),L",
                                                            "c": "肘关节囊Articular capsule(elbow),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分内、外两层。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Oblique cord(elbow),L",
                                                            "c": "斜索Oblique cord(elbow),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "斜索：前臂骨间膜上缘的一条斜带状纤维索。起自尺骨粗隆的外侧缘，止于桡骨粗隆稍下方。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Radial collateral ligament,L",
                                                            "c": "桡侧副韧带Radial collateral ligament,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "桡侧副韧带：位于肘关节囊桡侧，起于肱骨外上髁，向下止于桡骨环状韧带的纤维束。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Ulnar collateral ligament,anterior,L",
                                                            "c": "尺侧副韧带前部Ulnar collateral ligament,anterior,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "尺侧副韧带：位于肘关节囊的尺侧，起于肱骨内上髁，向下呈扇形扩展，分为前、中、后部，止于尺骨滑车切迹内侧缘的韧带。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Ulnar collateral ligament,intermediate,L",
                                                            "c": "尺侧副韧带中部Ulnar collateral ligament,intermediate,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "尺侧副韧带：位于肘关节囊的尺侧，起于肱骨内上髁，向下呈扇形扩展，分为前、中、后部，止于尺骨滑车切迹内侧缘的韧带。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Ulnar collateral ligament,posterior,L",
                                                            "c": "尺侧副韧带后部Ulnar collateral ligament,posterior,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "尺侧副韧带：位于肘关节囊的尺侧，起于肱骨内上髁，向下呈扇形扩展，分为前、中、后部，止于尺骨滑车切迹内侧缘的韧带。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Ulnar collateral ligament,transverse,L",
                                                            "c": "尺侧副韧带横束Ulnar collateral ligament,transverse,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "横束：变异很大，组成纤维沿内侧关节囊走向，自鹰嘴尖至尺骨内侧面，恰位于冠状突远端。横束的起点和止点均在尺骨上，所以对肘部的稳定作用很小。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Interousseous membrane(antebrachial),L",
                                                    "c": "前臂骨间膜Interosseous membrane(antebrachial),L"
                                                },
                                                "t":
                                                {
                                                    "s": "前臂骨间膜：连结于尺骨和桡骨的骨间缘之间的纤维膜。上方起于桡骨粗隆下方2-3cm，下至桡骨的尺切迹。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Joints of hand,L",
                                                    "c": "左手关节Joints of hand,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Articular disc of ulna,L",
                                                            "c": "尺骨关节盘Articular disc of ulna,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "尺骨关节盘：位于尺骨头下方的三角形纤维软骨。参与构成桡尺远侧关节和桡腕关节。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Carpometacarpal articular capsule of pollex,L",
                                                            "c": "拇指腕掌关节囊Carpometacarpal articular capsule of pollex,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分内、外两层。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Deep transverse metacarpal ligaments,L",
                                                            "c": "掌骨深横韧带Deep transverse metacarpal ligaments,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "掌骨深横韧带：三条分别连结第二与第三掌骨头、第三与第四掌骨头和第四与第五掌骨头的短宽而扁的纤维束。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Dorsal carpometacarpal ligaments,L",
                                                            "c": "腕掌背侧韧带Dorsal carpometacarpal ligaments,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腕掌背侧韧带：连结远侧列腕骨背侧面和第二至第四掌骨底背侧之间的数条坚韧的短韧带。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Dorsal intercarpal ligaments,L",
                                                            "c": "腕骨间背侧韧带Dorsal intercarpal ligaments,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腕骨间背侧韧带：位于近侧列和远侧列腕骨之间的背侧，连结相邻腕骨的纤维束。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Dorsal metacarpal ligaments,L",
                                                            "c": "掌骨背侧韧带Dorsal metacarpal ligaments,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "掌骨背侧韧带：连结第二至第五掌骨底背侧面之间的横行短韧带。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Dorsal radiocarpal ligament,L",
                                                            "c": "桡腕背侧韧带Dorsal radiocarpal ligament,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "桡腕背侧韧带：位于关节囊的背面，连结桡骨下端的后缘和舟骨、月骨、三角骨背面的韧带。最终移行于腕骨间背侧韧带。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Dorsal radioulnar ligament,L",
                                                            "c": "桡尺背侧韧带Dorsal radioulnar ligament,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "桡尺远侧关节有两条关节囊韧带加强，一条位于关节面的前面，叫桡尺掌侧韧带，旋后时该韧带紧张，另一条位于关节的后面，叫桡尺背侧韧带，旋前时该韧带紧张。桡尺远侧关节主要依靠桡尺掌侧、背侧韧带和关节盘维持稳定。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Extensor retinaculum,L",
                                                            "c": "伸肌支持带Extensor retinaculum,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "伸肌支持带：又名腕背侧韧带，由腕背部深筋膜增厚形成，其内侧附于尺骨茎突和三角骨，外侧附于桡骨远端外侧缘。伸肌支持带向深方发出5个纤维隔附于尺、桡骨的背面，使之形成6个骨纤维性管道，9块前臂后群肌的肌腱及腱鞘在管内通过。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Flexor retinaculum(transverse carpal ligament),L",
                                                            "c": "屈肌支持带Flexor retinaculum(transverse carpal ligament),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "屈肌支持带：又名腕横韧带，位于腕掌侧韧带的远侧深面，厚而坚韧，由致密结缔组织构成的带状结构，长2.5-3cm，宽1.5-2cm，其尺侧端附于豌豆骨和钩骨钩，桡侧端附于手舟骨和大多角骨结节。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Interphalangeal articular capsule of pollex,L",
                                                            "c": "拇指节间关节囊Interphalangeal articular capsule of pollex,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分内、外两层。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Interphalangeal articular capsules of the hand(DIP joints),L",
                                                            "c": "远端指节间关节囊Interphalangeal (distal) articular capsules of the hand(DIP joints),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分内、外两层。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Interphalangeal(proximal)articular capsules of the han (PIP joints),L",
                                                            "c": "近端指节间关节囊Interphalangeal (proximal) articular capsules of the han (PIP joints),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分内、外两层。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Lunotriquetral interosseous ligament,L",
                                                            "c": "月三角骨间韧带Lunotriquetral interosseous ligament,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "月三角骨间韧带：好像舟月骨间韧带的镜像，掌侧部分最厚为横行纤维，背侧部分最薄为斜形纤维，近侧部分由纤维软骨组成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Metacarpophalangeal articular capsule of pollex,L",
                                                            "c": "拇指掌指关节囊Metacarpophalangeal articular capsule of pollex,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分内、外两层。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Metacarpophalangeal articular capsules,L",
                                                            "c": "掌指关节囊Metacarpophalangeal articular capsules,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分内、外两层。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Palmar carpal ligament,L",
                                                            "c": "腕掌侧韧带Palmar carpal ligament,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腕掌侧韧带：腕部深筋膜浅层，两侧与腕背侧的伸肌支持带延续。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Palmar intercarpal ligament(scaphotrapezium),L",
                                                            "c": "舟大多角韧带Palmar intercarpal ligament(scaphotrapezium),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "舟大多角韧带：起于舟骨远极，止于大多角骨掌侧面。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Palmar metacarpal ligaments,L",
                                                            "c": "掌骨掌侧韧带Palmar metacarpal ligaments,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "掌骨掌侧韧带:连结第二至第五掌骨底掌侧面之间的横行短韧带。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Palmar radiocarpal ligament,radiocapitate part,L",
                                                            "c": "桡腕掌侧韧带（桡舟头韧带）Palmar radiocarpal ligament,radiocapitate part,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "桡舟头韧带：起自桡骨茎突掌面的三角面，斜向尺侧，行经舟骨腰部的横凹并与其有薄弱的连接，然后止于头状骨体掌桡侧的近端。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Palmar radiocarpal ligament,radioscapholunate part,L",
                                                            "c": "桡腕掌侧韧带（桡舟月韧带）Palmar radiocarpal ligament,radioscapholunate part,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "桡舟月韧带：位于桡月韧带的尺侧且位置较深。起自桡骨远端桡腕关节面髁间嵴的掌面，并沿髁间嵴向背侧稍微延伸，故起点呈一三角形，韧带向远侧也呈三角形分布，大部分纤维止于舟骨近端的掌面，同时也覆盖近端舟月间隙，与舟月骨间韧带相交织。韧带的尺侧缘有小部分止于月骨掌面的桡侧缘。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Palmar radiocarpal ligament,radiotriquetral part,L",
                                                            "c": "桡腕掌侧韧带（桡三角韧带）Palmar radiocarpal ligament,radiotriquetral part,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "桡三角韧带：起自桡骨茎突背面近桡侧，纤维近乎横行斜向尺侧，越过舟骨背面，止于三角骨背面的桡侧。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Palmar ulnocarpal ligament(ulnolunate and ulnotriquetral),L",
                                                            "c": "尺腕掌侧韧带(尺月、尺三角韧带)Palmar ulnocarpal ligament(ulnolunate and ulnotriquetral),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "尺月韧带：紧邻桡舟月韧带的尺侧起自桡骨末端尺侧的掌面和关节盘掌缘的桡侧半，止于月骨尺侧半的掌面和月三角骨间韧带。此韧带扁宽，较为粗壮，但伸展性小。 尺三角韧带：位于尺月韧带的尺侧，两者相邻紧密。该韧带起自关节盘掌缘的尺侧半，垂直下行止于三角骨的掌面。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Palmar(volar) carpometacarpal ligament,L",
                                                            "c": "腕掌掌侧韧带Palmar carpometacarpal ligament,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腕掌掌侧韧带：连结远侧列腕骨掌侧和第二至第四掌骨底掌侧之间的数条坚韧的短韧带。其中连结第三掌骨的有三条，分别起自大多角骨、头状骨和钩骨。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Palmar(volar) radioulnar ligament,L",
                                                            "c": "桡尺掌侧韧带Palmar radioulnar ligament,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "桡尺远侧关节有两条关节囊韧带加强，一条位于关节面的前面，叫桡尺掌侧韧带，旋后时该韧带紧张，另一条位于关节的后面，叫桡尺背侧韧带，旋前时该韧带紧张。桡尺远侧关节主要依靠桡尺掌侧、背侧韧带和关节盘维持稳定。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Pisohamate ligament,L",
                                                            "c": "豆钩韧带Pisohamate ligament,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "豆钩韧带：起自豌豆骨桡侧远端，止于钩骨的近端尺侧。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Radial carpal collateral ligament,L",
                                                            "c": "腕桡侧副韧带Radial carpal collateral ligament,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腕桡侧副韧带：起于桡骨茎突尖前面，放射状止于舟骨、头状骨以及大多角骨的结缔组织结构。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Radiate carpal ligament,scaphocapitate,L",
                                                            "c": "舟头韧带Radiate carpal ligament,Scaphocapitate,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "舟头韧带：起于舟骨远极，止于头状骨体部掌面。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Radiate carpal ligament,capitohamate,L",
                                                            "c": "头钩韧带Radiate carpal ligament,capitohamate,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "头钩韧带：分掌、背侧及深部三部分，前两部分起于头骨内侧面，止于钩骨外侧面。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Radiate carpal ligament,capitotrapezial,L",
                                                            "c": "头小多角韧带Radiate carpal ligament,capitotrapezial,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "头小多角韧带：分掌、背侧及深部三部分，前两部分起于小多角骨内侧，止于头状骨。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Radiate carpal ligament,scaphotrapezial,L",
                                                            "c": "舟小多角韧带Radiate carpal ligament,scaphotrapezial,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "舟小多角韧带：起于舟骨远极，止于小多角骨掌侧面。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Scapholunate interosseous ligament,L",
                                                            "c": "舟月骨间韧带Scapholunate interosseous ligament,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "舟月骨间韧带：连接于舟骨和月骨，舟月骨间韧带在解剖上分为3个部分，即背侧、近侧和掌侧部分。背侧部分厚，由横行排列的短胶原纤维组成。近侧部分主要由纤维软骨以及少量浅表纵向排列的胶原纤维组成，近侧部分像膝关节的半月板一样，可以突向舟月关节间隙数毫米。桡舟月韧带将舟月骨间韧带掌侧部分与近侧部分分开。掌侧部分薄，由斜行排列的胶原纤维束组成。舟月骨间韧带是维持舟骨近极和舟月骨间关节稳定及运动协调的重要结构。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Superficial transverse metacarpal ligaments,L",
                                                            "c": "掌骨浅横韧带Superficial transverse metacarpal ligaments,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "掌骨浅横韧带：横行纤维在掌骨头平面掌腱膜的4条腱前束之间的横行纤维束增厚形成掌骨浅横韧带，与深面的掌骨深横韧带共同形成蚓状肌管。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Ulnar carpal collateral ligament,L",
                                                            "c": "腕尺侧副韧带Ulnar carpal collateral ligament,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腕尺侧副韧带：起于尺骨茎突尖的扇形纤维结构。分为两束，一束止于三角骨的内侧和背侧，另一束止于豌豆骨及腕横韧带上缘。"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Articulations of upper limb,R",
                                    "c": "右上肢骨连结Articulations of upper limb,R"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "01Articulations of shoulder girdle,R",
                                            "c": "右上肢带连结Articulations of shoulder girdle,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Shoulder joint,R",
                                                    "c": "右肩关节Shoulder joint,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Acromioclavicular ligament,R",
                                                            "c": "肩锁韧带Acromioclavicular ligament,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肩锁韧带：为肩锁关节囊上部增厚的部分，呈长方形，连结锁骨肩峰端与肩峰的上面之间。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Articular capsule(shoulder),R",
                                                            "c": "肩关节囊Articular capsule(shoulder),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分内、外两层。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Coracoacromial ligament,R",
                                                            "c": "喙肩韧带Coracoacromial ligament,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "喙肩韧带：为三角形的扁韧带，连于肩胛骨的喙突与肩峰之间，它与喙突、肩峰共同构成喙肩弓，架于肩关节上方，有防止肱骨头向上脱位的作用。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Coracoclavicular ligament,conoid portion,R",
                                                            "c": "锥状韧带Coracoclavicular ligament,conoid portion,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "锥状韧带：斜方韧带的后内侧，呈椎状，较厚的韧带。底部连结锁骨下面的后缘，尖部连结喙突根部的内侧缘和后缘，部分与肩胛上横韧带愈合。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Coracoclavicular ligament,trapezoid portion,R",
                                                            "c": "斜方韧带Coracoclavicular ligament,trapezoid portion,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "斜方韧带：连结锁骨下面的喙突粗隆和肩胛骨喙突的韧带。位于喙锁韧带前外侧，呈斜方形。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Coracohumeral ligament,R",
                                                            "c": "喙肱韧带Coracohumeral ligament,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "喙肱韧带：为一宽而强的韧带，起自喙突根部的外侧缘，斜向外下方，达肱骨大结节的前面，与冈上肌腱相愈合。其前缘和上缘游离，后续和下缘与关节囊愈合。此韧带加强关节囊的上部，并能限制肱骨向外侧旋转，还防止肱骨头向上方脱位。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Glenoid labrum,R",
                                                            "c": "盂唇Glenoid labrum,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "盂唇：附着于关节盂周缘的纤维软骨环。主要起加深关节窝、增大关节面的作用。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Inferior glenohumeral ligament,R",
                                                            "c": "盂肱下韧带Inferior glenohumeral ligament,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "盂肱韧带：位于关节囊前壁的内侧面，分上、中、下三部，起于关节盂边缘，止于肱骨小结节至肱骨解剖颈下部的韧带。有加强关节囊前壁的作用。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Middle glenohumeral ligament,R",
                                                            "c": "盂肱中韧带Middle glenohumeral ligament,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "盂肱韧带：位于关节囊前壁的内侧面，分上、中、下三部，起于关节盂边缘，止于肱骨小结节至肱骨解剖颈下部的韧带。有加强关节囊前壁的作用。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Superior glenohumeral ligament,R",
                                                            "c": "盂肱上韧带Superior glenohumeral ligament,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "盂肱韧带：位于关节囊前壁的内侧面，分上、中、下三部，起于关节盂边缘，止于肱骨小结节至肱骨解剖颈下部的韧带。有加强关节囊前壁的作用。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Superior transverse scapular ligament,R",
                                                            "c": "肩胛上横韧带Superior transverse scapular ligament,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肩胛上横韧带：连结肩胛骨背侧面上缘和喙突基底部的韧带。横跨肩胛切迹的上方，与此切迹围成一孔，内有肩胛上神经通过。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Transverse humeral ligament,R",
                                                            "c": "肱横韧带Transverse humeral ligament,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肱横韧带：连于大、小结节之间肱骨的固有韧带。与结节间沟共同围成一管，有肱二头肌长头腱通过。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Sternoclavicular joint,R",
                                                    "c": "胸锁关节Sternoclavicular joint,R"
                                                },
                                                "ch":
                                                {
                                                    "sub":
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Capsule of the sternoclavicular joint,R",
                                                            "c": "胸锁关节囊Capsule of the sternoclavicular joint,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    }
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "02Joints of free upper limb,R",
                                            "c": "右自由上肢骨连结Joints of free upper limb,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Elbow joint,R",
                                                    "c": "右肘关节Elbow joint,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Annular ligament of radius,R",
                                                            "c": "桡骨环状韧带Annular ligament of radius,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "桡骨环状韧带：位于桡骨环状关节面的周围，两端附着于尺骨桡切迹的前、后缘，与尺骨桡切迹共同构成一个上口大、下口小的骨纤维环来容纳桡骨头；防止桡骨头脱出。幼儿4岁以前，桡骨头尚在发育之中，环状韧带松弛，在肘关节伸直位猛力牵拉前臂时，桡骨头易被环状韧带卡住，或环状韧带部分夹在肱桡骨之间，从而发生桡骨小头半脱位。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Articular capsule(elbow),R",
                                                            "c": "肘关节囊Articular capsule(elbow),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分内、外两层。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Oblique cord(elbow),R",
                                                            "c": "斜索Oblique cord(elbow),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "斜索：前臂骨间膜上缘的一条斜带状纤维索。起自尺骨粗隆的外侧缘，止于桡骨粗隆稍下方。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Radial collateral ligament,R",
                                                            "c": "桡侧副韧带Radial collateral ligament,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "桡侧副韧带：位于肘关节囊桡侧，起于肱骨外上髁，向下止于桡骨环状韧带的纤维束。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Ulnar collateral ligament,anterior,R",
                                                            "c": "尺侧副韧带前部Ulnar collateral ligament,anterior,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "尺侧副韧带：位于肘关节囊的尺侧，起于肱骨内上髁，向下呈扇形扩展，分为前、中、后部，止于尺骨滑车切迹内侧缘的韧带。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Ulnar collateral ligament,intermediate,R",
                                                            "c": "尺侧副韧带中部Ulnar collateral ligament,intermediate,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "尺侧副韧带：位于肘关节囊的尺侧，起于肱骨内上髁，向下呈扇形扩展，分为前、中、后部，止于尺骨滑车切迹内侧缘的韧带。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Ulnar collateral ligament,posterior,R",
                                                            "c": "尺侧副韧带后部Ulnar collateral ligament,posterior,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "尺侧副韧带：位于肘关节囊的尺侧，起于肱骨内上髁，向下呈扇形扩展，分为前、中、后部，止于尺骨滑车切迹内侧缘的韧带。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Ulnar collateral ligament,transverse,R",
                                                            "c": "尺侧副韧带横束Ulnar collateral ligament,transverse,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "横束：变异很大，组成纤维沿内侧关节囊走向，自鹰嘴尖至尺骨内侧面，恰位于冠状突远端。横束的起点和止点均在尺骨上，所以对肘部的稳定作用很小。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Interousseous membrane(antebrachial),R",
                                                    "c": "前臂骨间膜Interosseous membrane(antebrachial),R"
                                                },
                                                "t":
                                                {
                                                    "s": "前臂骨间膜：连结于尺骨和桡骨的骨间缘之间的纤维膜。上方起于桡骨粗隆下方2-3cm，下至桡骨的尺切迹。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Joints of hand,R",
                                                    "c": "右手关节Joints of hand,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Articular disc of ulna,R",
                                                            "c": "尺骨关节盘Articular disc of ulna,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "尺骨关节盘：位于尺骨头下方的三角形纤维软骨。参与构成桡尺远侧关节和桡腕关节。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Carpometacarpal articular capsule of pollex,R",
                                                            "c": "拇指腕掌关节囊Carpometacarpal articular capsule of pollex,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分内、外两层。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Deep transverse metacarpal ligaments,R",
                                                            "c": "掌骨深横韧带Deep transverse metacarpal ligaments,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "掌骨深横韧带：三条分别连结第二与第三掌骨头、第三与第四掌骨头和第四与第五掌骨头的短宽而扁的纤维束。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Dorsal carpometacarpal ligaments,R",
                                                            "c": "腕掌背侧韧带Dorsal carpometacarpal ligaments,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腕掌背侧韧带：连结远侧列腕骨背侧面和第二至第四掌骨底背侧之间的数条坚韧的短韧带。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Dorsal intercarpal ligaments,R",
                                                            "c": "腕骨间背侧韧带Dorsal intercarpal ligaments,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腕骨间背侧韧带：位于近侧列和远侧列腕骨之间的背侧，连结相邻腕骨的纤维束。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Dorsal metacarpal ligaments,R",
                                                            "c": "掌骨背侧韧带Dorsal metacarpal ligaments,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "掌骨背侧韧带：连结第二至第五掌骨底背侧面之间的横行短韧带。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Dorsal radiocarpal ligament,R",
                                                            "c": "桡腕背侧韧带Dorsal radiocarpal ligament,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "桡腕背侧韧带：位于关节囊的背面，连结桡骨下端的后缘和舟骨、月骨、三角骨背面的韧带。最终移行于腕骨间背侧韧带。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Dorsal radioulnar ligament,R",
                                                            "c": "桡尺背侧韧带Dorsal radioulnar ligament,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "桡尺远侧关节有两条关节囊韧带加强，一条位于关节面的前面，叫桡尺掌侧韧带，旋后时该韧带紧张，另一条位于关节的后面，叫桡尺背侧韧带，旋前时该韧带紧张。桡尺远侧关节主要依靠桡尺掌侧、背侧韧带和关节盘维持稳定。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Extensor retinaculum,R",
                                                            "c": "伸肌支持带Extensor retinaculum,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "伸肌支持带：又名腕背侧韧带，由腕背部深筋膜增厚形成，其内侧附于尺骨茎突和三角骨，外侧附于桡骨远端外侧缘。伸肌支持带向深方发出5个纤维隔附于尺、桡骨的背面，使之形成6个骨纤维性管道，9块前臂后群肌的肌腱及腱鞘在管内通过。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Flexor retinaculum(transverse carpal ligament),R",
                                                            "c": "屈肌支持带Flexor retinaculum(transverse carpal ligament),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "屈肌支持带：又名腕横韧带，位于腕掌侧韧带的远侧深面，厚而坚韧，由致密结缔组织构成的带状结构，长2.5-3cm，宽1.5-2cm，其尺侧端附于豌豆骨和钩骨钩，桡侧端附于手舟骨和大多角骨结节。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Interphalangeal articular capsule of pollex,R",
                                                            "c": "拇指节间关节囊Interphalangeal articular capsule of pollex,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分内、外两层。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Interphalangeal articular capsules of the hand(DIP joints),R",
                                                            "c": "远端指节间关节囊Interphalangeal (distal) articular capsules of the hand(DIP joints),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分内、外两层。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Interphalangeal(proximal)articular capsules of the hand(PIP joints),R",
                                                            "c": "近端指节间关节囊Interphalangeal (proximal) articular capsules of the hand(PIP joints),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分内、外两层。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Lunotriquetral interosseous ligament,R",
                                                            "c": "月三角骨间韧带Lunotriquetral interosseous ligament,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "月三角骨间韧带：好像舟月骨间韧带的镜像，掌侧部分最厚为横行纤维，背侧部分最薄为斜形纤维，近侧部分由纤维软骨组成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Metacarpophalangeal articular capsule of pollex,R",
                                                            "c": "拇指掌指关节囊Metacarpophalangeal articular capsule of pollex,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分内、外两层。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Metacarpophalangeal articular capsules,R",
                                                            "c": "掌指关节囊Metacarpophalangeal articular capsules,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分内、外两层。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Palmar carpal ligament,R",
                                                            "c": "腕掌侧韧带Palmar carpal ligament,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腕掌侧韧带：腕部深筋膜浅层，两侧与腕背侧的伸肌支持带延续。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Palmar intercarpal ligament(scaphotrapezium),R",
                                                            "c": "舟大多角韧带Palmar intercarpal ligament(scaphotrapezium),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "舟大多角韧带：起于舟骨远极，止于大多角骨掌侧面。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Palmar metacarpal ligaments,R",
                                                            "c": "掌骨掌侧韧带Palmar metacarpal ligaments,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "掌骨掌侧韧带:连结第二至第五掌骨底掌侧面之间的横行短韧带。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Palmar radiocarpal ligament,radiocapitate part,R",
                                                            "c": "桡腕掌侧韧带（桡舟头韧带）Palmar radiocarpal ligament,radiocapitate part,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "桡舟头韧带：起自桡骨茎突掌面的三角面，斜向尺侧，行经舟骨腰部的横凹并与其有薄弱的连接，然后止于头状骨体掌桡侧的近端。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Palmar radiocarpal ligament,radioscapholunate part,R",
                                                            "c": "桡腕掌侧韧带（桡舟月韧带）Palmar radiocarpal ligament,radioscapholunate part,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "桡舟月韧带：位于桡月韧带的尺侧且位置较深。起自桡骨远端桡腕关节面髁间嵴的掌面，并沿髁间嵴向背侧稍微延伸，故起点呈一三角形，韧带向远侧也呈三角形分布，大部分纤维止于舟骨近端的掌面，同时也覆盖近端舟月间隙，与舟月骨间韧带相交织。韧带的尺侧缘有小部分止于月骨掌面的桡侧缘。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Palmar radiocarpal ligament,radiotriquetral part,R",
                                                            "c": "桡腕掌侧韧带（桡三角韧带）Palmar radiocarpal ligament,radiotriquetral part,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "桡三角韧带：起自桡骨茎突背面近桡侧，纤维近乎横行斜向尺侧，越过舟骨背面，止于三角骨背面的桡侧。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Palmar ulnocarpal ligament(ulnolunate and ulnotriquetral),R",
                                                            "c": "尺腕掌侧韧带(尺月、尺三角韧带)Palmar ulnocarpal ligament(ulnolunate and ulnotriquetral),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "尺月韧带：紧邻桡舟月韧带的尺侧起自桡骨末端尺侧的掌面和关节盘掌缘的桡侧半，止于月骨尺侧半的掌面和月三角骨间韧带。此韧带扁宽，较为粗壮，但伸展性小。 尺三角韧带：位于尺月韧带的尺侧，两者相邻紧密。该韧带起自关节盘掌缘的尺侧半，垂直下行止于三角骨的掌面。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Palmar(volar) carpometacarpal ligament,R",
                                                            "c": "腕掌掌侧韧带Palmar carpometacarpal ligament,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腕掌掌侧韧带：连结远侧列腕骨掌侧和第二至第四掌骨底掌侧之间的数条坚韧的短韧带。其中连结第三掌骨的有三条，分别起自大多角骨、头状骨和钩骨。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Palmar(volar) radioulnar ligament,R",
                                                            "c": "桡尺掌侧韧带Palmar radioulnar ligament,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "桡尺远侧关节有两条关节囊韧带加强，一条位于关节面的前面，叫桡尺掌侧韧带，旋后时该韧带紧张，另一条位于关节的后面，叫桡尺背侧韧带，旋前时该韧带紧张。桡尺远侧关节主要依靠桡尺掌侧、背侧韧带和关节盘维持稳定。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Pisohamate ligament,R",
                                                            "c": "豆钩韧带Pisohamate ligament,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "豆钩韧带：起自豌豆骨桡侧远端，止于钩骨的近端尺侧。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Radial carpal collateral ligament,R",
                                                            "c": "腕桡侧副韧带Radial carpal collateral ligament,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腕桡侧副韧带：起于桡骨茎突尖前面，放射状止于舟骨、头状骨以及大多角骨的结缔组织结构。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Radiate carpal ligament,scaphocapitate,R",
                                                            "c": "舟头韧带Radiate carpal ligament,scaphocapitate,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "舟头韧带：起于舟骨远极，止于头状骨体部掌面。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Radiate carpal ligament,capitohamate,R",
                                                            "c": "头钩韧带Radiate carpal ligament,capitohamate,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "头钩韧带：分掌、背侧及深部三部分，前两部分起于头骨内侧面，止于钩骨外侧面。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Radiate carpal ligament,capitotrapezial,R",
                                                            "c": "头小多角韧带Radiate carpal ligament,capitotrapezial,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "头小多角韧带：分掌、背侧及深部三部分，前两部分起于小多角骨内侧，止于头状骨。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Radiate carpal ligament,scaphotrapezial,R",
                                                            "c": "舟小多角韧带Radiate carpal ligament,scaphotrapezial,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "舟小多角韧带：起于舟骨远极，止于小多角骨掌侧面。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Scapholunate interosseous ligament,R",
                                                            "c": "舟月骨间韧带Scapholunate interosseous ligament,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "舟月骨间韧带：连接于舟骨和月骨，舟月骨间韧带在解剖上分为3个部分，即背侧、近侧和掌侧部分。背侧部分厚，由横行排列的短胶原纤维组成。近侧部分主要由纤维软骨以及少量浅表纵向排列的胶原纤维组成，近侧部分像膝关节的半月板一样，可以突向舟月关节间隙数毫米。桡舟月韧带将舟月骨间韧带掌侧部分与近侧部分分开。掌侧部分薄，由斜行排列的胶原纤维束组成。舟月骨间韧带是维持舟骨近极和舟月骨间关节稳定及运动协调的重要结构。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Superficial transverse metacarpal ligaments,R",
                                                            "c": "掌骨浅横韧带Superficial transverse metacarpal ligaments,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "掌骨浅横韧带：横行纤维在掌骨头平面掌腱膜的4条腱前束之间的横行纤维束增厚形成掌骨浅横韧带，与深面的掌骨深横韧带共同形成蚓状肌管。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Ulnar carpal collateral ligament,R",
                                                            "c": "腕尺侧副韧带Ulnar carpal collateral ligament,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腕尺侧副韧带：起于尺骨茎突尖的扇形纤维结构。分为两束，一束止于三角骨的内侧和背侧，另一束止于豌豆骨及腕横韧带上缘。"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    }]
                                }
                            }]
                        }
                    },
                    {
                        "$":
                        {
                            "o": "04Articulations of lower limb",
                            "c": "下肢骨连结Articulations of lower limb"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "01Joints of pelvic girdle",
                                    "c": "下肢带连结Joints of pelvic girdle"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "M_Anterior sacroiliac ligament,L",
                                            "c": "骶髂前韧带Anterior sacroiliac ligament,L"
                                        },
                                        "t":
                                        {
                                            "s": "骶髂前韧带：位于骶髂关节前面的韧带。连结骶骨盆面的侧缘与髂骨。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Anterior sacroiliac ligament,R",
                                            "c": "骶髂前韧带Anterior sacroiliac ligament,R"
                                        },
                                        "t":
                                        {
                                            "s": "骶髂前韧带：位于骶髂关节前面的韧带。连结骶骨盆面的侧缘与髂骨。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Inguinal ligament,L",
                                            "c": "腹股沟韧带Inguinal ligament,L"
                                        },
                                        "t":
                                        {
                                            "s": "腹股沟韧带：又称“腹股沟弓”。腹外斜肌腱膜下缘卷折增厚形成的韧带。连于髂前上棘与耻骨结节之间。腹股沟韧带内侧端的一小部分纤维向下后方，并向外侧转折，形成腔隙韧带（陷窝韧带）。腔隙韧带向外侧延续附着于耻骨梳的部分，称为耻骨梳韧带（Cooper韧带）。这些韧带在腹股沟疝和股疝的修补术中都有重要意义。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Inguinal ligament,R",
                                            "c": "腹股沟韧带Inguinal ligament,R"
                                        },
                                        "t":
                                        {
                                            "s": "腹股沟韧带：又称“腹股沟弓”。腹外斜肌腱膜下缘卷折增厚形成的韧带。连于髂前上棘与耻骨结节之间。腹股沟韧带内侧端的一小部分纤维向下后方，并向外侧转折，形成腔隙韧带（陷窝韧带）。腔隙韧带向外侧延续附着于耻骨梳的部分，称为耻骨梳韧带（Cooper韧带）。这些韧带在腹股沟疝和股疝的修补术中都有重要意义。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Iliolumbar ligament,L",
                                            "c": "髂腰韧带Iliolumbar ligament,L"
                                        },
                                        "t":
                                        {
                                            "s": "髂腰韧带：起于第五腰椎横突，止于髂窝后缘和髂嵴后部内唇的强韧、肥厚的三角形韧带。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Iliolumbar ligament,R",
                                            "c": "髂腰韧带lliolumbar ligament,R"
                                        },
                                        "t":
                                        {
                                            "s": "髂腰韧带：起于第五腰椎横突，止于髂窝后缘和髂嵴后部内唇的强韧、肥厚的三角形韧带。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Obturator membrane,L",
                                            "c": "闭孔膜Obturator membrane,L"
                                        },
                                        "t":
                                        {
                                            "s": "闭孔膜：封闭闭孔的一薄层纤维膜。附于闭孔的周缘，上部与闭孔沟之间围城闭膜管。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Obturator membrane,R",
                                            "c": "闭孔膜Obturator membrane,R"
                                        },
                                        "t":
                                        {
                                            "s": "闭孔膜：封闭闭孔的一薄层纤维膜。附于闭孔的周缘，上部与闭孔沟之间围城闭膜管。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Posterior sacroiliac ligament,L",
                                            "c": "骶髂后韧带Posterior sacroiliac ligament,L"
                                        },
                                        "t":
                                        {
                                            "s": "骶髂后韧带：分为骶髂后短韧带和骶髂后长韧带。骶髂后短韧带：起自髂粗隆和髂骨耳状面后部及髂后下棘，斜向内下方，止于骶骨外侧嵴和骶关节嵴。骶髂后长韧带：骶髂后短韧带的浅层，自髂后上棘达第2至第4骶椎的关节突，向内与腰背筋膜相连，向外与骶结节韧带相链接。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Posterior sacroiliac ligament,R",
                                            "c": "骶髂后韧带Posterior sacroiliac ligament,R"
                                        },
                                        "t":
                                        {
                                            "s": "骶髂后韧带：分为骶髂后短韧带和骶髂后长韧带。骶髂后短韧带：起自髂粗隆和髂骨耳状面后部及髂后下棘，斜向内下方，止于骶骨外侧嵴和骶关节嵴。骶髂后长韧带：骶髂后短韧带的浅层，自髂后上棘达第2至第4骶椎的关节突，向内与腰背筋膜相连，向外与骶结节韧带相链接。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Pubic symphysis",
                                            "c": "耻骨联合Pubic symphysis"
                                        },
                                        "t":
                                        {
                                            "s": "耻骨联合：由两侧耻骨联合面借纤维软骨构成的耻骨间盘连结构成。耻骨间盘中往往出现一矢状位的裂隙，女性较男性的厚，裂隙也较大，孕妇和经产妇尤为显著。在耻骨联合的上、下方分别有连结两侧耻骨的耻骨上韧带和耻骨弓状韧带。耻骨联合的活动甚微，但在分娩过程中，耻骨间盘中的裂隙增宽，以增大骨盆的径线。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Sacrospinous ligament,L",
                                            "c": "骶棘韧带Sacrospinous ligament,L"
                                        },
                                        "t":
                                        {
                                            "s": "骶棘韧带：位于骶结节韧带的前方，起自骶、尾骨侧缘，呈三角形，止于坐骨棘，其起始部为骶结节韧带所遮掩。骶棘韧带与坐骨大切迹圈成坐骨大孔，骶棘韧带、骶结节韧带和坐骨小切迹围成坐骨小孔，有肌肉、血管和神经等从盆腔经坐骨大、小孔达臀部和会阴。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Sacrospinous ligament,R",
                                            "c": "骶棘韧带Sacrospinous ligament,R"
                                        },
                                        "t":
                                        {
                                            "s": "骶棘韧带：位于骶结节韧带的前方，起自骶、尾骨侧缘，呈三角形，止于坐骨棘，其起始部为骶结节韧带所遮掩。骶棘韧带与坐骨大切迹圈成坐骨大孔，骶棘韧带、骶结节韧带和坐骨小切迹围成坐骨小孔，有肌肉、血管和神经等从盆腔经坐骨大、小孔达臀部和会阴。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Sacrotuberous ligament,L",
                                            "c": "骶结节韧带Sacrotuberous ligament,L"
                                        },
                                        "t":
                                        {
                                            "s": "骶结节韧带：位于骨盆后方，起自骶、尾骨的侧缘，呈扇形，集中附着于坐骨结节内侧缘。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Sacrotuberous ligament,R",
                                            "c": "骶结节韧带Sacrotuberous ligament,R"
                                        },
                                        "t":
                                        {
                                            "s": "骶结节韧带：位于骨盆后方，起自骶、尾骨的侧缘，呈扇形，集中附着于坐骨结节内侧缘。"
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "02Joints of free lower limb,L",
                                    "c": "左自由下肢骨连结Joints of free lower limb,L"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Hip joint,L",
                                            "c": "左髋关节Hip joint,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "M_Acetabular labrum,L",
                                                    "c": "髋臼唇Acetabular labrum,L"
                                                },
                                                "t":
                                                {
                                                    "s": "髋臼唇：由髋臼的周缘和髋臼横韧带的纤维软骨构成。增加髋臼的深度。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Articular cartilage,acetabulum,L",
                                                    "c": "髋臼软骨Articular cartilage,acetabulum,L"
                                                },
                                                "t":
                                                {
                                                    "s": ""
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Iliofemoral ligament,L",
                                                    "c": "髂股韧带Iliofemoral ligament,L"
                                                },
                                                "t":
                                                {
                                                    "s": "髂股韧带：最为强健，起自髂前下棘，呈人字形向下经囊的前方止于转子间线。可限制大腿过伸，对维持人体直立姿势有很大作用。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Ischiofemoral ligament,L",
                                                    "c": "坐股韧带Ischiofemoral ligament,L"
                                                },
                                                "t":
                                                {
                                                    "s": "坐股韧带：加强关节囊的后部，起自坐骨体，斜向外上与关节囊融合，附着于大转子根部。可限制大腿的旋内运动。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Pubofemoral ligament,L",
                                                    "c": "耻股韧带Pubofemoral ligament,L"
                                                },
                                                "t":
                                                {
                                                    "s": "耻股韧带：由耻骨上支向外下于关节囊前下壁与髂股韧带的深部融合。可限制大腿的外展及旋外运动。"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Interosseous membrane of the leg,L",
                                            "c": "小腿骨间膜Interosseous membrane of the leg,L"
                                        },
                                        "t":
                                        {
                                            "s": "小腿骨间膜：连于胫、腓骨骨间缘之间的坚韧纤维膜。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Joints of foot,L",
                                            "c": "左足关节Joints of foot,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Anterior talofibular ligament,L",
                                                    "c": "距腓前韧带Anterior talofibular ligament,L"
                                                },
                                                "t":
                                                {
                                                    "s": "距腓前韧带：位于踝关节外侧的韧带。起自外踝前缘，向前内止于距骨外踝关节面的前方及距骨颈的外侧面。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Anterior tibiofibular ligament,L",
                                                    "c": "胫腓前韧带Anterior tibiofibular ligament,L"
                                                },
                                                "t":
                                                {
                                                    "s": "胫腓前韧带：连于胫骨下端踝关节面前缘和腓骨下端前缘之间的坚韧的三角形韧带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Bifurcate ligament,L",
                                                    "c": "分歧韧带Bifurcate ligament,L"
                                                },
                                                "t":
                                                {
                                                    "s": "分歧韧带：为强韧的“Y”形韧带，起自跟骨前部背面，向前分为两股，分别止于足的舟骨和骰骨。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Calcaneofibular ligament,L",
                                                    "c": "跟腓韧带Calcaneofibular ligament,L"
                                                },
                                                "t":
                                                {
                                                    "s": "跟腓韧带：起自外踝尖前方，向后下止于跟骨外侧面中部的小结节的一强韧的圆形纤维束。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Deep transverse metatarsal ligament,L",
                                                    "c": "跖骨深横韧带Deep transverse metatarsal ligament,L"
                                                },
                                                "t":
                                                {
                                                    "s": "跖骨深横韧带：位于相邻跖趾关节之间的韧带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Dorsal calcaneocuboid ligaments,L",
                                                    "c": "跟骰背侧韧带Dorsal calcaneocuboid ligaments,L"
                                                },
                                                "t":
                                                {
                                                    "s": "跟骰背侧韧带：位于跟骰关节背侧面，连于跟骨和骰骨上面的纤维束。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Dorsal cuboideonavicular ligament,L",
                                                    "c": "骰舟背侧韧带Dorsal cuboideonavicular ligament,L"
                                                },
                                                "t":
                                                {
                                                    "s": "骰舟背侧韧带：连接足舟骨上面和骰骨上面之间的纤维束。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Dorsal cunecuboid ligament,L",
                                                    "c": "楔骰背侧韧带Dorsal cuneocuboid ligament,L"
                                                },
                                                "t":
                                                {
                                                    "s": "楔骰背侧韧带：连接外侧楔骨的上面和骰骨背侧缘之间的纤维束。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Dorsal cuneonavicular ligaments,L",
                                                    "c": "楔舟背侧韧带Dorsal cuneonavicular ligaments,L"
                                                },
                                                "t":
                                                {
                                                    "s": "楔舟背侧韧带：起于足舟骨上面，向前外方，止于三块楔骨的上面，三条细而强韧的韧带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Dorsal intercuneiform ligaments,L",
                                                    "c": "楔间背侧韧带Dorsal intercuneiform ligaments,L"
                                                },
                                                "t":
                                                {
                                                    "s": "楔间背侧韧带：两条连接三块楔骨背侧面的纤维束。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Dorsal metatarsal ligaments,L",
                                                    "c": "跖骨背侧韧带Dorsal metatarsal ligaments,L"
                                                },
                                                "t":
                                                {
                                                    "s": "跖骨背侧韧带：位于足背侧的连结各跖骨的韧带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Dorsal tarsometatarsal ligaments,L",
                                                    "c": "跗跖背侧韧带Dorsal tarsometatarsal ligaments,L"
                                                },
                                                "t":
                                                {
                                                    "s": "跗跖背侧韧带：位于足背侧连结跗骨和跖骨的韧带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Flexor retinaculum,L",
                                                    "c": "屈肌支持带Flexor retinaculum,L"
                                                },
                                                "t":
                                                {
                                                    "s": "屈肌支持带：附着于内踝与跟骨内侧面之间的韧带。如分裂韧带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Inferior extensor retinaculum,L",
                                                    "c": "伸肌下支持带Inferior extensor retinaculum,L"
                                                },
                                                "t":
                                                {
                                                    "s": "伸肌下支持带：又称“小腿十字韧带”。位于伸肌上支持带下方，呈横置的“Y”型的韧带。其外侧端附于跟骨上面，内侧端以上、下两束分别附着于内踝和足内侧缘并与足底深筋膜融合。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Inferior peroneal retinaculum,L",
                                                    "c": "腓骨肌下支持带Inferior peroneal retinaculum,L"
                                                },
                                                "t":
                                                {
                                                    "s": "腓骨肌下支持带：附着于跟骨前外侧部与伸肌下支持带外侧端之间的韧带。与伸肌下支持带相续，将腓骨长、短肌约束跟骨外侧面。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Interosseous(anterior) talocalcaneal ligament,L",
                                                    "c": "距跟前韧带Interosseous (anterior) talocalcaneal ligament,L"
                                                },
                                                "t":
                                                {
                                                    "s": "距跟前韧带：又称“距跟颈韧带”。起自跗骨窦入口的外侧，向上内止于距骨颈的韧带。具有防止足过度内翻的作用。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Interphalangeal articular capsule of hallux,L",
                                                    "c": "拇趾趾骨间关节囊Interphalangeal articular capsule of hallux,L"
                                                },
                                                "t":
                                                {
                                                    "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分为内、外两层。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Interphalangeal (distal) articular capsule of the foot(DIP joints),L",
                                                    "c": "远端趾节间关节囊Interphalangeal (distal) articular capsule of the foot(DIP joints),L"
                                                },
                                                "t":
                                                {
                                                    "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分为内、外两层。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Interphalangeal (proximal) articular capsule of the foot(PIP joints),L",
                                                    "c": "近端趾节间关节囊Interphalangeal (proximal) articular capsule of the foot(PIP joints),L"
                                                },
                                                "t":
                                                {
                                                    "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分为内、外两层。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Lateral talocalcaneal ligament,L",
                                                    "c": "距跟外侧韧带Lateral talocalcaneal ligament,L"
                                                },
                                                "t":
                                                {
                                                    "s": "距跟外侧韧带：位于跟腓韧带前上方的韧带。短而扁，起自距骨外侧突，向后下止于跟骨外侧面。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Long plantar ligament,L",
                                                    "c": "足底长韧带Long plantar ligament,L"
                                                },
                                                "t":
                                                {
                                                    "s": "足底长韧带：位于足底连结跟骨与第二至第五跖骨底的长而宽阔的韧带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Medial talocalcaneal ligament,L",
                                                    "c": "距跟内侧韧带Medial talocalcaneal ligament,L"
                                                },
                                                "t":
                                                {
                                                    "s": "距跟内侧韧带：细而强韧，起自距骨后突的内侧结节，向前下方止于跟骨载距突的后面的韧带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Medial(deltoid) ligament(anterior tibiotalar part),L",
                                                    "c": "三角韧带胫距前部Medial (deltoid) ligament (anterior tibiotalar part),L"
                                                },
                                                "t":
                                                {
                                                    "s": "三角韧带胫距前部：起自内踝前缘，止于距骨内踝关节面前缘，是内侧韧带的胫距前部分。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Medial(deltoid) ligament(posterior tibiotalar part),L",
                                                    "c": "三角韧带胫距后部Medial (deltoid) ligament (posterior tibiotalar part),L"
                                                },
                                                "t":
                                                {
                                                    "s": "三角韧带胫距后部：起自内踝，止于距骨的内侧面及距骨后突内侧的小结节，是内侧韧带的胫距后部分。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Medial(deltoid) ligament(tibiocalcaneal part),L",
                                                    "c": "三角韧带胫跟部Medial (deltoid) ligament (tibiocalcaneal part),L"
                                                },
                                                "t":
                                                {
                                                    "s": "三角韧带胫跟部：内侧韧带的中间部。肥厚坚韧，起自内踝前缘，止于跟骨的载距突。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Medial(deltoid) ligament(tibionavicular part),L",
                                                    "c": "三角韧带胫舟部Medial (deltoid) ligament (tibionavicular part),L"
                                                },
                                                "t":
                                                {
                                                    "s": "三角韧带胫舟部：内侧韧带的前部。起自内踝的前面，止于舟骨粗隆及跟舟足底韧带的内侧缘。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Metatarsophalangeal articular capsules,L",
                                                    "c": "跖趾关节囊Metatarsophalangeal articular capsules,L"
                                                },
                                                "t":
                                                {
                                                    "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分为内、外两层。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Metatarsophalangeal carticular capsule of hallux,L",
                                                    "c": "拇趾跖趾关节囊Metatarsophalangeal carticular capsule of hallux,L"
                                                },
                                                "t":
                                                {
                                                    "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分为内、外两层。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Plantar aponeurosis(planter fascia),L",
                                                    "c": "足底腱膜Plantar aponeurosis(planter fascia),L"
                                                },
                                                "t":
                                                {
                                                    "s": "足底腱膜：足底深筋膜的中间部。较厚，呈三角形。后端较狭细附于跟骨结节，前端呈扇形分开至各趾，向深面发出两个肌间隔，分别附于第一、五跖骨，将足底分为3个骨筋膜鞘，容纳足底的三群肌肉。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Plantar calcaneocuboid(short plantar) ligament,L",
                                                    "c": "跟骰足底韧带Plantar calcaneocuboid (short plantar) ligament,L"
                                                },
                                                "t":
                                                {
                                                    "s": "跟骰足底韧带：位于足底的连结跟骨和骰骨的韧带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Plantar calcaneonavicular(spring) ligament,L",
                                                    "c": "跟舟足底韧带Plantar calcaneonavicular (spring) ligament,L"
                                                },
                                                "t":
                                                {
                                                    "s": "跟舟足底韧带：又称“跳跃韧带”。位于足底，连结跟骨与舟骨之间的宽而肥厚的纤维带。对维持足的内侧弓起重要作用。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Plantar cuboideonavicular ligament,L",
                                                    "c": "骰舟足底韧带Plantar cuboideonavicular ligament,L"
                                                },
                                                "t":
                                                {
                                                    "s": "骰舟足底韧带：位于足底的连结骰骨和舟骨的韧带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Plantar metatarsal ligaments,L",
                                                    "c": "跖骨足底韧带Plantar metatarsal ligaments,L"
                                                },
                                                "t":
                                                {
                                                    "s": "跖骨足底韧带：位于足底的连结各跖骨的韧带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Posterior talocalcaneal ligament,L",
                                                    "c": "距跟后韧带Posterior talocalcaneal ligament,L"
                                                },
                                                "t":
                                                {
                                                    "s": "距跟后韧带:起自距骨后突及长屈肌腱沟的下缘，止于跟骨后关节面后侧的韧带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Posterior talofibular ligament,L",
                                                    "c": "距腓后韧带Posterior talofibular ligament,L"
                                                },
                                                "t":
                                                {
                                                    "s": "距腓后韧带：位于踝关节外侧的韧带。位置较深，很强韧，起自外踝后缘，水平向后止于距骨后突。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Posterior tibiofibular ligament,L",
                                                    "c": "胫腓后韧带Posterior tibiofibular ligament,L"
                                                },
                                                "t":
                                                {
                                                    "s": "胫腓后韧带：连结胫、腓骨下端后面的韧带。较胫腓前韧带强韧。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Superior extensor retinaculum,L",
                                                    "c": "伸肌上支持带Superior extensor retinaculum,L"
                                                },
                                                "t":
                                                {
                                                    "s": "伸肌上支持带：又称小腿横韧带，呈宽带状位于踝关节前上方，连于胫、腓骨下端之间。其深面有两个间隙，内侧者有胫骨前肌腱、胫前血管和腓深神经通过；外侧者有拇长伸肌腱、趾长伸肌腱和第3腓骨肌通过。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Superior peroneal retinaculum,L",
                                                    "c": "腓骨肌上支持带Superior peroneal retinaculum,L"
                                                },
                                                "t":
                                                {
                                                    "s": "腓骨肌上支持带：附着于外踝与跟骨外侧面之间的韧带。约束腓骨长、短肌腱于外踝的后方。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Talonavicular ligament,L",
                                                    "c": "距舟韧带Talonavicular ligament,L"
                                                },
                                                "t":
                                                {
                                                    "s": "距舟韧带：又称“背侧韧带”。宽而薄，起于距骨颈的上面和外侧面，止于足舟骨上面的韧带。"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Knee joint,L",
                                            "c": "左膝关节Knee joint,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Anterior cruciate ligament(ACL),L",
                                                    "c": "前交叉韧带Anterior cruciate ligament(ACL),L"
                                                },
                                                "t":
                                                {
                                                    "s": "前交叉韧带：起自胫骨髁间隆起的前方内侧，与外侧半月板的前角愈着，斜向后上方外侧，纤维呈扇形附着于股骨外侧髁的内侧。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Anterolateral ligament(ALL),L",
                                                    "c": "前外侧韧带Anterolateral ligament(ALL),L"
                                                },
                                                "t":
                                                {
                                                    "s": "前外侧韧带：是人体膝关节的横向韧带，位于腓侧副韧带之前。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Lateral collateral(fibular collateral) ligament(LCL),L",
                                                    "c": "腓侧副韧带Lateral collateral (fibular collateral) ligament(LCL),L"
                                                },
                                                "t":
                                                {
                                                    "s": "腓侧副韧带：起自股骨外上踝，向下止于腓骨头的索状纤维束。位于关节囊的外侧，与关节囊之间留有间隙。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Lateral meniscus,L",
                                                    "c": "外侧半月板Lateral meniscus,L"
                                                },
                                                "t":
                                                {
                                                    "s": "外侧半月板：位于胫骨外侧髁关节面上的纤维软骨。近似环形，内薄外厚，上面光滑微凹，与股骨外侧髁相接。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Medial collateral(tibial collateral) ligament(MCL),L",
                                                    "c": "胫侧副韧带Medial collateral (tibial collateral) ligament(MCL),L"
                                                },
                                                "t":
                                                {
                                                    "s": "胫侧副韧带：位于关节囊的内侧，起自股骨内上髁，向下止于胫骨内侧髁，前部与膑内侧支持带愈合，后部与关节囊和内侧半月板结合的韧带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Medial meniscus,L",
                                                    "c": "内侧半月板Medial meniscus,L"
                                                },
                                                "t":
                                                {
                                                    "s": "内侧半月板：位于胫骨内侧髁关节面上的纤维软骨。呈“C”形，内薄外厚，上面光滑微凹，与股骨内侧髁相接。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Patellar ligament,L",
                                                    "c": "髌韧带Patellar ligament,L"
                                                },
                                                "t":
                                                {
                                                    "s": "髌韧带：股四头肌腱的下续部分。肥厚而坚韧，位于关节囊的前部，起自髌骨下缘，止于胫骨粗隆。内、外侧分别移行为髌内、外侧支持带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Posterior cruciate ligament(PCL),L",
                                                    "c": "后交叉韧带Posterior cruciate ligament(PCL),L"
                                                },
                                                "t":
                                                {
                                                    "s": "后交叉韧带：起自胫骨髁间隆起的后方，斜向前上方，附于股骨内侧髁的外侧面的一条韧带。屈膝时最紧张，可防止胫骨后移。"
                                                }
                                            }]
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "03Joints of free lower limb,R",
                                    "c": "右自由下肢骨连结Joints of free lower limb,R"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Hip joint,R",
                                            "c": "右髋关节Hip joint,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "M_Acetabular labrum,R",
                                                    "c": "髋臼唇Acetabular labrum,R"
                                                },
                                                "t":
                                                {
                                                    "s": "髋臼唇：由髋臼的周缘和髋臼横韧带的纤维软骨构成。增加髋臼的深度。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Articular cartilage,acetabulum,R",
                                                    "c": "髋臼软骨Articular cartilage,acetabulum,R"
                                                },
                                                "t":
                                                {
                                                    "s": ""
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Iliofemoral ligament,R",
                                                    "c": "髂股韧带Iliofemoral ligament,R"
                                                },
                                                "t":
                                                {
                                                    "s": "髂股韧带：最为强健，起自髂前下棘，呈人字形向下经囊的前方止于转子间线。可限制大腿过伸，对维持人体直立姿势有很大作用。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Ischiofemoral ligament,R",
                                                    "c": "坐股韧带Ischiofemoral ligament,R"
                                                },
                                                "t":
                                                {
                                                    "s": "坐股韧带：加强关节囊的后部，起自坐骨体，斜向外上与关节囊融合，附着于大转子根部。可限制大腿的旋内运动。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Pubofemoral ligament,R",
                                                    "c": "耻股韧带Pubofemoral ligament,R"
                                                },
                                                "t":
                                                {
                                                    "s": "耻股韧带：由耻骨上支向外下于关节囊前下壁与髂股韧带的深部融合。可限制大腿的外展及旋外运动。"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Interosseous membrane of the leg,R",
                                            "c": "小腿骨间膜Interosseous membrane of the leg,R"
                                        },
                                        "t":
                                        {
                                            "s": "小腿骨间膜：连于胫、腓骨骨间缘之间的坚韧纤维膜。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Joints of foot,R",
                                            "c": "右足关节Joints of foot,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Anterior talofibular ligament,R",
                                                    "c": "距腓前韧带Anterior talofibular ligament,R"
                                                },
                                                "t":
                                                {
                                                    "s": "距腓前韧带：位于踝关节外侧的韧带。起自外踝前缘，向前内止于距骨外踝关节面的前方及距骨颈的外侧面。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Anterior tibiofibular ligament,R",
                                                    "c": "胫腓前韧带Anterior tibiofibular ligament,R"
                                                },
                                                "t":
                                                {
                                                    "s": "胫腓前韧带：连于胫骨下端踝关节面前缘和腓骨下端前缘之间的坚韧的三角形韧带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Bifurcate ligament,R",
                                                    "c": "分歧韧带Bifurcate ligament,R"
                                                },
                                                "t":
                                                {
                                                    "s": "分歧韧带：为强韧的“Y”形韧带，起自跟骨前部背面，向前分为两股，分别止于足的舟骨和骰骨。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Calcaneofibular ligament,R",
                                                    "c": "跟腓韧带Calcaneofibular ligament,R"
                                                },
                                                "t":
                                                {
                                                    "s": "跟腓韧带：起自外踝尖前方，向后下止于跟骨外侧面中部的小结节的一强韧的圆形纤维束。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Deep transverse metatarsal ligament,R",
                                                    "c": "跖骨深横韧带Deep transverse metatarsal ligament,R"
                                                },
                                                "t":
                                                {
                                                    "s": "跖骨深横韧带：位于相邻跖趾关节之间的韧带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Dorsal calcaneocuboid ligaments,R",
                                                    "c": "跟骰背侧韧带Dorsal calcaneocuboid ligaments,R"
                                                },
                                                "t":
                                                {
                                                    "s": "跟骰背侧韧带：位于跟骰关节背侧面，连于跟骨和骰骨上面的纤维束。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Dorsal cuboideonavicular ligament,R",
                                                    "c": "骰舟背侧韧带Dorsal cuboideonavicular ligament,R"
                                                },
                                                "t":
                                                {
                                                    "s": "骰舟背侧韧带：连接足舟骨上面和骰骨上面之间的纤维束。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Dorsal cunecuboid ligament,R",
                                                    "c": "楔骰背侧韧带Dorsal cuneocuboid ligament,R"
                                                },
                                                "t":
                                                {
                                                    "s": "楔骰背侧韧带：连接外侧楔骨的上面和骰骨背侧缘之间的纤维束。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Dorsal cuneonavicular ligaments,R",
                                                    "c": "楔舟背侧韧带Dorsal cuneonavicular ligaments,R"
                                                },
                                                "t":
                                                {
                                                    "s": "楔舟背侧韧带：起于足舟骨上面，向前外方，止于三块楔骨的上面，三条细而强韧的韧带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Dorsal intercuneiform ligaments,R",
                                                    "c": "楔间背侧韧带Dorsal intercuneiform ligaments,R"
                                                },
                                                "t":
                                                {
                                                    "s": "楔间背侧韧带：两条连接三块楔骨背侧面的纤维束。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Dorsal metatarsal ligaments,R",
                                                    "c": "跖骨背侧韧带Dorsal metatarsal ligaments,R"
                                                },
                                                "t":
                                                {
                                                    "s": "跖骨背侧韧带：位于足背侧的连结各跖骨的韧带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Dorsal tarsometatarsal ligaments,R",
                                                    "c": "跗跖背侧韧带Dorsal tarsometatarsal ligaments,R"
                                                },
                                                "t":
                                                {
                                                    "s": "跗跖背侧韧带：位于足背侧连结跗骨和跖骨的韧带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Flexor retinaculum,R",
                                                    "c": "屈肌支持带Flexor retinaculum,R"
                                                },
                                                "t":
                                                {
                                                    "s": "屈肌支持带：附着于内踝与跟骨内侧面之间的韧带。如分裂韧带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Inferior extensor retinaculum,R",
                                                    "c": "伸肌下支持带Inferior extensor retinaculum,R"
                                                },
                                                "t":
                                                {
                                                    "s": "伸肌下支持带：又称“小腿十字韧带”。位于伸肌上支持带下方，呈横置的“Y”型的韧带。其外侧端附于跟骨上面，内侧端以上、下两束分别附着于内踝和足内侧缘并与足底深筋膜融合。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Inferior peroneal retinaculum,R",
                                                    "c": "腓骨肌下支持带Inferior peroneal retinaculum,R"
                                                },
                                                "t":
                                                {
                                                    "s": "腓骨肌下支持带：附着于跟骨前外侧部与伸肌下支持带外侧端之间的韧带。与伸肌下支持带相续，将腓骨长、短肌约束跟骨外侧面。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Interosseous(anterior) talocalcaneal ligament,R",
                                                    "c": "距跟前韧带Interosseous (anterior) talocalcaneal ligament,R"
                                                },
                                                "t":
                                                {
                                                    "s": "距跟前韧带：又称“距跟颈韧带”。起自跗骨窦入口的外侧，向上内止于距骨颈的韧带。具有防止足过度内翻的作用。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Interphalangeal articular capsule of hallux,R",
                                                    "c": "拇趾趾骨间关节囊Interphalangeal articular capsule of hallux,R"
                                                },
                                                "t":
                                                {
                                                    "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分为内、外两层。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Interphalangeal (distal) articular capsule of the foot(DIP joints),R",
                                                    "c": "远端趾节间关节囊Interphalangeal (distal) articular capsule of the foot(DIP joints),R"
                                                },
                                                "t":
                                                {
                                                    "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分为内、外两层。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Interphalangeal (proximal) articular capsule of the foot(PIP joints),R",
                                                    "c": "近端趾节间关节囊Interphalangeal (proximal) articular capsule of the foot(PIP joints),R"
                                                },
                                                "t":
                                                {
                                                    "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分为内、外两层。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Lateral talocalcaneal ligament,R",
                                                    "c": "距跟外侧韧带Lateral talocalcaneal ligament,R"
                                                },
                                                "t":
                                                {
                                                    "s": "距跟外侧韧带：位于跟腓韧带前上方的韧带。短而扁，起自距骨外侧突，向后下止于跟骨外侧面。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Long plantar ligament,R",
                                                    "c": "足底长韧带Long plantar ligament,R"
                                                },
                                                "t":
                                                {
                                                    "s": "足底长韧带：位于足底连结跟骨与第二至第五跖骨底的长而宽阔的韧带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Medial talocalcaneal ligament,R",
                                                    "c": "距跟内侧韧带Medial talocalcaneal ligament,R"
                                                },
                                                "t":
                                                {
                                                    "s": "距跟内侧韧带��细而强韧，起自距骨后突的内侧结节，向前下方止于跟骨载距突的后面的韧带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Medial(deltoid) ligament(anterior tibiotalar part),R",
                                                    "c": "三角韧带胫距前部Medial (deltoid) ligament (anterior tibiotalar part),R"
                                                },
                                                "t":
                                                {
                                                    "s": "三角韧带胫距前部：起自内踝前缘，止于距骨内踝关节面前缘，是内侧韧带的胫距前部分。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Medial(deltoid) ligament(posterior tibiotalar part),R",
                                                    "c": "三角韧带胫距后部Medial (deltoid) ligament (posterior tibiotalar part),R"
                                                },
                                                "t":
                                                {
                                                    "s": "三角韧带胫距后部：起自内踝，止于距骨的内侧面及距骨后突内侧的小结节，是内侧韧带的胫距后部分。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Medial(deltoid) ligament(tibiocalcaneal part),R",
                                                    "c": "三角韧带胫跟部Medial (deltoid) ligament (tibiocalcaneal part),R"
                                                },
                                                "t":
                                                {
                                                    "s": "三角韧带胫跟部：内侧韧带的中间部。肥厚坚韧，起自内踝前缘，止于跟骨的载距突。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Medial(deltoid) ligament(tibionavicular part),R",
                                                    "c": "三角韧带胫舟部Medial (deltoid) ligament (tibionavicular part),R"
                                                },
                                                "t":
                                                {
                                                    "s": "三角韧带胫舟部：内侧韧带的前部。起自内踝的前面，止于舟骨粗隆及跟舟足底韧带的内侧缘。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Metatarsophalangeal articular capsules,R",
                                                    "c": "跖趾关节囊Metatarsophalangeal articular capsules,R"
                                                },
                                                "t":
                                                {
                                                    "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分为内、外两层。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Metatarsophalangeal carticular capsule of hallux,R",
                                                    "c": "拇趾跖趾关节囊Metatarsophalangeal carticular capsule of hallux,R"
                                                },
                                                "t":
                                                {
                                                    "s": "关节囊：结缔组织膜构成的囊。附着于关节面周缘及其相邻的骨面上，并与骨膜融合，分为内、外两层。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Plantar aponeurosis(planter fascia),R",
                                                    "c": "足底腱膜Plantar aponeurosis(planter fascia),R"
                                                },
                                                "t":
                                                {
                                                    "s": "足底腱膜：足底深筋膜的中间部。较厚，呈三角形。后端较狭细附于跟骨结节，前端呈扇形分开至各趾，向深面发出两个肌间隔，分别附于第一、五跖骨，将足底分为3个骨筋膜鞘，容纳足底的三群肌肉。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Plantar calcaneocuboid(short plantar) ligament,R",
                                                    "c": "跟骰足底韧带Plantar calcaneocuboid (short plantar) ligament,R"
                                                },
                                                "t":
                                                {
                                                    "s": "跟骰足底韧带：位于足底的连结跟骨和骰骨的韧带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Plantar calcaneonavicular(spring) ligament,R",
                                                    "c": "跟舟足底韧带Plantar calcaneonavicular (spring) ligament,R"
                                                },
                                                "t":
                                                {
                                                    "s": "跟舟足底韧带：又称“跳跃韧带”。位于足底，连结跟骨与舟骨之间的宽而肥厚的纤维带。对维持足的内侧弓起重要作用。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Plantar cuboideonavicular ligament,R",
                                                    "c": "骰舟足底韧带Plantar cuboideonavicular ligament,R"
                                                },
                                                "t":
                                                {
                                                    "s": "骰舟足底韧带：位于足底的连结骰骨和舟骨的韧带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Plantar metatarsal ligaments,R",
                                                    "c": "跖骨足底韧带Plantar metatarsal ligaments,R"
                                                },
                                                "t":
                                                {
                                                    "s": "跖骨足底韧带：位于足底的连结各跖骨的韧带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Posterior talocalcaneal ligament,R",
                                                    "c": "距跟后韧带Posterior talocalcaneal ligament,R"
                                                },
                                                "t":
                                                {
                                                    "s": "距跟后韧带:起自距骨后突及长屈肌腱沟的下缘，止于跟骨后关节面后侧的韧带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Posterior talofibular ligament,R",
                                                    "c": "距腓后韧带Posterior talofibular ligament,R"
                                                },
                                                "t":
                                                {
                                                    "s": "距腓后韧带：位于踝关节外侧的韧带。位置较深，很强韧，起自外踝后缘，水平向后止于距骨后突。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Posterior tibiofibular ligament,R",
                                                    "c": "胫腓后韧带Posterior tibiofibular ligament,R"
                                                },
                                                "t":
                                                {
                                                    "s": "胫腓后韧带：连结胫、腓骨下端后面的韧带。较胫腓前韧带强韧。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Superior extensor retinaculum,R",
                                                    "c": "伸肌上支持带Superior extensor retinaculum,R"
                                                },
                                                "t":
                                                {
                                                    "s": "伸肌上支持带：又称小腿横韧带，呈宽带状位于踝关节前上方，连于胫、腓骨下端之间。其深面有两个间隙，内侧者有胫骨前肌腱、胫前血管和腓深神经通过；外侧者有拇长伸肌腱、趾长伸肌腱和第3腓骨肌通过。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Superior peroneal retinaculum,R",
                                                    "c": "腓骨肌上支持带Superior peroneal retinaculum,R"
                                                },
                                                "t":
                                                {
                                                    "s": "腓骨肌上支持带：附着于外踝与跟骨外侧面之间的韧带。约束腓骨长、短肌腱于外踝的后方。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Talonavicular ligament,R",
                                                    "c": "距舟韧带Talonavicular ligament,R"
                                                },
                                                "t":
                                                {
                                                    "s": "距舟韧带：又称“背侧韧带”。宽而薄，起于距骨颈的上面和外侧面，止于足舟骨上面的韧带。"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Knee joint,R",
                                            "c": "右膝关节Knee joint,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Anterior cruciate ligament(ACL),R",
                                                    "c": "前交叉韧带Anterior cruciate ligament(ACL),R"
                                                },
                                                "t":
                                                {
                                                    "s": "前交叉韧带：起自胫骨髁间隆起的前方内侧，与外侧半月板的前角愈着，斜向后上方外侧，纤维呈扇形附着于股骨外侧髁的内侧。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Anterolateral ligament(ALL),R",
                                                    "c": "前外侧韧带Anterolateral ligament(ALL),R"
                                                },
                                                "t":
                                                {
                                                    "s": "前外侧韧带：是人体膝关节的横向韧带，位于腓侧副韧带之前。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Lateral collateral(fibular collateral) ligament(LCL),R",
                                                    "c": "腓侧副韧带Lateral collateral (fibular collateral) ligament(LCL),R"
                                                },
                                                "t":
                                                {
                                                    "s": "腓侧副韧带：起自股骨外上踝，向下止于腓骨头的索状纤维束。位于关节囊的外侧，与关节囊之间留有间隙。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Lateral meniscus,R",
                                                    "c": "外侧半月板Lateral meniscus,R"
                                                },
                                                "t":
                                                {
                                                    "s": "外侧半月板：位于胫骨外侧髁关节面上的纤维软骨。近似环形，内薄外厚，上面光滑微凹，与股骨外侧髁相接。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Medial collateral(tibial collateral) ligament(MCL),R",
                                                    "c": "胫侧副韧带Medial collateral (tibial collateral) ligament(MCL),R"
                                                },
                                                "t":
                                                {
                                                    "s": "胫侧副韧带：位于关节囊的内侧，起自股骨内上髁，向下止于胫骨内侧髁，前部与膑内侧支持带愈合，后部与关节囊和内侧半月板结合的韧带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Medial meniscus,R",
                                                    "c": "内侧半月板Medial meniscus,R"
                                                },
                                                "t":
                                                {
                                                    "s": "内侧半月板：位于胫骨内侧髁关节面上的纤维软骨。呈“C”形，内薄外厚，上面光滑微凹，与股骨内侧髁相接。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Patellar ligament,R",
                                                    "c": "髌韧带Patellar ligament,R"
                                                },
                                                "t":
                                                {
                                                    "s": "髌韧带：股四头肌腱的下续部分。肥厚而坚韧，位于关节囊的前部，起自髌骨下缘，止于胫骨粗隆。内、外侧分别移行为髌内、外侧支持带。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Posterior cruciate ligament(PCL),R",
                                                    "c": "后交叉韧带Posterior cruciate ligament(PCL),R"
                                                },
                                                "t":
                                                {
                                                    "s": "后交叉韧带：起自胫骨髁间隆起的后方，斜向前上方，附于股骨内侧髁的外侧面的一条韧带。屈膝时最紧张，可防止胫骨后移。"
                                                }
                                            }]
                                        }
                                    }]
                                }
                            }]
                        }
                    }]
                }
            },
            {
                "$":
                {
                    "o": "005Skeletal system",
                    "c": "骨骼系统Skeletal system"
                },
                "ch":
                {
                    "sub": [
                    {
                        "$":
                        {
                            "o": "01Bone of trunk",
                            "c": "躯干骨Bone of trunk"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "01Vertebral column",
                                    "c": "椎骨Vertebral column"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "01Cervical vertebrae",
                                            "c": "颈椎Cervical vertebrae"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "C01 Atlas",
                                                    "c": "寰椎C01 Atlas"
                                                },
                                                "t":
                                                {
                                                    "s": "第1颈椎又名寰椎，呈环状，无椎体、棘突和关节突，由前弓、后弓及侧块组成。前弓较短，后面正中有齿突凹，与枢椎的齿突相关节。侧块连接前后两弓，上面各有一椭圆形关节面，与枕髁相关节；下面有圆形关节面与枢椎上关节面相关节。后弓较长，上面有横行的椎动脉沟，有椎动脉通过。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "C02 Axis",
                                                    "c": "枢椎C02 Axis"
                                                },
                                                "t":
                                                {
                                                    "s": "第2颈椎又名枢椎，特点是椎体向上伸出齿突，与寰椎齿突凹相关节。齿突原为寰椎椎体，发育过程中脱离寰椎而与枢椎椎体融合。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "C03 Vertebra",
                                                    "c": "第三颈椎C03 Vertebra"
                                                },
                                                "t":
                                                {
                                                    "s": "颈椎：椎体较小，横断面呈椭圆形；上、下关节突的关节面几乎呈水平位。第3-7颈椎体上面侧缘向上突起称椎体钩。椎体钩与上位椎体下面的两侧唇缘相接，则形成钩椎关节，又称Luschka关节。如椎体钩过度增生肥大，可使椎间孔狭窄，压迫脊神经，产生颈椎病的症状和体征。颈椎椎孔较大，呈三角形。横突有孔，称横突孔，有椎动脉和椎静脉通过。第6颈椎横突末端前方的结节特别隆起，称颈动脉结节，有颈总动脉经其前方。当头部出血时，可用手指将颈总动脉压于此结节，进行暂时止血。第2-6颈椎的棘突较短，末端分叉。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "C04 Vertebra",
                                                    "c": "第四颈椎C04 Vertebra"
                                                },
                                                "t":
                                                {
                                                    "s": "颈椎：椎体较小，横断面呈椭圆形；上、下关节突的关节面几乎呈水平位。第3-7颈椎体上面侧缘向上突起称椎体钩。椎体钩与上位椎体下面的两侧唇缘相接，则形成钩椎关节，又称Luschka关节。如椎体钩过度增生肥大，可使椎间孔狭窄，压迫脊神经，产生颈椎病的症状和体征。颈椎椎孔较大，呈三角形。横突有孔，称横突孔，有椎动脉和椎静脉通过。第6颈椎横突末端前方的结节特别隆起，称颈动脉结节，有颈总动脉经其前方。当头部出血时，可用手指将颈总动脉压于此结节，进行暂时止血。第2-6颈椎的棘突较短，末端分叉。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "C05 Vertebra",
                                                    "c": "第五颈椎C05 Vertebra"
                                                },
                                                "t":
                                                {
                                                    "s": "颈椎：椎体较小，横断面呈椭圆形；上、下关节突的关节面几乎呈水平位。第3-7颈椎体上面侧缘向上突起称椎体钩。椎体钩与上位椎体下面的两侧唇缘相接，则形成钩椎关节，又称Luschka关节。如椎体钩过度增生肥大，可使椎间孔狭窄，压迫脊神经，产生颈椎病的症状和体征。颈椎椎孔较大，呈三角形。横突有孔，称横突孔，有椎动脉和椎静脉通过。第6颈椎横突末端前方的结节特别隆起，称颈动脉结节，有颈总动脉经其前方。当头部出血时，可用手指将颈总动脉压于此结节，进行暂时止血。第2-6颈椎的棘突较短，末端分叉。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "C06 Vertebra",
                                                    "c": "第六颈椎C06 Vertebra"
                                                },
                                                "t":
                                                {
                                                    "s": "颈椎：椎体较小，横断面呈椭圆形；上、下关节突的关节面几乎呈水平位。第3-7颈椎体上面侧缘向上突起称椎体钩。椎体钩与上位椎体下面的两侧唇缘相接，则形成钩椎关节，又称Luschka关节。如椎体钩过度增生肥大，可使椎间孔狭窄，压迫脊神经，产生颈椎病的症状和体征。颈椎椎孔较大，呈三角形。横突有孔，称横突孔，有椎动脉和椎静脉通过。第6颈椎横突末端前方的结节特别隆起，称颈动脉结节，有颈总动脉经其前方。当头部出血时，可用手指将颈总动脉压于此结节，进行暂时止血。第2-6颈椎的棘突较短，末端分叉。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "C07 Vertebra",
                                                    "c": "第七颈椎C07 Vertebra"
                                                },
                                                "t":
                                                {
                                                    "s": "颈椎：椎体较小，横断面呈椭圆形；上、下关节突的关节面几乎呈水平位。第3-7颈椎体上面侧缘向上突起称椎体钩。椎体钩与上位椎体下面的两侧唇缘相接，则形成钩椎关节，又称Luschka关节。如椎体钩过度增生肥大，可使椎间孔狭窄，压迫脊神经，产生颈椎病的症状和体征。颈椎椎孔较大，呈三角形。横突有孔，称横突孔，有椎动脉和椎静脉通过。第6颈椎横突末端前方的结节特别隆起，称颈动脉结节，有颈总动脉经其前方。当头部出血时，可用手指将颈总动脉压于此结节，进行暂时止血。第2-6颈椎的棘突较短，末端分叉。"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "02Thoracic vertebrae",
                                            "c": "胸椎Thoracic vertebrae"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "T01 Vertebra",
                                                    "c": "第一胸椎T01 Vertebra"
                                                },
                                                "t":
                                                {
                                                    "s": "胸椎：椎体从上向下逐渐增大，横断面呈心形。在椎体两侧面后份的上缘和下缘处，有半圆形浅凹。称上、下肋凹，与肋头相关节。在横突末端前面，有横突肋凹与肋结节相关节。关节突的关节面几乎呈冠状位，上关节突关节面朝向后，下关节突的则朝向前。棘突较长，向后下方倾斜，各相邻棘突呈叠瓦状排列。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "T02 Vertebra",
                                                    "c": "第二胸椎T02 Vertebra"
                                                },
                                                "t":
                                                {
                                                    "s": "胸椎：椎体从上向下逐渐增大，横断面呈心形。在椎体两侧面后份的上缘和下缘处，有半圆形浅凹。称上、下肋凹，与肋头相关节。在横突末端前面，有横突肋凹与肋结节相关节。关节突的关节面几乎呈冠状位，上关节突关节面朝向后，下关节突的则朝向前。棘突较长，向后下方倾斜，各相邻棘突呈叠瓦状排列。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "T03 Vertebra",
                                                    "c": "第三胸椎T03 Vertebra"
                                                },
                                                "t":
                                                {
                                                    "s": "胸椎：椎体从上向下逐渐增大，横断面呈心形。在椎体两侧面后份的上缘和下缘处，有半圆形浅凹。称上、下肋凹，与肋头相关节。在横突末端前面，有横突肋凹与肋结节相关节。关节突的关节面几乎呈冠状位，上关节突关节面朝向后，下关节突的则朝向前。棘突较长，向后下方倾斜，各相邻棘突呈叠瓦状排列。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "T04 Vertebra",
                                                    "c": "第四胸椎T04 Vertebra"
                                                },
                                                "t":
                                                {
                                                    "s": "胸椎：椎体从上向下逐渐增大，横断面呈心形。在椎体两侧面后份的上缘和下缘处，有半圆形浅凹。称上、下肋凹，与肋头相关节。在横突末端前面，有横突肋凹与肋结节相关节。关节突的关节面几乎呈冠状位，上关节突关节面朝向后，下关节突的则朝向前。棘突较长，向后下方倾斜，各相邻棘突呈叠瓦状排列。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "T05 Vertebra",
                                                    "c": "第五胸椎T05 Vertebra"
                                                },
                                                "t":
                                                {
                                                    "s": "胸椎：椎体从上向下逐渐增大，横断面呈心形。在椎体两侧面后份的上缘和下缘处，有半圆形浅凹。称上、下肋凹，与肋头相关节。在横突末端前面，有横突肋凹与肋结节相关节。关节突的关节面几乎呈冠状位，上关节突关节面朝向后，下关节突的则朝向前。棘突较长，向后下方倾斜，各相邻棘突呈叠瓦状排列。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "T06 Vertebra",
                                                    "c": "第六胸椎T06 Vertebra"
                                                },
                                                "t":
                                                {
                                                    "s": "胸椎：椎体从上向下逐渐增大，横断面呈心形。在椎体两侧面后份的上缘和下缘处，有半圆形浅凹。称上、下肋凹，与肋头相关节。在横突末端前面，有横突肋凹与肋结节相关节。关节突的关节面几��呈冠状位，上关节突关节面朝向后，下关节突的则朝向前。棘突较长，向后下方倾斜，各相邻棘突呈叠瓦状排列。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "T07 Vertebra",
                                                    "c": "第七胸椎T07 Vertebra"
                                                },
                                                "t":
                                                {
                                                    "s": "胸椎：椎体从上向下逐渐增大，横断面呈心形。在椎体两侧面后份的上缘和下缘处，有半圆形浅凹。称上、下肋凹，与肋头相关节。在横突末端前面，有横突肋凹与肋结节相关节。关节突的关节面几乎呈冠状位，上关节突关节面朝向后，下关节突的则朝向前。棘突较长，向后下方倾斜，各相邻棘突呈叠瓦状排列。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "T08 Vertebra",
                                                    "c": "第八胸椎T08 Vertebra"
                                                },
                                                "t":
                                                {
                                                    "s": "胸椎：椎体从上向下逐渐增大，横断面呈心形。在椎体两侧面后份的上缘和下缘处，有半圆形浅凹。称上、下肋凹，与肋头相关节。在横突末端前面，有横突肋凹与肋结节相关节。关节突的关节面几乎呈冠状位，上关节突关节面朝向后，下关节突的则朝向前。棘突较长，向后下方倾斜，各相邻棘突呈叠瓦状排列。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "T09 Vertebra",
                                                    "c": "第九胸椎T09 Vertebra"
                                                },
                                                "t":
                                                {
                                                    "s": "胸椎：椎体从上向下逐渐增大，横断面呈心形。在椎体两侧面后份的上缘和下缘处，有半圆形浅凹。称上、下肋凹，与肋头相关节。在横突末端前面，有横突肋凹与肋结节相关节。关节突的关节面几乎呈冠状位，上关节突关节面朝向后，下关节突的则朝向前。棘突较长，向后下方倾斜，各相邻棘突呈叠瓦状排列。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "T10 Vertebra",
                                                    "c": "第十胸椎T10 Vertebra"
                                                },
                                                "t":
                                                {
                                                    "s": "胸椎：椎体从上向下逐渐增大，横断面呈心形。在椎体两侧面后份的上缘和下缘处，有半圆形浅凹。称上、下肋凹，与肋头相关节。在横突末端前面，有横突肋凹与肋结节相关节。关节突的关节面几乎呈冠状位，上关节突关节面朝向后，下关节突的则朝向前。棘突较长，向后下方倾斜，各相邻棘突呈叠瓦状排列。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "T11 Vertebra",
                                                    "c": "第十一胸椎T11 Vertebra"
                                                },
                                                "t":
                                                {
                                                    "s": "胸椎：椎体从上向下逐渐增大，横断面呈心形。在椎体两侧面后份的上缘和下缘处，有半圆形浅凹。称上、下肋凹，与肋头相关节。在横突末端前面，有横突肋凹与肋结节相关节。关节突的关节面几乎呈冠状位，上关节突关节面朝向后，下关节突的则朝向前。棘突较长，向后下方倾斜，各相邻棘突呈叠瓦状排列。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "T12 Vertebra",
                                                    "c": "第十二胸椎T12 Vertebra"
                                                },
                                                "t":
                                                {
                                                    "s": "胸椎：椎体从上向下逐渐增大，横断面呈心形。在椎体两侧面后份的上缘和下缘处，有半圆形浅凹。称上、下肋凹，与肋头相关节。在横突末端前面，有横突肋凹与肋结节相关节。关节突的关节面几乎呈冠状位，上关节突关节面朝向后，下关节突的则朝向前。棘突较长，向后下方倾斜，各相邻棘突呈叠瓦状排列。"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "03Lumbar vertebrae",
                                            "c": "腰椎Lumbar vertebrae"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "L01 Vertebra",
                                                    "c": "第一腰椎L01 Vertebra"
                                                },
                                                "t":
                                                {
                                                    "s": "腰椎：椎体粗壮，横断面呈肾形。椎孔呈卵圆形或三角形。上、下关节突粗大，关节面几呈矢状位，棘突宽而短，呈板状，水平伸向后方。各棘突的间隙较宽，临床上可于此作腰椎穿刺术。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "L02 Vertebra",
                                                    "c": "第二腰椎L02 Vertebra"
                                                },
                                                "t":
                                                {
                                                    "s": "腰椎：椎体粗壮，横断面呈肾形。椎孔呈卵圆形或三角形。上、下关节突粗大，关节面几呈矢状位，棘突宽而短，呈板状，水平伸向后方。各棘突的间隙较宽，临床上可于此作腰椎穿刺术。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "L03 Vertebra",
                                                    "c": "第三腰椎L03 Vertebra"
                                                },
                                                "t":
                                                {
                                                    "s": "腰椎：椎体粗壮，横断面呈肾形。椎孔呈卵圆形或三角形。上、下关节突粗大，关节面几呈矢状位，棘突宽而短，呈板状，水平伸向后方。各棘突的间隙较宽，临床上可于此作腰椎穿刺术。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_L04 Vertebra",
                                                    "c": "第四腰椎L04 Vertebra"
                                                },
                                                "t":
                                                {
                                                    "s": "腰椎：椎体粗壮，横断面呈肾形。椎孔呈卵圆形或三角形。上、下关节突粗大，关节面几呈矢状位，棘突宽而短，呈板状，水平伸向后方。各棘突的间隙较宽，临床上可于此作腰椎穿刺术。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_L05 Vertebra",
                                                    "c": "第五腰椎L05 Vertebra"
                                                },
                                                "t":
                                                {
                                                    "s": "腰椎：椎体粗壮，横断面呈肾形。椎孔呈卵圆形或三角形。上、下关节突粗大，关节面几呈矢状位，棘突宽而短，呈板状，水平伸向后方。各棘突的间隙较宽，临床上可于此作腰椎穿刺术。"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_04Sacrum",
                                            "c": "骶骨Sacrum"
                                        },
                                        "t":
                                        {
                                            "s": "骶骨：由5块骶椎长合而成，呈三角形，底向上，尖向下，盆面（前面）凹陷，上缘中份向前隆凸，称岬。盆面中部有四条横线，是椎体融合的痕迹。横线两端有4对骶前孔。背面粗糙隆凸，正中线上有骶正中嵴，嵴外侧有4对骶后孔。 骶前、后孔均与骶管相通，有骶神经前后支通过。骶管上通连椎管，下端的裂孔称骶管裂孔，裂孔两侧有向下突出的骶角，骶管麻醉常以骶角作为标志。骶骨外侧部上宽下窄，上份有耳状面与髂骨的耳状面构成骶髂关节，耳状面后方骨面凹凸不平，称骶粗隆。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_05Coccyx",
                                            "c": "尾骨Coccyx"
                                        },
                                        "t":
                                        {
                                            "s": "尾骨：由3-4块退化的尾椎长合而成。上接骶骨，下端游离为尾骨尖。"
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "02Sternum",
                                    "c": "胸骨Sternum"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Body of sternum",
                                            "c": "胸骨体Body of sternum"
                                        },
                                        "t":
                                        {
                                            "s": "骨位于胸前壁正中，前凸后凹，自上而下可分柄、体和剑突三部分。胸骨柄上宽下窄，上缘中份为颈静脉切迹，两侧有锁切迹与锁骨相连结。柄外侧缘上份接第1肋。柄与体连接处微向前突，称胸骨角，可在体表扪及，两侧平对第2肋，是计数肋的重要标志。胸骨角向后平对第4胸椎体下缘。胸骨体呈长方形，外侧缘接第2-7肋软骨。剑突扁而薄，形状变化较大，下端游离。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Manubrium",
                                            "c": "胸骨柄Manubrium"
                                        },
                                        "t":
                                        {
                                            "s": "骨位于胸前壁正中，前凸后凹，自上而下可分柄、体和剑突三部分。胸骨柄上宽下窄，上缘中份为颈静脉切迹，两侧有锁切迹与锁骨相连结。柄外侧缘上份接第1肋。柄与体连接处微向前突，称胸骨角，可在体表扪及，两侧平对第2肋，是计数肋的重要标志。胸骨角向后平对第4胸椎体下缘。胸骨体呈长方形，外侧缘接第2-7肋软骨。剑突扁而薄，形状变化较大，下端游离。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Xiphoid process",
                                            "c": "剑突Xiphoid process"
                                        },
                                        "t":
                                        {
                                            "s": "骨位于胸前壁正中，前凸后凹，自上而下可分柄、体和剑突三部分。胸骨柄上宽下窄，上缘中份为颈静脉切迹，两侧有锁切迹与锁骨相连结。柄外侧缘上份接第1肋。柄与体连接处微向前突，称胸骨角，可在体表扪及，两侧平对第2肋，是计数肋的重要标志。胸骨角向后平对第4胸椎体下缘。胸骨体呈长方形，外侧缘接第2-7肋软骨。剑突扁而薄，形状变化较大，下端游离。"
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "03Ribs",
                                    "c": "肋Ribs"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Ribs,L",
                                            "c": "左肋Ribs,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Eighth rib,L",
                                                    "c": "第八肋Eight rib,L"
                                                },
                                                "t":
                                                {
                                                    "s": "肋由肋骨与肋软骨组成，共12对。第1-7对肋前端直接与胸骨连接，称真肋。第8-12对肋不直接与胸骨相连称假肋；其中第1对肋与胸骨柄间为软骨结合，第2对肋至第7对肋与胸骨构成微动的胸肋关节，而第8-10对肋前端借肋软骨与上位肋软骨连接，形成肋弓，第11-12对肋前端游离于腹壁肌层中，称浮肋。\r\n                                                    肋骨属扁骨，分为体和前、后两端。后端膨大，称肋头，有关节面与胸椎上、下肋凹相关节。肋头外侧稍细，称肋颈。颈外侧的粗糙突起，称肋结节，与相应胸椎横突肋凹相关节。肋体长而扁，分内、外两面和上、下两缘。内面近下缘处有肋沟，肋间神经和血管走行其中。体的后份急转处称肋角。前端稍宽，与肋软骨相接。 第1肋骨扁宽而短，分上、下面和内、外缘．无肋角和肋沟。内缘前份有前斜角肌结节，为前斜角肌附着处。其前、后方分别有锁骨下静脉和锁骨下动脉经过的压迹（沟）。第2肋骨为过渡型。第11、12肋骨无肋结节、肋颈及肋角。\r\n                                                    肋软骨位于各肋骨的前端，由透明软骨构成，终生不骨化。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Eleventh rib,L",
                                                    "c": "第十一肋Eleventh rib,L"
                                                },
                                                "t":
                                                {
                                                    "s": "肋由肋骨与肋软骨组成，共12对。第1-7对肋前端直接与胸骨连接，称真肋。第8-12对肋不直接与胸骨相连称假肋；其中第1对肋与胸骨柄间为软骨结合，第2对肋至第7对肋与胸骨构成微动的胸肋关节，而第8-10对肋前端借肋软骨与上位肋软骨连接，形成肋弓，第11-12对肋前端游离于腹壁肌层中，称浮肋。\r\n                                                    肋骨属扁骨，分为体和前、后两端。后端膨大，称肋头，有关节面与胸椎上、下肋凹相关节。肋头外侧稍细，称肋颈。颈外侧的粗糙突起，称肋结节，与相应胸椎横突肋凹相关节。肋体长而扁，分内、外两面和上、下两缘。内面近下缘处有肋沟，肋间神经和血管走行其中。体的后份急转处称肋角。前端稍宽，与肋软骨相接。 第1肋骨扁宽而短，分上、下面和内、外缘．无肋角和肋沟。内缘前份有前斜角肌结节，为前斜角肌附着处。其前、后方分别有锁骨下静脉和锁骨下动脉经过的压迹（沟）。第2肋骨为过渡型。第11、12肋骨无肋结节、肋颈及肋角。\r\n                                                    肋软骨位于各肋骨的前端，由透明软骨构成，终生不骨化。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Fifth rib,L",
                                                    "c": "第五肋Fifth rib,L"
                                                },
                                                "t":
                                                {
                                                    "s": "肋由肋骨与肋软骨组成，共12对。第1-7对肋前端直接与胸骨连接，称真肋。第8-12对肋不直接与胸骨相连称假肋；其中第1对肋与胸骨柄间为软骨结合，第2对肋至第7对肋与胸骨构成微动的胸肋关节，而第8-10对肋前端借肋软骨与上位肋软骨连接，形成肋弓，第11-12对肋前端游离于腹壁肌层中，称浮肋。\r\n                                                    肋骨属扁骨，分为体和前、后两端。后端膨大，称肋头，有关节面与胸椎上、下肋凹相关节。肋头外侧稍细，称肋颈。颈外侧的粗糙突起，称肋结节，与相应胸椎横突肋凹相关节。肋体长而扁，分内、外两面和上、下两缘。内面近下缘处有肋沟，肋间神经和血管走行其中。体的后份急转处称肋角。前端稍宽，与肋软骨相接。 第1肋骨扁宽而短，分上、下面和内、外缘．无肋角和肋沟。内缘前份有前斜角肌结节，为前斜角肌附着处。其前、后方分别有锁骨下静脉和锁骨下动脉经过的压迹（沟）。第2肋骨为过渡型。第11、12肋骨无肋结节、肋颈及肋角。\r\n                                                    肋软骨位于各肋骨的前端，由透明软骨构成，终生不骨化。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "First rib,L",
                                                    "c": "第一肋First rib,L"
                                                },
                                                "t":
                                                {
                                                    "s": "肋由肋骨与肋软骨组成，共12对。第1-7对肋前端直接与胸骨连接，称真肋。第8-12对肋不直接与胸骨相连称假肋；其中第1对肋与胸骨柄间为软骨结合，第2对肋至第7对肋与胸骨构成微动的胸肋关节，而第8-10对肋前端借肋软骨与上位肋软骨连接，形成肋弓，第11-12对肋前端游离于腹壁肌层中，称浮肋。\r\n                                                    肋骨属扁骨，分为体和前、后两端。后端膨大，称肋头，有关节面与胸椎上、下肋凹相关节。肋头外侧稍细，称肋颈。颈外侧的粗糙突起，称肋结节，与相应胸椎横突肋凹相关节。肋体长而扁，分内、外两面和上、下两缘。内面近下缘处有肋沟，肋间神经和血管走行其中。体的后份急转处称肋角。前端稍宽，与肋软骨相接。 第1肋骨扁宽而短，分上、下面和内、外缘．无肋角和肋沟。内缘前份有前斜角肌结节，为前斜角肌附着处。其前、后方分别有锁骨下静脉和锁骨下动脉经过的压迹（沟）。第2肋骨为过渡型。第11、12肋骨无肋结节、肋颈及肋角。\r\n                                                    肋软骨位于各肋骨的前端，由透明软骨构成，终生不骨化。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Fourth rib,L",
                                                    "c": "第四肋Fourth rib,L"
                                                },
                                                "t":
                                                {
                                                    "s": "肋由肋骨与肋软骨组成，共12对。第1-7对肋前端直接与胸骨连接，称真肋。第8-12对肋不直接与胸骨相连称假肋；其中第1对肋与胸骨柄间为软骨结合，第2对肋至第7对肋与胸骨构成微动的胸肋关节，而第8-10对肋前端借肋软骨与上位肋软骨连接，形成肋弓，第11-12对肋前端游离于腹壁肌层中，称浮肋。\r\n                                                    肋骨属扁骨，分为体和前、后两端。后端膨大，称肋头，有关节面与胸椎上、下肋凹相关节。肋头外侧稍细，称肋颈。颈外侧的粗糙突起，称肋结节，与相应胸椎横突肋凹相关节。肋体长而扁，分内、外两面和上、下两缘。内面近下缘处有肋沟，肋间神经和血管走行其中。体的后份急转处称肋角。前端稍宽，与肋软骨相接。 第1肋骨扁宽而短，分上、下面和内、外缘．无肋角和肋沟。内缘前份有前斜角肌结节，为前斜角肌附着处。其前、后方分别有锁骨下静脉和锁骨下动脉经过的压迹（沟）。第2肋骨为过渡型。第11、12肋骨无肋结节、肋颈及肋角。\r\n                                                    肋软骨位于各肋骨的前端，由透明软骨构成，终生不骨化。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Ninth rib,L",
                                                    "c": "第九肋Ninth rib,L"
                                                },
                                                "t":
                                                {
                                                    "s": "肋由肋骨与肋软骨组成，共12对。第1-7对肋前端直接与胸骨连接，称真肋。第8-12对肋不直接与胸骨相连称假肋；其中第1对肋与胸骨柄间为软骨结合，第2对肋至第7对肋与胸骨构成微动的胸肋关节，而第8-10对肋前端借肋软骨与上位肋软骨连接，形成肋弓，第11-12对肋前端游离于腹壁肌层中，称浮肋。\r\n                                                    肋骨属扁骨，分为体和前、后两端。后端膨大，称肋头，有关节面与胸椎上、下肋凹相关节。肋头外侧稍细，称肋颈。颈外侧的粗糙突起，称肋结节，与相应胸椎横突肋凹相关节。肋体长而扁，分内、外两面和上、下两缘。内面近下缘处有肋沟，肋间神经和血管走行其中。体的后份急转处称肋角。前端稍宽，与肋软骨相接。 第1肋骨扁宽而短，分上、下面和内、外缘．无肋角和肋沟。内缘前份有前斜角肌结节，为前斜角肌附着处。其前、后方分别有锁骨下静脉和锁骨下动脉经过的压迹（沟）。第2肋骨为过渡型。第11、12肋骨无肋结节、肋颈及肋角。\r\n                                                    肋软骨位于各肋骨的前端，由透明软骨构成，终生不骨化。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Second rib,L",
                                                    "c": "第二肋Second rib,L"
                                                },
                                                "t":
                                                {
                                                    "s": "肋由肋骨与肋软骨组成，共12对。第1-7对肋前端直接与胸骨连接，称真肋。第8-12对肋不直接与胸骨相连称假肋；其中第1对肋与胸骨柄间为软骨结合，第2对肋至第7对肋与胸骨构成微动的胸肋关节，而第8-10对肋前端借肋软骨与上位肋软骨连接，形成肋弓，第11-12对肋前端游离于腹壁肌层中，称浮肋。\r\n                                                    肋骨属扁骨，分为体和前、后两端。后端膨大，称肋头，有关节面与胸椎上、下肋凹相关节。肋头外侧稍细，称肋颈。颈外侧的粗糙突起，称肋结节，与相应胸椎横突肋凹相关节。肋体长而扁，分内、外两面和上、下两缘。内面近下缘处有肋沟，肋间神经和血管走行其中。体的后份急转处称肋角。前端稍宽，与肋软骨相接。 第1肋骨扁宽而短，分上、下面和内、外缘．无肋角和肋沟。内缘前份有前斜角肌结节，为前斜角肌附着处。其前、后方分别有锁骨下静脉和锁骨下动脉经过的压迹（沟）。第2肋骨为过渡型。第11、12肋骨无肋结节、肋颈及肋角。\r\n                                                    肋软骨位于各肋骨的前端，由透明软骨构成，终生不骨化。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Seventh rib,L",
                                                    "c": "第七肋Seventh rib,L"
                                                },
                                                "t":
                                                {
                                                    "s": "肋由肋骨与肋软骨组成，共12对。第1-7对肋前端直接与胸骨连接，称真肋。第8-12对肋不直接与胸骨相连称假肋；其中第1对肋与胸骨柄间为软骨结合，第2对肋至第7对肋与胸骨构成微动的胸肋关节，而第8-10对肋前端借肋软骨与上位肋软骨连接，形成肋弓，第11-12对肋前端游离于腹壁肌层中，称浮肋。\r\n                                                    肋骨属扁骨，分为体和前、后两端。后端膨大，称肋头，有关节面与胸椎上、下肋凹相关节。肋头外侧稍细，称肋颈。颈外侧的粗糙突起，称肋结节，与相应胸椎横突肋凹相关节。肋体长而扁，分内、外两面和上、下两缘。内面近下缘处有肋沟，肋间神经和血管走行其中。体的后份急转处称肋角。前端稍宽，与肋软骨相接。 第1肋骨扁宽而短，分上、下面和内、外缘．无肋角和肋沟。内缘前份有前斜角肌结节，为前斜角肌附着处。其前、后方分别有锁骨下静脉和锁骨下动脉经过的压迹（沟）。第2肋骨为过渡型。第11、12肋骨无肋结节、肋颈及肋角。\r\n                                                    肋软骨位于各肋骨的前端，由透明软骨构成，终生不骨化。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Sixth rib,L",
                                                    "c": "第六肋Sixth rib,L"
                                                },
                                                "t":
                                                {
                                                    "s": "肋由肋骨与肋软骨组成，共12对。第1-7对肋前端直接与胸骨连接，称真肋。第8-12对肋不直接与胸骨相连称假肋；其中第1对肋与胸骨柄间为软骨结合，第2对肋至第7对肋与胸骨构成微动的胸肋关节，而第8-10对肋前端借肋软骨与上位肋软骨连接，形成肋弓，第11-12对肋前端游离于腹壁肌层中，称浮肋。\r\n                                                    肋骨属扁骨，分为体和前、后两端。后端膨大，称肋头，有关节面与胸椎上、下肋凹相关节。肋头外侧稍细，称肋颈。颈外侧的粗糙突起，称肋结节，与相应胸椎横突肋凹相关节。肋体长而扁，分内、外两面和上、下两缘。内面近下缘处有肋沟，肋间神经和血管走行其中。体的后份急转处称肋角。前端稍宽，与肋软骨相接。 第1肋骨扁宽而短，分上、下面和内、外缘．无肋角和肋沟。内缘前份有前斜角肌结节，为前斜角肌附着处。其前、后方分别有锁骨下静脉和锁骨下动脉经过的压迹（沟）。第2肋骨为过渡型。第11、12肋骨无肋结节、肋颈及肋角。\r\n                                                    肋软骨位于各肋骨的前端，由透明软骨构成，终生不骨化。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Tenth rib,L",
                                                    "c": "第十肋Tenth rib,L"
                                                },
                                                "t":
                                                {
                                                    "s": "肋由肋骨与肋软骨组成，共12对。第1-7对肋前端直接与胸骨连接，称真肋。第8-12对肋不直接与胸骨相连称假肋；其中第1对肋与胸骨柄间为软骨结合，第2对肋至第7对肋与胸骨构成微动的胸肋关节，而第8-10对肋前端借肋软骨与上位肋软骨连接，形成肋弓，第11-12对肋前端游离于腹壁肌层中，称浮肋。\r\n                                                    肋骨属扁骨，分为体和前、后两端。后端膨大，称肋头，有关节面与胸椎上、下肋凹相关节。肋头外侧稍细，称肋颈。颈外侧的粗糙突起，称肋结节，与相应胸椎横突肋凹相关节。肋体长而扁，分内、外两面和上、下两缘。内面近下缘处有肋沟，肋间神经和血管走行其中。体的后份急转处称肋角。前端稍宽，与肋软骨相接。 第1肋骨扁宽而短，分上、下面和内、外缘．无肋角和肋沟。内缘前份有前斜角肌结节，为前斜角肌附着处。其前、后方分别有锁骨下静脉和锁骨下动脉经过的压迹（沟）。第2肋骨为过渡型。第11、12肋骨无肋结节、肋颈及肋角。\r\n                                                    肋软骨位于各肋骨的前端，由透明软骨构成，终生不骨化。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Third rib,L",
                                                    "c": "第三肋Third rib,L"
                                                },
                                                "t":
                                                {
                                                    "s": "肋由肋骨与肋软骨组成，共12对。第1-7对肋前端直接与胸骨连接，称真肋。第8-12对肋不直接与胸骨相连称假肋；其中第1对肋与胸骨柄间为软骨结合，第2对肋至第7对肋与胸骨构成微动的胸肋关节，而第8-10对肋前端借肋软骨与上位肋软骨连接，形成肋弓，第11-12对肋前端游离于腹壁肌层中，称浮肋。\r\n                                                    肋骨属扁骨，分为体和前、后两端。后端膨大，称肋头，有关节面与胸椎上、下肋凹相关节。肋头外侧稍细，称肋颈。颈外侧的粗糙突起，称肋结节，与相应胸椎横突肋凹相关节。肋体长而扁，分内、外两面和上、下两缘。内面近下缘处有肋沟，肋间神经和血管走行其中。体的后份急转处称肋角。前端稍宽，与肋软骨相接。 第1肋骨扁宽而短，分上、下面和内、外缘．无肋角和肋沟。内缘前份有前斜角肌结节，为前斜角肌附着处。其前、后方分别有锁骨下静脉和锁骨下动脉经过的压迹（沟）。第2肋骨为过渡型。第11、12肋骨无肋结节、肋颈及肋角。\r\n                                                    肋软骨位于各肋骨的前端，由透明软骨构成，终生不骨化。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Twelfth rib,L",
                                                    "c": "第十二肋Twelfth rib,L"
                                                },
                                                "t":
                                                {
                                                    "s": "肋由肋骨与肋软骨组成，共12对。第1-7对肋前端直接与胸骨连接，称真肋。第8-12对肋不直接与胸骨相连称假肋；其中第1对肋与胸骨柄间为软骨结合，第2对肋至第7对肋与胸骨构成微动的胸肋关节，而第8-10对肋前端借肋软骨与上位肋软骨连接，形成肋弓，第11-12对肋前端游离于腹壁肌层中，称浮肋。\r\n                                                    肋骨属扁骨，分为体和前、后两端。后端膨大，称肋头，有关节面与胸椎上、下肋凹相关节。肋头外侧稍细，称肋颈。颈外侧的粗糙突起，称肋结节，与相应胸椎横突肋凹相关节。肋体长而扁，分内、外两面和上、下两缘。内面近下缘处有肋沟，肋间神经和血管走行其中。体的后份急转处称肋角。前端稍宽，与肋软骨相接。 第1肋骨扁宽而短，分上、下面和内、外缘．无肋角和肋沟。内缘前份有前斜角肌结节，为前斜角肌附着处。其前、后方分别有锁骨下静脉和锁骨下动脉经过的压迹（沟）。第2肋骨为过渡型。第11、12肋骨无肋结节、肋颈及肋角。\r\n                                                    肋软骨位于各肋骨的前端，由透明软骨构成，终生不骨化。"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Ribs,R",
                                            "c": "右肋Ribs,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Eighth rib,R",
                                                    "c": "第八肋Eighth rib,R"
                                                },
                                                "t":
                                                {
                                                    "s": "肋由肋骨与肋软骨组成，共12对。第1-7对肋前端直接与胸骨连接，称真肋。第8-12对肋不直接与胸骨相连称假肋；其中第1对肋与胸骨柄间为软骨结合，第2对肋至第7对肋与胸骨构成微动的胸肋关节，而第8-10对肋前端借肋软骨与上位肋软骨连接，形成肋弓，第11-12对肋前端游离于腹壁肌层中，称浮肋。\r\n                                                    肋骨属扁骨，分为体和前、后两端。后端膨大，称肋头，有关节面与胸椎上、下肋凹相关节。肋头外侧稍细，称肋颈。颈外侧的粗糙突起，称肋结节，与相应胸椎横突肋凹相关节。肋体长而扁，分内、外两面和上、下两缘。内面近下缘处有肋沟，肋间神经和血管走行其中。体的后份急转处称肋角。前端稍宽，与肋软骨相接。 第1肋骨扁宽而短，分上、下面和内、外缘．无肋角和肋沟。内缘前份有前斜角肌结节，为前斜角肌附着处。其前、后方分别有锁骨下静脉和锁骨下动脉经过的压迹（沟）。第2肋骨为过渡型。第11、12肋骨无肋结节、肋颈及肋角。\r\n                                                    肋软骨位于各肋骨的前端，由透明软骨构成，终生不骨化。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Eleventh rib,R",
                                                    "c": "第十一肋Eleventh rib,R"
                                                },
                                                "t":
                                                {
                                                    "s": "肋由肋骨与肋软骨组成，共12对。第1-7对肋前端直接与胸骨连接，称真肋。第8-12对肋不直接与胸骨相连称假肋；其中第1对肋与胸骨柄间为软骨结合，第2对肋至第7对肋与胸骨构成微动的胸肋关节，而第8-10对肋前端借肋软骨与上位肋软骨连接，形成肋弓，第11-12对肋前端游离于腹壁肌层中，称浮肋。\r\n                                                    肋骨属扁骨，分为体和前、后两端。后端膨大，称肋头，有关节面与胸椎上、下肋凹相关节。肋头外侧稍细，称肋颈。颈外侧的粗糙突起，称肋结节，与相应胸椎横突肋凹相关节。肋体长而扁，分内、外两面和上、下两缘。内面近下缘处有肋沟，肋间神经和血管走行其中。体的后份急转处称肋角。前端稍宽，与肋软骨相接。 第1肋骨扁宽而短，分上、下面和内、外缘．无肋角和肋沟。内缘前份有前斜角肌结节，为前斜角肌附着处。其前、后方分别有锁骨下静脉和锁骨下动脉经过的压迹（沟）。第2肋骨为过渡型。第11、12肋骨无肋结节、肋颈及肋角。\r\n                                                    肋软骨位于各肋骨的前端，由透明软骨构成，终生不骨化。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Fifth rib,R",
                                                    "c": "第五肋Fifth rib,R"
                                                },
                                                "t":
                                                {
                                                    "s": "肋由肋骨与肋软骨组成，共12对。第1-7对肋前端直接与胸骨连接，称真肋。第8-12对肋不直接与胸骨相连称假肋；其中第1对肋与胸骨柄间为软骨结合，第2对肋至第7对肋与胸骨构成微动的胸肋关节，而第8-10对肋前端借肋软骨与上位肋软骨连接，形成肋弓，第11-12对肋前端游离于腹壁肌层中，称浮肋。\r\n                                                    肋骨属扁骨，分为体和前、后两端。后端膨大，称肋头，有关节面与胸椎上、下肋凹相关节。肋头外侧稍细，称肋颈。颈外侧的粗糙突起，称肋结节，与相应胸椎横突肋凹相关节。肋体长而扁，分内、外两面和上、下两缘。内面近下缘处有肋沟，肋间神经和血管走行其中。体的后份急转处称肋角。前端稍宽，与肋软骨相接。 第1肋骨扁宽而短，分上、下面和内、外缘．无肋角和肋沟。内缘前份有前斜角肌结节，为前斜角肌附着处。其前、后方分别有锁骨下静脉和锁骨下动脉经过的压迹（沟）。第2肋骨为过渡型。第11、12肋骨无肋结节、肋颈及肋角。\r\n                                                    肋软骨位于各肋骨的前端，由透明软骨构成，终生不骨化。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "First rib,R",
                                                    "c": "第一肋First rib,R"
                                                },
                                                "t":
                                                {
                                                    "s": "肋由肋骨与肋软骨组成，共12对。第1-7对肋前端直接与胸骨连接，称真肋。第8-12对肋不直接与胸骨相连称假肋；其中第1对肋与胸骨柄间为软骨结合，第2对肋至第7对肋与胸骨构成微动的胸肋关节，而第8-10对肋前端借肋软骨与上位肋软骨连接，形成肋弓，第11-12对肋前端游离于腹壁肌层中，称浮肋。\r\n                                                    肋骨属扁骨，分为体和前、后两端。后端膨大，称肋头，有关节面与胸椎上、下肋凹相关节。肋头外侧稍细，称肋颈。颈外侧的粗糙突起，称肋结节，与相应胸椎横突肋凹相关节。肋体长而扁，分内、外两面和上、下两缘。内面近下缘处有肋沟，肋间神经和血管走行其中。体的后份急转处称肋角。前端稍宽，与肋软骨相接。 第1肋骨扁宽而短，分上、下面和内、外缘．无肋角和肋沟。内缘前份有前斜角肌结节，为前斜角肌附着处。其前、后方分别有锁骨下静脉和锁骨下动脉经过的压迹（沟）。第2肋骨为过渡型。第11、12肋骨无肋结节、肋颈及肋角。\r\n                                                    肋软骨位于各肋骨的前端，由透明软骨构成，终生不骨化。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Fourth rib,R",
                                                    "c": "第四肋Fourth rib,R"
                                                },
                                                "t":
                                                {
                                                    "s": "肋由肋骨与肋软骨组成，共12对。第1-7对肋前端直接与胸骨连接，称真肋。第8-12对肋不直接与胸骨相连称假肋；其中第1对肋与胸骨柄间为软骨结合，第2对肋至第7对肋与胸骨构成微动的胸肋关节，而第8-10对肋前端借肋软骨与上位肋软骨连接，形成肋弓，第11-12对肋前端游离于腹壁肌层中，称浮肋。\r\n                                                    肋骨属扁骨，分为体和前、后两端。后端膨大，称肋头，有关节面与胸椎上、下肋凹相关节。肋头外侧稍细，称肋颈。颈外侧的粗糙突起，称肋结节，与相应胸椎横突肋凹相关节。肋体长而扁，分内、外两面和上、下两缘。内面近下缘处有肋沟，肋间神经和血管走行其中。体的后份急转处称肋角。前端稍宽，与肋软骨相接。 第1肋骨扁宽而短，分上、下面和内、外缘．无肋角和肋沟。内缘前份有前斜角肌结节，为前斜角肌附着处。其前、后方分别有锁骨下静脉和锁骨下动脉经过的压迹（沟）。第2肋骨为过渡型。第11、12肋骨无肋结节、肋颈及肋角。\r\n                                                    肋软骨位于各肋骨的前端，由透明软骨构成，终生不骨化。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Ninth rib,R",
                                                    "c": "第九肋Ninth rib,R"
                                                },
                                                "t":
                                                {
                                                    "s": "肋由肋骨与肋软骨组成，共12对。第1-7对肋前端直接与胸骨连接，称真肋。第8-12对肋不直接与胸骨相连称假肋；其中第1对肋与胸骨柄间为软骨结合，第2对肋至第7对肋与胸骨构成微动的胸肋关节，而第8-10对肋前端借肋软骨与上位肋软骨连接，形成肋弓，第11-12对肋前端游离于腹壁肌层中，称浮肋。\r\n                                                    肋骨属扁骨，分为体和前、后两端。后端膨大，称肋头，有关节面与胸椎上、下肋凹相关节。肋头外侧稍细，称肋颈。颈外侧的粗糙突起，称肋结节，与相应胸椎横突肋凹相关节。肋体长而扁，分内、外两面和上、下两缘。内面近下缘处有肋沟，肋间神经和血管走行其中。体的后份急转处称肋角。前端稍宽，与肋软骨相接。 第1肋骨扁宽而短，分上、下面和内、外缘．无肋角和肋沟。内缘前份有前斜角肌结节，为前斜角肌附着处。其前、后方分别有锁骨下静脉和锁骨下动脉经过的压迹（沟）。第2肋骨为过渡型。第11、12肋骨无肋结节、肋颈及肋角。\r\n                                                    肋软骨位于各肋骨的前端，由透明软骨构成，终生不骨化。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Second rib,R",
                                                    "c": "第二肋Second rib,R"
                                                },
                                                "t":
                                                {
                                                    "s": "肋由肋骨与肋软骨组成，共12对。第1-7对肋前端直接与胸骨连接，称真肋。第8-12对肋不直接与胸骨相连称假肋；其中第1对肋与胸骨柄间为软骨结合，第2对肋至第7对肋与胸骨构成微动的胸肋关节，而第8-10对肋前端借肋软骨与上位肋软骨连接，形成肋弓，第11-12对肋前端游离于腹壁肌层中，称浮肋。\r\n                                                    肋骨属扁骨，分为体和前、后两端。后端膨大，称肋头，有关节面与胸椎上、下肋凹相关节。肋头外侧稍细，称肋颈。颈外侧的粗糙突起，称肋结节，与相应胸椎横突肋凹相关节。肋体长而扁，分内、外两面和上、下两缘。内面近下缘处有肋沟，肋间神经和血管走行其中。体的后份急转处称肋角。前端稍宽，与肋软骨相接。 第1肋骨扁宽而短，分上、下面和内、外缘．无肋角和肋沟。内缘前份有前斜角肌结节，为前斜角肌附着处。其前、后方分别有锁骨下静脉和锁骨下动脉经过的压迹（沟）。第2肋骨为过渡型。第11、12肋骨无肋结节、肋颈及肋角。\r\n                                                    肋软骨位于各肋骨的前端，由透明软骨构成，终生不骨化。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Seventh rib,R",
                                                    "c": "第七肋Seventh rib,R"
                                                },
                                                "t":
                                                {
                                                    "s": "肋由肋骨与肋软骨组成，共12对。第1-7对肋前端直接与胸骨连接，称真肋。第8-12对肋不直接与胸骨相连称假肋；其中第1对肋与胸骨柄间为软骨结合，第2对肋至第7对肋与胸骨构成微动的胸肋关节，而第8-10对肋前端借肋软骨与上位肋软骨连接，形成肋弓，第11-12对肋前端游离于腹壁肌层中，称浮肋。\r\n                                                    肋骨属扁骨，分为体和前、后两端。后端膨大，称肋头，有关节面与胸椎上、下肋凹相关节。肋头外侧稍细，称肋颈。颈外侧的粗糙突起，称肋结节，与相应胸椎横突肋凹相关节。肋体长而扁，分内、外两面和上、下两缘。内面近下缘处有肋沟，肋间神经和血管走行其中。体的后份急转处称肋角。前端稍宽，与肋软骨相接。 第1肋骨扁宽而短，分上、下面和内、外缘．无肋角和肋沟。内缘前份有前斜角肌结节，为前斜角肌附着处。其前、后方分别有锁骨下静脉和锁骨下动脉经过的压迹（沟）。第2肋骨为过渡型。第11、12肋骨无肋结节、肋颈及肋角。\r\n                                                    肋软骨位于各肋骨的前端，由透明软骨构成，终生不骨化。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Sixth rib,R",
                                                    "c": "第六肋Sixth rib,R"
                                                },
                                                "t":
                                                {
                                                    "s": "肋由肋骨与肋软骨组成，共12对。第1-7对肋前端直接与胸骨连接，称真肋。第8-12对肋不直接与胸骨相连称假肋；其中第1对肋与胸骨柄间为软骨结合，第2对肋至第7对肋与胸骨构成微动的胸肋关节，而第8-10对肋前端借肋软骨与上位肋软骨连接，形成肋弓，第11-12对肋前端游离于腹壁肌层中，称浮肋。\r\n                                                    肋骨属扁骨，分为体和前、后两端。后端膨大，称肋头，有关节面与胸椎上、下肋凹相关节。肋头外侧稍细，称肋颈。颈外侧的粗糙突起，称肋结节，与相应胸椎横突肋凹相关节。肋体长而扁，分内、外两面和上、下两缘。内面近下缘处有肋沟，肋间神经和血管走行其中。体的后份急转处称肋角。前端稍宽，与肋软骨相接。 第1肋骨扁宽而短，分上、下面和内、外缘．无肋角和肋沟。内缘前份有前斜角肌结节，为前斜角肌附着处。其前、后方分别有锁骨下静脉和锁骨下动脉经过的压迹（沟）。第2肋骨为过渡型。第11、12肋骨无肋结节、肋颈及肋角。\r\n                                                    肋软骨位于各肋骨的前端，由透明软骨构成，终生不骨化。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Tenth rib,R",
                                                    "c": "第十肋Tenth rib,R"
                                                },
                                                "t":
                                                {
                                                    "s": "肋由肋骨与肋软骨组成，共12对。第1-7对肋前端直接与胸骨连接，称真肋。第8-12对肋不直接与胸骨相连称假肋；其中第1对肋与胸骨柄间为软骨结合，第2对肋至第7对肋与胸骨构成微动的胸肋关节，而第8-10对肋前端借肋软骨与上位肋软骨连接，形成肋弓，第11-12对肋前端游离于腹壁肌层中，称浮肋。\r\n                                                    肋骨属扁骨，分为体和前、后两端。后端膨大，称肋头，有关节面与胸椎上、下肋凹相关节。肋头外侧稍细，称肋颈。颈外侧的粗糙突起，称肋结节，与相应胸椎横突肋凹相关节。肋体长而扁，分内、外两面和上、下两缘。内面近下缘处有肋沟，肋间神经和血管走行其中。体的后份急转处称肋角。前端稍宽，与肋软骨相接。 第1肋骨扁宽而短，分上、下面和内、外缘．无肋角和肋沟。内缘前份有前斜角肌结节，为前斜角肌附着处。其前、后方分别有锁骨下静脉和锁骨下动脉经过的压迹（沟）。第2肋骨为过渡型。第11、12肋骨无肋结节、肋颈及肋角。\r\n                                                    肋软骨位于各肋骨的前端，由透明软骨构成，终生不骨化。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Third rib,R",
                                                    "c": "第三肋Third rib,R"
                                                },
                                                "t":
                                                {
                                                    "s": "肋由肋骨与肋软骨组成，共12对。第1-7对肋前端直接与胸骨连接，称真肋。第8-12对肋不直接与胸骨相连称假肋；其中第1对肋与胸骨柄间为软骨结合，第2对肋至第7对肋与胸骨构成微动的胸肋关节，而第8-10对肋前端借肋软骨与上位肋软骨连接，形成肋弓，第11-12对肋前端游离于腹壁肌层中，称浮肋。\r\n                                                    肋骨属扁骨，分为体和前、后两端。后端膨大，称肋头，有关节面与胸椎上、下肋凹相关节。肋头外侧稍细，称肋颈。颈外侧的粗糙突起，称肋结节，与相应胸椎横突肋凹相关节。肋体长而扁，分内、外两面和上、下两缘。内面近下缘处有肋沟，肋间神经和血管走行其中。体的后份急转处称肋角。前端稍宽，与肋软骨相接。 第1肋骨扁宽而短，分上、下面和内、外缘．无肋角和肋沟。内缘前份有前斜角肌结节，为前斜角肌附着处。其前、后方分别有锁骨下静脉和锁骨下动脉经过的压迹（沟）。第2肋骨为过渡型。第11、12肋骨无肋结节、肋颈及肋角。\r\n                                                    肋软骨位于各肋骨的前端，由透明软骨构成，终生不骨化。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Twelfth rib,R",
                                                    "c": "第十二肋Twelfth rib,R"
                                                },
                                                "t":
                                                {
                                                    "s": "肋由肋骨与肋软骨组成，共12对。第1-7对肋前端直接与胸骨连接，称真肋。第8-12对肋不直接与胸骨相连称假肋；其中第1对肋与胸骨柄间为软骨结合，第2对肋至第7对肋与胸骨构成微动的胸肋关节，而第8-10对肋前端借肋软骨与上位肋软骨连接，形成肋弓，第11-12对肋前端游离于腹壁肌层中，称浮肋。\r\n                                                    肋骨属扁骨，分为体和前、后两端。后端膨大，称肋头，有关节面与胸椎上、下肋凹相关节。肋头外侧稍细，称肋颈。颈外侧的粗糙突起，称肋结节，与相应胸椎横突肋凹相关节。肋体长而扁，分内、外两面和上、下两缘。内面近下缘处有肋沟，肋间神经和血管走行其中。体的后份急转处称肋角。前端稍宽，与肋软骨相接。 第1肋骨扁宽而短，分上、下面和内、外缘．无肋角和肋沟。内缘前份有前斜角肌结节，为前斜角肌附着处。其前、后方分别有锁骨下静脉和锁骨下动脉经过的压迹（沟）。第2肋骨为过渡型。第11、12肋骨无肋结节、肋颈及肋角。\r\n                                                    肋软骨位于各肋骨的前端，由透明软骨构成，终生不骨化。"
                                                }
                                            }]
                                        }
                                    }]
                                }
                            }]
                        }
                    },
                    {
                        "$":
                        {
                            "o": "02Skull",
                            "c": "颅骨Skull"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "01Cerebral cranium",
                                    "c": "脑颅骨Cerebral cranium"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Ethmoid1",
                                            "c": "筛骨Ethmoid"
                                        },
                                        "ch":
                                        {
                                            "sub":
                                            {
                                                "$":
                                                {
                                                    "o": "Ethmoid",
                                                    "c": "筛骨Ethmoid"
                                                },
                                                "t":
                                                {
                                                    "s": "筛骨：为最脆弱的含气骨。位于两眶之间，参与构成鼻腔上部、鼻腔外侧壁和鼻中隔。此骨额状切面呈巾字形，分三部：①筛板：是多孔的水平骨板，构成鼻腔的顶，板的前份有向上伸出的骨嵴称鸡冠；②垂直板：自筛板中线下垂，居正中矢状位，构成骨性鼻中隔上部；③筛骨迷路；位于垂直板两侧由菲薄骨片围成许多小腔，称筛窦。迷路内侧壁具有两个卷曲小骨片，即上鼻甲和中鼻甲。迷路外侧壁骨质极薄，构成眶的内侧壁，称眶板。"
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Frontal",
                                            "c": "额骨Frontal"
                                        },
                                        "ch":
                                        {
                                            "sub":
                                            {
                                                "$":
                                                {
                                                    "o": "Frontal",
                                                    "c": "额骨Frontal"
                                                },
                                                "t":
                                                {
                                                    "s": "额骨：位于颅的前上方，分三部：①额鳞：是瓢形或贝壳形的扁骨，内含空腔称额窦；②眶部：为后伸的水平位薄骨板，构成眶上壁；③鼻部：位于两侧眶部之间，呈马蹄铁形，缺口处为筛切迹。"
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Occipital",
                                            "c": "枕骨Occipital"
                                        },
                                        "ch":
                                        {
                                            "sub":
                                            {
                                                "$":
                                                {
                                                    "o": "Occipital",
                                                    "c": "枕骨Occipital"
                                                },
                                                "t":
                                                {
                                                    "s": "枕骨：位颅的后下部，呈勺状。前下部有枕骨大孔。枕骨借此孔分为四部。前为基底部，后为枕鳞，两侧为侧部。侧部的下方有椭圆形关节面，称枕髁。"
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Parietal_L",
                                            "c": "顶骨Parietal_L"
                                        },
                                        "t":
                                        {
                                            "s": "顶骨：外隆内凹，呈四边形，位颅顶中部，左右各一。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Parietal_R",
                                            "c": "顶骨Parietal_R"
                                        },
                                        "t":
                                        {
                                            "s": "顶骨：外隆内凹，呈四边形，位颅顶中部，左右各一。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Sphenoid",
                                            "c": "蝶骨Sphenoid"
                                        },
                                        "ch":
                                        {
                                            "sub":
                                            {
                                                "$":
                                                {
                                                    "o": "Sphenoid",
                                                    "c": "蝶骨Sphenoid"
                                                },
                                                "t":
                                                {
                                                    "s": "蝶骨：形似蝴蝶，居颅底中央，分体、大翼、小翼和翼突四部。①体：为中间部的立方形骨块，内含蝶窦，窦分隔为左右两半，分别向前开口于蝶筛隐窝。体上面呈马鞍状，称蝶鞍，中央凹陷为垂体窝。②大翼：由体两侧发出，向上方扩展，分为凹陷的大脑面、前内侧的眶面和外下方的颞面。颞面借颞下嵴，分上下两部：上部是颞窝的一部分，下部构成颞下窝的顶。大翼根部由前向后外有圆孔、卵圆孔和棘孔，分别通过重要的神经和血管。\r\n                                                    ③小翼：为三角形薄板，从体的前上份发出。上面是颅前窝的后部，下面构成眶上壁的后部。小翼与体的交界处有视神经管。小翼与大翼间的裂隙为眶上裂。④翼突：从体与大翼连接处下垂，向后敞开成为内侧板和外侧板，根部矢状方向贯通的细管，称翼管，向前通入翼腭窝。"
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Temporal,L",
                                            "c": "左颞骨Temporal,L"
                                        },
                                        "ch":
                                        {
                                            "sub":
                                            {
                                                "$":
                                                {
                                                    "o": "Temporal,L",
                                                    "c": "颞骨Temporal,L"
                                                },
                                                "t":
                                                {
                                                    "s": "颞骨：参与构成颅底和颅腔侧壁，形状不规则，以外耳门为中心分三部；①鳞部：位于外耳门前上方，呈鳞片状。内面有脑回的压迹和脑膜中动脉沟；外面光滑，前下部有伸向前的颧突，与颧骨的颞突构成颧弓，颧突根部下面的深窝称下颌窝，窝前缘的横行突起，称关节结节。②鼓部：位于下颌窝后方，为弯曲的骨片。从前、下、后三面围绕外耳道。\r\n                                                    ③岩部(锥部)：呈三棱锥形，尖指向前内，对着蝶骨体，底与颞鳞、乳突部相接。岩部前面朝向颅中窝，中央有弓状隆起，隆起外侧较薄的部分，称鼓室盖，近尖端处有光滑的三叉神经压迹。后面中央部有一大孔，即内耳门，通入内耳道。下面凹凸不平，中央有颈动脉管外口，向前内通入颈动脉管。此管先垂直上行，继而折向前内，开口于岩部尖，称颈动脉管内口。颈动脉管外口后方的深窝是颈静脉窝，后外侧的细长骨突，为茎突。岩部后份肥厚的突起，位于外耳门后方，称乳突，内有许多腔隙称乳突小房，茎突根部后方的孔为茎乳孔。"
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Temporal,R",
                                            "c": "右颞骨Temporal,R"
                                        },
                                        "ch":
                                        {
                                            "sub":
                                            {
                                                "$":
                                                {
                                                    "o": "Temporal,R",
                                                    "c": "颞骨Temporal,R"
                                                },
                                                "t":
                                                {
                                                    "s": "颞骨：参与构成颅底和颅腔侧壁，形状不规则，以外耳门为中心分三部；①鳞部：位于外耳门前上方，呈鳞片状。内面有脑回的压迹和脑膜中动脉沟；外面光滑，前下部有伸向前的颧突，与颧骨的颞突构成颧弓，颧突根部下面的深窝称下颌窝，窝前缘的横行突起，称关节结节。②鼓部：位于下颌窝后方，为弯曲的骨片。从前、下、后三面围绕外耳道。\r\n                                                    ③岩部(锥部)：呈三棱锥形，尖指向前内，对着蝶骨体，底与颞鳞、乳突部相接。岩部前面朝向颅中窝，中央有弓状隆起，隆起外侧较薄的部分，称鼓室盖，近尖端处有光滑的三叉神经压迹。后面中央部有一大孔，即内耳门，通入内耳道。下面凹凸不平，中央有颈动脉管外口，向前内通入颈动脉管。此管先垂直上行，继而折向前内，开口于岩部尖，称颈动脉管内口。颈动脉管外口后方的深窝是颈静脉窝，后外侧的细长骨突，为茎突。岩部后份肥厚的突起，位于外耳门后方，称乳突，内有许多腔隙称乳突小房，茎突根部后方的孔为茎乳孔。"
                                                }
                                            }
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "02Facial cranium",
                                    "c": "面颅骨Facial cranium"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Hyoid bone",
                                            "c": "舌骨Hyoid bone"
                                        },
                                        "t":
                                        {
                                            "s": "舌骨：居下颌骨下后方，呈马蹄铁形。中间部称体，向后外延伸的长突为大角，向上的短突为小角。大角和体都可在体表扪到。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Inferior nasal concha",
                                            "c": "下鼻甲Inferior nasal concha"
                                        },
                                        "t":
                                        {
                                            "s": "下鼻甲：为薄而卷曲的小骨片，附着于上颌体和腭骨垂直板的鼻面上。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Lacrimal",
                                            "c": "泪骨Lacrimal"
                                        },
                                        "t":
                                        {
                                            "s": "泪骨：为方形小骨片，位眶内侧壁的前份。前接上颌骨，后连筛骨迷路眶板。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Mandible",
                                            "c": "下颌骨Mandible"
                                        },
                                        "ch":
                                        {
                                            "sub":
                                            {
                                                "$":
                                                {
                                                    "o": "Mandible",
                                                    "c": "下颌骨Mandible"
                                                },
                                                "t":
                                                {
                                                    "s": "下颌骨：为面颅骨最大者，分一体两支：①下颌体为弓状板，有上、下两缘及内、外两面。下缘圆钝，为下颌底，上缘构成牙槽弓，有容纳下牙根的牙槽。体外面正中凸向前为颏隆凸。前外侧面有颏孔。内面正中有二个小棘，称颏棘，为肌肉附着处。其下外方有一椭圆形浅窝，称二腹肌窝。\r\n                                                    ②下颌支是由体后方上耸的方形骨板，末端有两个突起，前方的称冠突，为颞肌附着处，后方的称髁突，两突之间的凹陷为下颌切迹。髁突上端的膨大为下颌头，与下颌窝相关节，头下方较细处是下颌颈。下颔支后缘与下颌底相交处，称下颌角。下颔支内面中央有下颌孔，孔的前缘有伸向上后的骨突，称下颌小舌。"
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Maxilla,L",
                                            "c": "左上颌骨Maxilla,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Palatine process,L",
                                                    "c": "腭突Palatine process_L"
                                                },
                                                "t":
                                                {
                                                    "s": "腭突：由体向内水平伸出，于中线与对侧腭突结合，组成骨腭的前份。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Maxilla,L",
                                                    "c": "上颌骨Maxilla,L"
                                                },
                                                "t":
                                                {
                                                    "s": "上颌骨：成对，构成颜面的中央部，几乎与全部面颅骨相接，可分：1体和4突：上颌体：内含上颌窦，分前面、颞下面、眶面及鼻面。前面上份有眶下孔，孔下方凹陷，称尖牙窝。颞下面朝向后外，中部有几个小的牙槽孔。眶面构成眶的下壁，有矢状位的眶下沟，向前下连于眶下管。鼻面构成鼻腔外侧壁，后份有大的上颔窦裂孔，通入上颌窦，前份有纵行的泪沟。 额突突向上方，接额骨、鼻骨和泪骨。颧突伸向外侧，接颧骨。牙槽突由体向下伸出，其下缘有牙槽，容纳上颌牙根。腭突由体向内水平伸出，于中线与对侧腭突结合，组成骨腭的前份。"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Maxilla,R",
                                            "c": "右上颌骨Maxilla,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Palatine process,R",
                                                    "c": "腭突Palatine process_R"
                                                },
                                                "t":
                                                {
                                                    "s": "腭突：由体向内水平伸出，于中线与对侧腭突结合，组成骨腭的前份。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Maxilla,R",
                                                    "c": "上颌骨Maxilla,R"
                                                },
                                                "t":
                                                {
                                                    "s": "上颌骨：成对，构成颜面的中央部，几乎与全部面颅骨相接，可分：1体和4突：上颌体：内含上颌窦，分前面、颞下面、眶面及鼻面。前面上份有眶下孔，孔下方凹陷，称尖牙窝。颞下面朝向后外，中部有几个小的牙槽孔。眶面构成眶的下壁，有矢状位的眶下沟，向前下连于眶下管。鼻面构成鼻腔外侧壁，后份有大的上颔窦裂孔，通入上颌窦，前份有纵行的泪沟。 额突突向上方，接额骨、鼻骨和泪骨。颧突伸向外侧，接颧骨。牙槽突由体向下伸出，其下缘有牙槽，容纳上颌牙根。腭突由体向内水平伸出，于中线与对侧腭突结合，组成骨腭的前份。"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Nasal",
                                            "c": "鼻骨Nasal"
                                        },
                                        "t":
                                        {
                                            "s": "鼻骨：两侧上颌骨额突之间成对的长方形骨板。构成鼻腔上壁的一部分。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Palatine",
                                            "c": "腭骨Palatine"
                                        },
                                        "t":
                                        {
                                            "s": "腭骨：成对，呈L形，位于上颌骨腭突与蝶骨翼突之间，分为水平板和垂直板两部，水平板组成骨腭的后份，垂直板构成鼻腔外侧壁的后份。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Teeth",
                                            "c": "牙Teeth"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Lower dental arch1",
                                                    "c": "下牙弓Lower dental arch1"
                                                },
                                                "ch":
                                                {
                                                    "sub":
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Lower dental arch",
                                                            "c": "下牙弓Lower dental arch"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Upper dental arch1",
                                                    "c": "上牙弓Upper dental arch1"
                                                },
                                                "ch":
                                                {
                                                    "sub":
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Upper dental arch",
                                                            "c": "上牙弓Upper dental arch"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    }
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Vomer",
                                            "c": "犁骨Vomer"
                                        },
                                        "t":
                                        {
                                            "s": "犁骨：位于左、右鼻腔之间矢状位四边形的扁平薄骨板。构成鼻中隔的下部及后部。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Zygomatic,L",
                                            "c": "左颧骨Zygomatic,L"
                                        },
                                        "ch":
                                        {
                                            "sub":
                                            {
                                                "$":
                                                {
                                                    "o": "Zygomatic,L",
                                                    "c": "颧骨Zygomatic,L"
                                                },
                                                "t":
                                                {
                                                    "s": "颧骨：位于额骨和上颌骨之间，近似菱形的成对的骨。分为颊、颞、眶3面，前上、前下、后上、后下、后内5缘及额碟、颞、上颌3个突起。"
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Zygomatic,R",
                                            "c": "右颧骨Zygomatic,R"
                                        },
                                        "ch":
                                        {
                                            "sub":
                                            {
                                                "$":
                                                {
                                                    "o": "Zygomatic,R",
                                                    "c": "颧骨Zygomatic,R"
                                                },
                                                "t":
                                                {
                                                    "s": "颧骨：位于额骨和上颌骨之间，近似菱形的成对的骨。分为颊、颞、眶3面，前上、前下、后上、后下、后内5缘及额碟、颞、上颌3个突起。"
                                                }
                                            }
                                        }
                                    }]
                                }
                            }]
                        }
                    },
                    {
                        "$":
                        {
                            "o": "03Bone of upper limb",
                            "c": "上肢骨Bone of upper limb"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "Bone of upper limb,L",
                                    "c": "左上肢骨Bone of upper limb,L"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "01Shoulder girdle,L",
                                            "c": "左上肢带骨Shoulder girdle,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Clavicle,L",
                                                    "c": "锁骨Clavicle,L"
                                                },
                                                "t":
                                                {
                                                    "s": "锁骨：呈“～”形弯曲，架于胸廓前上方。全长可在体表扪到。内侧端粗大，为胸骨端，有关节面与胸骨柄相关节。外侧端扁平，为肩峰端，有小关节面与肩胛骨肩峰相关节。内侧2/3凸向前，呈三棱形，外侧1/3凸向后，呈扁平形。两者之间交界处较薄弱，锁骨骨折多发生在此处。锁骨上面光滑，下面粗糙。锁骨像—个杠杆，使上肢远离胸壁，以保证上肢的灵活运动。锁骨是唯一直接与躯干相连接的骨，能将应力从上肢传给躯干。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Scapula,L",
                                                    "c": "肩胛骨Scapula,L"
                                                },
                                                "t":
                                                {
                                                    "s": "肩胛骨：为三角形扁骨，贴于胸廓后外面，介于第2到第7肋骨之间。可分二面、三缘和三个角。腹侧面或肋面与胸廓相对，为一大浅窝，称肩胛下窝。背侧面有一横嵴，称肩胛冈。冈上、下方的浅窝，分别称冈上窝和冈下窝。肩胛冈向外侧延伸的扁平突起，称肩峰，与锁骨外侧端相接。\r\n                                                    上缘短而薄，外侧份有肩胛切迹，更外侧有突向前的指状突起称喙突。内侧缘薄而锐利，因邻近脊柱，故又称脊柱缘。外侧缘肥厚邻近腋窝，称腋缘。上角为上缘与脊柱缘会合处，平对第2肋。下角为脊柱缘与腋缘会合处，平对第7肋或第7肋间隙，为计数肋的标志。外侧角为腋缘与上缘会合处，最肥厚，朝外侧方的梨形浅窝，称关节盂，与肱骨头相关节。盂上、下方各有一粗糙隆起，分别称盂上结节和盂下结节。肩胛冈、肩峰、肩胛骨下角、内侧缘及喙突都可在体表扪到。"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "02Bone of free upper limb,L",
                                            "c": "左自由上肢骨Bone of free upper limb,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Bone of hand,L",
                                                    "c": "左手骨Bone of hand,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Carpal bone,L",
                                                            "c": "左腕骨Carpal bone,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Capitate,L",
                                                                    "c": "头状骨Capitate,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "头状骨：腕骨中最大者。居腕骨的中央，与第三掌骨底相对应。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Hamate,L",
                                                                    "c": "钩骨Hamate,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "钩骨：介于头状骨与三角骨之间的一块楔形骨。上面狭窄，有向外上方的关节面，与月骨相关节。其下面宽广，被一微嵴分成内、外2部，分别与第五及第四掌骨底相关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Lunate,L",
                                                                    "c": "月骨Lunate,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "月骨：半月形，介于手舟骨与三角骨之间的骨。上面光滑而凸隆，与桡骨和桡尺远侧关节盘相接。下面凹陷，由后外方的微嵴分成内、外2部，与钩骨、头状骨相关节。掌侧面呈三角形，宽广而粗糙。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Pisiform,L",
                                                                    "c": "豌豆骨Pisiform,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "豌豆骨：形似豌豆，为腕骨中最小者。掌侧面粗糙而凸隆，背侧面有椭圆形的关节面，与三角骨相关节，其内、外两面均粗糙。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Scaphoid,L",
                                                                    "c": "手舟骨Scaphoid,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "手舟骨：近侧列腕骨中最大者。其长轴斜向前外下方，上面凸隆，呈三角形，向外上方，与桡骨相接。下面也凸隆，由一微嵴分为内、外2部，分别与小多角骨及大多角骨相关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Trapezium,L",
                                                                    "c": "大多角骨Trapezium,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "大多角骨：介于舟骨与第一掌骨之间的一块骨。上面凹陷，向内上方，与舟骨相关节。下面有鞍状关节面，向外下方，与第一掌骨底相关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Trapezoid,L",
                                                                    "c": "小多角骨Trapezoid,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "小多角骨：远侧列腕骨中最小者。近似楔形，被第二掌骨底、大多角骨、舟骨及头状骨包绕。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Triquetral(triangular),L",
                                                                    "c": "三角骨Triquetral,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "三角骨：基底向外上方，尖部向内下方的一块锥形骨。其掌侧面卵圆形的关节面，与豌豆骨相关节。"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Metacarpal bone,L",
                                                            "c": "左掌骨Metacarpal bone,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "1st Metacarpal(pollex),L",
                                                                    "c": "第一掌骨1st Metacarpal(pollex),L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": ""
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "2nd Metacarpal,L",
                                                                    "c": "第二掌骨2nd Metacarpal,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "掌骨：共5块。由桡侧向尺侧，依次为第1-5掌骨。近端为底，接腕骨，远端为头，接指骨；中间部为体。第1掌骨短而粗，其底有鞍状关节面，与大多角骨的鞍状关节面相关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "3rd Metacarpal,L",
                                                                    "c": "第三掌骨3rd Metacarpal,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "掌骨：共5块。由桡侧向尺侧，依次为第1-5掌骨。近端为底，接腕骨，远端为头，接指骨；中间部为体。第1掌骨短而粗，其底有鞍状关节面，与大多角骨的鞍状关节面相关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "4th Metacarpal,L",
                                                                    "c": "第四掌骨4th Metacarpal,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "掌骨：共5块。由桡侧向尺侧，依次为第1-5掌骨。近端为底，接腕骨，远端为头，接指骨；中间部为体。第1掌骨短而粗，其底有鞍状关节面，与大多角骨的鞍状关节面相关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "5th Metacarpal,L",
                                                                    "c": "第五掌骨5th Metacarpal,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "掌骨：共5块。由桡侧向尺侧，依次为第1-5掌骨。近端为底，接腕骨，远端为头，接指骨；中间部为体。第1掌骨短而粗，其底有鞍状关节面，与大多角骨的鞍状关节面相关节。"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Phalanx,L",
                                                            "c": "左指骨Phalanx,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Index finger,L",
                                                                    "c": "左食指Index finger,L"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "2nd Distal phalanx(hand),L",
                                                                            "c": "食指远节指骨2nd Distal phalanx(hand),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "2nd Middle phalanx(hand),L",
                                                                            "c": "食指中节指骨2nd Middle phalanx(hand),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "2st Proximal phalanx(hand),L",
                                                                            "c": "食指近节指骨2st Proximal phalanx(hand),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    }]
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Little finger,L",
                                                                    "c": "左小指Little finger,L"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "5th Distal phalanx(hand),L",
                                                                            "c": "小指远节指骨5th Distal phalanx(hand),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "5th Middle phalanx(hand),L",
                                                                            "c": "小指中节指骨5th Middle phalanx(hand),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "5th Proximal phalanx(hand),L",
                                                                            "c": "小指近节指骨5th Proximal phalanx(hand),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    }]
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Middle finger,L",
                                                                    "c": "左中指Middle finger,L"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "3rd Distal phalanx(hand),L",
                                                                            "c": "中指远节指骨3rd Distal phalanx(hand),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "3rd Middle phalanx(hand),L",
                                                                            "c": "中指中节指骨3rd Middle phalanx(hand),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "3rd Proximal phalanx(hand),L",
                                                                            "c": "中指近节指骨3rd Proximal phalanx(hand),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    }]
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Ring finger,L",
                                                                    "c": "左环指Ring finger,L"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "4th Distal phalanx(hand),L",
                                                                            "c": "环指远节指骨4th Distal phalanx(hand),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "4th Middle phalanx(hand),L",
                                                                            "c": "环指中节指骨4th Middle phalanx(hand),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "4th Proximal phalanx(hand),L",
                                                                            "c": "环指近节指骨4th Proximal phalanx(hand),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    }]
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Thumb,L",
                                                                    "c": "左拇指Thumb,L"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "1st Distal phalanx(pollex),L",
                                                                            "c": "拇指远节指骨1st Distal phalanx(pollex),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "1st Proximal phalanx(pollex),L",
                                                                            "c": "拇指近节指骨1st Proximal phalanx(pollex),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    }]
                                                                }
                                                            }]
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Humerus,L",
                                                    "c": "肱骨Humerus,L"
                                                },
                                                "t":
                                                {
                                                    "s": "肱骨：分一体及上、下两端。上端有朝向上后内方呈半球形的肱骨头，与肩胛骨的关节盂相关节。头周围的向环状浅沟，称解剖颈。肱骨头的外侧和前方有隆起的大结节和小结节，大小结节向下各延伸一嵴，称大结节嵴和小结节嵴。两结节间有一纵沟，称结节间沟。上端与体交界处稍细，称外科颈，较易发生骨折。肱骨体上半部呈圆柱形，下半部呈三棱柱形。中部外侧面有粗糙的三角肌粗隆，后面中部，有一自内上斜向外下的浅沟，称桡神经沟，桡神经和肱深动脉沿此沟经过，肱骨中部骨折可能伤及桡神经。内侧缘近中点处有开口向上的滋养孔。\r\n                                                    下端较扁，外侧部前面有半球状的肱骨小头，与桡骨相关节；内侧部有滑车状的肱骨滑车，与尺骨形成关节。滑车前面上方有一窝，称冠突窝；肱骨小头前面上方有一窝，称桡窝；滑车后面上方有一窝，称鹰嘴窝，伸肘时容纳尺骨鹰嘴。小头外侧和滑车内侧各有一突起，分别称外上髁和内上髁。内上髁后方有一浅沟，称尺神经沟，尺神经由此经过。下端与体交界处，即肱骨内、外上髁稍上方，骨质较薄弱，受暴力可发生肱骨髁上骨折。肱骨大结节和内外上髁都可在体表扪到。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Radius,L",
                                                    "c": "桡骨Radius,L"
                                                },
                                                "t":
                                                {
                                                    "s": "桡骨：位于前臂外侧部，分一体两端。上端膨大称桡骨头，头上面的关节凹于肱骨小头相关节；周围的环状关节面与尺骨相关节，头下方略细，称桡骨颈。颈的内下侧有突起的桡骨粗隆。桡骨体呈三棱柱形，内侧缘为薄锐的骨间缘。下端前凹后凸，外侧向下突出，称茎突。下端内面有关节面，称尺切迹，与尺骨头相关节，下面有腕关节面与腕骨相关节。桡骨茎突和桡骨头在体表可扪到。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Ulna,L",
                                                    "c": "尺骨Ulna,L"
                                                },
                                                "t":
                                                {
                                                    "s": "尺骨：居前壁内侧，分一体两端。上端粗大，前面有一半圆形深凹，称滑车切迹，与肱骨滑车相关节。切迹后上方的突起称鹰嘴，前下方的突起称冠突。冠突外侧面有桡切迹，与桡骨头相关节；冠突下方的粗糙隆起，称尺骨粗隆。尺骨体上段粗，下段细，外缘锐利，为骨间缘，与桡骨的骨间缘相对。下端为尺骨头，其前、外、后有环状关节面与桡骨的尺切迹相关节，下面光滑借三角形的关节盘与腕骨隔开。头后内侧的锥状突起，称尺骨茎突。在正常情况下，尺骨茎突比桡骨茎突约高lcm。鹰嘴、后缘全长、尺骨头和茎突都可在体表扪到。"
                                                }
                                            }]
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Bone of upper limb,R",
                                    "c": "右上肢骨Bone of upper limb,R"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "01Shoulder girdle,R",
                                            "c": "右上肢带骨houlder girdle,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Clavicle,R",
                                                    "c": "锁骨Clavicle,R"
                                                },
                                                "t":
                                                {
                                                    "s": "锁骨：呈“～”形弯曲，架于胸廓前上方。全长可在体表扪到。内侧端粗大，为胸骨端，有关节面与胸骨柄相关节。外侧端扁平，为肩峰端，有小关节面与肩胛骨肩峰相关节。内侧2/3凸向前，呈三棱形，外侧1/3凸向后，呈扁平形。两者之间交界处较薄弱，锁骨骨折多发生在此处。锁骨上面光滑，下面粗糙。锁骨像—个杠杆，使上肢远离胸壁，以保证上肢的灵活运动。锁骨是唯一直接与躯干相连接的骨，能将应力从上肢传给躯干。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Scapula,R",
                                                    "c": "肩胛骨Scapula,R"
                                                },
                                                "t":
                                                {
                                                    "s": "肩胛骨：为三角形扁骨，贴于胸廓后外面，介于第2到第7肋骨之间。可分二面、三缘和三个角。腹侧面或肋面与胸廓相对，为一大浅窝，称肩胛下窝。背侧面有一横嵴，称肩胛冈。冈上、下方的浅窝，分别称冈上窝和冈下窝。肩胛冈向外侧延伸的扁平突起，称肩峰，与锁骨外侧端相接。\r\n                                                    上缘短而薄，外侧份有肩胛切迹，更外侧有突向前的指状突起称喙突。内侧缘薄而锐利，因邻近脊柱，故又称脊柱缘。外侧缘肥厚邻近腋窝，称腋缘。上角为上缘与脊柱缘会合处，平对第2肋。下角为脊柱缘与腋缘会合处，平对第7肋或第7肋间隙，为计数肋的标志。外侧角为腋缘与上缘会合处，最肥厚，朝外侧方的梨形浅窝，称关节盂，与肱骨头相关节。盂上、下方各有一粗糙隆起，分别称盂上结节和盂下结节。肩胛冈、肩峰、肩胛骨下角、内侧缘及喙突都可在体表扪到。"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "02Bone of free upper limb,R",
                                            "c": "右自由上肢骨Bone of free upper limb,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Bone of hand,R",
                                                    "c": "右手骨Bone of hand,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Carpal bone,R",
                                                            "c": "右腕骨Carpal bone,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Capitate,R",
                                                                    "c": "头状骨Capitate,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "头状骨：腕骨中最大者。居腕骨的中央，与第三掌骨底相对应。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Hamate,R",
                                                                    "c": "钩骨Hamate,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "钩骨：介于头状骨与三角骨之间的一块楔形骨。上面狭窄，有向外上方的关节面，与月骨相关节。其下面宽广，被一微嵴分成内、外2部，分别与第五及第四掌骨底相关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Lunate,R",
                                                                    "c": "月骨Lunate,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "月骨：半月形，介于手舟骨与三角骨之间的骨。上面光滑而凸隆，与桡骨和桡尺远侧关节盘相接。下面凹陷，由后外方的微嵴分成内、外2部，与钩骨、头状骨相关节。掌侧面呈三角形，宽广而粗糙。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Pisiform,R",
                                                                    "c": "豌豆骨Pisiform,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "豌豆骨：形似豌豆，为腕骨中最小者。掌侧面粗糙而凸隆，背侧面有椭圆形的关节面，与三角骨相关节，其内、外两面均粗糙。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Scaphoid,R",
                                                                    "c": "手舟骨Scaphoid,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "手舟骨：近侧列腕骨中最大者。其长轴斜向前外下方，上面凸隆，呈三角形，向外上方，与桡骨相接。下面也凸隆，由一微嵴分为内、外2部，分别与小多角骨及大多角骨相关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Trapezium,R",
                                                                    "c": "大多角骨Trapezium,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "大多角骨：介于舟骨与第一掌骨之间的一块骨。上面凹陷，向内上方，与舟骨相关节。下面有鞍状关节面，向外下方，与第一掌骨底相关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Trapezoid,R",
                                                                    "c": "小多角骨Trapezoid,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "小多角骨：远侧列腕骨中最小者。近似楔形，被第二掌骨底、大多角骨、舟骨及头状骨包绕。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Triquetral(triangular),R",
                                                                    "c": "三角骨Triquetral,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "三角骨：基底向外上方，尖部向内下方的一块锥形骨。其掌侧面卵圆形的关节面，与豌豆骨相关节。"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Metacarpal bone,R",
                                                            "c": "右掌骨Metacarpal bone,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "1st Metacarpal(pollex),R",
                                                                    "c": "第一掌骨1st Metacarpal(pollex),R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "掌骨：共5块。由桡侧向尺侧，依次为第1-5掌骨。近端为底，接腕骨，远端为头，接指骨；中间部为体。第1掌骨短而粗，其底有鞍状关节面，与大多角骨的鞍状关节面相关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "2nd Metacarpal,R",
                                                                    "c": "第二掌骨2nd Metacarpal,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "掌骨：共5块。由桡侧向尺侧，依次为第1-5掌骨。近端为底，接腕骨，远端为头，接指骨；中间部为体。第1掌骨短而粗，其底有鞍状关节面，与大多角骨的鞍状关节面相关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "3rd Metacarpal,R",
                                                                    "c": "第三掌骨3rd Metacarpal,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "掌骨：共5块。由桡侧向尺侧，依次为第1-5掌骨。近端为底，接腕骨，远端为头，接指骨；中间部为体。第1掌骨短而粗，其底有鞍状关节面，与大多角骨的鞍状关节面相关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "4th Metacarpal,R",
                                                                    "c": "第四掌骨4th Metacarpal,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "掌骨：共5块。由桡侧向尺侧，依次为第1-5掌骨。近端为底，接腕骨，远端为头，接指骨；中间部为体。第1掌骨短而粗，其底有鞍状关节面，与大多角骨的鞍状关节面相关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "5th Metacarpal,R",
                                                                    "c": "第五掌骨5th Metacarpal,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "掌骨：共5块。由桡侧向尺侧，依次为第1-5掌骨。近端为底，接腕骨，远端为头，接指骨；中间部为体。第1掌骨短而粗，其底有鞍状关节面，与大多角骨的鞍状关节面相关节。"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Phalanx,R",
                                                            "c": "右指骨Phalanx,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Index finger,R",
                                                                    "c": "右食指Index finger,R"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "2nd Distal phalanx(hand),R",
                                                                            "c": "食指远节指骨2nd Distal phalanx(hand),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "2nd Middle phalanx(hand),R",
                                                                            "c": "食指中节指骨2nd Middle phalanx(hand),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "2st Proximal phalanx(hand),R",
                                                                            "c": "食指近节指骨2st Proximal phalanx(hand),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    }]
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Little finger,R",
                                                                    "c": "右小指Little finger,R"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "5th Distal phalanx(hand),R",
                                                                            "c": "小指远节指骨5th Distal phalanx(hand),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "5th Middle phalanx(hand),R",
                                                                            "c": "小指中节指骨5th Middle phalanx(hand),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "5th Proximal phalanx(hand),R",
                                                                            "c": "小指近节指骨5th Proximal phalanx(hand),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    }]
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Middle finger,R",
                                                                    "c": "右中指Middle finger,R"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "3rd Distal phalanx(hand),R",
                                                                            "c": "中指远节指骨3rd Distal phalanx(hand),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "3rd Middle phalanx(hand),R",
                                                                            "c": "中指中节指骨3rd Middle phalanx(hand),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "3rd Proximal phalanx(hand),R",
                                                                            "c": "中指近节指骨3rd Proximal phalanx(hand),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    }]
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Ring finger,R",
                                                                    "c": "右环指Ring finger,R"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "4th Distal phalanx(hand),R",
                                                                            "c": "环指远节指骨4th Distal phalanx(hand),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "4th Middle phalanx(hand),R",
                                                                            "c": "环指中节指骨4th Middle phalanx(hand),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "4th Proximal phalanx(hand),R",
                                                                            "c": "环指近节指骨4th Proximal phalanx(hand),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    }]
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Thumb,R",
                                                                    "c": "右拇指Thumb,R"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "1st Distal phalanx(pollex),R",
                                                                            "c": "拇指远节指骨1st Distal phalanx(pollex),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "1st Proximal phalanx(pollex),R",
                                                                            "c": "拇指近节指骨1st Proximal phalanx(pollex),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "指骨：手部小的短管状骨。属于长骨，共14节。拇指有2节，分为近节和远节指骨，其余各指为3节，分为近节指骨、中节指骨和远节指骨。每节指骨的近端为底，中间部为体，远端为滑车。远节指骨远端掌面粗糙，称远节指骨粗隆。远节指骨为第三节指骨，最小。底呈不规则形，与中节指骨相关节，底的掌侧面微凹，为指深屈肌的附着点。"
                                                                        }
                                                                    }]
                                                                }
                                                            }]
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Humerus,R",
                                                    "c": "肱骨Humerus,R"
                                                },
                                                "t":
                                                {
                                                    "s": "肱骨：分一体及上、下两端。上端有朝向上后内方呈半球形的肱骨头，与肩胛骨的关节盂相关节。头周围的向环状浅沟，称解剖颈。肱骨头的外侧和前方有隆起的大结节和小结节，大小结节向下各延伸一嵴，称大结节嵴和小结节嵴。两结节间有一纵沟，称结节间沟。上端与体交界处稍细，称外科颈，较易发生骨折。肱骨体上半部呈圆柱形，下半部呈三棱柱形。中部外侧面有粗糙的三角肌粗隆，后面中部，有一自内上斜向外下的浅沟，称桡神经沟，桡神经和肱深动脉沿此沟经过，肱骨中部骨折可能伤及桡神经。内侧缘近中点处有开口向上的滋养孔。\r\n                                                    下端较扁，外侧部前面有半球状的肱骨小头，与桡骨相关节；内侧部有滑车状的肱骨滑车，与尺骨形成关节。滑车前面上方有一窝，称冠突窝；肱骨小头前面上方有一窝，称桡窝；滑车后面上方有一窝，称鹰嘴窝，伸肘时容纳尺骨鹰嘴。小头外侧和滑车内侧各有一突起，分别称外上髁和内上髁。内上髁后方有一浅沟，称尺神经沟，尺神经由此经过。下端与体交界处，即肱骨内、外上髁稍上方，骨质较薄弱，受暴力可发生肱骨髁上骨折。肱骨大结节和内外上髁都可在体表扪到。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Radius,R",
                                                    "c": "桡骨Radius,R"
                                                },
                                                "t":
                                                {
                                                    "s": "桡骨：位于前臂外侧部，分一体两端。上端膨大称桡骨头，头上面的关节凹于肱骨小头相关节；周围的环状关节面与尺骨相关节，头下方略细，称桡骨颈。颈的内下侧有突起的桡骨粗隆。桡骨体呈三棱柱形，内侧缘为薄锐的骨间缘。下端前凹后凸，外侧向下突出，称茎突。下端内面有关节面，称尺切迹，与尺骨头相关节，下面有腕关节面与腕骨相关节。桡骨茎突和桡骨头在体表可扪到。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Ulna,R",
                                                    "c": "尺骨Ulna,R"
                                                },
                                                "t":
                                                {
                                                    "s": "尺骨：居前壁内侧，分一体两端。上端粗大，前面有一半圆形深凹，称滑车切迹，与肱骨滑车相关节。切迹后上方的突起称鹰嘴，前下方的突起称冠突。冠突外侧面有桡切迹，与桡骨头相关节；冠突下方的粗糙隆起，称尺骨粗隆。尺骨体上段粗，下段细，外缘锐利，为骨间缘，与桡骨的骨间缘相对。下端为尺骨头，其前、外、后有环状关节面与桡骨的尺切迹相关节，下面光滑借三角形的关节盘与腕骨隔开。头后内侧的锥状突起，称尺骨茎突。在正常情况下，尺骨茎突比桡骨茎突约高lcm。鹰嘴、后缘全长、尺骨头和茎突都可在体表扪到。"
                                                }
                                            }]
                                        }
                                    }]
                                }
                            }]
                        }
                    },
                    {
                        "$":
                        {
                            "o": "04Bone of lower limb",
                            "c": "下肢骨Bone of lower limb"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "Bone of lower limb,L",
                                    "c": "左下肢骨Bone of lower limb,L"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "01Pelvic girdle,L",
                                            "c": "左下肢带骨Pelvic girdle,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "M_Ilium,L",
                                                    "c": "髂骨Ilium,L"
                                                },
                                                "t":
                                                {
                                                    "s": "髂骨：构成髋骨上部，分为肥厚的髂骨体和扁阔的髂骨翼。髂骨体构成髋臼的上2/5，翼上缘肥厚，形成弓形的髂嵴。髂嵴前端为髂前上棘，后端为髂后上棘。髂前上棘后方5-7cm处，髂嵴外唇向外突起，称髂结节,它们都是重要的体表标志。在髂前、后上棘的下方各有一薄锐突起，分别称髂前下棘和髂后下棘。髂后下棘下方有深陷的坐骨大切迹。髂骨翼内面的浅窝称髂窝，髂窝下界有圆钝骨嵴，称弓状线。髂骨翼后下方粗糙的耳状面与骶骨的耳状面相关节。耳状面后上方有髂粗隆与骶骨借韧带相连结。髂骨翼外面称为臀面，有臀肌附着。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Ischium,L",
                                                    "c": "坐骨Ischium,L"
                                                },
                                                "t":
                                                {
                                                    "s": "坐骨：构成髋骨下部，分坐骨体和坐骨支。体组成髋臼的后下2/5，后缘有尖形的坐骨棘，棘下方有坐骨小切迹。坐骨棘与髂后下棘之间为坐骨大切迹。坐骨体下后部向前、上、内延伸为较细的坐骨支，其末端与耻骨下支结合。坐骨体与坐骨支移行处的后部是粗糙的隆起，为坐骨结节，是坐骨最低部，可在体表扪到。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Pubis,L",
                                                    "c": "耻骨Pubis,L"
                                                },
                                                "t":
                                                {
                                                    "s": "耻骨：构成髋骨前下部，分体和上、下二支。体组成髋臼前下1/5。与髂骨体的结合处骨面粗糙隆起，称髂耻隆起，由此向前内伸出耻骨上支，其末端急转向下，成为耻骨下支。耻骨上支上面有一条锐嵴，称耻骨梳，向后移行于弓状线，向前终于耻骨结节，是重要体表标志。耻骨结节到中线的粗钝上缘为耻骨嵴，也可在体表扪到，耻骨上、下支相互移行处内侧的椭圆形粗糙面，称耻骨联合面，两侧联合面借软骨相接，构成耻骨联合。耻骨下支伸向后下外，与坐骨支结合，这样，耻骨与坐骨共同围成闭孔。"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "02Bone of free lower limb,L",
                                            "c": "左自由下肢骨Bone of free lower limb,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Bone of foot,L",
                                                    "c": "左足骨Bone of foot,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Metatarsal bone,L",
                                                            "c": "左跖骨Metatarsal bone,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Sesamoid,lateral,L",
                                                                    "c": "外侧籽骨Sesamoid,lateral,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": ""
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Sesamoid,medial,L",
                                                                    "c": "内侧籽骨Sesamoid,medial,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": ""
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "1st Metatarsal(hallux),L",
                                                                    "c": "第一跖骨1st Metatarsal(hallux),L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "第一跖骨：短而粗，底部有鞍状关节面，与内侧楔骨相关节，其头部与近节趾骨底相关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "2nd Metatarsal,L",
                                                                    "c": "第二跖骨2nd Metatarsal,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "第二跖骨：最长的跖骨，底部有四个关节面，分别与外侧和中间楔骨及第三跖骨相关节，头部与第二近节跖骨底相关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "3rd Metatarsal,L",
                                                                    "c": "第三跖骨3rd Metatarsal,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "第三跖骨：较第二跖骨短，底部与外侧楔骨、第二、四跖骨底相关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "4th Metatarsal,L",
                                                                    "c": "第四跖骨4th Metatarsal,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "第四跖骨：底部与骰骨、外侧楔骨、第三跖骨相关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "5th Metatarsal,L",
                                                                    "c": "第五跖骨5th Metatarsal,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "第五跖骨：较第一跖骨略长，底部后面与骰骨、内侧与第四跖骨相关节。"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Phalange of toe,L",
                                                            "c": "左趾骨Phalange of toe,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "1st toe,L",
                                                                    "c": "左第一趾骨1st toe,L"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "1st Distal phalanx(hallux),L",
                                                                            "c": "第一趾远节趾骨1st Distal phalanx(hallux),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "远节趾骨：各趾中最远的一节趾骨。底较宽，接中节趾骨滑车，前端变宽，下面粗糙，形成远节趾骨粗隆。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "1st Proximal phalanx(hallux),L",
                                                                            "c": "第一拇趾近节趾骨1st Proximal phalanx(hallux),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "近节趾骨：各趾骨中最长的骨块。共5块，底部后面有卵圆形关节面，与相应跖骨头相关节，远侧端呈滑车状，接中节趾骨底。"
                                                                        }
                                                                    }]
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "2nd toe,L",
                                                                    "c": "左第二趾骨2nd toe,L"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "2nd Distal phalanx(foot),L",
                                                                            "c": "第二趾远节趾骨2nd Distal phalanx(foot),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "远节趾骨：各趾中最远的一节趾骨。底较宽，接中节趾骨滑车，前端变宽，下面粗糙，形成远节趾骨粗隆。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "2nd Middle phalanx(foot),L",
                                                                            "c": "第二趾中节趾骨2nd Middle phalanx(foot),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "中节趾骨：在第二至第五趾位于中间的一节趾骨。短小，底部与近节趾骨滑车相关节，远侧端为趾骨滑车，与远节趾骨底相接。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "2nd Proximal phalanx(foot),L",
                                                                            "c": "第二趾近节趾骨2nd Proximal phalanx(foot),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "近节趾骨：各趾骨中最长的骨块。共5块，底部后面有卵圆形关节面，与相应跖骨头相关节，远侧端呈滑车状，接中节趾骨底。"
                                                                        }
                                                                    }]
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "3th toe,L",
                                                                    "c": "左第三趾骨3th toe,L"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "3rd Distal phalanx(foot),L",
                                                                            "c": "第三趾远节趾骨3rd Distal phalanx(foot),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "远节趾骨：各趾中最远的一节趾骨。底较宽，接中节趾骨滑车，前端变宽，下面粗糙，形成远节趾骨粗隆。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "3rd Middle phalanx(foot),L",
                                                                            "c": "第三趾中节趾骨3rd Middle phalanx(foot),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "中节趾骨：在第二至第五趾位于中间的一节趾骨。短小，底部与近节趾骨滑车相关节，远侧端为趾骨滑车，与远节趾骨底相接。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "3rd Proximal phalanx(foot),L",
                                                                            "c": "第三趾近节趾骨3rd Proximal phalanx(foot),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "近节趾骨：各趾骨中最长的骨块。共5块，底部后面有卵圆形关节面，与相应跖骨头相关节，远侧端呈滑车状，接中节趾骨底。"
                                                                        }
                                                                    }]
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "4th toe,L",
                                                                    "c": "左第四趾骨4th toe,L"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "4th Distal phalanx(foot),L",
                                                                            "c": "第四趾远节趾骨4th Distal phalanx(foot),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "远节趾骨：各趾中最远的一节趾骨。底较宽，接中节趾骨滑车，前端变宽，下面粗糙，形成远节趾骨粗隆。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "4th Middle phalanx(foot),L",
                                                                            "c": "第四趾中节趾骨4th Middle phalanx(foot),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "中节趾骨：在第二至第五趾位于中间的一节趾骨。短小，底部与近节趾骨滑车相关节，远侧端为趾骨滑车，与远节趾骨底相接。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "4th Proximal phalanx(foot),L",
                                                                            "c": "第四趾近节趾骨4th Proximal phalanx(foot),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "近节趾骨：各趾骨中最长的骨块。共5块，底部后面有卵圆形关节面，与相应跖骨头相关节，远侧端呈滑车状，接中节趾骨底。"
                                                                        }
                                                                    }]
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "5th toe,L",
                                                                    "c": "左第五趾骨5th toe,L"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "5th Distal phalanx(foot),L",
                                                                            "c": "第五趾远节趾骨5th Distal phalanx(foot),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "远节趾骨：各趾中最远的一节趾骨。底较宽，接中节趾骨滑车，前端变宽，下面粗糙，形成远节趾骨粗隆。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "5th Middle phalanx(foot),L",
                                                                            "c": "第五趾中节趾骨5th Middle phalanx(foot),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "中节趾骨：在第二至第五趾位于中间的一节趾骨。短小，底部与近节趾骨滑车相关节，远侧端为趾骨滑车，与远节趾骨底相接。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "5th Proximal phalanx(foot),L",
                                                                            "c": "第五趾近节趾骨5th Proximal phalanx(foot),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "近节趾骨：各趾骨中最长的骨块。共5块，底部后面有卵圆形关节面，与相应跖骨头相关节，远侧端呈滑车状，接中节趾骨底。"
                                                                        }
                                                                    }]
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Tarsal bone,L",
                                                            "c": "左跗骨Tarsal bone,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Calcaneus,L",
                                                                    "c": "跟骨Calcaneus,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "跟骨：足骨中最大者。近似长方形，位于距骨的下方。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Cuboid,L",
                                                                    "c": "骰骨Cuboid,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "骰骨：位于跗骨远侧列的最外侧呈不规则的立方形骨。近侧与跟骨、远侧与第四、五跖骨、内侧与外侧楔骨相关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Intermediate cuneiform,L",
                                                                    "c": "中间楔骨Intermediate cuneiform,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "中间楔骨：在内侧楔骨的外侧，短小，与足舟骨、第二跖骨、内侧楔骨和外侧楔骨相关节。上面有韧带附着，下面有肌及韧带附着。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Lateral cuneiform,L",
                                                                    "c": "外侧楔骨Lateral cuneiform,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "外侧楔骨：位于外侧，与足舟骨、第三跖骨、中间楔骨和骰骨相关节。上面有韧带附着，下面有肌腱附着。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Medial cuneiform,L",
                                                                    "c": "内侧楔骨Medial cuneiform,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "内侧楔骨：位于内侧，与足舟骨、第一、二跖骨和中间楔骨相关节。内侧面有肌腱经过，上面有韧带附着，下面有肌腱附着。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Navicular,L",
                                                                    "c": "足舟骨Navicular,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "足舟骨：介于距骨头与三块楔骨之间的一块跗骨。呈舟形，分前、后、上、下、内、外6个面。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Talus,L",
                                                                    "c": "距骨Talus,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "距骨：属短骨，位于胫骨、腓骨和跟骨之间，分头、颈、体三部分。"
                                                                }
                                                            }]
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Fibula,L",
                                                    "c": "腓骨Fibula,L"
                                                },
                                                "t":
                                                {
                                                    "s": "腓骨：腓骨细长，位于胫骨外后方，分一体两端。上端稍膨大，称腓骨头，有腓骨头关节面与胫骨相关节。头下方缩窄，称腓骨颈。体内侧缘锐利，称骨间缘，有小腿骨间膜附着，体内侧近中点处，有向上开口的滋养孔。下端膨大，形成外踝。其内侧有外踝关节面，与距骨相关节。腓骨头和外踝都可在体表扪到。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Femur,L",
                                                    "c": "股骨Femur,L"
                                                },
                                                "t":
                                                {
                                                    "s": "股骨：是人体最长最结实的长骨，长度约为体高的1/4,分一体两端。上端有朝向内上的股骨头，与髋臼相关节。头中央稍下有小的股骨头凹。头下外侧的狭细部称股骨颈。颈与体连接处上外侧的方形隆起，称大转子；内下方的隆起，称小转子，有肌肉附着。大、小转子之间，前面有转子间线，后面有转子间嵴。大转子是重要的体表标志，可在体表扪到。股骨体略弓向前，上段呈圆柱形，中段呈三棱柱形，下段前后略扁。体后面有纵行骨嵴，为粗线。此线上端分叉，向上外延续于粗糙的臀肌粗隆，向上内侧延续为耻骨肌线。粗线下端也分为内、外两线，两线间的骨面为腘面。粗线中点附近，有口朝下的滋养孔。\r\n                                                    下端有两个向后突出的膨大，为内侧髁和外侧髁，内、外侧髁的前面、下面和后面都是光滑的关节面。两髁前方的关节面彼此相连，形成髌面，与髌骨相接。两髁后份之间的深窝称髁间窝。两髁侧面最突起处，分别为内上髁和外上髁。内上髁上方的小突起，称收肌结节。它们在体表可扪到的重要标志。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Patella,L",
                                                    "c": "髌骨Patella,L"
                                                },
                                                "t":
                                                {
                                                    "s": "髌骨：是人体最大的籽骨，位股骨下端前面，在股四头肌腱内，上宽下尖，前面粗糙，后面为关节面，与股骨髌面相关节。髌骨可在体表扪到。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Tibia,L",
                                                    "c": "胫骨Tibia,L"
                                                },
                                                "t":
                                                {
                                                    "s": "胫骨：于小腿内侧，是粗大的长骨，分一体两端。上端膨大，向两侧突出，形成内侧髁和外侧髁。两髁上面各有上关节面，与股骨髁相关节。两上关节面之间的粗糙小隆起，称髁间隆起。外侧髁后下方有腓关节面与腓骨头相关节。上端前面的隆起称胫骨粗隆。内、外侧髁和胫骨粗隆于体表均可扪到。\r\n                                                    胫骨体呈三棱柱形，较锐的前缘和平滑的内侧面直接位于皮下，外侧缘有小腿骨间膜附着，称骨间缘。后面上份有斜向下内的比目鱼肌线。体上、中1/3交界处附近，有向上开口的滋养孔。胫骨下端稍膨大，其内下方有一突起，称内踝。下端的下面和内踝的外侧面有关节面与距骨相关节。下端的外侧面有腓切迹与腓骨相接。内踝可在体表们到。"
                                                }
                                            }]
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Bone of lower limb,R",
                                    "c": "右下肢骨Bone of lower limb,R"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "01Pelvic girdle,R",
                                            "c": "右下肢带骨Pelvic girdle,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "M_Ilium,R",
                                                    "c": "髂骨Ilium,R"
                                                },
                                                "t":
                                                {
                                                    "s": "髂骨：构成髋骨上部，分为肥厚的髂骨体和扁阔的髂骨翼。髂骨体构成髋臼的上2/5，翼上缘肥厚，形成弓形的髂嵴。髂嵴前端为髂前上棘，后端为髂后上棘。髂前上棘后方5-7cm处，髂嵴外唇向外突起，称髂结节,它们都是重要的体表标志。在髂前、后上棘的下方各有一薄锐突起，分别称髂前下棘和髂后下棘。髂后下棘下方有深陷的坐骨大切迹。髂骨翼内面的浅窝称髂窝，髂窝下界有圆钝骨嵴，称弓状线。髂骨翼后下方粗糙的耳状面与骶骨的耳状面相关节。耳状面后上方有髂粗隆与骶骨借韧带相连结。髂骨翼外面称为臀面，有臀肌附着。",
                                                    "pinsList": ""
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Ischium,R",
                                                    "c": "坐骨Ischium,R"
                                                },
                                                "t":
                                                {
                                                    "s": "坐骨：构成髋骨下部，分坐骨体和坐骨支。体组成髋臼的后下2/5，后缘有尖形的坐骨棘，棘下方有坐骨小切迹。坐骨棘与髂后下棘之间为坐骨大切迹。坐骨体下后部向前、上、内延伸为较细的坐骨支，其末端与耻骨下支结合。坐骨体与坐骨支移行处的后部是粗糙的隆起，为坐骨结节，是坐骨最低部，可在体表扪到。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Pubis,R",
                                                    "c": "耻骨Pubis,R"
                                                },
                                                "t":
                                                {
                                                    "s": "耻骨：构成髋骨前下部，分体和上、下二支。体组成髋臼前下1/5。与髂骨体的结合处骨面粗糙隆起，称髂耻隆起，由此向前内伸出耻骨上支，其末端急转向下，成为耻骨下支。耻骨上支上面有一条锐嵴，称耻骨梳，向后移行于弓状线，向前终于耻骨结节，是重要体表标志。耻骨结节到中线的粗钝上缘为耻骨嵴，也可在体表扪到，耻骨上、下支相互移行处内侧的椭圆形粗糙面，称耻骨联合面，两侧联合面借软骨相接，构成耻骨联合。耻骨下支伸向后下外，与坐骨支结合，这样，耻骨与坐骨共同围成闭孔。"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "02Bone of free lower limb,R",
                                            "c": "右自由下肢骨Bone of free lower limb,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Bone of foot,R",
                                                    "c": "右足骨Bone of foot,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Metatarsal bone,R",
                                                            "c": "右跖骨Metatarsal bone,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Sesamoid,lateral,R",
                                                                    "c": "外侧籽骨Sesamoid,lateral,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": ""
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Sesamoid,medial,R",
                                                                    "c": "外侧籽骨Sesamoid,medial,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": ""
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "1st Metatarsal(hallux),R",
                                                                    "c": "第一跖骨1st Metatarsal(hallux),R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "第一跖骨：短而粗，底部有鞍状关节面，与内侧楔骨相关节，其头部与近节趾骨底相关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "2nd Metatarsal,R",
                                                                    "c": "第二跖骨2nd Metatarsal,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "第二跖骨：最长的跖骨，底部有四个关节面，分别与外侧和中间楔骨及第三跖骨相关节，头部与第二近节跖骨底相关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "3rd Metatarsal,R",
                                                                    "c": "第三跖骨3rd Metatarsal,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "第三跖骨：较第二跖骨短，底部与外侧楔骨、第二、四跖骨底相关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "4th Metatarsal,R",
                                                                    "c": "第四跖骨4th Metatarsal,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "第四跖骨：底部与骰骨、外侧楔骨、第三跖骨相关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "5th Metatarsal,R",
                                                                    "c": "第五跖骨5th Metatarsal,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "第五跖骨：较第一跖骨略长，底部后面与骰骨、内侧与第四跖骨相关节。"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Phalange of toe,R",
                                                            "c": "右趾骨Phalange of toe,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "1st toe,R",
                                                                    "c": "右第一趾骨1st toe,R"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "1st Distal phalanx(hallux),R",
                                                                            "c": "第一趾远节趾骨1st Distal phalanx(hallux),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "远节趾骨：各趾中最远的一节趾骨。底较宽，接中节趾骨滑车，前端变宽，下面粗糙，形成远节趾骨粗隆。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "1st Proximal phalanx(hallux),R",
                                                                            "c": "第一拇趾近节趾骨1st Proximal phalanx(hallux),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "近节趾骨：各趾骨中最长的骨块。共5块，底部后面有卵圆形关节面，与相应跖骨头相关节，远侧端呈滑车状，接中节趾骨底。"
                                                                        }
                                                                    }]
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "2nd toe,R",
                                                                    "c": "右第二趾骨2nd toe,R"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "2nd Distal phalanx(foot),R",
                                                                            "c": "第二趾远节趾骨2nd Distal phalanx(foot),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "远节趾骨：各趾中最远的一节趾骨。底较宽，接中节趾骨滑车，前端变宽，下面粗糙，形成远节趾骨粗隆。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "2nd Middle phalanx(foot),R",
                                                                            "c": "第二趾中节趾骨2nd Middle phalanx(foot),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "中节趾骨：在第二至第五趾位于中间的一节趾骨。短小，底部与近节趾骨滑车相关节，远侧端为趾骨滑车，与远节趾骨底相接。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "2nd Proximal phalanx(foot),R",
                                                                            "c": "第二趾近节趾骨2nd Proximal phalanx(foot),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "近节趾骨：各趾骨中最长的骨块。共5块，底部后面有卵圆形关节面，与相应跖骨头相关节，远侧端呈滑车状，接中节趾骨底。"
                                                                        }
                                                                    }]
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "3th toe,R",
                                                                    "c": "右第三趾骨3th toe,R"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "3rd Distal phalanx(foot),R",
                                                                            "c": "第三趾远节趾骨3rd Distal phalanx(foot),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "远节趾骨：各趾中最远的一节趾骨。底较宽，接中节趾骨滑车，前端变宽，下面粗糙，形成远节趾骨粗隆。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "3rd Middle phalanx(foot),R",
                                                                            "c": "第三趾中节趾骨3rd Middle phalanx(foot),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "中节趾骨：在第二至第五趾位于中间的一节趾骨。短小，底部与近节趾骨滑车相关节，远侧端为趾骨滑车，与远节趾骨底相接。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "3rd Proximal phalanx(foot),R",
                                                                            "c": "第三趾近节趾骨3rd Proximal phalanx(foot),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "近节趾骨：各趾骨中最长的骨块。共5块，底部后面有卵圆形关节面，与相应跖骨头相关节，远侧端呈滑车状，接中节趾骨底。"
                                                                        }
                                                                    }]
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "4th toe,R",
                                                                    "c": "右第四趾骨4th toe,R"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "4th Distal phalanx(foot),R",
                                                                            "c": "第四趾远节趾骨4th Distal phalanx(foot),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "远节趾骨：各趾中最远的一节趾骨。底较宽，接中节趾骨滑车，前端变宽，下面粗糙，形成远节趾骨粗隆。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "4th Middle phalanx(foot),R",
                                                                            "c": "第四趾中节趾骨4th Middle phalanx(foot),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "中节趾骨：在第二至第五趾位于中间的一节趾骨。短小，底部与近节趾骨滑车相关节，远侧端为趾骨滑车，与远节趾骨底相接。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "4th Proximal phalanx(foot),R",
                                                                            "c": "第四趾近节趾骨4th Proximal phalanx(foot),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "近节趾骨：各趾骨中最长的骨块。共5块，底部后面有卵圆形关节面，与相应跖骨头相关节，远侧端呈滑车状，接中节趾骨底。"
                                                                        }
                                                                    }]
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "5th toe,R",
                                                                    "c": "第五趾骨5th toe,R"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "5th Distal phalanx(foot),R",
                                                                            "c": "第五趾远节趾骨5th Distal phalanx(foot),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "远节趾骨：各趾中最远的一节趾骨。底较宽，接中节趾骨滑车，前端变宽，下面粗糙，形成远节趾骨粗隆。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "5th Middle phalanx(foot),R",
                                                                            "c": "第五趾中节趾骨5th Middle phalanx(foot),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "中节趾骨：在第二至第五趾位于中间的一节趾骨。短小，底部与近节趾骨滑车相关节，远侧端为趾骨滑车，与远节趾骨底相接。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "5th Proximal phalanx(foot),R",
                                                                            "c": "第五趾近节趾骨5th Proximal phalanx(foot),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "近节趾骨：各趾骨中最长的骨块。共5块，底部后面有卵圆形关节面，与相应跖骨头相关节，远侧端呈滑车状，接中节趾骨底。"
                                                                        }
                                                                    }]
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Tarsal bone,R",
                                                            "c": "右跗骨Tarsal bone,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Calcaneus,R",
                                                                    "c": "跟骨Calcaneus,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "跟骨：足骨中最大者。近似长方形，位于距骨的下方。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Cuboid,R",
                                                                    "c": "骰骨Cuboid,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "骰骨：位于跗骨远侧列的最外侧呈不规则的立方形骨。近侧与跟骨、远侧与第四、五跖骨、内侧与外侧楔骨相关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Intermediate cuneiform,R",
                                                                    "c": "中间楔骨Intermediate cuneiform,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "中间楔骨：在内侧楔骨的外侧，短小，与足舟骨、第二跖骨、内侧楔骨和外侧楔骨相关节。上面有韧带附着，下面有肌及韧带附着。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Lateral cuneiform,R",
                                                                    "c": "外侧楔骨Lateral cuneiform,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "外侧楔骨：位于外侧，与足舟骨、第三跖骨、中间楔骨和骰骨相关节。上面有韧带附着，下面有肌腱附着。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Medial cuneiform,R",
                                                                    "c": "内侧楔骨Medial cuneiform,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "内侧楔骨：位于内侧，与足舟骨、第一、二跖骨和中间楔骨相关节。内侧面有肌腱经过，上面有韧带附着，下面有肌腱附着。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Navicular,R",
                                                                    "c": "足舟骨Navicular,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "足舟骨：介于距骨头与三块楔骨之间的一块跗骨。呈舟形，分前、后、上、下、内、外6个面。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Talus,R",
                                                                    "c": "距骨Talus,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "距骨：属短骨，位于胫骨、腓骨和跟骨之间，分头、颈、体三部分。"
                                                                }
                                                            }]
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Fibula,R",
                                                    "c": "腓骨Fibula,R"
                                                },
                                                "t":
                                                {
                                                    "s": "腓骨：腓骨细长，位于胫骨外后方，分一体两端。上端稍膨大，称腓骨头，有腓骨头关节面与胫骨相关节。头下方缩窄，称腓骨颈。体内侧缘锐利，称骨间缘，有小腿骨间膜附着，体内侧近中点处，有向上开口的滋养孔。下端膨大，形成外踝。其内侧有外踝关节面，与距骨相关节。腓骨头和外踝都可在体表扪到。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Femur,R",
                                                    "c": "股骨Femur,R"
                                                },
                                                "t":
                                                {
                                                    "s": "股骨：是人体最长最结实的长骨，长度约为体高的1/4,分一体两端。上端有朝向内上的股骨头，与髋臼相关节。头中央稍下有小的股骨头凹。头下外侧的狭细部称股骨颈。颈与体连接处上外侧的方形隆起，称大转子；内下方的隆起，称小转子，有肌肉附着。大、小转子之间，前面有转子间线，后面有转子间嵴。大转子是重要的体表标志，可在体表扪到。股骨体略弓向前，上段呈圆柱形，中段呈三棱柱形，下段前后略扁。体后面有纵行骨嵴，为粗线。此线上端分叉，向上外延续于粗糙的臀肌粗隆，向上内侧延续为耻骨肌线。粗线下端也分为内、外两线，两线间的骨面为腘面。粗线中点附近，有口朝下的滋养孔。\r\n                                                    下端有两个向后突出的膨大，为内侧髁和外侧髁，内、外侧髁的前面、下面和后面都是光滑的关节面。两髁前方的关节面彼此相连，形成髌面，与髌骨相接。两髁后份之间的深窝称髁间窝。两髁侧面最突起处，分别为内上髁和外上髁。内上髁上方的小突起，称收肌结节。它们在体表可扪到的重要标志。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Patella,R",
                                                    "c": "髌骨Patella,R"
                                                },
                                                "t":
                                                {
                                                    "s": "髌骨：是人体最大的籽骨，位股骨下端前面，在股四头肌腱内，上宽下尖，前面粗糙，后面为关节面，与股骨髌面相关节。髌骨可在体表扪到。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Tibia,R",
                                                    "c": "胫骨Tibia,R"
                                                },
                                                "t":
                                                {
                                                    "s": "胫骨：于小腿内侧，是粗大的长骨，分一体两端。上端膨大，向两侧突出，形成内侧髁和外侧髁。两髁上面各有上关节面，与股骨髁相关节。两上关节面之间的粗糙小隆起，称髁间隆起。外侧髁后下方有腓关节面与腓骨头相关节。上端前面的隆起称胫骨粗隆。内、外侧髁和胫骨粗隆于体表均可扪到。\r\n                                                    胫骨体呈三棱柱形，较锐的前缘和平滑的内侧面直接位于皮下，外侧缘有小腿骨间膜附着，称骨间缘。后面上份有斜向下内的比目鱼肌线。体上、中1/3交界处附近，有向上开口的滋养孔。胫骨下端稍膨大，其内下方有一突起，称内踝。下端的下面和内踝的外侧面有关节面与距骨相关节。下端的外侧面有腓切迹与腓骨相接。内踝可在体表们到。"
                                                }
                                            }]
                                        }
                                    }]
                                }
                            }]
                        }
                    }]
                }
            },
            {
                "$":
                {
                    "o": "006Systemic circulation venous",
                    "c": "静脉Systemic circulation venous"
                },
                "ch":
                {
                    "sub": [
                    {
                        "$":
                        {
                            "o": "JM_Inferior vena cava system",
                            "c": "下腔静脉系Inferior vena cava system"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "JM_01Lower limb",
                                    "c": "下肢静脉Lower limb"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "JM_Lower limb,L",
                                            "c": "左下肢静脉Lower limb,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "JM_Deep veins of lower limb,L",
                                                    "c": "左下肢深静脉Deep veins of lower limb,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Anterior tibial recurrent,L",
                                                            "c": "胫前返静脉Anterior tibial recurrent,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Anterior tibial,L",
                                                            "c": "胫前静脉Anterior tibial,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胫前静脉:胫前动脉的伴行静脉。穿小腿骨间膜向后与胫后静脉汇合成腘静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Calcaneal branches,L",
                                                            "c": "腓静脉跟支Calcaneal branches,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Circumflex femoral,lateral,L",
                                                            "c": "旋股外侧静脉Circumflex femoral,lateral,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "旋股外侧静脉：旋股外侧动脉的伴行静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Circumflex femoral,medial,L",
                                                            "c": "旋股内侧静脉Circumflex femoral,medial,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "旋股内侧静脉：旋股内侧动脉的伴行静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Deep plantar metatarsal,L",
                                                            "c": "足心静脉Deep plantar metatarsal,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "足心静脉：足心动脉的伴行静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Deep plantar venous arch,L",
                                                            "c": "足底静脉弓Deep plantar venous arch,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "足底静脉弓:足底动脉弓的伴行静脉弓。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Distal perforating branches,L",
                                                            "c": "远端穿支静脉Distal perforating branches,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Dorsal venous arch,perforating branch,L",
                                                            "c": "足背静脉弓穿支Dorsal venous arch,perforating branch,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Fibular(peroneal),L",
                                                            "c": "腓静脉Fibular(peroneal),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腓静脉：胫后静脉的属支，腓动脉的伴行静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Lateral inferior genicular,L",
                                                            "c": "膝下外侧静脉Lateral inferior genicular,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Lateral plantar,L",
                                                            "c": "足底外侧静脉Lateral plantar,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Lateral superior genicular,L",
                                                            "c": "膝上外侧静脉Lateral superior genicular,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_JM_Deep external pudendal(pudic),L",
                                                            "c": "阴部外深静脉Deep external pudendal(pudic),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "阴部外静脉：收纳外阴部的静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_JM_Femoral,L",
                                                            "c": "股静脉Femoral,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "股静脉为腘静脉向上的延续。起自收肌腱裂孔，与股动脉伴行，位于股动脉后方，逐渐转至动脉内侧，继而穿血管腔隙移行为髂外静脉。股静脉除收集大腿深部的静脉外，主要收纳大隐静脉的血液。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_JM_Profunda femoris,L",
                                                            "c": "股深静脉Profunda femoris,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "股深静脉：股深动脉的伴行静脉。通常为两条。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Medial inferior genicular,L",
                                                            "c": "膝下内侧静脉Medial inferior genicular,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Medial plantar,L",
                                                            "c": "足底内侧静脉Medial plantar,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Medial superior genicular,L",
                                                            "c": "膝上内侧静脉Medial superior genicular,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Perforating branches,L",
                                                            "c": "穿静脉Perforating branches,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "穿静脉：穿动脉的伴行静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Plantar digital,L",
                                                            "c": "趾足底静脉Plantar digital,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "趾足底静脉：位于足趾屈侧的静脉。注入跖底静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Popliteal,L",
                                                            "c": "腘静脉Popliteal,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腘静脉：位于腘动脉与胫神经间，由胫前静脉与胫后静脉合成的静脉。穿收肌腱裂孔后移行为股静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Posterior tibial,L",
                                                            "c": "胫后静脉Posterior tibial,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胫后静脉：胫后动脉的伴行静脉。由足底内、外侧静脉汇合而成，至小腿与同名动脉伴行，向上与胫前静脉合成腘静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Proximal perforating branches,L",
                                                            "c": "近端穿支Proximal perforating branches,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "JM_Superficial veins of lower limb,L",
                                                    "c": "下肢浅静脉Superficial veins of lower limb,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Dorsal venous arch,L",
                                                            "c": "足背静脉弓Dorsal venous arch,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "足背静脉弓：横位于跖骨远侧端的静脉弓。为足背静脉网的最发达部分。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Dorsalis pedis,L",
                                                            "c": "足背静脉Dorsalis pedis,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_JM_Great saphenous,L",
                                                            "c": "大隐静脉Great saphenous,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "大隐静脉：全身最长的浅静脉。起于足背静脉弓内侧，经内踝前方，沿小腿内侧上行，经过膝关节内后方，沿大腿内侧转至大腿前面上行，于耻骨结节下外方3-4cm处，穿过阔筋膜的隐静脉裂孔注入股静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_JM_Superficial circumflex iliac,L",
                                                            "c": "旋髂浅静脉Superficial circumflex iliac,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "旋髂浅静脉：引流腹前壁下部和腹下外侧部浅层静脉血的血管。注入大隐静脉近端。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_JM_Superficial epigastric,L",
                                                            "c": "腹壁浅静脉Superficial epigastric,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腹壁的浅静脉比较丰富。在脐区，浅静脉细小，彼此吻合形成脐周围静脉网。在脐平面以上，浅静脉逐级汇合成一较大的胸腹壁静脉，并经胸外侧静脉注入腋静脉；在脐平面以下，浅静脉经过腹壁浅静脉或旋髂浅静脉汇入大隐静脉，再回流入股静脉。因此，腹壁的��静脉构成了上、下腔静脉系统之间吻合。\r\n                                                                    当上、下腔静脉之一右阻塞（高压）时，血液可经另一腔静脉途径回流，呈现“纵行”的腹壁浅静脉曲张。在脐区，浅静脉与深部的附脐静脉相吻合，并借之与肝门静脉沟通，从而构成肝门系统与上、下腔静脉系统的沟通。肝门静脉高压时，肝门静脉的血液返流向脐周围静脉网，呈现以脐为中心的放射状静脉曲张，形成“海蛇头”征。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_JM_Thoracoepigastric,L",
                                                            "c": "胸腹壁静脉Thoracoepigastric,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腹壁的浅静脉比较丰富。在脐区，浅静脉细小，彼此吻合形成脐周围静脉网。在脐平面以上，浅静脉逐级汇合成一较大的胸腹壁静脉，并经胸外侧静脉注入腋静脉；在脐平面以下，浅静脉经过腹壁浅静脉或旋髂浅静脉汇入大隐静脉，再回流入股静脉。因此，腹壁的浅静脉构成了上、下腔静脉系统之间吻合。\r\n                                                                    当上、下腔静脉之一右阻塞（高压）时，血液可经另一腔静脉途径回流，呈现“纵行”的腹壁浅静脉曲张。在脐区，浅静脉与深部的附脐静脉相吻合，并借之与肝门静脉沟通，从而构成肝门系统与上、下腔静脉系统的沟通。肝门静脉高压时，肝门静脉的血液返流向脐周围静脉网，呈现以脐为中心的放射状静脉曲张，形成“海蛇头”征。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Small saphenous,L",
                                                            "c": "小隐静脉Small saphenous,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "小隐静脉：始于足背静脉弓外侧缘，在小腿后面浅筋膜中上行至腘窝，注入腘静脉的浅静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Superficial(dorsal) digital,L",
                                                            "c": "趾背静脉Superficial (dorsal) digital,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "趾背静脉：足趾背侧的静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Superficial(dorsal) metatarsal,L",
                                                            "c": "跖背静脉Superficial (dorsal) metatarsal,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "跖背静脉：跖背动脉的伴行静脉。由趾背静脉汇合而成。"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "JM_Lower limb,R",
                                            "c": "右下肢静脉Lower limb,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "JM_Deep veins of lower limb,R",
                                                    "c": "右下肢深静脉Deep veins of lower limb,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Anterior tibial recurrent,R",
                                                            "c": "胫前返静脉Anterior tibial recurrent,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Anterior tibial,R",
                                                            "c": "胫前静脉Anterior tibial,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胫前静脉:胫前动脉的伴行静脉。穿小腿骨间膜向后与胫后静脉汇合成腘静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Calcaneal branches,R",
                                                            "c": "腓静脉跟支Calcaneal branches,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Circumflex femoral,lateral,R",
                                                            "c": "旋股外侧静脉Circumflex femoral,lateral,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "旋股外侧静脉：旋股外侧动脉的伴行静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Circumflex femoral,medial,R",
                                                            "c": "旋股内侧静脉Circumflex femoral,medial,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "旋股内侧静脉：旋股内侧动脉的伴行静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Deep plantar metatarsal,R",
                                                            "c": "足心静脉Deep plantar metatarsal,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "足心静脉：足心动脉的伴行静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Deep plantar venous arch,R",
                                                            "c": "足底静脉弓Deep plantar venous arch,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "足底静脉弓:足底动脉弓的伴行静脉弓。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Distal perforating branches,R",
                                                            "c": "远端穿支静脉Distal perforating branches,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Dorsal venous arch,perforating branch,R",
                                                            "c": "足背静脉弓穿支Dorsal venous arch,perforating branch,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Fibular(peroneal),R",
                                                            "c": "腓静脉Fibular(peroneal),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腓静脉：胫后静脉的属支，腓动脉的伴行静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Lateral inferior genicular,R",
                                                            "c": "膝下外侧静脉Lateral inferior genicular,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Lateral plantar,R",
                                                            "c": "足底外侧静脉Lateral plantar,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Lateral superior genicular,R",
                                                            "c": "膝上外侧静脉Lateral superior genicular,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_JM_Deep external pudendal(pudic),R",
                                                            "c": "阴部外深静脉Deep external pudendal(pudic),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "阴部外静脉：收纳外阴部的静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_JM_Femoral,R",
                                                            "c": "股静脉Femoral,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "股静脉为腘静脉向上的延续。起自收肌腱裂孔，与股动脉伴行，位于股动脉后方，逐渐转至动脉内侧，继而穿血管腔隙移行为髂外静脉。股静脉除收集大腿深部的静脉外，主要收纳大隐静脉的血液。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_JM_Profunda femoris,R",
                                                            "c": "股深静脉Profunda femoris,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "股深静脉：股深动脉的伴行静脉。通常为两条。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Medial inferior genicular,R",
                                                            "c": "膝下内侧静脉Medial inferior genicular,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Medial plantar,R",
                                                            "c": "足底内侧静脉Medial plantar,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Medial superior genicular,R",
                                                            "c": "膝上内侧静脉Medial superior genicular,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Perforating branches,R",
                                                            "c": "穿静脉Perforating branches,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "穿静脉：穿动脉的伴行静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Plantar digital,R",
                                                            "c": "趾足底静脉Plantar digital,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "趾足底静脉：位于足趾屈侧的静脉。注入跖底静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Popliteal,R",
                                                            "c": "腘静脉Popliteal,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腘静脉：位于腘动脉与胫神经间，由胫前静脉与胫后静脉合成的静脉。穿收肌腱裂孔后移行为股静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Posterior tibial,R",
                                                            "c": "胫后静脉Posterior tibial,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胫后静脉：胫后动脉的伴行静脉。由足底内、外侧静脉汇合而成，至小腿与同名动脉伴行，向上与胫前静脉合成腘静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Proximal perforating branches,R",
                                                            "c": "近端穿支Proximal perforating branches,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "JM_Superficial veins of lower limb,R",
                                                    "c": "下肢浅静脉Superficial veins of lower limb,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Dorsal venous arch,R",
                                                            "c": "足背静脉弓Dorsal venous arch,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "足背静脉弓：横位于跖骨远侧端的静脉弓。为足背静脉网的最发达部分。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Dorsalis pedis,R",
                                                            "c": "足背静脉Dorsalis pedis,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_JM_Great saphenous,R",
                                                            "c": "大隐静脉Great saphenous,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "大隐静脉：全身最长的浅静脉。起于足背静脉弓内侧，经内踝前方，沿小腿内侧上行，经过膝关节内后方，沿大腿内侧转至大腿前面上行，于耻骨结节下外方3-4cm处，穿过阔筋膜的隐静脉裂孔注入股静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_JM_Superficial circumflex iliac,R",
                                                            "c": "旋髂浅静脉Superficial circumflex iliac,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "旋髂浅静脉：引流腹前壁下部和腹下外侧部浅层静脉血的血管。注入大隐静脉近端。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_JM_Superficial epigastric,R",
                                                            "c": "腹壁浅静脉Superficial epigastric,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腹壁的浅静脉比较丰富。在脐区，浅静脉细小，彼此吻合形成脐周围静脉网。在脐平面以上，浅静脉逐级汇合成一较大的胸腹壁静脉，并经胸外侧静脉注入腋静脉；在脐平面以下，浅静脉经过腹壁浅静脉或旋髂浅静脉汇入大隐静脉，再回流入股静脉。因此，腹壁的浅静脉构成了上、下腔静脉系统之间吻合。\r\n                                                                    当上、下腔静脉之一右阻塞（高压）时，血液可经另一腔静脉途径回流，呈现“纵行”的腹壁浅静脉曲张。在脐区，浅静脉与深部的附脐静脉相吻合，并借之与肝门静脉沟通，从而构成肝门系统与上、下腔静脉系统的沟通。肝门静脉高压时，肝门静脉的血液返流向脐周围静脉网，呈现以脐为中心的放射状静脉曲张，形成“海蛇头”征。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_JM_Thoracoepigastric,R",
                                                            "c": "胸腹壁静脉Thoracoepigastric,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腹壁的浅静脉比较丰富。在脐区，浅静脉细小，彼此吻合形成脐周围静脉网。在脐平面以上，浅静脉逐级汇合成一较大的胸腹壁静脉，并经胸外侧静脉注入腋静脉；在脐平面以下，浅静脉经过腹壁浅静脉或旋髂浅静脉汇入大隐静脉，再回流入股静脉。因此，腹壁的浅静脉构成了上、下腔静脉系统之间吻合。\r\n                                                                    当上、下腔静脉之一右阻塞（高压）时，血液可经另一腔静脉途径回流，呈现“纵行”的腹壁浅静脉曲张。在脐区，浅静脉与深部的附脐静脉相吻合，并借之与肝门静脉沟通，从而构成肝门系统与上、下腔静脉系统的沟通。肝门静脉高压时，肝门静脉的血液返流向脐周围静脉网，呈现以脐为中心的放射状静脉曲张，形成“海蛇头”征。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Small saphenous,R",
                                                            "c": "小隐静脉Small saphenous,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "小隐静脉：始于足背静脉弓外侧缘，在小腿后面浅筋膜中上行至腘窝，注入腘静脉的浅静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Superficial(dorsal) digital,R",
                                                            "c": "趾背静脉Superficial (dorsal) digital,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "趾背静脉：足趾背侧的静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Superficial(dorsal) metatarsal,R",
                                                            "c": "跖背静脉Superficial (dorsal) metatarsal,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "跖背静脉：跖背动脉的伴行静脉。由趾背静脉汇合而成。"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "JM_02Pelvis",
                                    "c": "盆部静脉Pelvis"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "JM_Common iliac vein,L",
                                            "c": "左髂总静脉Common iliac vein,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "JM_External iliac vein,L",
                                                    "c": "左髂外静脉External iliac vein,L"
                                                },
                                                "t": ""
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "JM_Internal iliac vein,L",
                                                    "c": "左髂内静脉Internal iliac vein,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Internal iliac vein,anterior trunk,L",
                                                            "c": "左髂内静脉前干Internal iliac vein,anterior trunk,L"
                                                        },
                                                        "t": ""
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Internal iliac vein,posterior trunk,L",
                                                            "c": "左髂内静脉后干Internal iliac vein,posterior trunk,L"
                                                        },
                                                        "t": ""
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_JM_Internal iliac,L",
                                                            "c": "髂内静脉Internal iliac,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "髂内静脉：在坐骨大孔稍上方由盆部的静脉汇合形成的大血管。位于髂内动脉的后内侧，在骶髂关节前方与髂外静脉汇合成髂总静脉。其属支与动脉伴行，有壁支和脏支两种。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_JM_Common iliac,L",
                                                    "c": "髂总静脉Common iliac,L"
                                                },
                                                "t":
                                                {
                                                    "s": "髂总静脉：由髂外静脉和髂内静脉汇合而成。双侧髂总静脉伴髂总动脉上行至第5腰椎体右侧汇合成下腔静脉。左髂总静脉长而倾斜，先沿左髂总动脉内侧，后沿右髂总动脉后方上行。右髂总静脉短而垂直，先行于右髂总动脉后方，后行于动脉外侧。髂总静脉接受髂腰静脉和骶外侧静脉，左髂总静脉还接受骶正中静脉。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_JM_Median(middle)sacral",
                                                    "c": "骶正中静脉Median (middle) sacral"
                                                },
                                                "t":
                                                {
                                                    "s": "骶正中静脉：在骶骨的前面，与骶正中动脉伴行的静脉。常为两支小静脉，最后合为一支，注入左髂总静脉或左、右髂总静脉的汇合处。"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "JM_Common iliac vein,R",
                                            "c": "右髂总静脉Common iliac vein,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "JM_External iliac vein,R",
                                                    "c": "右髂外静脉External iliac vein,R"
                                                },
                                                "t": ""
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "JM_Internal iliac,R",
                                                    "c": "右髂内静脉Internal iliac,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Internal iliac vein,anterior trunk,R",
                                                            "c": "右髂内静脉前干Internal iliac vein,anterior trunk,R"
                                                        },
                                                        "t": ""
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Internal iliac vein,posterior trunk,R",
                                                            "c": "右髂内静脉后干Internal iliac vein,posterior trunk,R"
                                                        },
                                                        "t": ""
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_JM_Internal iliac,R",
                                                            "c": "髂内静脉Internal iliac,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "髂内静脉：在坐骨大孔稍上方由盆部的静脉汇合形成的大血管。位于髂内动脉的后内侧，在骶髂关节前方与髂外静脉汇合成髂总静脉。其属支与动脉伴行，有壁支和脏支两种。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_JM_Common iliac,R",
                                                    "c": "髂总静脉Common iliac,R"
                                                },
                                                "t":
                                                {
                                                    "s": "髂总静脉：由髂外静脉和髂内静脉汇合而成。双侧髂总静脉伴髂总动脉上行至第5腰椎体右侧汇合成下腔静脉。左髂总静脉长而倾斜，先沿左髂总动脉内侧，后沿右髂总动脉后方上行。右髂总静脉短而垂直，先行于右髂总动脉后方，后行于动脉外侧。髂总静脉接受髂腰静脉和骶外侧静脉，左髂总静脉还接受骶正中静脉。"
                                                }
                                            }]
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "JM_03Abdomen",
                                    "c": "腹部静脉Abdomen"
                                },
                                "ch":
                                {
                                    "sub":
                                    {
                                        "$":
                                        {
                                            "o": "JM_Inferior vena cava",
                                            "c": "下腔静脉Inferior vena cava"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "JM_Hepatic vein",
                                                    "c": "肝静脉Hepatic vein"
                                                },
                                                "t": ""
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "JM_Inferior phrenic,R",
                                                    "c": "膈下静脉Inferior phrenic,R"
                                                },
                                                "t":
                                                {
                                                    "s": "膈下静脉：位于膈下面的成对静脉。除收受膈中央部的静脉血外，尚有肾上腺静脉和肾囊静脉汇入。膈下静脉常有前、后两支，与膈下动脉的分支伴行。右膈下静脉前、后支汇合后注入下腔静脉。左膈下静脉后支较粗大，沿膈下动脉下降注入左肾上腺静脉；前支较小，经食管裂孔前方注入下腔静脉。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "JM_Lumbar,L",
                                                    "c": "腰静脉Lumbar,L"
                                                },
                                                "t":
                                                {
                                                    "s": "腰静脉4对，收集腰部组织的静脉血，汇入下腔静脉。左侧腰静脉走行于腹主动脉的后方。腰静脉与椎外静脉丛有吻合，并借之与椎内静脉丛相通。各腰静脉之间纵行的交通支称为腰升静脉。两侧的腰升静脉分别经左、右膈脚入后纵膈后，左侧移行于半奇静脉，右侧移行于奇静脉，最后汇入上腔静脉。因此，腰升静脉也是沟通上、下腔静脉系统间的侧支循环途径之一。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "JM_Lumbar,R",
                                                    "c": "腰静脉Lumbar,R"
                                                },
                                                "t":
                                                {
                                                    "s": "腰静脉4对，收集腰部组织的静脉血，汇入下腔静脉。左侧腰静脉走行于腹主动脉的后方。腰静脉与椎外静脉丛有吻合，并借之与椎内静脉丛相通。各腰静脉之间纵行的交通支称为腰升静脉。两侧的腰升静脉分别经左、右膈脚入后纵膈后，左侧移行于半奇静脉，右侧移行于奇静脉，最后汇入上腔静脉。因此，腰升静脉也是沟通上、下腔静脉系统间的侧支循环途径之一。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_JM_Ascending lumbar,L",
                                                    "c": "腰升静脉Ascending lumbar,L"
                                                },
                                                "t":
                                                {
                                                    "s": "腰升静脉：下端与髂外静脉或髂总静脉外侧壁相连，沿腰椎侧前方上升，接受各腰静脉外侧端和左、右肋下静脉后，汇入奇静脉和半奇静脉。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_JM_Ascending lumbar,R",
                                                    "c": "腰升静脉Ascending lumbar,R"
                                                },
                                                "t":
                                                {
                                                    "s": "腰升静脉：下端与髂外静脉或髂总静脉外侧壁相连，沿腰椎侧前方上升，接受各腰静脉外侧端和左、右肋下静脉后，汇入奇静脉和半奇静脉。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_JM_Inferior vena cava",
                                                    "c": "下腔静脉Inferior vena cava"
                                                },
                                                "t":
                                                {
                                                    "s": "下腔静脉：由左、右髂总静脉在第4或第5腰椎体右前方汇合而成，沿腹主动脉右侧和脊柱右前方上行，经肝的腔静脉沟，穿膈的腔静脉孔进入胸腔，再穿纤维心包注入右心房。下腔静脉的属支分壁支和脏支两种，多数与同名动脉伴行。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "JM_Renal vein,L",
                                                    "c": "肾静脉Renal vein,L"
                                                },
                                                "t": ""
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "JM_Renal,R",
                                                    "c": "肾静脉Renal,R"
                                                },
                                                "t":
                                                {
                                                    "s": "肾静脉：在肾门附近由肾内2-3个属支汇合而成的静脉。于肾动脉前方行向内侧，以直角注入下腔静脉。左肾静脉跨越腹主动脉前面注入下腔静脉，较右肾静脉长，并接受左肾上腺静脉与睾丸或卵巢静脉。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "JM_Suprarenal,R",
                                                    "c": "右肾上腺静脉Suprarenal,R"
                                                },
                                                "t":
                                                {
                                                    "s": "肾上腺静脉：左肾上腺静脉从肾上腺门穿出，呈垂直方向下降，注入左肾静脉的血管。较右侧长，此静脉常与左膈下静脉和肾囊静脉相连。右肾上腺静脉引流右肾上腺静脉血的血管。较左侧者短，约在第一腰椎水平处，向内行开口于下腔静脉的后壁。"
                                                }
                                            }]
                                        }
                                    }
                                }
                            }]
                        }
                    },
                    {
                        "$":
                        {
                            "o": "JM_Superior vena cava system",
                            "c": "上腔静脉系Superior vena cava system"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "JM_01Head and neck",
                                    "c": "头颈部静脉Head and neck"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "JM_Head and neck,L",
                                            "c": "左头颈部静脉Head and neck,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "JM_Internal jugular vein,L",
                                                    "c": "左颈内静脉Internal jugular vein,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Facial vein,L",
                                                            "c": "左面静脉Facial vein,L"
                                                        },
                                                        "t": ""
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Internal jugular,L",
                                                            "c": "颈内静脉Internal jugular,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈内静脉：于颈静脉孔处续于乙状窦，在颈动脉鞘内沿颈内动脉和颈总动脉外侧下行，至胸锁关节后方与锁骨下静脉汇合成头臂静脉。颈内静脉的颅内属支有乙状窦和岩下窦，收集颅骨、脑膜、脑、泪器和前庭蜗器等处的静脉血。颅外属支包括面静脉、舌静脉、咽静脉、甲状腺上静脉和甲状腺中静脉等。颈内静脉壁附着于颈动脉鞘，并通过颈动脉鞘与周围的颈深筋膜和肩胛舌骨肌中间腱相连，故管腔经常处于开放状态，有利于血液回流。颈内静脉外伤时，由于管腔不能闭锁和胸腔负压对血液的吸引，可导致空气栓塞。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Middle thyroid,L",
                                                            "c": "甲状腺中静脉Middle thyroid,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "甲状腺中静脉：起于甲状腺侧叶外侧缘中点稍下，越过颈总动脉汇入颈内静脉前壁的静脉。只有58%个体具有一侧或双侧的甲状腺中静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Retromandibular vein,L",
                                                            "c": "下颌后静脉Retromandibular vein,L"
                                                        },
                                                        "t": ""
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Superior thyroid,L",
                                                            "c": "甲状腺上静脉Superior thyroid,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "甲状腺上静脉：在甲状腺侧叶上端汇成后，沿甲状腺上动脉外侧伴行向上，接受喉上静脉的汇入，最后越过颈总动脉前方汇入颈内静脉或面总静脉末端。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "JM_Ophthalmic vein,L",
                                                    "c": "眼静脉Ophthalmic vein,L"
                                                },
                                                "t": ""
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "JM_Subclavian vein,L",
                                                    "c": "左锁骨下静脉Subclavian vein,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_External jugular vein,L",
                                                            "c": "左颈外静脉External jugular vein,L"
                                                        },
                                                        "t": ""
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Subclavian,L",
                                                            "c": "锁骨下静脉Subclavian,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "锁骨下静脉：在第1肋外侧缘续于腋静脉，向内行于腋动脉的前下方，至胸锁关节后方与颈内静脉汇合成头臂静脉。两静脉汇合部称静脉角，是淋巴导管的注入部位。锁骨下静脉的主要属支是腋静脉和颈外静脉。临床上常经锁骨上或锁骨下入路作锁骨下静脉导管插入。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Suprascapular,L",
                                                            "c": "肩胛上静脉Suprascapular,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肩胛上静脉：肩胛上动脉的伴行静脉。汇入颈外静脉下部，或直接注入锁骨下静脉。"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "JM_Head and neck,R",
                                            "c": "右头颈部静脉Head and neck,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "JM_Internal jugular vein,R",
                                                    "c": "右颈内静脉Internal jugular vein,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Facial vein,R",
                                                            "c": "右面静脉Facial vein,R"
                                                        },
                                                        "t": ""
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Internal jugular,R",
                                                            "c": "颈内静脉Internal jugular,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈内静脉：于颈静脉孔处续于乙状窦，在颈动脉鞘内沿颈内动脉和颈总动脉外侧下行，至胸锁关节后方与锁骨下静脉汇合成头臂静脉。颈内静脉的颅内属支有乙状窦和岩下窦，收集颅骨、脑膜、脑、泪器和前庭蜗器等处的静脉血。颅外属支包括面静脉、舌静脉、咽静脉、甲状腺上静脉和甲状腺中静脉等。颈内静脉壁附着于颈动脉鞘，并通过颈动脉鞘与周围的颈深筋膜和肩胛舌骨肌中间腱相连，故管腔经常处于开放状态，有利于血液回流。颈内静脉外伤时，由于管腔不能闭锁和胸腔负压对血液的吸引，可导致空气栓塞。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Middle thyroid,R",
                                                            "c": "甲状腺中静脉Middle thyroid,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "甲状腺中静脉：起于甲状腺侧叶外侧缘中点稍下，越过颈总动脉汇入颈内静脉前壁的静脉。只有58%个体具有一侧或双侧的甲状腺中静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Retromandibular vein,R",
                                                            "c": "下颌后静脉Retromandibular vein,R"
                                                        },
                                                        "t": ""
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Superior thyroid,R",
                                                            "c": "甲状腺上静脉Superior thyroid,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "甲状腺上静脉：在甲状腺侧叶上端汇成后，沿甲状腺上动脉外侧伴行向上，接受喉上静脉的汇入，最后越过颈总动脉前方汇入颈内静脉或面总静脉末端。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "JM_Ophthalmic vein,R",
                                                    "c": "眼静脉Ophthalmic vein,R"
                                                },
                                                "t": ""
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "JM_Subclavian vein,R",
                                                    "c": "右锁骨下静脉Subclavian vein,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_External jugular vein,R",
                                                            "c": "右颈外静脉External jugular vein,R"
                                                        },
                                                        "t": ""
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Subclavian,R",
                                                            "c": "锁骨下静脉Subclavian,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "锁骨下静脉：在第1肋外侧缘续于腋静脉，向内行于腋动脉的前下方，至胸锁关节后方与颈内静脉汇合成头臂静脉。两静脉汇合部称静脉角，是淋巴导管的注入部位。锁骨下静脉的主要属支是腋静脉和颈外静脉。临床上常经锁骨上或锁骨下入路作锁骨下静脉导管插入。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Suprascapular,R",
                                                            "c": "肩胛上静脉Suprascapular,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肩胛上静脉：肩胛上动脉的伴行静脉。汇入颈外静脉下部，或直接注入锁骨下静脉。"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "JM_02Upper limb",
                                    "c": "上肢静脉Upper limb"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "JM_Upper limb,L",
                                            "c": "左上肢静脉Upper limb,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "JM_Deep veins of upper limb,L",
                                                    "c": "左上肢深静脉Deep veins of upper limb,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Axillary,L",
                                                            "c": "腋静脉Axillary,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腋静脉：外侧有腋动脉、两者之间有臂丛内侧束、尺神经及前臂内侧皮神经等，内侧有臂内侧皮神经，远端有腋淋巴结外侧群，近端有腋淋巴结尖群。当上肢外展时，腋静脉位于腋动脉的前方。腋静脉的属支与腋动脉的分支同名并伴行。此外，头静脉穿过锁胸筋膜注入腋静脉。腋静脉的管壁与腋鞘和锁胸筋膜愈着，使其管腔保持扩张状态，一旦损伤容易发生空气栓塞。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Brachial,L",
                                                            "c": "肱静脉Brachial,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肱静脉：肱动脉的伴行静脉。有两支，两静脉间有多数横支相互吻合，并接受肱动脉分支的伴行静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Circumflex humeral,anterior,L",
                                                            "c": "旋肱前静脉Circumflex humeral,anterior,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "旋肱前静脉：旋肱前动脉的伴行静脉。汇入腋静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Circumflex humeral,posterior,L",
                                                            "c": "旋肱后静脉Circumflex humeral,posterior,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "旋肱后静脉：旋肱后动脉的伴行静脉，汇入腋静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Circumflex scapular,L",
                                                            "c": "旋肩胛静脉Circumflex scapular,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "旋肩胛静脉：旋肩胛动脉的伴行静脉，肩胛下静脉的属支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Lateral thoracic,L",
                                                            "c": "胸外侧静脉Lateral thoracic,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸外侧静脉：胸外侧动脉的伴行静脉。接受胸壁外侧的浅静脉，汇入腋静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Radial,L",
                                                            "c": "桡静脉Radial,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "桡静脉：桡动脉的伴行静脉。向上至肘窝与尺静脉汇合组成肱静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Subscapular,L",
                                                            "c": "肩胛下静脉Subscapular,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肩胛下静脉：肩胛下动脉的伴行静脉。汇入腋静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Thoracodorsal,L",
                                                            "c": "胸背静脉Thoracodorsal,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸背静脉：胸背动脉的伴行静脉。与旋肩胛静脉汇合形成肩胛下静脉，汇入腋静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Ulnar,L",
                                                            "c": "尺静脉Ulnar,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "尺静脉：尺动脉的伴行静脉。接受来自掌深静脉弓的属支，在腕部与浅静脉相交通，至肘部附近，收纳骨间前、后静脉。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "JM_Superficial veins of upper limb,L",
                                                    "c": "左上肢浅静脉Superficial veins of upper limb,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Accessory cephalic,L",
                                                            "c": "副头静脉Accessory cephalic,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "副头静脉：位于头静脉外侧，前臂部的一个静脉属支。向上至肘窝以下注入头静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Basilic,L",
                                                            "c": "贵要静脉Basilic,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "贵要静脉：起自手背静脉网的尺侧，沿前臂尺侧上行，至肘部转至前面，在肘窝处接受肘正中静脉，再经肱二头肌内侧沟行至臂中点高度，穿深筋膜注入肱静脉，或伴肱静脉上行，注入腋静脉。贵要静脉收集手和前臂尺侧浅层结构的静脉血。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Cephalic,L",
                                                            "c": "头静脉Cephalic,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "头静脉：起自手背静脉网的桡侧，沿前臂下部的桡侧、前臂上部和肘部的前面以及肱二头肌外侧沟上行，再经三角肌与胸大肌间沟行至锁骨下窝，穿深筋膜注入腋静脉或锁骨下静脉。头静脉在肘窝处通过肘正中静脉与贵要静脉交通。头静脉收集手和前臂桡侧浅层结构的静脉血。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Dorsal venous rete of hand,L",
                                                            "c": "左手背静脉网Dorsal venous rete of hand,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "JM_Dorsal digital,L",
                                                                    "c": "指背静脉Dorsal digital,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "指背静脉：起自甲床两侧的小静脉。沿指背两侧向近侧上行，彼此间有一些斜行的交通支互相连接，形成指背静脉弓。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "JM_Dorsal metacarpal,L",
                                                                    "c": "掌背静脉Dorsal metacarpal,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "掌背静脉：由相邻指的指背静脉彼此吻合形成的静脉。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "JM_Dorsal venous arch,L",
                                                                    "c": "手背静脉弓Dorsal venous arch,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": ""
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Median antebrachial,L",
                                                            "c": "前臂正中静脉Median antebrachial,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "前臂正中静脉：起自手掌静脉丛，沿前臂前面上行，注入肘正中静脉。前臂正中静脉有时分叉，分别注入头静脉和贵要静脉，因而不存在肘正中静脉。前臂正中静脉收集手掌侧和前臂前部浅层结构的静脉血。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Median cubital,L",
                                                            "c": "肘正中静脉Median cubital,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肘正中静脉：变异较多，通常在肘窝处连接头静脉和贵要静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Palmar venous rete of hand,L",
                                                            "c": "左手掌侧静脉网Palmar venous rete of hand,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "JM_Common palmar digital,L",
                                                                    "c": "指掌侧总静脉Common palmar digital,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "指掌侧总静脉：指掌侧总动脉的伴行静脉。汇入掌浅弓静脉。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "JM_Intercapitular,L",
                                                                    "c": "掌骨头间静脉Intercapitular,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "掌骨头间静脉：位于掌骨头间隙内沟通指背静脉与指掌侧静脉的血管。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "JM_Palmar digital,L",
                                                                    "c": "指掌侧静脉Palmar digital,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "指掌侧静脉：多为数条纵行的静脉，由侧支互相吻合成网，在手指基部汇成两条小静脉。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "JM_Palmar metacarpal,L",
                                                                    "c": "掌心静脉Palmar metacarpal,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "掌心静脉：掌心动脉的伴行静脉，汇入掌深弓静脉。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "JM_Palmar venous arch,deep,L",
                                                                    "c": "掌深弓静脉Palmar venous arch,deep,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "掌深弓静脉：掌深弓的伴行静脉。有两支，较粗大。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "JM_Palmar venous arch,superficial,L",
                                                                    "c": "掌浅静脉弓Palmar venous arch,superficial,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "掌浅静脉弓：掌浅弓的伴行静脉。较细小。"
                                                                }
                                                            }]
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "JM_Upper limb,R",
                                            "c": "右上肢静脉Upper limb,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "JM_Deep veins of upper limb,R",
                                                    "c": "右上肢深静脉Deep veins of upper limb,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Axillary,R",
                                                            "c": "腋静脉Axillary,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腋静脉：外侧有腋动脉、两者之间有臂丛内侧束、尺神经及前臂内侧皮神经等，内侧有臂内侧皮神经，远端有腋淋巴结外侧群，近端有腋淋巴结尖群。当上肢外展时，腋静脉位于腋动脉的前方。腋静脉的属支与腋动脉的分支同名并伴行。此外，头静脉穿过锁胸筋膜注入腋静脉。腋静脉的管壁与腋鞘和锁胸筋膜愈着，使其管腔保持扩张状态，一旦损伤容易发生空气栓塞。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Brachial,R",
                                                            "c": "肱静脉Brachial,R 1"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肱静脉：肱动脉的伴行静脉。有两支，两静脉间有多数横支相互吻合，并接受肱动脉分支的伴行静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Circumflex humeral,anterior,R",
                                                            "c": "旋肱前静脉Circumflex humeral,anterior,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "旋肱前静脉：旋肱前动脉的伴行静脉。汇入腋静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Circumflex humeral,posterior,R",
                                                            "c": "旋肱后静脉Circumflex humeral,posterior,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "旋肱后静脉：旋肱后动脉的伴行静脉，汇入腋静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Circumflex scapular,R",
                                                            "c": "旋肩胛静脉Circumflex scapular,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "旋肩胛静脉：旋肩胛动脉的伴行静脉，肩胛下静脉的属支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Lateral thoracic,R",
                                                            "c": "胸外侧静脉Lateral thoracic,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸外侧静脉：胸外侧动脉的伴行静脉。接受胸壁外侧的浅静脉，汇入腋静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Radial,R",
                                                            "c": "桡静脉Radial,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "桡静脉：桡动脉的伴行静脉。向上至肘窝与尺静脉汇合组成肱静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Subscapular,R",
                                                            "c": "肩胛下静脉Subscapular,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肩胛下静脉：肩胛下动脉的伴行静脉。汇入腋静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Thoracodorsal,R",
                                                            "c": "胸背静脉Thoracodorsal,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸背静脉：胸背动脉的伴行静脉。与旋肩胛静脉汇合形成肩胛下静脉，汇入腋静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Ulnar,R",
                                                            "c": "尺静脉Ulnar,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "尺静脉：尺动脉的伴行静脉。接受来自掌深静脉弓的属支，在腕部与浅静脉相交通，至肘部附近，收纳骨间前、后静脉。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "JM_Superficial veins of upper limb,R",
                                                    "c": "右上肢浅静脉Superficial veins of upper limb,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Accessory cephalic,R",
                                                            "c": "副头静脉Accessory cephalic,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "副头静脉：位于头静脉外侧，前臂部的一个静脉属支。向上至肘窝以下注入头静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Basilic,R",
                                                            "c": "贵要静脉Basilic,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "贵要静脉：起自手背静脉网的尺侧，沿前臂尺侧上行，至肘部转至前面，在肘窝处接受肘正中静脉，再经肱二头肌内侧沟行至臂中点高度，穿深筋膜注入肱静脉，或伴肱静脉上行，注入腋静脉。贵要静脉收集手和前臂尺侧浅层结构的静脉血。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Cephalic,R",
                                                            "c": "头静脉Cephalic,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "头静脉：起自手背静脉网的桡侧，沿前臂下部的桡侧、前臂上部和肘部的前面以及肱二头肌外侧沟上行，再经三角肌与胸大肌间沟行至锁骨下窝，穿深筋膜注入腋静脉或锁骨下静脉。头静脉在肘窝处通过肘正中静脉与贵要静脉交通。头静脉收集手和前臂桡侧浅层结构的静脉血。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Median antebrachial,R",
                                                            "c": "前臂正中静脉Median antebrachial,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "前臂正中静脉：起自手掌静脉丛，沿前臂前面上行，注入肘正中静脉。前臂正中静脉有时分叉，分别注入头静脉和贵要静脉，因而不存在肘正中静脉。前臂正中静脉收集手掌侧和前臂前部浅层结构的静脉血。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Median cubital,R",
                                                            "c": "肘正中静脉Median cubital,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肘正中静脉：变异较多，通常在肘窝处连接头静脉和贵要静脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Dorsal venous rete of hand,R",
                                                            "c": "右手背静脉网Dorsal venous rete of hand,R"
                                                        },
                                                        "t": ""
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "JM_Palmar venous rete of hand,R",
                                                            "c": "右手掌侧静脉网Palmar venous rete of hand,R"
                                                        },
                                                        "t": ""
                                                    }]
                                                }
                                            }]
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "JM_03Thorax",
                                    "c": "胸部静脉Thorax"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "JM_Superior vena cava",
                                            "c": "上腔静脉Superior vena cava"
                                        },
                                        "t":
                                        {
                                            "s": "上腔静脉：由左、右头臂静脉汇合而成。沿升主动脉右侧下行，至右侧第2胸肋关节后方穿纤维心包，平第3胸肋关节下缘注入右心房。在穿纤维心包之前，有奇静脉注入。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "JM_Azygos vein",
                                            "c": "奇静脉Azygos vein"
                                        },
                                        "t": ""
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "JM_Brachiocephalic vein,L",
                                            "c": "左头臂静脉Brachiocephalic vein,L"
                                        },
                                        "t": ""
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "JM_Brachiocephalic vein,R",
                                            "c": "右头臂静脉Brachiocephalic vein,R"
                                        },
                                        "t": ""
                                    }]
                                }
                            }]
                        }
                    }]
                }
            },
            {
                "$":
                {
                    "o": "007Systemic circulation arterial",
                    "c": "动脉Systemic circulation arterial"
                },
                "ch":
                {
                    "sub": [
                    {
                        "$":
                        {
                            "o": "DM_01Aortic arch and branches",
                            "c": "主动脉弓及其分支Aortic arch and branches"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "DM_Aortic arch",
                                    "c": "主动脉弓Aortic arch"
                                },
                                "t":
                                {
                                    "s": "主动脉弓：位于胸骨角平面以上，于右第2胸肋关节上缘水平续接升主动脉，呈弓形向左后到脊柱左侧第4胸椎体下缘续为胸主动脉。在与胸主动脉移行处，管径略小，称主动脉峡。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "DM_Brachiocephalic trunk(innominate artery)1",
                                    "c": "头臂干Brachiocephalic trunk (innominate artery)"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "DM_Brachiocephalic trunk(innominate artery)",
                                            "c": "头臂干(无名动脉)Brachiocephalic trunk (innominate artery)"
                                        },
                                        "t":
                                        {
                                            "s": "头臂干为一粗短的干，向右上方斜行至右胸锁关节后方分为右颈总动脉和右锁骨下动脉。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_Right common carotid artery",
                                            "c": "右颈总动脉Right common carotid artery"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Common carotid,R",
                                                    "c": "颈总动脉Common carotid,R"
                                                },
                                                "t":
                                                {
                                                    "s": "颈总动脉：是头颈部的动脉主干。左颈总动脉起自主动脉弓，右颈总动脉起自头臂干。两侧的颈总动脉均经胸锁关节后方沿食管、气管和喉的外侧上行，至甲状软骨上缘高度，分为颈内动脉和颈外动脉。颈总动脉上段位置表浅，在活体上可摸到其搏动。当头面部大出血时，在胸锁乳突肌前缘，平环状软骨弓的侧方，向后内将动脉压向后内方的第6颈椎横突上，进行急救止血。在颈总动脉分杈处及附近有颈动脉窦和颈动脉小球两个重要结构。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_External carotid artery,R",
                                                    "c": "右颈外动脉External carotid artery,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_External carotid,R",
                                                            "c": "颈外动脉External carotid,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈外动脉：颈总动脉两终支之一。初居颈内动脉的前内侧，后经其前方转至外侧，上行穿腮腺至下颌颈处分为颞浅动脉和上颌动脉两终支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Facial artery,R",
                                                            "c": "右面动脉Facial artery,R"
                                                        },
                                                        "t": ""
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Lingual,R",
                                                            "c": "舌动脉Lingual,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "舌动脉：平舌骨大角处发自颈外动脉的前方，行向前内方入舌。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Maxillary artery,R",
                                                            "c": "右上颌动脉Maxillary artery,R"
                                                        },
                                                        "t": ""
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Occipital,R",
                                                            "c": "枕动脉Occipital,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "枕动脉：与面动脉的起点相对，在乳突根部的内侧向后行至枕部。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Posterior auricular,R",
                                                            "c": "耳后动脉Posterior auricular,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "耳后动脉：起自颈外动脉后壁，发出部位大都低于或平乳突尖。该支动脉的分支有耳后支和枕支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Superficial temporal artery,R",
                                                            "c": "颞浅动脉Superficial temporal artery,R"
                                                        },
                                                        "t": ""
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Superior thyroid,R",
                                                            "c": "甲状腺上动脉Superior thyroid,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "甲状腺上动脉：颈外动脉的第一分支。起自颈外动脉的起始处，行向前下方，分布到甲状腺上部和喉。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Internal carotid artery,R",
                                                    "c": "右颈内动脉Internal carotid artery,R"
                                                },
                                                "t": ""
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_Right subclavian artery",
                                            "c": "右锁骨下动脉Right subclavian artery"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Axillary artery,R",
                                                    "c": "右腋动脉Axillary artery,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Axillary,R",
                                                            "c": "腋动脉Axillary,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腋动脉：锁骨下动脉的延续。从第一肋的外侧缘至大圆肌的下缘，以胸小肌为界分为3段。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Circumflex humeral,anterior,R",
                                                            "c": "旋肱前动脉Circumflex humeral,anterior,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "旋肱前动脉：腋动脉第三段的分支。绕肱骨外科颈前面分布至邻近肌、骨膜和肩关节囊。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Circumflex humeral,posterior,R",
                                                            "c": "旋肱后动脉Circumflex humeral,posterior,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "旋肱后动脉：腋动脉第三段的分支。伴腋神经穿四边孔，绕肱骨外科颈至三角肌和肩关节等处，并与旋肱前动脉吻合。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Circumflex scapular,R",
                                                            "c": "旋肩胛动脉Circumflex scapular,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "旋肩胛动脉：肩胛下动脉的终支之一。穿三边孔至肩背部，分布至邻近肌肉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Lateral thoracic,R",
                                                            "c": "胸外侧动脉Lateral thoracic,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸外侧动脉：约69%起自于腋动脉第二段，较少起于第三段，有的与腋动脉的其他分支共干。该动脉发出后在胸小肌后面下行，分柘于前锯肌和胸大、小肌，在女性有分支至乳房。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Subscapular,R",
                                                            "c": "肩胛下动脉Subscapular,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肩胛下动脉：腋动脉第三段的分支。沿腋窝后壁下行，分为两个终支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Superior thoracic,R",
                                                            "c": "胸上动脉Superior thoracic,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸上动脉：锁骨下动脉第一段的分支。较小，分布至胸前壁上部结构。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Thoracoacromial trunk,R",
                                                            "c": "胸肩峰动脉Thoracoacromial trunk,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸肩峰动脉：为一短干，约65%起自腋动脉第一段，35%起自第二段。该动脉发出后穿锁胸筋膜，分为肩峰支、三角肌支、胸肌支和锁骨支，并分布于同名区域。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Thoracoacromial,acromial branch,R",
                                                            "c": "胸肩峰动脉肩峰支Thoracoacromial,acromial branch,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸肩峰动脉肩峰支：胸肩峰动脉的分支之一。行向肩峰，参与肩峰网的形成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Thoracoacromial,deltoid branch,R",
                                                            "c": "胸肩峰动脉三角肌支Thoracoacromial,deltoid branch,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸肩峰动脉三角肌支：胸肩峰动脉供应三角肌的分支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Thoracoacromial,pectoral branch,R",
                                                            "c": "胸肩峰动脉胸肌支Thoracoacromial,pectoral branch,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸肩峰动脉胸肌支：行于胸大、小肌间并分支营养此2肌。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Thoracodorsal,R",
                                                            "c": "胸背动脉Thoracodorsal,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸背动脉：肩胛下动脉的终支之一。穿三边孔至肩背部，分布至邻近肌肉。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Brachial artery,R",
                                                    "c": "右肱动脉Brachial artery,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Brachial,R",
                                                            "c": "肱动脉Brachial,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肱动脉：与正中神经伴行沿肱二头肌的内侧至肘窝，在平桡骨颈高度分为桡动脉和尺动脉。肱动脉位置表浅，可在肱二头肌内侧沟处触知其搏动。当前臂和手部出血时，可在臂中部用指压法将该动脉压向肱骨以达到暂时止血的目的。如果使用止血带进行止血，应避开臂部中1/3部，以免因长时间压迫位于桡神经沟内的桡神经造成该神经的损伤。\r\n                                                                    肱动脉最重要的分支是肱深动脉。肱深动脉斜向后外方走行，伴桡神经沿桡神经沟下行，分支营养肱三头肌和肱骨，其终支参与肘关节网的组成。肱动脉还发出尺侧上副动脉、尺侧下副动脉、肱骨滋养动脉和肌支，营养臂肌和肱骨。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Inferior ulnar collateral,R",
                                                            "c": "尺侧下副动脉Inferior ulnar collateral,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "尺侧下副动脉：肱动脉的分支。在肱骨内上髁稍上方发自肱动脉，参与形成肘关节网。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Middle collateral,R",
                                                            "c": "中副动脉Middle collateral,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "中副动脉：为肱深动脉的一条终支，在肱骨肌管内下行至肘关节，与骨间返动脉吻合，参与肘关节动脉网的组成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Profunda brachii,R",
                                                            "c": "肱深动脉Profunda brachii,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肱深动脉：在大圆肌腱稍下方，起自肱动脉后内侧壁，与桡神经伴行，行向下外入肱骨肌管，分支营养肱三头肌和肱肌。在肱骨肌管分为前、后两支，前支称桡侧副动脉，与桡神经伴行穿外侧肌间隔；后支称中副动脉，在臂后区下行。二者均参与肘关节动脉网的组成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Radial collateral,R",
                                                            "c": "桡侧副动脉Radial collateral,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "桡侧副动脉：肱深动脉末梢支。在臂外侧肌间隔的后方下行，参与肘关节网的形成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Superior ulnar collateral,R",
                                                            "c": "尺侧上副动脉Superior ulnar collateral,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "尺侧上副动脉：肱动脉的分支。在肱骨内上髁稍上方发自肱动脉，参与形成肘关节网。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Deep palmar arch,R",
                                                    "c": "右掌深弓Deep palmar arch,R"
                                                },
                                                "t": ""
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Dorsal carpal rete,R",
                                                    "c": "右腕背网Dorsal carpal rete,R"
                                                },
                                                "t": ""
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Radial artery,R",
                                                    "c": "右桡动脉Radial artery,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Princeps pollicis,R",
                                                            "c": "拇主要动脉Princeps pollicis,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "拇主要动脉分为3支，分布于拇指掌面两侧缘和示指桡侧缘。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Radial artery of indexcis,R",
                                                            "c": "示指桡侧动脉Radial artery of indexcis,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "示指桡侧动脉：拇主要动脉分布至第二指掌侧外侧缘的分支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Radial recurrent,R",
                                                            "c": "桡侧返动脉Radial recurrent,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "桡侧返动脉：桡动脉近侧段的分支。经肱桡肌与肱肌间上行，参与形成肘关节网。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Radial,R",
                                                            "c": "桡动脉Radial,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "桡动脉：肱动脉的两个终支之一。先经肱桡肌和旋前圆肌之间，继而在肱桡肌腱与桡侧腕屈肌腱之间下行，绕桡骨茎突至手背，穿第1掌骨间隙至手掌，其末端与尺动脉掌深支吻合形成掌深弓。桡动脉的下段仅被皮肤和筋膜覆盖，是临床触摸脉搏的常用部位，可在桡骨茎突的内上方触摸其脉搏。桡动脉的主要分支包括：①掌浅支，与尺动脉末端吻合形成掌浅弓。②拇主要动脉，分为三支分布于拇指掌侧面的两侧缘以及示指桡侧缘。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Subclavian artery,R",
                                                    "c": "右锁骨下动脉Subclavian artery,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Ascending cervical,R",
                                                            "c": "颈升动脉Ascending cervical,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈升动脉：甲状腺下动脉的分支。在颈深部肌内上行，分布至颈深肌、脊髓和颈椎体等。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Costocervical trunk,R",
                                                            "c": "肋颈干Costocervical trunk,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肋颈干：起自锁骨下动脉第1或第2段，经胸膜顶上方弓形向后至第1肋颈处分为颈深动脉和最上肋间动脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Deep cervical,R",
                                                            "c": "颈深动脉Deep cervical,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈深动脉：由肋颈干发出的动脉，上行至颈背部，行向头半棘肌，供应邻近肌肉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Dorsal scapular(transverse scapular,deep branch),R",
                                                            "c": "肩胛背动脉（颈横动脉深支）Dorsal scapular(transverse scapular,deep branch),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肩胛背动脉（颈横动脉深支）：锁骨下动脉的分支。常起自颈横动脉，即颈横动脉的深支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_First posterior intercostal,R",
                                                            "c": "第一肋间后动脉First posterior intercostal,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "第一肋间后动脉：发自肋间最上动脉，分布至第一肋间隙的动脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Inferior thyroid,R",
                                                            "c": "甲状腺下动脉Inferior thyroid,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "甲状腺下动脉：为锁骨下动脉的甲状颈干的分支，沿前斜角肌内侧缘上行到第6颈椎水平，再弓形弯向内下，经颈动脉鞘深面至甲状腺侧叶后面，分为数支入甲状腺，供应其下1/3部。该动脉在甲状腺侧叶下极的后方与喉返神经相交叉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Internal thoracic(mammary),R",
                                                            "c": "胸廓内动脉Internal thoracic(mammary),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸廓内动脉：起于锁骨下动脉的下面，椎动脉起点的相对侧，向下入胸腔，沿第1-6肋软骨后面(距胸骨外侧缘约lcm)下降，分支布于胸前壁、心包、膈和乳房等处。 胸廓内动脉行至第6肋间隙发出两终支，其中较大的终支为腹壁上动脉。该动脉为胸廓内动脉的直接延续，穿膈进入腹直肌鞘，在腹直肌的深面下行，到脐附近与腹壁下动脉吻合，分支营养腹直肌和腹膜。 胸廓内动脉的另一终支为肌膈动脉，行于第7-9肋软骨后面，穿膈后终于最下两个肋间隙，分支布于下五个肋间隙前部、腹壁诸肌及膈。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Second posterior intercostal,R",
                                                            "c": "第二肋间后动脉Second posterior intercostal,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "第二肋间后动脉：发自肋间最上动脉，分布至第二肋间隙的动脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Subclavian,R",
                                                            "c": "锁骨下动脉Subclavian,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "锁骨下动脉：左锁骨下动脉起自主动脉弓，右锁骨下动脉起自头臂干，均经胸锁关节的后方斜向外行至颈根部，呈弓状经胸膜顶前方，穿斜角肌间隙，至第1肋外侧缘续为腋动脉。上肢出血时，可于锁骨中点上方的锁骨上窝处向后下压迫，将该动脉压向第一肋骨进行止血。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Superficial cervical(transverse cervical,superficial branch),R",
                                                            "c": "颈横动脉浅支Transverse cervical,superficial branch (superficial cervical),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈横动脉浅支：由颈横动脉发出的一个分支，在斜角肌深面伴副神经下行。此动脉若发自甲状颈干，则称颈浅动脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Superior epigastric,R",
                                                            "c": "腹壁上动脉Superior epigastric,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腹壁上动脉：胸廓内动脉的两个终支之一，沿胸前壁下行至腹前壁进入腹直肌鞘，供应腹直肌。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Suprascapular,R",
                                                            "c": "肩胛上动脉Suprascapular,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肩胛上动脉：又称肩胛横动脉。甲状颈干的分支。越过臂丛和锁骨下动脉的上方行向上外，经肩胛上横韧带上方至冈上窝。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Supreme intercostal(highest),R",
                                                            "c": "肋间最上动脉Supreme intercostal,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肋间最上动脉:发自肋颈干，随即分为两支，分布至第一、二肋间隙的动脉。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Thyrocervical trunk,R",
                                                            "c": "甲状颈干Thyrocervical trunk,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "甲状颈干：为一条短而粗的动脉干，其主要分支有甲状腺下动脉。该动脉向上内横过颈总动脉的后方，分布到甲状腺等。主要分支有：甲状腺下动脉，肩胛上动脉，肋颈干，肩胛背动脉。分支分布：甲状腺，咽和食管，喉和气管以及肩部肌，脊髓及其被摸等处。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Transverse cervical,R",
                                                            "c": "颈横动脉Transverse cervical,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈横动脉：往往与甲状腺下动脉共干或单独发自锁骨下动脉第三段，其行程与肩胛上动脉相似，穿过臂丛向后，布于菱形肌周围。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Vertebral_Basilar artery,R",
                                                            "c": "右椎基底动脉Vertebral_Basilar artery,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "DM_Basilar,R",
                                                                    "c": "右基底动脉Basilar,R"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "DM_Anterior inferior cerebellar,R",
                                                                            "c": "小脑下前动脉Anterior inferior cerebellar,R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "小脑下前动脉：自基底动脉起始段发出，经展神经、面神经和前庭蜗神经的腹侧达小脑下面，供应小脑下面的前部。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "DM_Basilar,right side",
                                                                            "c": "基底动脉Basilar,right side"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "基底动脉：左、右椎动脉合并而成的动脉。位于脑桥腹侧面的基底沟内。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "DM_Pontine,R",
                                                                            "c": "脑桥动脉Pontine,R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "脑桥动脉：为一些细小分支，供应脑桥基底部。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "DM_Posterior cerebral,R",
                                                                            "c": "右大脑后动脉Posterior cerebral,R"
                                                                        },
                                                                        "t": ""
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "DM_Superior cerebellar,R",
                                                                            "c": "小脑上动脉Superior cerebellar,R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "小脑上动脉：基底动脉的分支。起自基底动脉的末端，经小脑幕的下面分布至小脑的上面。"
                                                                        }
                                                                    }]
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "DM_Posterior inferior cerebellar,R",
                                                                    "c": "小脑下后动脉Posterior inferior cerebellar,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "小脑下后动脉：是椎动脉最大的分支，通常平橄榄下端附近发出，向后外行经延髓与小脑扁桃体之间，行程弯曲，供应小脑下面后部和延髓后外侧部。该动脉行程弯曲，易发生栓塞而出现同侧面部浅感觉障碍、对侧躯体浅感觉障碍和小脑共济失调等。该动脉还发出脉络膜支组成第4脑室脉络丛。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "DM_Vertebral,R",
                                                                    "c": "椎动脉Vertebral,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "椎动脉：起于前斜角肌内侧，向上穿第6-l颈椎横突孔，经枕骨大孔入颅腔，分支布于脑与脊髓。"
                                                                }
                                                            }]
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Superficial palmar arch,R",
                                                    "c": "右掌浅弓Superficial palmar arch,R"
                                                },
                                                "t": ""
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Ulnar artery,R",
                                                    "c": "右尺动脉Ulnar artery,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Anterior interosseous,R",
                                                            "c": "骨间前动脉Anterior interosseous,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "骨间前动脉：自骨间总动脉分出后，在拇长屈肌和指深屈肌之间，沿前臂骨间膜前面下行，分支营养尺、桡骨及邻近诸肌，并参与形成腕掌网和腕背网。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Common interosseous,R",
                                                            "c": "骨间总动脉Common interosseous,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "骨间总动脉：在肘窝处起自尺动脉，行于尺肾屈肌与拇长屈肌之间，在前臂骨间膜近侧端又分为骨间前动脉和骨间后动脉，分别沿前臂骨间膜的前、后面下降，沿途分支至前臂肌和尺、桡骨。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Interosseous recurrent,R",
                                                            "c": "骨间返动脉Interosseous recurrent,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "骨间返动脉：由骨间后动脉发出后上行至肘肌深方，过鹰嘴与外上髁之间达肘关节后方，与中副动脉相吻合。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Posterior interosseous,R",
                                                            "c": "骨间后动脉Posterior interosseous,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "骨间后动脉：自骨间总动脉分出后，立即经骨间膜上缘进入前臂后区，在浅、深两层肌之间下行，分支营养邻近诸肌，并发出骨间返动脉向上返行，参与构成肘关节动脉网。骨间返动脉发自骨间后动脉者占55.34%，发自骨间总动脉者占44.66%。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Ulnar recurrent,anterior,R",
                                                            "c": "尺侧返动脉前支Ulnar recurrent,anterior,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "尺侧返动脉前支：尺侧返动脉的分支。行于肘关节前方，参与构成肘关节网。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Ulnar recurrent,posterior,R",
                                                            "c": "尺侧返动脉后支Ulnar recurrent,posterior,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "尺侧返动脉后支：尺侧返动脉的分支。行于肘关节后面，参与形成肘关节网。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Ulnar recurrent,R",
                                                            "c": "尺侧返动脉Ulnar recurrent,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "尺侧返动脉：尺动脉近端向上的分支。随即分为前、后二支，参与形成肘关节网。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Ulnar,R",
                                                            "c": "尺动脉Ulnar,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "尺动脉：在尺侧腕屈肌与指浅屈肌之间下行，经豌豆骨桡侧至手掌。其末端与桡动脉掌浅支吻合形成掌浅弓。尺动脉在行程过程中除发支至前臂尺侧诸肌和参与形成肘关节网外，主要分支有：①骨间总动脉，又分为骨间前动脉和骨间后动脉，分别沿前臂骨间膜的前、后面下降，沿途分支至前臂肌和尺、桡骨。②掌深支，穿小鱼际至掌深部，与桡动脉的末端吻合形成掌深弓。"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "DM_Left common carotid artery",
                                    "c": "左颈总动脉Left common carotid artery"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "DM_Common carotid,L",
                                            "c": "颈总动脉Common carotid,L"
                                        },
                                        "t":
                                        {
                                            "s": "颈总动脉：是头颈部的动脉主干。左颈总动脉起自主动脉弓，右颈总动脉起自头臂干。两侧的颈总动脉均经胸锁关节后方沿食管、气管和喉的外侧上行，至甲状软骨上缘高度，分为颈内动脉和颈外动脉。颈总动脉上段位置表浅，在活体上可摸到其搏动。当头面部大出血时，在胸锁乳突肌前缘，平环状软骨弓的侧方，向后内将动脉压向后内方的第6颈椎横突上，进行急救止血。在颈总动脉分杈处及附近有颈动脉窦和颈动脉小球两个重要结构。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_External carotid artery,L",
                                            "c": "左颈外动脉External carotid artery,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "DM_External carotid,L",
                                                    "c": "颈外动脉External carotid,L"
                                                },
                                                "t":
                                                {
                                                    "s": "颈外动脉：颈总动脉两终支之一。初居颈内动脉的前内侧，后经其前方转至外侧，上行穿腮腺至下颌颈处分为颞浅动脉和上颌动脉两终支。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Facial artery,L",
                                                    "c": "左面动脉Facial artery,L"
                                                },
                                                "t": ""
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Lingual,L",
                                                    "c": "舌动脉Lingual,L"
                                                },
                                                "t":
                                                {
                                                    "s": "舌动脉：平舌骨大角处发自颈外动脉的前方，行向前内方入舌。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Maxillary artery,L",
                                                    "c": "左上颌动脉Maxillary artery,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Accessory meningeal,L",
                                                            "c": "脑膜副支Accessory meningeal,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脑膜副支：上颌动脉第一段供应硬脑膜的细小分支。出现率约为50%，发自上颌动脉第一段的上壁，经卵圆孔入颅分布于硬脑膜。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Anterior deep temporal,L",
                                                            "c": "颞深前动脉Anterior deep temporal,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颞深前动脉：上颌动脉第二段供应颞肌和颅骨前部的分支。发自上颌动脉第二段的上内侧壁，于颞肌与颅骨之间行向上，分布于颞肌和邻近颅骨。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Anterior meningeal,L",
                                                            "c": "脑膜前动脉Anterior meningeal,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脑膜前动脉：为眼动脉的筛前动脉分支，供给硬脑膜前部的血液。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Buccal,L",
                                                            "c": "颊动脉Buccal,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颊动脉：上颌动脉第二段供应颊的分支。发自上颌动脉的下壁，沿颊肌上缘前行，分布于颊肌及邻近表情肌。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Descending palatine,L",
                                                            "c": "腭降动脉Descending palatine,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腭降动脉：上颌动脉第三段供应上腭的分支。在翼腭窝内发自上颌动脉的下壁，进入翼腭管，在管内分为腭大动脉和腭小动脉，分别经腭大孔和腭小孔穿出，分布至上腭。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Greater palatine,L",
                                                            "c": "腭大动脉Greater palatine,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腭大动脉：腭降动脉供应硬腭部的分支。在翼腭管内发自腭降动脉，下行经腭大孔穿出，转向前分布至硬腭前部的黏膜及牙龈。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Inferior alveolar,L",
                                                            "c": "下牙槽动脉Inferior alveolar,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "下牙槽动脉：上颌动脉第一段供应下颌牙齿及齿龈的分支。发自上颌动脉第一段的下壁，与下牙槽神经伴行，经下颌孔进入下颌骨内，分布至下颌牙齿和齿龈。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Infraorbital,L",
                                                            "c": "眶下动脉Infraorbital,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "眶下动脉：上颌动脉的直接延续，经眶下裂、眶下沟和眶下管，与眶下神经伴行入眶，末梢经眶下孔至面部。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Lateral pterygoid,L",
                                                            "c": "翼外肌支Lateral pterygoid,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "翼外肌支：上颌动脉第二段供应翼外肌的分支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Lesser palatine,L",
                                                            "c": "腭小动脉Lesser palatine,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腭小动脉：腭降动脉供应软腭的分支。在翼腭管内发自腭降动脉，下行经腭小孔穿出，转向后分布至软腭及扁桃体。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Masseteric,L",
                                                            "c": "咬肌动脉Masseteric,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "咬肌动脉：上颌动脉第二段供应咬肌的分支。发自上颌动脉第二段的上壁，经下颌切迹向外分布至咬肌。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Maxillary,L",
                                                            "c": "上颌动脉Maxillary,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "上颌动脉：经下颌颈深面入颞下窝，在翼内、外肌之间行向前内至翼腭窝，沿途分支至外耳道、鼓室、牙及牙龈、鼻腔、腭、咀嚼肌、硬脑膜等处。其中分布于硬脑膜者称脑膜中动脉，在下颌颈深面发出，向上穿棘孔进入颅腔，分为前、后两支，紧贴颅骨内面走行，分布于颅骨和硬脑膜。前支行经颅骨翼点内面，当颞部骨折时易受损伤，可引起硬膜外血肿。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Medial pterygoid,L",
                                                            "c": "翼内肌支Medial pterygoid,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "翼内肌支：上颌动脉第二段供应翼内肌的分支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Mental,L",
                                                            "c": "颏动脉Mental,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颏动脉：下牙槽动脉经颏孔穿出的分支。分布至颏孔邻近组织。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Middle meningeal,L",
                                                            "c": "脑膜中动脉Middle meningeal,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脑膜中动脉：上颌动脉第一段供应硬脑膜的主要分支。发自上颌动脉第一段的上壁，上行经棘孔入颅，分布至硬脑膜。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Mylohyoid,L",
                                                            "c": "下颌舌骨肌支Mylohyoid,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "下颌舌骨肌支：下牙槽动脉供应下颌舌骨肌的分支。在下牙槽动脉进入下颌孔之前发出，分布至下颌舌骨肌。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Pharyngeal,L",
                                                            "c": "咽动脉Pharyngeal,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "咽动脉：上颌动脉第三段供应上腭的分支。在翼腭窝内发自上颌动脉的下壁，进入翼腭管，在管内分为腭大动脉和腭小动脉，分别经腭大孔和腭小孔穿出，分布至上腭。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Posterior deep temporal,L",
                                                            "c": "颞深后动脉Posterior deep temporal,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颞深后动脉：上颌动脉第二段供应颞肌和颅骨后部的分支。发自上颌动脉第二段的上内侧壁，于颞肌与颅骨之间行向后上，分布于颞肌和颅骨。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Posterior lateral nasal branches,L",
                                                            "c": "鼻后外侧动脉Posterior lateral nasal branches,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "鼻后外侧动脉：蝶腭动脉供应鼻外侧壁的分支。在蝶腭动脉穿出蝶腭孔后发出，一般为3支，沿鼻腔侧壁前行，分布于鼻腔外侧壁的鼻甲与鼻道。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Posterior meningeal,L",
                                                            "c": "脑膜后动脉Posterior meningeal,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脑膜后动脉：咽升动脉的终末分支。通过颈静脉孔到达颅后窝。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Sphenopalatine,L",
                                                            "c": "蝶腭动脉Sphenopalatine,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "蝶腭动脉：供应鼻腔内结构的上颌动脉终末分支。在翼腭窝内发自上颌动脉第三段的上壁，前行经蝶腭孔即翼腭孔入鼻腔，分数支分布至鼻甲，鼻道，鼻旁窦及鼻中隔。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Posterior superior alveolar artery,L",
                                                            "c": "上牙槽后动脉Posterior superior alveolar artery,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "上牙槽后动脉：上颌动脉第三段供应上颌牙的分支。发自上颌动脉的下壁，常为2-3支，经上颌骨后面进入上颌骨，分布至上颌牙和牙龈。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Artery of pterygoid canal,L",
                                                            "c": "翼管动脉Artery of pterygoid canal,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "翼管动脉：上颌动脉第三段的分支。经翼管至咽腔上部，供应咽腔上部结构及咽鼓管等。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Occipital,L",
                                                    "c": "枕动脉Occipital,L"
                                                },
                                                "t":
                                                {
                                                    "s": "枕动脉：与面动脉的起点相对，在乳突根部的内侧向后行至枕部。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Posterior auricular,L",
                                                    "c": "耳后动脉Posterior auricular,L"
                                                },
                                                "t":
                                                {
                                                    "s": "耳后动脉起自颈外动脉后壁，发出部位大都低于或平乳突尖。该支动脉的分支有耳后支和枕支。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Superficial temporal artery,L",
                                                    "c": "左颞浅动脉Superficial temporal artery,L"
                                                },
                                                "t": ""
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Superior thyroid,L",
                                                    "c": "甲状腺上动脉Superior thyroid,L"
                                                },
                                                "t":
                                                {
                                                    "s": "甲状腺上动脉：颈外动脉的第一分支。起自颈外动脉的起始处，行向前下方，分布到甲状腺上部和喉。"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_Internal carotid artery,L1",
                                            "c": "左颈内动脉Internal carotid artery,L"
                                        },
                                        "t": ""
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "DM_Left subclavian artery",
                                    "c": "左锁骨下动脉Left subclavian artery"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "DM_Axillary artery,L",
                                            "c": "左腋动脉Axillary artery,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Axillary,L",
                                                    "c": "腋动脉Axillary,L"
                                                },
                                                "t":
                                                {
                                                    "s": "腋动脉：锁骨下动脉的延续。从第一肋的外侧缘至大圆肌的下缘，以胸小肌为界分为3段。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Circumflex humeral,anterior,L",
                                                    "c": "旋肱前动脉Circumflex humeral,anterior,L"
                                                },
                                                "t":
                                                {
                                                    "s": "旋肱前动脉：腋动脉第三段的分支。绕肱骨外科颈前面分布至邻近肌、骨膜和肩关节囊。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Circumflex humeral,posterior,L",
                                                    "c": "旋肱后动脉Circumflex humeral,posterior,L"
                                                },
                                                "t":
                                                {
                                                    "s": "旋肱后动脉：腋动脉第三段的分支。伴腋神经穿四边孔，绕肱骨外科颈至三角肌和肩关节等处，并与旋肱前动脉吻合。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Circumflex scapular,L",
                                                    "c": "旋肩胛动脉Circumflex scapular,L"
                                                },
                                                "t":
                                                {
                                                    "s": "旋肩胛动脉：肩胛下动脉的终支之一。穿三边孔至肩背部，分布至邻近肌肉。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Lateral thoracic,L",
                                                    "c": "胸外侧动脉Lateral thoracic,L"
                                                },
                                                "t":
                                                {
                                                    "s": "胸外侧动脉：约69%起自于腋动脉第二段，较少起于第三段，有的与腋动脉的其他分支共干。该动脉发出后在胸小肌后面下行，分柘于前锯肌和胸大、小肌，在女性有分支至乳房。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Subscapular,L",
                                                    "c": "肩胛下动脉Subscapular,L"
                                                },
                                                "t":
                                                {
                                                    "s": "肩胛下动脉：腋动脉第三段的分支。沿腋窝后壁下行，分为两个终支。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Superior thoracic,L",
                                                    "c": "胸上动脉Superior thoracic,L"
                                                },
                                                "t":
                                                {
                                                    "s": "胸上动脉：锁骨下动脉第一段的分支。较小，分布至胸前壁上部结构。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Thoracoacromial trunk,L",
                                                    "c": "胸肩峰动脉Thoracoacromial trunk,L"
                                                },
                                                "t":
                                                {
                                                    "s": "胸肩峰动脉：为一短干，约65%起自腋动脉第一段，35%起自第二段。该动脉发出后穿锁胸筋膜，分为肩峰支、三角肌支、胸肌支和锁骨支，并分布于同名区域。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Thoracoacromial,acromial branch,L",
                                                    "c": "胸肩峰动脉肩峰支Thoracoacromial,acromial branch,L"
                                                },
                                                "t":
                                                {
                                                    "s": "胸肩峰动脉肩峰支：胸肩峰动脉的分支之一。行向肩峰，参与肩峰网的形成。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Thoracoacromial,deltoid branch,L",
                                                    "c": "胸肩峰动脉三角肌支Thoracoacromial,deltoid branch,L"
                                                },
                                                "t":
                                                {
                                                    "s": "胸肩峰动脉三角肌支：胸肩峰动脉供应三角肌的分支。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Thoracoacromial,pectoral branch,L",
                                                    "c": "胸肩峰动脉胸肌支Thoracoacromial,pectoral branch,L"
                                                },
                                                "t":
                                                {
                                                    "s": "胸肩峰动脉胸肌支：行于胸大、小肌间并分支营养此2肌。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Thoracodorsal,L",
                                                    "c": "胸背动脉Thoracodorsal,L"
                                                },
                                                "t":
                                                {
                                                    "s": "胸背动脉：肩胛下动脉的终支之一。穿三边孔至肩背部，分布至邻近肌肉。"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_Brachial artery,L",
                                            "c": "左肱动脉Brachial artery,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Brachial,L",
                                                    "c": "肱动脉Brachial,L"
                                                },
                                                "t":
                                                {
                                                    "s": "肱动脉：与正中神经伴行沿肱二头肌的内侧至肘窝，在平桡骨颈高度分为桡动脉和尺动脉。肱动脉位置表浅，可在肱二头肌内侧沟处触知其搏动。当前臂和手部出血时，可在臂中部用指压法将该动脉压向肱骨以达到暂时止血的目的。如果使用止血带进行止血，应避开臂部中1/3部，以免因长时间压迫位于桡神经沟内的桡神经造成该神经的损伤。\r\n                                                            肱动脉最重要的分支是肱深动脉。肱深动脉斜向后外方走行，伴桡神经沿桡神经沟下行，分支营养肱三头肌和肱骨，其终支参与肘关节网的组成。肱动脉还发出尺侧上副动脉、尺侧下副动脉、肱骨滋养动脉和肌支，营养臂肌和肱骨。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Inferior ulnar collateral,L",
                                                    "c": "尺侧下副动脉Inferior ulnar collateral,L"
                                                },
                                                "t":
                                                {
                                                    "s": "尺侧下副动脉：肱动脉的分支。在肱骨内上髁稍上方发自肱动脉，参与形成肘关节网。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Middle collateral,L",
                                                    "c": "中副动脉Middle collateral,L"
                                                },
                                                "t":
                                                {
                                                    "s": "中副动脉：为肱深动脉的一条终支，在肱骨肌管内下行至肘关节，与骨间返动脉吻合，参与肘关节动脉网的组成。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Profunda brachii,L",
                                                    "c": "肱深动脉Profunda brachii,L"
                                                },
                                                "t":
                                                {
                                                    "s": "肱深动脉：在大圆肌腱稍下方，起自肱动脉后内侧壁，与桡神经伴行，行向下外入肱骨肌管，分支营养肱三头肌和肱肌。在肱骨肌管分为前、后两支，前支称桡侧副动脉，与桡神经伴行穿外侧肌间隔；后支称中副动脉，在臂后区下行。二者均参与肘关节动脉网的组成。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Radial collateral,L",
                                                    "c": "桡侧副动脉Radial collateral,L"
                                                },
                                                "t":
                                                {
                                                    "s": "桡侧副动脉：肱深动脉末梢支。在臂外侧肌间隔的后方下行，参与肘关节网的形成。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Superior ulnar collateral,L",
                                                    "c": "尺侧上副动脉Superior ulnar collateral,L"
                                                },
                                                "t":
                                                {
                                                    "s": "尺侧上副动脉：肱动脉的分支。在肱骨内上髁稍上方发自肱动脉，参与形成肘关节网。"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_Deep palmar arch,L",
                                            "c": "左掌深弓Deep palmar arch,L"
                                        },
                                        "t": ""
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_Dorsal carpal rete,L",
                                            "c": "左腕背网Dorsal carpal rete,L"
                                        },
                                        "t": ""
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_Radial artery,L",
                                            "c": "左桡动脉Radial artery,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Princeps pollicis,L",
                                                    "c": "拇主要动脉Princeps pollicis,L"
                                                },
                                                "t":
                                                {
                                                    "s": "拇主要动脉分为3支，分布于拇指掌面两侧缘和示指桡侧缘。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Radial artery of indexcis,L",
                                                    "c": "示指桡侧动脉Radial artery of indexcis,L"
                                                },
                                                "t":
                                                {
                                                    "s": "示指桡侧动脉：拇主要动脉分布至第二指掌侧外侧缘的分支。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Radial recurrent,L",
                                                    "c": "桡侧返动脉Radial recurrent,L"
                                                },
                                                "t":
                                                {
                                                    "s": "桡侧返动脉：桡动脉近侧段的分支。经肱桡肌与肱肌间上行，参与形成肘关节网。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Radial,L",
                                                    "c": "桡动脉Radial,L"
                                                },
                                                "t":
                                                {
                                                    "s": "桡动脉：肱动脉的两个终支之一。先经肱桡肌和旋前圆肌之间，继而在肱桡肌腱与桡侧腕屈肌腱之间下行，绕桡骨茎突至手背，穿第1掌骨间隙至手掌，其末端与尺动脉掌深支吻合形成掌深弓。桡动脉的下段仅被皮肤和筋膜覆盖，是临床触摸脉搏的常用部位，可在桡骨茎突的内上方触摸其脉搏。桡动脉的主要分支包括：①掌浅支，与尺动脉末端吻合形成掌浅弓。②拇主要动脉，分为三支分布于拇指掌侧面的两侧缘以及示指桡侧缘。"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_Subclavian artery,L",
                                            "c": "左锁骨下动脉Subclavian artery,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Ascending cervical,L",
                                                    "c": "颈升动脉Ascending cervical,L"
                                                },
                                                "t":
                                                {
                                                    "s": "颈升动脉：甲状腺下动脉的分支。在颈深部肌内上行，分布至颈深肌、脊髓和颈椎体等。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Costocervical trunk,L",
                                                    "c": "肋颈干Costocervical trunk,L"
                                                },
                                                "t":
                                                {
                                                    "s": "肋颈干：起自锁骨下动脉第1或第2段，经胸膜顶上方弓形向后至第1肋颈处分为颈深动脉和最上肋间动脉。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Deep cervical,L",
                                                    "c": "颈深动脉Deep cervical,L"
                                                },
                                                "t":
                                                {
                                                    "s": "颈深动脉：由肋颈干发出的动脉，上行至颈背部，行向头半棘肌，供应邻近肌肉。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Dorsal scapular(transverse scapular,deep branch),L",
                                                    "c": "肩胛背动脉（颈横动脉深支）Dorsal scapular (transverse scapular,deep branch),L"
                                                },
                                                "t":
                                                {
                                                    "s": "肩胛背动脉（颈横动脉深支）：锁骨下动脉的分支。常起自颈横动脉，即颈横动脉的深支。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_First posterior intercostal,L",
                                                    "c": "第一肋间后动脉First posterior intercostal,L"
                                                },
                                                "t":
                                                {
                                                    "s": "第一肋间后动脉：发自肋间最上动脉，分布至第一肋间隙的动脉。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Inferior thyroid,L",
                                                    "c": "甲状腺下动脉Inferior thyroid,L"
                                                },
                                                "t":
                                                {
                                                    "s": "甲状腺下动脉：为锁骨下动脉的甲状颈干的分支，沿前斜角肌内侧缘上行到第6颈椎水平，再弓形弯向内下，经颈动脉鞘深面至甲状腺侧叶后面，分为数支入甲状腺，供应其下1/3部。该动脉在甲状腺侧叶下极的后方与喉返神经相交叉。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Internal thoracic(mammary),L",
                                                    "c": "胸廓内动脉Internal thoracic (mammary),L"
                                                },
                                                "t":
                                                {
                                                    "s": "胸廓内动脉：起于锁骨下动脉的下面，椎动脉起点的相对侧，向下入胸腔，沿第1-6肋软骨后面(距胸骨外侧缘约lcm)下降，分支布于胸前壁、心包、膈和乳房等处。 胸廓内动脉行至第6肋间隙发出两终支，其中较大的终支为腹壁上动脉。该动脉为胸廓内动脉的直接延续，穿膈进入腹直肌鞘，在腹直肌的深面下行，到脐附近与腹壁下动脉吻合，分支营养腹直肌和腹膜。 胸廓内动脉的另一终支为肌膈动脉，行于第7-9肋软骨后面，穿膈后终于最下两个肋间隙，分支布于下五个肋间隙前部、腹壁诸肌及膈。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Second posterior intercostal,L",
                                                    "c": "第二肋间后动脉Second posterior intercostal,L"
                                                },
                                                "t":
                                                {
                                                    "s": "第二肋间后动脉：发自肋间最上动脉，分布至第二肋间隙的动脉。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Subclavian,L",
                                                    "c": "锁骨下动脉Subclavian,L"
                                                },
                                                "t":
                                                {
                                                    "s": "锁骨下动脉：左锁骨下动脉起自主动脉弓，右锁骨下动脉起自头臂干，均经胸锁关节的后方斜向外行至颈根部，呈弓状经胸膜顶前方，穿斜角肌间隙，至第1肋外侧缘续为腋动脉。上肢出血时，可于锁骨中点上方的锁骨上窝处向后下压迫，将该动脉压向第一肋骨进行止血。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Superficial cervical(transverse cervical,superficial branch),L",
                                                    "c": "颈横动脉浅支Transverse cervical,superficial branch (superficial cervical),L"
                                                },
                                                "t":
                                                {
                                                    "s": "颈横动脉浅支：由颈横动脉发出的一个分支，在斜角肌深面伴副神经下行。此动脉若发自甲状颈干，则称颈浅动脉。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Superior epigastric,L",
                                                    "c": "腹壁上动脉Superior epigastric,L"
                                                },
                                                "t":
                                                {
                                                    "s": "腹壁上动脉：胸廓内动脉的两个终支之一，沿胸前壁下行至腹前壁进入腹直肌鞘，供应腹直肌。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Suprascapular,L",
                                                    "c": "肩胛上动脉Suprascapular,L"
                                                },
                                                "t":
                                                {
                                                    "s": "肩胛上动脉：又称肩胛横动脉。甲状颈干的分支。越过臂丛和锁骨下动脉的上方行向上外，经肩胛上横韧带上方至冈上窝。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Supreme intercostal(highest),L",
                                                    "c": "肋间最上动脉Supreme intercostal,L"
                                                },
                                                "t":
                                                {
                                                    "s": "肋间最上动脉:发自肋颈干，随即分为两支，分布至第一、二肋间隙的动脉。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Thyrocervical trunk,L",
                                                    "c": "甲状颈干Thyrocervical trunk,L"
                                                },
                                                "t":
                                                {
                                                    "s": "甲状颈干：为一条短而粗的动脉干，其主要分支有甲状腺下动脉。该动脉向上内横过颈总动脉的后方，分布到甲状腺等。主要分支有：甲状腺下动脉，肩胛上动脉，肋颈干，肩胛背动脉。分支分布：甲状腺，咽和食管，喉和气管以及肩部肌，脊髓及其被摸等处。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Transverse cervical,L",
                                                    "c": "颈横动脉Transverse cervical,L"
                                                },
                                                "t":
                                                {
                                                    "s": "颈横动脉：往往与甲状腺下动脉共干或单独发自锁骨下动脉第三段，其行程与肩胛上动脉相似，穿过臂丛向后，布于菱形肌周围。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Vertebral_Basilar artery,L",
                                                    "c": "左椎基底动脉Vertebral_Basilar artery,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Basilar,L",
                                                            "c": "左基底动脉Basilar,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "DM_Anterior inferior cerebellar,L",
                                                                    "c": "小脑下前动脉Anterior inferior cerebellar,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "小脑下前动脉：自基底动脉起始段发出，经展神经、面神经和前庭蜗神经的腹侧达小脑下面，供应小脑下面的前部。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "DM_Basilar,left side",
                                                                    "c": "基底动脉Basilar,left side"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "基底动脉：左、右椎动脉合并而成的动脉。位于脑桥腹侧面的基底沟内。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "DM_Pontine,L",
                                                                    "c": "脑桥动脉Pontine,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "脑桥动脉：为一些细小分支，供应脑桥基底部。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "DM_Posterior cerebral,L",
                                                                    "c": "左大脑后动脉Posterior cerebral,L"
                                                                },
                                                                "t": ""
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "DM_Superior cerebellar,L",
                                                                    "c": "小脑上动脉Superior cerebellar,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "小脑上动脉：基底动脉的分支。起自基底动脉的末端，经小脑幕的下面分布至小脑的上面。"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Posterior inferior cerebellar,L",
                                                            "c": "小脑下后动脉Posterior inferior cerebellar,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "小脑下后动脉：是椎动脉最大的分支，通常平橄榄下端附近发出，向后外行经延髓与小脑扁桃体之间，行程弯曲，供应小脑下面后部和延髓后外侧部。该动脉行程弯曲，易发生栓塞而出现同侧面部浅感觉障碍、对侧躯体浅感觉障碍和小脑共济失调等。该动脉还发出脉络膜支组成第4脑室脉络丛。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Vertebral,L",
                                                            "c": "椎动脉Vertebral,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "椎动脉：起于前斜角肌内侧，向上穿第6-l颈椎横突孔，经枕骨大孔入颅腔，分支布于脑与脊髓。"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_Superficial palmar arch,L",
                                            "c": "左掌浅弓Superficial palmar arch,L"
                                        },
                                        "t": ""
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_Ulnar artery,L",
                                            "c": "左尺动脉Ulnar artery,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Anterior interosseous,L",
                                                    "c": "骨间前动脉Anterior interosseous,L"
                                                },
                                                "t":
                                                {
                                                    "s": "骨间前动脉：自骨间总动脉分出后，在拇长屈肌和指深屈肌之间，沿前臂骨间膜前面下行，分支营养尺、桡骨及邻近诸肌，并参与形成腕掌网和腕背网。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Common interosseous,L",
                                                    "c": "骨间总动脉Common interosseous,L"
                                                },
                                                "t":
                                                {
                                                    "s": "骨间总动脉：在肘窝处起自尺动脉，行于尺肾屈肌与拇长屈肌之间，在前臂骨间膜近侧端又分为骨间前动脉和骨间后动脉，分别沿前臂骨间膜的前、后面下降，沿途分支至前臂肌和尺、桡骨。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Interosseous recurrent,L",
                                                    "c": "骨间返动脉Interosseous recurrent,L"
                                                },
                                                "t":
                                                {
                                                    "s": "骨间返动脉：由骨间后动脉发出后上行至肘肌深方，过鹰嘴与外上髁之间达肘关节后方，与中副动脉相吻合。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Posterior interosseous,L",
                                                    "c": "骨间后动脉Posterior interosseous,L"
                                                },
                                                "t":
                                                {
                                                    "s": "骨间后动脉：自骨间总动脉分出后，立即经骨间膜上缘进入前臂后区，在浅、深两层肌之间下行，分支营养邻近诸肌，并发出骨间返动脉向上返行，参与构成肘关节动脉网。骨间返动脉发自骨间后动脉者占55.34%，发自骨间总动脉者占44.66%。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Ulnar recurrent,anterior,L",
                                                    "c": "尺侧返动脉前支Ulnar recurrent,anterior,L"
                                                },
                                                "t":
                                                {
                                                    "s": "尺侧返动脉前支：尺侧返动脉的分支。行于肘关节前方，参与构成肘关节网。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Ulnar recurrent,L",
                                                    "c": "尺侧返动脉Ulnar recurrent,L"
                                                },
                                                "t":
                                                {
                                                    "s": "尺侧返动脉：尺动脉近端向上的分支。随即分为前、后二支，参与形成肘关节网。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Ulnar recurrent,posterior,L",
                                                    "c": "尺侧返动脉后支Ulnar recurrent,posterior,L"
                                                },
                                                "t":
                                                {
                                                    "s": "尺侧返动脉后支：尺侧返动脉的分支。行于肘关节后面，参与形成肘关节网。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Ulnar,L",
                                                    "c": "尺动脉Ulnar,L"
                                                },
                                                "t":
                                                {
                                                    "s": "尺动脉：在尺侧腕屈肌与指浅屈肌之间下行，经豌豆骨桡侧至手掌。其末端与桡动脉掌浅支吻合形成掌浅弓。尺动脉在行程过程中除发支至前臂尺侧诸肌和参与形成肘关节网外，主要分支有：①骨间总动脉，又分为骨间前动脉和骨间后动脉，分别沿前臂骨间膜的前、后面下降，沿途分支至前臂肌和尺、桡骨。②掌深支，穿小鱼际至掌深部，与桡动脉的末端吻合形成掌深弓。"
                                                }
                                            }]
                                        }
                                    }]
                                }
                            }]
                        }
                    },
                    {
                        "$":
                        {
                            "o": "DM_02Thoracic aorta and branches",
                            "c": "胸主动脉及其分支Thoracic aorta and branches"
                        },
                        "t": ""
                    },
                    {
                        "$":
                        {
                            "o": "DM_03Abdominal aorta",
                            "c": "腹主动脉Abdominal aorta"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "M_DM_Abdominal aorta",
                                    "c": "腹主动脉Abdominal aorta"
                                },
                                "t":
                                {
                                    "s": "腹主动脉：是降主动脉的腹段，又称主动脉腹部，为胸主动脉的延续。在第12胸椎下缘前方，经膈的主动脉裂孔进入腹膜后隙，沿脊柱左前方下行，在第4腰椎下缘高度分为左、右髂总动脉。腹主动脉全长约14-15cm，周径2.9-3.Ocm。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "DM_Parietal branches of abdominal aorta",
                                    "c": "腹主动脉壁支Parietal branches of abdominal aorta"
                                },
                                "t": ""
                            },
                            {
                                "$":
                                {
                                    "o": "DM_Visceral branches of abdominal aorta",
                                    "c": "腹主动脉脏支Visceral branches of abdominal aorta"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "DM_Celiac trunk1",
                                            "c": "腹腔干Celiac trunk"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Celiac trunk",
                                                    "c": "腹腔干Celiac trunk"
                                                },
                                                "t":
                                                {
                                                    "s": "腹腔干：为一粗短动脉干，在膈的主动脉裂孔稍下方起自腹主动脉前壁，向前达胰上缘，分为3条较大的分支：胃左动脉，脾动脉，肝总动脉。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Common hepatic artery",
                                                    "c": "肝总动脉Common hepatic artery"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Common hepatic",
                                                            "c": "肝总动脉Common hepatic"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肝总动脉：向右行至肝十二指肠上部的上缘后进入肝十二指肠韧带，分为以下两支：①肝固有动脉，行于十二指肠韧带内，随后发出胃右动脉，沿胃小弯向左行，与胃左动脉吻合，沿途分支分布于胃小弯侧的胃壁。本干入肝门前发出肝左支和肝右支，分布于肝。肝右支发出胆囊动脉分布于胆囊。 ②胃十二指肠动脉，经十二指肠上部，幽门的后方至胃的下缘分为胃网膜右动脉和胰十二指肠上动脉。前者沿胃大弯向左行，分布于胃大弯右侧的胃壁和大网膜，终末支与胃网膜左动脉相吻合；后者分前、后两支分布于胰头和十二指肠。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Gastrodudenal artery",
                                                            "c": "胃十二指肠动脉Gastroduodenal artery"
                                                        },
                                                        "t": ""
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "DM_Proper hepatic artery",
                                                            "c": "肝固有动脉Proper hepatic artery"
                                                        },
                                                        "t": ""
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Left gastric",
                                                    "c": "胃左动脉Left gastric"
                                                },
                                                "t":
                                                {
                                                    "s": "胃左动脉：起于腹腔干，向左上方经胃胰襞深面至贲门附近，转向前下，在肝胃韧带内循胃小弯右侧下行，终支多与胃右动脉吻合。胃左动脉在贲门处分出食管支营养食管；行径胃小弯时发5-6支至胃前、后壁。胃大部切除术常在第1、2胃壁分支间切断胃小弯。偶尔肝固有动脉左支或副肝左动脉起于胃左动脉，故胃切除手术时切忌盲目结扎。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "DM_Splenic artery",
                                                    "c": "脾动脉Splenic artery"
                                                },
                                                "t": ""
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_Inferior mesenteric artery",
                                            "c": "肠系膜下动脉Inferior mesenteric artery"
                                        },
                                        "t": ""
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_DM_Testicular,internal spermatic,L",
                                            "c": "睾丸动脉Testicular,internal spermatic,L"
                                        },
                                        "t":
                                        {
                                            "s": "睾丸动脉：腹主动脉供应睾丸和附睾的成对动脉分支。在肾动脉的稍下方发自腹主动脉的前外侧壁，沿腹后壁下行，经腹股沟管进入阴囊，分布至睾丸和附睾等结构。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_DM_Testicular,internal spermatic,R",
                                            "c": "睾丸动脉Testicular,internal spermatic,R"
                                        },
                                        "t":
                                        {
                                            "s": "睾丸动脉：腹主动脉供应睾丸和附睾的成对动脉分支。在肾动脉的稍下方发自腹主动脉的前外侧壁，沿腹后壁下行，经腹股沟管进入阴囊，分布至睾丸和附睾等结构。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_Middle suprarenal,L",
                                            "c": "肾上腺中动脉Middle suprarenal,L"
                                        },
                                        "t":
                                        {
                                            "s": "肾上腺中动脉：腹主动脉供应肾上腺的成对分支。分布至肾上腺中部。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_Middle suprarenal,R",
                                            "c": "肾上腺中动脉Middle suprarenal,R"
                                        },
                                        "t":
                                        {
                                            "s": "肾上腺中动脉：腹主动脉供应肾上腺的成对分支。分布至肾上腺中部。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_Renal artery,L",
                                            "c": "左肾动脉Renal artery,L"
                                        },
                                        "t": ""
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_Renal artery,R",
                                            "c": "右肾动脉Renal artery,R"
                                        },
                                        "t": ""
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_Superior mesenteric artery",
                                            "c": "肠系膜上动脉Superior mesenteric artery"
                                        },
                                        "t": ""
                                    }]
                                }
                            }]
                        }
                    },
                    {
                        "$":
                        {
                            "o": "DM_04Common iliac artery,L",
                            "c": "左髂总动脉Common iliac artery,L"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "DM_External iliac artery,L",
                                    "c": "左髂外动脉External iliac artery,L"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "DM_Anterior tibial artery,L",
                                            "c": "左胫前动脉Anterior tibial artery,L"
                                        },
                                        "t": ""
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_External iliac,L",
                                            "c": "左髂外动脉External iliac,L"
                                        },
                                        "t": ""
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_Femoral artery,L",
                                            "c": "左股动脉Femoral artery,L"
                                        },
                                        "t": ""
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_Popliteal artery,L",
                                            "c": "左腘动脉Popliteal artery,L"
                                        },
                                        "t": ""
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_Posterior tibial artery,L",
                                            "c": "左胫后动脉Posterior tibial artery,L"
                                        },
                                        "t": ""
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "DM_Internal iliac artery,L",
                                    "c": "左髂内动脉Internal iliac artery,L"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "DM_Internal iliac,anterior trunk,L",
                                            "c": "左髂内动脉前干Internal iliac,anterior trunk,L"
                                        },
                                        "t": ""
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_Internal iliac,posterior trunk,L",
                                            "c": "左髂内动脉后干Internal iliac,posterior trunk,L"
                                        },
                                        "t": ""
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_DM_Internal iliac,L",
                                            "c": "髂内动脉Internal iliac,L"
                                        },
                                        "t":
                                        {
                                            "s": "髂内动脉：为一短干，长约4cm，于骶骼关节前方由髂总动脉分出后，斜向内下进入盆腔。其前外侧有输尿管越过，后方邻近腰骶干，髂内静脉和闭孔神经行于其内侧。主干行至坐骨大孔上缘处，一般分为前、后两干，前干分支多至脏器，后干分支多至盆壁。髂内动脉按其分布，又可分为壁支与脏支。"
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_DM_Common iliac,L",
                                    "c": "髂总动脉Common iliac,L"
                                },
                                "t":
                                {
                                    "s": "髂总动脉:由腹主动脉分出后，沿腰大肌内侧下行至骶髂关节处分为髂内动脉和髂外动脉。"
                                }
                            }]
                        }
                    },
                    {
                        "$":
                        {
                            "o": "DM_05Common iliac artery,R",
                            "c": "右髂总动脉Common iliac artery,R"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "DM_External iliac artery,R",
                                    "c": "右髂外动脉External iliac artery,R"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "DM_Anterior tibial artery,R",
                                            "c": "右胫前动脉Anterior tibial artery,R"
                                        },
                                        "t": ""
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_External iliac,R",
                                            "c": "右髂外动脉External iliac,R"
                                        },
                                        "t": ""
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_Femoral artery,R",
                                            "c": "右股动脉Femoral artery,R"
                                        },
                                        "t": ""
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_Popliteal artery,R",
                                            "c": "右腘动脉Popliteal artery,R"
                                        },
                                        "t": ""
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_Posterior tibial artery,R",
                                            "c": "右胫后动脉Posterior tibial artery,R"
                                        },
                                        "t": ""
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "DM_Internal iliac artery,R",
                                    "c": "右髂内动脉Internal iliac artery,R"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "DM_Internal iliac,anterior trunk,R",
                                            "c": "右髂内动脉前干Internal iliac,anterior trunk,R"
                                        },
                                        "t": ""
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "DM_Internal iliac,posterior trunk,R",
                                            "c": "右髂内动脉后干Internal iliac,posterior trunk,R"
                                        },
                                        "t": ""
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_DM_Internal iliac,R",
                                            "c": "髂内动脉Internal iliac,R"
                                        },
                                        "t":
                                        {
                                            "s": "髂内动脉：为一短干，长约4cm，于骶骼关节前方由髂总动脉分出后，斜向内下进入盆腔。其前外侧有输尿管越过，后方邻近腰骶干，髂内静脉和闭孔神经行于其内侧。主干行至坐骨大孔上缘处，一般分为前、后两干，前干分支多至脏器，后干分支多至盆壁。髂内动脉按其分布，又可分为壁支与脏支。"
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_DM_Common iliac,R",
                                    "c": "髂总动脉Common iliac,R"
                                },
                                "t":
                                {
                                    "s": "髂总动脉:由腹主动脉分出后，沿腰大肌内侧下行至骶髂关节处分为髂内动脉和髂外动脉。"
                                }
                            }]
                        }
                    }]
                }
            },
            {
                "$":
                {
                    "o": "008Heart system",
                    "c": "心脏Heart"
                },
                "ch":
                {
                    "sub": [
                    {
                        "$":
                        {
                            "o": "01Heart",
                            "c": "心脏Heart"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "01Shape of heart",
                                    "c": "心的外形Shape of heart"
                                },
                                "ch":
                                {
                                    "sub":
                                    {
                                        "$":
                                        {
                                            "o": "Heart",
                                            "c": "心脏Heart"
                                        },
                                        "t": ""
                                    }
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "04Coronary vessels",
                                    "c": "心的血管Coronary vessels"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Arteries",
                                            "c": "心动脉Arteries"
                                        },
                                        "t": ""
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Veins",
                                            "c": "心静脉Veins"
                                        },
                                        "t": ""
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "05Pericardium",
                                    "c": "心包Pericardium"
                                },
                                "t":
                                {
                                    "s": "心包：包裹心和出入心的大血管根部的圆锥形纤维浆膜囊。分内、外两层，外层为纤维心包，内层为浆膜心包。"
                                }
                            }]
                        }
                    },
                    {
                        "$":
                        {
                            "o": "02Pulmonary circulation arteries",
                            "c": "肺循环动脉Pulmonary circulation arteries"
                        },
                        "ch":
                        {
                            "sub":
                            {
                                "$":
                                {
                                    "o": "Pulmonary arteries",
                                    "c": "肺动脉Pulmonary arteries"
                                },
                                "t":
                                {
                                    "s": "左肺动脉：进入左肺的肺动脉。较短，水平向左，经食管、胸主动脉前方至左肺门分两支进入左肺上、下叶。"
                                }
                            }
                        }
                    },
                    {
                        "$":
                        {
                            "o": "03Pulmonary circulation veins",
                            "c": "肺循环静脉Pulmonary circulation veins"
                        },
                        "ch":
                        {
                            "sub":
                            {
                                "$":
                                {
                                    "o": "Pulmonary veins",
                                    "c": "肺静脉Pulmonary veins"
                                },
                                "t": ""
                            }
                        }
                    }]
                }
            },
            {
                "$":
                {
                    "o": "009010Nervous system",
                    "c": "神经系统Nervous system"
                },
                "ch":
                {
                    "sub": [
                    {
                        "$":
                        {
                            "o": "009Central",
                            "c": "中枢神经Central"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "01Spinal cord",
                                    "c": "脊髓Spinal cord"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Conus medullaris",
                                            "c": "脊髓圆锥Conus medullaris"
                                        },
                                        "t":
                                        {
                                            "s": "脊髓圆锥：腰骶膨大以下脊髓末端变细的部分。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Cauda equina",
                                            "c": "马尾Cauda equina"
                                        },
                                        "t":
                                        {
                                            "s": "马尾：腰骶神经根丝在出椎间孔前，在椎管内下行于终丝周围，整体形似马尾，故名。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Filum terminale",
                                            "c": "终丝Filum terminale"
                                        },
                                        "t":
                                        {
                                            "s": "终丝：软脊膜自脊髓末端至第一尾椎的背面形成的丝状结构。对脊髓起固定作用。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Spinal cord",
                                            "c": "脊髓Spinal cord"
                                        },
                                        "t":
                                        {
                                            "s": "脊髓位于椎管内，上端平枕骨大孔处与延髓相连，下端在成人平第1腰椎体下缘（新生儿可达第3腰椎下缘平面），全长约42-45cm，最宽处横径为1-1.2cm。脊髓呈前、后稍扁的圆柱形，全长粗细不等，有两个梭形的膨大，即颈膨大和腰骶膨大。前者自第4颈节至第1胸节，后者自第2腰节至第3骶节。这两个膨大的形成是因为内部的神经元数量相对较多，与四肢的出现有关。脊髓末端变细，称为脊髓圆锥，自此处向下延为细长的无神经组织的终丝，长约20cm,向上与软脊膜相连，向下在第2骶椎水平以下由硬脊膜包裹，止于尾骨的背面。\r\n                                            脊髓表面可见6条纵行浅沟，前面正中较明显的沟称前正中裂，后面正中较浅的沟为后正中沟，由此沟向脊髓内部入一薄层神经胶质性的后正中隔，深达中央管。这两条纵沟将脊髓分为左右对称的两半。此外还有两对外侧沟，即前外侧沟和后外侧沟，分别有脊神经前根、后根的根丝附着。在颈髓和胸髓上部，后正中沟和后外侧沟之间，还有一条较浅的后中间沟，是薄束和楔束之间的分界标志。\r\n                                            脊髓由灰质和白质两大部分组成。在脊髓的横切面上，可见中央有一细小的中央管，围绕中央管周围是\"H”形的灰质，灰质的外周是白质。每侧的灰质，前部扩大为前角或前柱；后部狭细为后角或后柱，它由后向前又可分为头、颈和基底三部分；在胸髓和上部腰髓(L1-L3)，前、后角之间有向外伸出的侧角或侧柱；前、后角之间的区域为中间带。"
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "02Brain",
                                    "c": "脑Brain"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "01Brainstem",
                                            "c": "脑干Brainstem"
                                        },
                                        "ch":
                                        {
                                            "sub":
                                            {
                                                "$":
                                                {
                                                    "o": "Medulla oblongata",
                                                    "c": "延髓Medulla oblongata"
                                                },
                                                "ch":
                                                {
                                                    "sub":
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Medulla oblongata",
                                                            "c": "延髓Medulla oblongata"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "延髓：腹侧面形似倒置的圆锥体，下端乎枕骨大孔处与脊髓相续，上端借横行的延髓脑桥沟与脑桥为界。延髓下部的外形与脊髓相似，脊髓表面的各条纵行沟、裂向上延续到延髓。延髓腹侧面正中有前正中裂，其两侧的纵行隆起为锥体，由大脑皮质发出的锥体束（主要为皮质脊髓束）纤维构成。在锥体的下端，大部分皮质脊髓柬纤维左右交叉，形成发辫状的锥体交叉，部分填堵了前正中裂。在延髓上部，锥体背外侧的卵圆形隆起称橄榄，内含下橄榄核。锥体和橄榄之间的纵沟称前外侧沟，舌下神经根丝由此出脑。在橄榄背外侧的后外侧沟内，自上而下依次有舌咽神经、迷走神经和副神经的根丝连脑。\r\n                                                            背侧面的上部构成菱形窝的下半；下部形似脊髓，在后正中沟的两侧各有两个膨大，内侧者为薄束结节，外上者为楔束结节，两者与脊髓的薄束、楔束相延续，其深面分别隐含薄束核和楔束核，它们是薄束、楔束的终止核。楔束结节外上方的隆起为小脑下脚(又称绳状体)，其纤维向后连于小脑。"
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "03Diencephalon",
                                            "c": "间脑Diencephalon"
                                        },
                                        "ch":
                                        {
                                            "sub":
                                            {
                                                "$":
                                                {
                                                    "o": "Diencephalon",
                                                    "c": "间脑Diencephalon,L"
                                                },
                                                "ch":
                                                {
                                                    "sub":
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Pituitary gland",
                                                            "c": "垂体Pituitary gland"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Infundibulum",
                                                                    "c": "漏斗Infundibulum"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "漏斗：位于下丘脑视交叉和乳头体之间，灰结节向脑垂体延伸的漏斗状结构。其下端与垂体相接。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Neurohypophysis (posterior pituitary)",
                                                                    "c": "神经垂体Neurohypophysis"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "神经垂体位于脑垂体后部，它主要由下丘脑束的无髓神经纤维由神经胶质分化而成的神经垂体细胞所组成。这些神经纤维由下丘脑的视上核与室旁核发出，经过漏斗进入神经垂体。神经垂体没有腺细胞，但含有丰富的毛细血管，来自下丘脑的神经纤维末梢终止在毛细血管壁上。\r\n                                                                    经研究证明由神经垂体释放的催产素和升压素是在下丘脑合成的，下丘脑的视上核与室旁核均能产生催产素与升压素，但视上核以合成升压素为主，而室旁核以催产素为主。这两种激素都是在下丘脑先合成激素原，并与同时合成的神经垂体激素的运载蛋白形成复合物。这种激素运载蛋白复合物被包在小颗粒状的囊泡里，沿下丘脑-垂体束的无髓神经纤维的轴浆移动到神经末梢，贮存在神经垂体。在受到适宜刺激时由神经垂体释放出来透过毛细血管进入血液中。因此可以把下丘脑的视上核、室旁核和神经垂体一起看作是一个完整的分泌单位。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Pars distalis",
                                                                    "c": "远侧部Pars distalis"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "垂体：位于丘脑下部的腹侧，为一卵圆形小体。是身体内最复杂的内分泌腺，所产生的激素不但与身体骨骼和软组织的生长有关，且可影响内分泌腺的活动。垂体可分为腺垂体和神经垂体两大部分。神经垂体由神经部和漏斗部组成。垂体借漏斗连于下丘脑，呈椭圆形，位于颅中窝、蝶骨体上面的垂体窝内，外包坚韧的硬脑膜。位于前方的腺垂体来自胚胎口凹顶的上皮囊（Rathke囊），腺垂体包括远侧部、结节部和中间部；位于后方的神经垂体较小，由第三脑室底向下突出形成。成人垂体大小约为1*1.5*0.5厘米，重约0.5-0.6克，妇女妊娠期可稍大。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Pars intermedialis",
                                                                    "c": "中间部Pars intermedialis"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "垂体：位于丘脑下部的腹侧，为一卵圆形小体。是身体内最复杂的内分泌腺，所产生的激素不但与身体骨骼和软组织的生长有关，且可影响内分泌腺的活动。垂体可分为腺垂体和神经垂体两大部分。神经垂体由神经部和漏斗部组成。垂体借漏斗连于下丘脑，呈椭圆形，位于颅中窝、蝶骨体上面的垂体窝内，外包坚韧的硬脑膜。位于前方的腺垂体来自胚胎口凹顶的上皮囊（Rathke囊），腺垂体包括远侧部、结节部和中间部；位于后方的神经垂体较小，由第三脑室底向下突出形成。成人垂体大小约为1*1.5*0.5厘米，重约0.5-0.6克，妇女妊娠期可稍大。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Pars tuberalis",
                                                                    "c": "结节部Pars tuberalis"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "垂体：位于丘脑下部的腹侧，为一卵圆形小体。是身体内最复杂的内分泌腺，所产生的激素不但与身体骨骼和软组织的生长有关，且可影响内分泌腺的活动。垂体可分为腺垂体和神经垂体两大部分。神经垂体由神经部和漏斗部组成。垂体借漏斗连于下丘脑，呈椭圆形，位于颅中窝、蝶骨体上面的垂体窝内，外包坚韧的硬脑膜。位于前方的腺垂体来自胚胎口凹顶的上皮囊（Rathke囊），腺垂体包括远侧部、结节部和中间部；位于后方的神经垂体较小，由第三脑室底向下突出形成。成人垂体大小约为1*1.5*0.5厘米，重约0.5-0.6克，妇女妊娠期可稍大。"
                                                                }
                                                            }]
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "03Meninges",
                                    "c": "脑膜Meninges"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Cerebral dura mater",
                                            "c": "硬脑膜Cerebral dura mater"
                                        },
                                        "t":
                                        {
                                            "s": "硬脑膜：坚韧而有光泽，由两层合成，外层源于颅骨的内骨膜，内层较外层坚厚，两层之间有丰富的血管和神经。硬脑膜与颅盖骨连接疏松，易于分离，当硬脑膜血管损伤时，可在硬脑膜与颅骨之间形成硬膜外血肿。硬脑膜在颅底处则与颅骨结合紧密，故颅底骨折时，易将硬脑膜与脑蛛网膜同时撕裂，使脑脊液外漏。如颅前窝骨折时，脑脊液可流入鼻腔，形成鼻漏。硬脑膜在脑神经出颅处移行为神经外膜，在枕骨大孔的边缘与硬脊膜相延续。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Diaphragma sellae",
                                            "c": "鞍膈Diaphragma sellae"
                                        },
                                        "t":
                                        {
                                            "s": "鞍膈：张于鞍背上缘和鞍结节之间的硬膜隔。覆盖垂体，膈中央有孔，供垂体柄通过。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Spinal dura mater",
                                            "c": "硬脊膜Spinal dura mater"
                                        },
                                        "t":
                                        {
                                            "s": "硬脊膜：脊髓3层被膜的最外层。呈厚而坚韧的管状，上端附着于枕骨大孔周缘，下端与终丝融合，止于尾骨背面的骨膜，在椎间孔处与脊神经外膜相续。"
                                        }
                                    }]
                                }
                            }]
                        }
                    },
                    {
                        "$":
                        {
                            "o": "010Peripheral",
                            "c": "周围神经Peripheral"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "01Cervical plexus and cervical nerves",
                                    "c": "颈丛Cervical plexus and cervical nerves"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Cervical plexus and cervical nerves,L",
                                            "c": "左颈丛及其分支Cervical plexus and cervical nerves,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Roots and ganglions(C1-C4),L",
                                                    "c": "左神经根及神经节Roots and ganglions(C1-C4),L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C01 Dorsal root ganglion,L",
                                                            "c": "C01脊神经节C01 Dorsal root ganglion,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经节：位于脊神经后根上的感觉神经节。内含假单极神经元。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C01 Dorsal root,L",
                                                            "c": "C01后根C01 Dorsal root,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经后根：由连于脊髓后外侧沟的脊神经根丝合成的神经根。一般由感觉纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C01 Ventral root,L",
                                                            "c": "C01前根C01 Ventral root,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经前根：由连于脊髓前外侧沟的脊神经根丝合成的神经根。一般由运动纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C02 Dorsal root ganglion,L",
                                                            "c": "C02脊神经节C02 Dorsal root ganglion,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经节：位于脊神经后根上的感觉神经节。内含假单极神经元。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C02 Dorsal root,L",
                                                            "c": "C02后根C02 Dorsal root,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经后根：由连于脊髓后外侧沟的脊神经根丝合成的神经根。一般由感觉纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C02 Ventral root,L",
                                                            "c": "C02前根C02 Ventral root,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经前根：由连于脊髓前外侧沟的脊神经根丝合成的神经根。一般由运动纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C03 Dorsal root ganglion,L",
                                                            "c": "C03脊神经节C03 Dorsal root ganglion,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经节：位于脊神经后根上的感觉神经节。内含假单极神经元。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C03 Dorsal root,L",
                                                            "c": "C03后根C03 Dorsal root,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经后根：由连于脊髓后外侧沟的脊神经根丝合成的神经根。一般由感觉纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C03 Ventral root,L",
                                                            "c": "C03前根C03 Ventral root,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经前根：由连于脊髓前外侧沟的脊神经根丝合成的神经根。一般由运动纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C04 Dorsal root ganglion,L",
                                                            "c": "C04脊神经节C04 Dorsal root ganglion,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经节：位于脊神经后根上的感觉神经节。内含假单极神经元。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C04 Dorsal root,L",
                                                            "c": "C04后根C04 Dorsal root,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经后根：由连于脊髓后外侧沟的脊神经根丝合成的神经根。一般由感觉纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C04 Ventral root,L",
                                                            "c": "C04前根C04 Ventral root,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经前根：由连于脊髓前外侧沟的脊神经根丝合成的神经根。一般由运动纤维构成。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Cervical plexus,L",
                                                    "c": "左颈丛Cervical plexus,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Ansa cervicalis,branch to omohyoid(superior belly),L",
                                                            "c": "颈袢-肩胛舌骨肌上腹支Ansa cervicalis,branch to omohyoid(superior belly),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈袢：又称“舌下神经袢”。由来自第一颈神经的上根（舌下神经降支）与来自第二、第三颈神经的下根（颈神经降支）在环状软骨水平结合而成的神经袢。该袢发出分支分布于舌骨下肌群。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Ansa cervicalis,branch to omohyoid,L",
                                                            "c": "颈袢-肩胛舌骨肌支Ansa cervicalis,branch to omohyoid,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈袢：又称“舌下神经袢”。由来自第一颈神经的上根（舌下神经降支）与来自第二、第三颈神经的下根（颈神经降支）在环状软骨水平结合而成的神经袢。该袢发出分支分布于舌骨下肌群。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Ansa cervicalis,branch to sternohyoid,L",
                                                            "c": "颈袢-胸骨舌骨肌支Ansa cervicalis,branch to sternohyoid,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈袢：又称“舌下神经袢”。由来自第一颈神经的上根（舌下神经降支）与来自第二、第三颈神经的下根（颈神经降支）在环状软骨水平结合而成的神经袢。该袢发出分支分布于舌骨下肌群。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Ansa cervicalis,branch to sternothyroid,L",
                                                            "c": "颈袢-胸骨甲状肌支Ansa cervicalis,branch to sternothyroid,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈袢：又称“舌下神经袢”。由来自第一颈神经的上根（舌下神经降支）与来自第二、第三颈神经的下根（颈神经降支）在环状软骨水平结合而成的神经袢。该袢发出分支分布于舌骨下肌群。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C01 Spinal nerve(ventral ramus),L",
                                                            "c": "C01前支C01 Spinal nerve(ventral ramus),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经前支：颈神经出椎间孔向前的粗大分支。主要分布于颈部和上肢的肌肉、皮肤及膈。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C02 Spinal nerve(ventral ramus),L",
                                                            "c": "C02前支C02 Spinal nerve(ventral ramus),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经前支：颈神经出椎间孔向前的粗大分支。主要分布于颈部和上肢的肌肉、皮肤及膈。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C03 Spinal nerve(ventral ramus),L",
                                                            "c": "C03前支C03 Spinal nerve(ventral ramus),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经前支：颈神经出椎间孔向前的粗大分支。主要分布于颈部和上肢的肌肉、皮肤及膈。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C04 Spinal nerve(ventral ramus),L",
                                                            "c": "C04前支C04 Spinal nerve(ventral ramus),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经前支：颈神经出椎间孔向前的粗大分支。主要分布于颈部和上肢的肌肉、皮肤及膈。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Communicating branches,L",
                                                            "c": "交通支Communicating branches,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Great auricular,L",
                                                            "c": "耳大神经Great auricular,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "耳大神经：(C2、C3)沿胸锁乳突肌表面向耳垂方向上行，分布于耳廓及附近皮肤。耳大神经由于其位置表浅，附近没有重要结构，是临床神经干移植的理想替代物。该神经由枕动脉和耳动脉的分支供血，长度约为5.5-7.4cm，直径约为2-4mm。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Inferior root of cervical ansa,L",
                                                            "c": "颈袢下根Inferior root of cervical ansa,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈袢下根：又称“颈袢后根”。由第二、三颈神经所形成的颈神经降支组成，参与颈袢的构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Lesser occipital,L",
                                                            "c": "枕小神经Lesser occipital,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "枕小神经：(C2)沿胸锁乳突肌后缘上行，分布于枕部及耳廓背面上部的皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Phranic nerve(C03-C05),L",
                                                            "c": "膈神经Phrenic nerve,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "膈神经：(C3-C5)起初从前斜角肌上端的外侧浅出下行，继而沿该肌前面下降至肌的内侧，在锁骨下动、静脉之间经胸廓上口进入胸腔。入胸后经由肺根前方，在纵隔胸膜与心包之间下行到达膈，最后于中心腱附近穿入膈。膈神经的运动纤维支配膈肌的运动，感觉纤维分布于胸膜、心包以及膈下面的部分腹膜。一般认为，右膈神经的感觉纤维尚分布到肝、胆囊和肝外胆道的浆膜。膈神经受到损伤后，同侧半膈肌的功能受影响，表现为腹式呼吸减弱或消失，严重者可有窒息感。膈神经受到刺激时可发生呃逆。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Superior root of cervical ansa,L",
                                                            "c": "颈袢上根Superior root of cervical ansa,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈袢上根：又称“颈袢前根”。由第一颈神经发出的部分纤维构成，随舌下神经下行，离开舌下神经后构成舌下神经降支，参与颈袢的构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Supraclavicular,L",
                                                            "c": "锁骨上神经Supraclavicular,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "锁骨上神经：(C3、C4)共有2-4条分支，呈辐射状行向下方和下外侧，越过锁骨达胸前壁上份及肩部。该神经主要分布于颈侧区下份、胸壁上部和肩部的皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Transverse cervical,L",
                                                            "c": "颈横神经Transverse cervical,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈横神经：(C2、C3)发出后横行跨过胸锁乳突肌表面向前走行，分布于颈前部皮肤。该神经支常与面神经分支间有交通支存在。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "03Posterior branch(C1-C4),L",
                                                    "c": "左颈神经后支Posterior branch(C1-C4),L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C03 Dorsal ramus,L",
                                                            "c": "C03后支C03 Dorsal ramus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支：颈神经出椎间孔向后的分支。主要分布于项背部深层肌及该区皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C03 Dorsal ramus,lateral branch,L",
                                                            "c": "C03后支外侧支C03 Dorsal ramus,lateral branch,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支：颈神经出椎间孔向后的分支。主要分布于项背部深层肌及该区皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C03 Dorsal ramus,medial branch,L",
                                                            "c": "C03后支内侧支C03 Dorsal ramus,medial branch,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支：颈神经出椎间孔向后的分支。主要分布于项背部深层肌及该区皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C04 Dorsal ramus,L",
                                                            "c": "C04后支C04 Dorsal ramus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支：颈神经出椎间孔向后的分支。主要分布于项背部深层肌及该区皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C04 Dorsal ramus,lateral branch,L",
                                                            "c": "C04后支外侧支C04 Dorsal ramus,lateral branch,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支：颈神经出椎间孔向后的分支。主要分布于项背部深层肌及该区皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C04 Dorsal ramus,medial branch,L",
                                                            "c": "C04后支内侧支C04 Dorsal ramus,medial branch,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支：颈神经出椎间孔向后的分支。主要分布于项背部深层肌及该区皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Greater occipital,L",
                                                            "c": "枕大神经Greater occipital,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "第2颈神经后支的皮支称为枕大神经。该支穿斜方肌肌腱到达皮下，分布于枕、项部皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Suboccipital,L",
                                                            "c": "枕下神经Suboccipital,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "第1颈神经后支又称枕下神经，该支直径粗大，在寰椎后弓上方与椎动脉下方之间穿行，支配椎枕肌。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Third(least) occipital,L",
                                                            "c": "第三枕神经Third (least) occipital,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "第三枕神经：第三枕神经后支的内侧支。穿斜方肌分布于枕下区皮肤。"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Cervical plexus and cervical nerves,R",
                                            "c": "右颈丛及其分支Cervical plexus and cervical nerves,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Roots and ganglions(C1-C4),R",
                                                    "c": "右神经根及神经节Roots and ganglions(C1-C4),R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C01 Dorsal root ganglion,R",
                                                            "c": "C01脊神经节C01 Dorsal root ganglion,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经节：位于脊神经后根上的感觉神经节。内含假单极神经元。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C01 Dorsal root,R",
                                                            "c": "C01后根C01 Dorsal root,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经后根：由连于脊髓后外侧沟的脊神经根丝合成的神经根。一般由感觉纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C01 Ventral root,R",
                                                            "c": "C01前根C01 Ventral root,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经前根：由连于脊髓前外侧沟的脊神经根丝合成的神经根。一般由运动纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C02 Dorsal root ganglion,R",
                                                            "c": "C02脊神经节C02 Dorsal root ganglion,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经节：位于脊神经后根上的感觉神经节。内含假单极神经元。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C02 Dorsal root,R",
                                                            "c": "C02后根C02 Dorsal root,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经后根：由连于脊髓后外侧沟的脊神经根丝合成的神经根。一般由感觉纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C02 Ventral root,R",
                                                            "c": "C02前根C02 Ventral root,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经前根：由连于脊髓前外侧沟的脊神经根丝合成的神经根。一般由运动纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C03 Dorsal root ganglion,R",
                                                            "c": "C03脊神经节C03 Dorsal root ganglion,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经节：位于脊神经后根上的感觉神经节。内含假单极神经元。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C03 Dorsal root,R",
                                                            "c": "C03后根C03 Dorsal root,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经后根：由连于脊髓后外侧沟的脊神经根丝合成的神经根。一般由感觉纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C03 Ventral root,R",
                                                            "c": "C03前根C03 Ventral root,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经前根：由连于脊髓前外侧沟的脊神经根丝合成的神经根。一般由运动纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C04 Dorsal root ganglion,R",
                                                            "c": "C04脊神经节C04 Dorsal root ganglion,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经节：位于脊神经后根上的感觉神经节。内含假单极神经元。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C04 Dorsal root,R",
                                                            "c": "C04后根C04 Dorsal root,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经后根：由连于脊髓后外侧沟的脊神经根丝合成的神经根。一般由感觉纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C04 Ventral root,R",
                                                            "c": "C04前根C04 Ventral root,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经前根：由连于脊髓前外侧沟的脊神经根丝合成的神经根。一般由运动纤维构成。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Cervical plexus,R",
                                                    "c": "右颈丛Cervical plexus,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Ansa cervicalis,branch to omohyoid(superior belly),R",
                                                            "c": "颈袢-肩胛舌骨肌上腹支Ansa cervicalis,branch to omohyoid(superior belly),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈袢：又称“舌下神经袢”。由来自第一颈神经的上根（舌下神经降支）与来自第二、第三颈神经的下根（颈神经降支）在环状软骨水平结合而成的神经袢。该袢发出分支分布于舌骨下肌群。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Ansa cervicalis,branch to omohyoid,R",
                                                            "c": "颈袢-肩胛舌骨肌支Ansa cervicalis,branch to omohyoid,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈袢：又称“舌下神经袢”。由来自第一颈神经的上根（舌下神经降支）与来自第二、第三颈神经的下根（颈神经降支）在环状软骨水平结合而成的神经袢。该袢发出分支分布于舌骨下肌群。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Ansa cervicalis,branch to sternohyoid,R",
                                                            "c": "颈袢-胸骨舌骨肌支Ansa cervicalis,branch to sternohyoid,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈袢：又称“舌下神经袢”。由来自第一颈神经的上根（舌下神经降支）与来自第二、第三颈神经的下根（颈神经降支）在环状软骨水平结合而成的神经袢。该袢发出分支分布于舌骨下肌群。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Ansa cervicalis,branch to sternothyroid,R",
                                                            "c": "颈袢-胸骨甲状肌支Ansa cervicalis,branch to sternothyroid,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈袢：又称“舌下神经袢”。由来自第一颈神经的上根（舌下神经降支）与来自第二、第三颈神经的下根（颈神经降支）在环状软骨水平结合而成的神经袢。该袢发出分支分布于舌骨下肌群。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C01 Spinal nerve(ventral ramus),R",
                                                            "c": "C01前支C01 Spinal nerve(ventral ramus),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经前支：颈神经出椎间孔向前的粗大分支。主要分布于颈部和上肢的肌肉、皮肤及膈。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C02 Spinal nerve(ventral ramus),R",
                                                            "c": "C02前支C02 Spinal nerve(ventral ramus),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经前支：颈神经出椎间孔向前的粗大分支。主要分布于颈部和上肢的肌肉、皮肤及膈。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C03 Spinal nerve(ventral ramus),R",
                                                            "c": "C03前支C03 Spinal nerve(ventral ramus),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经前支：颈神经出椎间孔向前的粗大分支。主要分布于颈部和上肢的肌肉、皮肤及膈。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C04 Spinal nerve(ventral ramus),R",
                                                            "c": "C04前支C04 Spinal nerve(ventral ramus),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经前支：颈神经出椎间孔向前的粗大分支。主要分布于颈部和上肢的肌肉、皮肤及膈。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Communicating branches,R",
                                                            "c": "交通支Communicating branches,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Great auricular,R",
                                                            "c": "耳大神经Great auricular,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "耳大神经：(C2、C3)沿胸锁乳突肌表面向耳垂方向上行，分布于耳廓及附近皮肤。耳大神经由于其位置表浅，附近没有重要结构，是临床神经干移植的理想替代物。该神经由枕动脉和耳动脉的分支供血，长度约为5.5-7.4cm，直径约为2-4mm。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Inferior root of cervical ansa,R",
                                                            "c": "颈袢下根Inferior root of cervical ansa,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈袢下根：又称“颈袢后根”。由第二、三颈神经所形成的颈神经降支组成，参与颈袢的构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Lesser occipital,R",
                                                            "c": "枕小神经Lesser occipital,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "枕小神经：(C2)沿胸锁乳突肌后缘上行，分布于枕部及耳廓背面上部的皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Phranic nerve(C03-C05),R",
                                                            "c": "膈神经Phrenic nerve,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "膈神经：(C3-C5)起初从前斜角肌上端的外侧浅出下行，继而沿该肌前面下降至肌的内侧，在锁骨下动、静脉之间经胸廓上口进入胸腔。入胸后经由肺根前方，在纵隔胸膜与心包之间下行到达膈，最后于中心腱附近穿入膈。膈神经的运动纤维支配膈肌的运动，感觉纤维分布于胸膜、心包以及膈下面的部分腹膜。一般认为，右膈神经的感觉纤维尚分布到肝、胆囊和肝外胆道的浆膜。膈神经受到损伤后，同侧半膈肌的功能受影响，表现为腹式呼吸减弱或消失，严重者可有窒息感。膈神经受到刺激时可发生呃逆。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Superior root of cervical ansa,R",
                                                            "c": "颈袢上根Superior root of cervical ansa,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈袢上根：又称“颈袢前根”。由第一颈神经发出的部分纤维构成，随舌下神经下行，离开舌下神经后构成舌下神经降支，参与颈袢的构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Supraclavicular,R",
                                                            "c": "锁骨上神经Supraclavicular,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "锁骨上神经：(C3、C4)共有2-4条分支，呈辐射状行向下方和下外侧，越过锁骨达胸前壁上份及肩部。该神经主要分布于颈侧区下份、胸壁上部和肩部的皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Transverse cervical,R",
                                                            "c": "颈横神经Transverse cervical,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈横神经：(C2、C3)发出后横行跨过胸锁乳突肌表面向前走行，分布于颈前部皮肤。该神经支常与面神经分支间有交通支存在。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "03Posterior branch(C1-C4),R",
                                                    "c": "右颈神经后支Posterior branch(C1-C4),R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C03 Dorsal ramus,lateral branch,R",
                                                            "c": "C03后支外侧支C03 Dorsal ramus,lateral branch,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支：颈神经出椎间孔向后的分支。主要分布于项背部深层肌及该区皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C03 Dorsal ramus,medial branch,R",
                                                            "c": "C03后支内侧支C03 Dorsal ramus,medial branch,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支：颈神经出椎间孔向后的分支。主要分布于项背部深层肌及该区皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C03 Dorsal ramus,R",
                                                            "c": "C03后支C03 Dorsal ramus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支：颈神经出椎间孔向后的分支。主要分布于项背部深层肌及该区皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C04 Dorsal ramus,lateral branch,R",
                                                            "c": "C04后支外侧支C04 Dorsal ramus,lateral branch,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支：颈神经出椎间孔向后的分支。主要分布于项背部深层肌及该区皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C04 Dorsal ramus,medial branch,R",
                                                            "c": "C04后支内侧支C04 Dorsal ramus,medial branch,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支：颈神经出椎间孔向后的分支。主要分布于项背部深层肌及该区皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C04 Dorsal ramus,R",
                                                            "c": "C04后支C04 Dorsal ramus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支：颈神经出椎间孔向后的分支。主要分布于项背部深层肌及该区皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Greater occipital,R",
                                                            "c": "枕大神经Greater occipital,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "第2颈神经后支的皮支称为枕大神经。该支穿斜方肌肌腱到达皮下，分布于枕、项部皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Suboccipital,R",
                                                            "c": "枕下神经Suboccipital,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "第1颈神经后支又称枕下神经，该支直径粗大，在寰椎后弓上方与椎动脉下方之间穿行，支配椎枕肌。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Third(least) occipital,R",
                                                            "c": "第三枕神经Third (least) occipital,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "第三枕神经：第三枕神经后支的内侧支。穿斜方肌分布于枕下区皮肤。"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "02Brachial plexus and upper limb",
                                    "c": "臂丛Brachial plexus and upper limb"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Brachial plexus and upper limb,L",
                                            "c": "左臂丛及其分支Brachial plexus and upper limb,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Roots,L",
                                                    "c": "左臂丛根Roots,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C05 Dorsal root ganglion,L",
                                                            "c": "C05脊神经节C05 Dorsal root ganglion,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经节：位于脊神经后根上的感觉神经节。内含假单极神经元。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C05 Dorsal root,L",
                                                            "c": "C05后根C05 Dorsal root,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经后根：由连于脊髓后外侧沟的脊神经根丝合成的神经根。一般由感觉纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C05 Spinal nerve(ventral ramus),L",
                                                            "c": "C05前支C05 Spinal nerve(ventral ramus),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经前支：颈神经出椎间孔向前的粗大分支。主要分布于颈部和上肢的肌肉、皮肤及膈。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C05 Ventral root,L",
                                                            "c": "C05前根C05 Ventral root,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经前根：由连于脊髓前外侧沟的脊神经根丝合成的神经根。一般由运动纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C06 Dorsal root ganglion,L",
                                                            "c": "C06脊神经节C06 Dorsal root ganglion,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经节：位于脊神经后根上的感觉神经节。内含假单极神经元。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C06 Dorsal root,L",
                                                            "c": "C06后根C06 Dorsal root,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经后根：由连于脊髓后外侧沟的脊神经根丝合成的神经根。一般由感觉纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C06 Spinal nerve(ventral ramus),L",
                                                            "c": "C06前支C06 Spinal nerve (ventral ramus),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经前支：颈神经出椎间孔向前的粗大分支。主要分布于颈部和上肢的肌肉、皮肤及膈。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C06 Ventral root,L",
                                                            "c": "C06前根C06 Ventral root,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经前根：由连于脊髓前外侧沟的脊神经根丝合成的神经根。一般由运动纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C07 Dorsal root ganglion,L",
                                                            "c": "C07脊神经节C07 Dorsal root ganglion,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经节：位于脊神经后根上的感觉神经节。内含假单极神经元。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C07 Dorsal root,L",
                                                            "c": "C07后根C07 Dorsal root,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经后根：由连于脊髓后外侧沟的脊神经根丝合成的神经根。一般由感觉纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C07 Spinal nerve(ventral ramus),L",
                                                            "c": "C07前支C07 Spinal nerve(ventral ramus),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经前支：颈神经出椎间孔向前的粗大分支。主要分布于颈部和上肢的肌肉、皮肤及膈。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C07 Ventral root,L",
                                                            "c": "C07前根C07 Ventral root,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经前根：由连于脊髓前外侧沟的脊神经根丝合成的神经根。一般由运动纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C08 Dorsal root ganglion,L",
                                                            "c": "C08脊神经节C08 Dorsal root ganglion,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经节：位于脊神经后根上的感觉神经节。内含假单极神经元。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C08 Dorsal root,L",
                                                            "c": "C08后根C08 Dorsal root,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经后根：由连于脊髓后外侧沟的脊神经根丝合成的神经根。一般由感觉纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C08 Spinal nerve(ventral ramus),L",
                                                            "c": "C08前支C08 Spinal nerve(ventral ramus),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经前支：颈神经出椎间孔向前的粗大分支。主要分布于颈部和上肢的肌肉、皮肤及膈。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C08 Ventral root,L",
                                                            "c": "C08前根C08 Ventral root,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经前根：由连于脊髓前外侧沟的脊神经根丝合成的神经根。一般由运动纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T01 Contribution,L",
                                                            "c": "第一胸神经部分前支T01 Contribution,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Trunks,L",
                                                    "c": "左臂丛干Trunks,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Lower trunk(C08,T01),L",
                                                            "c": "臂丛下干Lower trunk (C08,T01),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "下干：由第八颈神经前支与第一胸神经前支的部分纤维在斜角肌后方合成的臂丛神经干。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Middle trunk(C07),L",
                                                            "c": "臂丛中干Middle trunk (C07),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "中干：由第七颈神经前支构成的臂丛神经干。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Upper trunk(C05,C06),L",
                                                            "c": "臂丛上干Upper trunk (C05,C06),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "上干：多由第五、六颈神经前支合成的臂丛神经干。位于中斜角肌外援。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "03Divisions,L",
                                                    "c": "左臂丛股Divisions,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Anterior divisions,L",
                                                            "c": "臂丛前股Anterior divisions,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "臂丛股：臂丛的上、中、下干纤维均又分为两支，偏前方者称为前股，偏后方者称后股。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Posterior division,L",
                                                            "c": "臂丛后股Posterior division,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "臂丛股：臂丛的上、中、下干纤维均又分为两支，偏前方者称为前股，偏后方者称后股。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "04Cords,L",
                                                    "c": "左臂丛束Cords,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Lateral cord(C05-C07),L",
                                                            "c": "臂丛外侧束Lateral cord (C05-C07),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "臂丛外侧束：由臂丛上、中两干的前股纤维合成的神经束。于腋窝中部行于腋动脉的外侧。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Medial cord(C08,T01),L",
                                                            "c": "臂丛内侧束Medial cord (C08,T01),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "臂丛内侧束：由臂丛下干前股的纤维独自构成的神经束。在腋窝中部行于腋动脉的内侧。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Posterior cord(C05-T01),L",
                                                            "c": "臂丛后束Posterior cord (C05-T01),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "臂丛后束：由臂丛上、中、下3干后股合成的神经束，在腋窝中部，向外行于腋动脉后方。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "05Supraclavicular branches of cords,L",
                                                    "c": "左锁骨上分支Supraclavicular branches of cords,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Dorsal scapular(C03-C05),L",
                                                            "c": "肩胛背神经Dorsal scapular,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肩胛背神经：主要发自第五颈神经前支，发出后，穿中斜角肌向后越过肩胛提肌，在肩胛骨内侧缘和脊柱之间下行，分布至菱形肌和肩胛提肌。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Long thoracic(C05-C07),L",
                                                            "c": "胸长神经Long thoracic (C05-C07),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸长神经：(C5-C7)在臂丛主要结构的后方斜向外下行至前锯肌表面，分布于该肌和乳房外侧份。此神经的损伤可致前锯肌瘫痪，出现以肩胛骨内侧缘翘起为特征的“翼状肩”体征。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Nerve to the subclavius(C05,C06),L",
                                                            "c": "锁骨下肌神经Nerve to the subclavius (C05,C06),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "锁骨下肌神经：发自颈5、6神经根，支配锁骨下肌的神经。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Suprascapular(C04-C06),L",
                                                            "c": "肩胛上神经Suprascapular (C04-C06),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肩胛上神经：发自臂丛上干，向后进入冈上窝、冈下窝，分布于冈上肌、冈下肌和肩关节的神经。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "06Infraclavicular branches of cords,L",
                                                    "c": "左锁骨下分支Infraclavicular branches of cords,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Branches of lateral cord,L",
                                                            "c": "左外侧束分支Branches of lateral cord,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Anterior interosseous,L",
                                                                    "c": "骨间前神经Anterior interosseous,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "骨间前神经：正中神经在前臂深层的分支。分布于指深屈肌桡侧半、拇长屈肌、旋前方肌及和附近关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Common palmar digital,L",
                                                                    "c": "正中神经指掌侧总神经Common palmar digital,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "正中神经指掌侧总神经：正中神经在掌部的终支。有3条，其分支主要分布于第一、二蚓状肌，桡侧3个半指掌面的皮肤及食指、中指末节指背面皮肤。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Lateral pectoral(C05-C07),L",
                                                                    "c": "胸外侧神经Lateral pectoral (C05-C07),L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "胸外侧神经：(C5-C7)自臂丛外侧束发出，跨过腋动、静脉的前方，穿锁胸筋膜后行于胸大肌深面，并分布至该肌。在走行过程中，此神经尚发出一支与胸内侧神经汇合，分布于胸小肌。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Median(C06-T01),L",
                                                                    "c": "正中神经Median (C06-T01),L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "正中神经：(C6-T1)臂丛内侧束的内侧根和臂丛外侧束的外侧根在腋动脉前方汇合为正中神经主干后，先于肱动脉的外侧下行，至喙肱肌止点处，斜越动脉浅面或深面转至动脉的内侧，继而伴随同名血管一起降至肘窝。经肘窝向下至前臂，穿旋前圆肌和指浅屈肌腱弓在前臂正中下行，于指浅、深屈肌之间到达腕部。在腕部正中神经于桡侧腕屈肌腱和掌长肌键之间穿经腕管，在掌腱膜深面分支分布于手掌。\r\n                                                                    正中神经在臂部不发出分支，在肘部及前臂发出较多肌支，其中骨间前神经较粗大，行程较长，沿前臂骨间膜前面下行。正中神经主干在前臂发支支配除肱桡肌、尺侧腕屈肌和指深屈肌尺侧半以外的所有前臂屈肌和旋前肌。在手部屈肌支持带的下方正中神经发出一粗短的返支，于桡动脉掌浅支外侧进入鱼际，支配除拇收肌以外的鱼际肌群。在手掌区，正中神经发出数条指掌侧总神经，每一条指掌侧总神经下行至掌骨头附近又分为两支指掌侧固有神经，后者沿手指的相对缘行至指尖。正中神经在手部的分布可概括为：运动纤维支配第1、2蚓状肌和鱼际肌（拇收肌除外）；感觉纤维则分布于桡侧半手掌、桡侧三个半手指掌面皮肤及其中节和远节指背皮肤。\r\n                                                                    前臂和腕部外伤时常累及正中神经，此时出现该神经分布区的功能障碍。旋前肌综合征表现为该神经所支配的肌收缩无力和手掌感觉障碍；腕管综合征表现为鱼际肌萎缩，手掌变平呈“猿掌”，同时桡侧三个半手指掌面皮肤及桡侧半手掌出现感觉障碍。 在肱二头肌内侧沟上端肱动脉的搏动处确定一点，在肘部肱骨内、外上髁间连线中点稍内侧确定另一点，此二点之间的连线即为正中神经在臂部的投影线。将此投影线延至腕部桡侧腕屈肌腱与掌长肌腱连线的中点，即为正中神经在前臂的投影线。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Median,lateral root,L",
                                                                    "c": "正中神经外侧根Median,lateral root,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "正中神经外侧根：发自臂丛外侧束的正中神经纤维。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Musculocutaneous(C05-C07),L",
                                                                    "c": "肌皮神经Musculocutaneous (C05-C07),L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "肌皮神经：(C5-C7)发自臂丛外侧束，向外下方走行斜穿喙肱肌，后于肱二头肌与肱肌之间下行，沿途发支支配以上三肌。在肘关节稍下方，部分纤维从肱二头肌下端外侧穿出深筋膜，分布于前臂外侧份的皮肤，称为前臂外侧皮神经。肱骨上中段骨折时可导致该神经的损伤，表现为屈肘无力以及前臂外侧部皮肤感觉的减弱。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Palmar digital(median),L",
                                                                    "c": "正中神经指掌侧固有神经Palmar digital (median),L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "正中神经指掌侧固有神经：指掌侧总神经在掌骨头处分出的终支。一般分布于相邻两指相对缘的皮肤，尚分布于末节指背面皮肤。"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Branches of medial cord,L",
                                                            "c": "左内侧束分支Branches of medial cord,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Deep branch of ulnar,L",
                                                                    "c": "尺神经深支Deep branch of ulnar,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "尺神经深支：尺神经终支之一。支配小鱼际肌、拇收肌、第三、四蚓状肌和全部骨间肌。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Dorsal digital(ulnar),L",
                                                                    "c": "尺神经指背神经Dorsal digital (ulnar),L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "尺神经指背神经：尺神经的终支。分布于尺侧2个半指背面的皮肤（中指远节除外）。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Medial antebrachial cutaneous(C08,T01),L",
                                                                    "c": "前臂内侧皮神经Medial antebrachial cutaneous (C08,T01),L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "前臂内侧皮神经：发自臂丛内侧束的神经。分前、后两支。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Medial brachial cutaneous(T01),L",
                                                                    "c": "臂内侧皮神经Medial brachial cutaneous (T01),L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "臂内侧皮神经：发自臂丛内侧束，分布于臂前内侧面皮肤的神经。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Medial pectoral(C08,T01),L",
                                                                    "c": "胸内侧神经Medial pectoral (C08,T01),L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "胸内侧神经：发自臂丛内侧束，常与胸外侧神经分支联合，分布于胸小肌和部分胸大肌的神经。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Median,medial root,L",
                                                                    "c": "正中神经内侧根Median,medial root,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "正中神经内侧根：发自臂丛内侧束的正中神经纤维。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Palmar digital(ulnar),L",
                                                                    "c": "尺神经指掌侧固有神经Palmar digital (ulnar),L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "尺神经指掌侧固有神经：尺神经的浅支。共有3条，分布于第四、五指的相对缘和第五指尺侧缘皮肤。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Ulnar(C08,T01),L",
                                                                    "c": "尺神经Ulnar (C08,T01),L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "尺神经：自臂丛内侧束发出后，经腋动、静脉之间出腋窝，先在肱二头肌内侧沟内肱动脉内侧下行至臂中份，继而穿内侧肌间隔至臂后区内侧继续下行入肱骨内上髁后方的尺神经沟。在此尺神经由后向前穿过尺侧腕屈肌的起点，行至前臂前内侧份，伴随尺动脉于尺侧腕屈肌与指深屈肌之间下行至桡腕关节上方发出手背支，主干在豌豆骨桡侧，屈肌支持带浅面分为浅支和深支。这些分支在掌腱膜深面、腕横韧带浅面进入手掌。\r\n                                                                    尺神经在臂部不发出分支，于前臂上部发肌支支配尺侧腕屈肌和指深屈肌尺侧半。其手背支从腕部伸肌支持带浅面转行至手背部，发支分布于手背尺侧半和小指、环指及中指尺侧半背面皮肤。浅支分布于小鱼际表面的皮肤、小指掌面皮肤和环指尺侧半掌面皮肤。深支分布于小鱼际肌、拇收肌、骨间掌侧肌、骨间背侧肌及第3、4蚓状肌。\r\n                                                                    尺神经在肘部肱骨内上髁后方、尺侧腕屈肌起点处和豌豆骨外侧较易受到损伤。尺神经在上两个部位受到损伤时，运动障碍主要表现为屈腕力减弱，环指和小指远节指关节不能屈曲，小鱼际肌和骨间肌萎缩，拇指不能内收，各指不能相互靠拢。同时，各掌指关节过伸，掌骨间呈现深凹，表现为“爪形手”。感觉障碍则表现为手掌和手背内侧缘皮肤感觉丧失。在豌豆骨处受损后主要表现为骨间肌的运动障碍。\r\n                                                                    自胸大肌下缘肱动脉搏动点开始，向下内侧到肱骨内上髁与鹰嘴之间的连线为尺神经在臂部的投影线。将此线在前臂的尺侧延至豌豆骨的外侧，则为尺神经在前臂的投影线。尺神经在肱骨内上髁后方的尺神经沟内位置最浅，容易触及。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Ulnar,communicating branch,L",
                                                                    "c": "尺神经交通支Ulnar,communicating branch,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": ""
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Ulnar,dorsal branch,L",
                                                                    "c": "尺神经手背支Ulnar,dorsal branch,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "尺神经手背支：在桡腕关节上方发出的尺神经分支。分布于手背尺侧，并分出3条指背神经。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Ulnar,superficial branch,L",
                                                                    "c": "尺神经浅支Ulnar,superficial branch,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "尺神经浅支：尺神经的皮支。分出1支指掌侧总神经和1支指掌侧固有神经。"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Branches of posterior cord,L",
                                                            "c": "左后束分支Branches of posterior cord,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Axillary(C05,C06),L",
                                                                    "c": "腋神经Axillary (C05,C06),L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "腋神经：(C5、C6)从臂丛后束发出，伴旋肱后血管向后外方向走行，穿过四边孔后，绕肱骨外科颈至三角肌深面，发支支配三角肌和小圆肌。部分纤维自三角肌后缘浅出后延为皮神经，分布于肩部和臂外侧区上部的皮肤，称为臂外侧上皮神经。肱骨外科颈骨折、肩关节脱位和使用腋杖不当所致的重压，常造成腋神经的损伤，体征为臂不能外展，臂部旋外力减弱，肩部和臂外上部皮肤感觉障碍。神经损伤致三角肌萎缩，患者肩部亦失去圆隆的外形。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Deep branch of radial,L",
                                                                    "c": "桡神经深支Deep branch of radial,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "桡神经深支：又称“骨间后神经”。桡神经终支之一。穿旋后肌至前臂后，分布于前臂后群肌及附近关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Dorsal digital(radial),L",
                                                                    "c": "桡神经指背神经Dorsal digital(radial),L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "桡神经指背神经：桡神经浅支手背区的4-5条分支。分布于桡侧2个半指近、中节背面的皮肤。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Lower subscapular(C05-C06),L",
                                                                    "c": "下肩胛下神经Lower subscapular (C05-C06),L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "肩胛下神经：发自臂丛的后束，常分为上支和下支，分别进入肩胛下肌和大圆肌，支配该二肌的运动。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Posterior interosseous,L",
                                                                    "c": "骨间后神经Posterior interosseous,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "骨间后神经：桡神经终支之一。穿旋后肌至前臂后，分布于前臂后群肌及附近关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Radial(C05-T01),L",
                                                                    "c": "桡神经Radial (C05-T01),L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "桡神经：发自臂丛后束，始位于腋动脉的后方，与肱深动脉伴行，经肱三头肌长头和内侧头之间下行，沿桡神经沟绕肱骨中段后面旋行向外下，至肱骨外上髁稍上方穿过外侧肌间隔达肱肌与肱桡肌之间，后继续于肱桡肌与桡侧腕长伸肌之间在前臂下行。桡神经在臂部发出较多分支，其中肌支主要分布于肱三头肌、肘肌、肱桡肌和桡侧腕长伸肌。关节支分布于肘关节。皮支共有三支：臂后皮神经在腋窝发出后分布于臂后区的皮肤；臂外侧下皮神经在三角肌止点远侧浅出，分布于臂下外侧部的皮肤；前臂后皮神经自臂中份外侧浅出下行至前臂后面，直达腕部，沿途分支分布于前臂后面皮肤。\r\n                                                                    在肱骨外上髁前方桡神经分为浅支和深支两终末支。桡神经浅支为皮支，自肱骨外上髁前外侧向下沿桡动脉外侧下行，在前臂中、下1/3交界处转向背侧，继续下行至手背部，分为4-5支指背神经，分布于手背桡侧半皮肤和桡侧三个半手指近节背面的皮肤。深支较浅支粗大，主要为肌支。该支在桡骨颈外侧穿过旋后肌至前臂后面，在前臂浅、深伸肌群之间下行达腕关节背面，沿途发支分布于前臂伸肌群、桡尺远侧关节、桡腕关节和掌骨间关节。因其走行及分布的特点，深支又被称为骨间后神经。\r\n                                                                    桡神经在肱骨中段紧贴桡神经沟骨面走行，肱骨中段或中、下1/3交界处骨折容易合并桡神经的损伤，导致前臂伸肌群的瘫痪，表现为抬前臂时呈“垂腕”状，同时第1、2掌骨间背面皮肤感觉障碍明显。桡骨颈骨折时，可损伤桡神经深支，出现伸腕无力，不能伸指等症状。 自腋后襞下缘外侧端与臂相交处斜向外下连于肱骨外上髁，此连线即为桡神经在臂背侧面的投影。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Radial,superficial branch,L",
                                                                    "c": "桡神经浅支Radial,superficial branch,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "桡神经浅支：桡神经的终皮支。分出指背神经并与尺神经手背支的分支间有交通。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Thoracodorsal(middle subscapular,long subscapular)(C06-C08),L",
                                                                    "c": "胸背神经Thoracodorsal (C06-C08),L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "胸背神经：(C6-C8)自臂丛后束发出，后沿肩胛骨外侧缘伴肩胛下血管下行，分支分布于背阔肌。乳腺癌根治术过程中清除淋巴结时，应注意勿伤及此神经。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Upper subscapular(C05-C06),L",
                                                                    "c": "上肩胛下神经Upper subscapular (C05-C06),L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "肩胛下神经：发自臂丛的后束，常分为上支和下支，分别进入肩胛下肌和大圆肌，支配该二肌的运动。"
                                                                }
                                                            }]
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Posterior branch(C5-C8),L",
                                                    "c": "左臂丛后支Posterior branch (C5-C8),L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C05 Dorsal ramus,L",
                                                            "c": "C05后支C05 Dorsal ramus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支：颈神经出椎间孔向后的分支。主要分布于项背部深层肌及该区皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C05 Dorsal ramus,lateral branch,L",
                                                            "c": "C05后支外侧支C05 Dorsal ramus,lateral branch,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支外侧支：颈神经后支的分支。主要分布于项背外侧区深层肌及皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C05 Dorsal ramus,medial branch,L",
                                                            "c": "C05后支内侧支C05 Dorsal ramus,medial branch,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支内侧支：颈神经后支的分支。主要分布于项背内侧区深层肌及皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C06 Dorsal ramus,L",
                                                            "c": "C06后支C06 Dorsal ramus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支：颈神经出椎间孔向后的分支。主要分布于项背部深层肌及该区皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C06 Dorsal ramus,lateral branch,L",
                                                            "c": "C06后支外侧支C06 Dorsal ramus,lateral branch,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支外侧支：颈神经后支的分支。主要分布于项背外侧区深层肌及皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C06 Dorsal ramus,medial branch,L",
                                                            "c": "C06后支内侧支C06 Dorsal ramus,medial branch,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支内侧支：颈神经后支的分支。主要分布于项背内侧区深层肌及皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C07 Dorsal ramus,L",
                                                            "c": "C07后支C07 Dorsal ramus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支：颈神经出椎间孔向后的分支。主要分布于项背部深层肌及该区皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C07 Dorsal ramus,lateral branch,L",
                                                            "c": "C07后支外侧支C07 Dorsal ramus,lateral branch,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支外侧支：颈神经后支的分支。主要分布于项背外侧区深层肌及皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C07 Dorsal ramus,medial branch,L",
                                                            "c": "C07后支内侧支C07 Dorsal ramus,medial branch,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支内侧支：颈神经后支的分支。主要分布于项背内侧区深层肌及皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C08 Dorsal ramus,L",
                                                            "c": "C08后支C08 Dorsal ramus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支：颈神经出椎间孔向后的分支。主要分布于项背部深层肌及该区皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C08 Dorsal ramus,lateral branch,L",
                                                            "c": "C08后支外侧支C08 Dorsal ramus,lateral branch,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支外侧支：颈神经后支的分支。主要分布于项背外侧区深层肌及皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C08 Dorsal ramus,medial branch,L",
                                                            "c": "C08后支内侧支C08 Dorsal ramus,medial branch,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支内侧支：颈神经后支的分支。主要分布于项背内侧区深层肌及皮肤。"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Brachial plexus and upper limb,R",
                                            "c": "右臂丛及其分支Brachial plexus and upper limb,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Roots,R",
                                                    "c": "右臂丛根Roots,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C05 Dorsal root ganglion,R",
                                                            "c": "C05脊神经节C05 Dorsal root ganglion,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经节：位于脊神经后根上的感觉神经节。内含假单极神经元。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C05 Dorsal root,R",
                                                            "c": "C05后根C05 Dorsal root,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经后根：由连于脊髓后外侧沟的脊神经根丝合成的神经根。一般由感觉纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C05 Spinal nerve(ventral ramus),R",
                                                            "c": "C05前支C05 Spinal nerve(ventral ramus),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经前支：颈神经出椎间孔向前的粗大分支。主要分布于颈部和上肢的肌肉、皮肤及膈。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C05 Ventral root,R",
                                                            "c": "C05前根C05 Ventral root,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经前根：由连于脊髓前外侧沟的脊神经根丝合成的神经根。一般由运动纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C06 Dorsal root ganglion,R",
                                                            "c": "C06脊神经节C06 Dorsal root ganglion,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经节：位于脊神经后根上的感觉神经节。内含假单极神经元。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C06 Dorsal root,R",
                                                            "c": "C06后根C06 Dorsal root,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经后根：由连于脊髓后外侧沟的脊神经根丝合成的神经根。一般由感觉纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C06 Spinal nerve(ventral ramus),R",
                                                            "c": "C06前支C06 Spinal nerve(ventral ramus),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经前支：颈神经出椎间孔向前的粗大分支。主要分布于颈部和上肢的肌肉、皮肤及膈。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C06 Ventral root,R",
                                                            "c": "C06前根C06 Ventral root,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经前根：由连于脊髓前外侧沟的脊神经根丝合成的神经根。一般由运动纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C07 Dorsal root ganglion,R",
                                                            "c": "C07脊神经节C07 Dorsal root ganglion,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经节：位于脊神经后根上的感觉神经节。内含假单极神经元。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C07 Dorsal root,R",
                                                            "c": "C07后根C07 Dorsal root,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经后根：由连于脊髓后外侧沟的脊神经根丝合成的神经根。一般由感觉纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C07 Spinal nerve(ventral ramus),R",
                                                            "c": "C07前支C07 Spinal nerve(ventral ramus),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经前支：颈神经出椎间孔向前的粗大分支。主要分布于颈部和上肢的肌肉、皮肤及膈。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C07 Ventral root,R",
                                                            "c": "C07前根C07 Ventral root,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经前根：由连于脊髓前外侧沟的脊神经根丝合成的神经根。一般由运动纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C08 Dorsal root ganglion,R",
                                                            "c": "C08脊神经节C08 Dorsal root ganglion,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经节：位于脊神经后根上的感觉神经节。内含假单极神经元。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C08 Dorsal root,R",
                                                            "c": "C08后根C08 Dorsal root,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经后根：由连于脊髓后外侧沟的脊神经根丝合成的神经根。一般由感觉纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C08 Spinal nerve(ventral ramus),R",
                                                            "c": "C08前支C08 Spinal nerve(ventral ramus),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经前支：颈神经出椎间孔向前的粗大分支。主要分布于颈部和上肢的肌肉、皮肤及膈。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C08 Ventral root,R",
                                                            "c": "C08前根C08 Ventral root,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "脊神经前根：由连于脊髓前外侧沟的脊神经根丝合成的神经根。一般由运动纤维构成。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T01 Contribution,R",
                                                            "c": "第一胸神经部分前支T01 Contribution,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": ""
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Trunks,R",
                                                    "c": "右臂丛干Trunks,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Lower trunk(C08,T01),R",
                                                            "c": "臂丛下干Lower trunk (C08,T01),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "下干：由第八颈神经前支与第一胸神经前支的部分纤维在斜角肌后方合成的臂丛神经干。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Middle trunk(C07),R",
                                                            "c": "臂丛中干Middle trunk (C07),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "中干：由第七颈神经前支构成的臂丛神经干。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Upper trunk(C05,C06),R",
                                                            "c": "臂丛上干Upper trunk (C05,C06),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "上干：多由第五、六颈神经前支合成的臂丛神经干。位于中斜角肌外援。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "03Divisions,R",
                                                    "c": "右臂丛股Divisions,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Anterior divisions,R",
                                                            "c": "臂丛前股Anterior divisions,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "臂丛股：臂丛的上、中、下干纤维均又分为两支，偏前方者称为前股，偏后方者称后股。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Posterior division,R",
                                                            "c": "臂丛后股Posterior division,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "臂丛股：臂丛的上、中、下干纤维均又分为两支，偏前方者称为前股，偏后方者称后股。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "04Cords,R",
                                                    "c": "右臂丛束Cords,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Lateral cord(C05-C07),R",
                                                            "c": "臂丛外侧束Lateral cord (C05-C07),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "臂丛外侧束：由臂丛上、中两干的前股纤维合成的神经束。于腋窝中部行于腋动脉的外侧。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Medial cord(C08,T01),R",
                                                            "c": "臂丛内侧束Medial cord (C08,T01),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "臂丛内侧束：由臂丛下干前股的纤维独自构成的神经束。在腋窝中部行于腋动脉的内侧。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Posterior cord(C05-T01),R",
                                                            "c": "臂丛后束Posterior cord (C05-T01),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "臂丛后束：由臂丛上、中、下3干后股合成的神经束，在腋窝中部，向外行于腋动脉后方。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "05Supraclavicular branches of cords,R",
                                                    "c": "右锁骨上分支Supraclavicular branches of cords,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Dorsal scapular(C03-C05),R",
                                                            "c": "肩胛背神经Dorsal scapular,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肩胛背神经：主要发自第五颈神经前支，发出后，穿中斜角肌向后越过肩胛提肌，在肩胛骨内侧缘和脊柱之间下行，分布至菱形肌和肩胛提肌。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Long thoracic(C05-C07),R",
                                                            "c": "胸长神经Long thoracic (C05-C07),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸长神经：(C5-C7)在臂丛主要结构的后方斜向外下行至前锯肌表面，分布于该肌和乳房外侧份。此神经的损伤可致前锯肌瘫痪，出现以肩胛骨内侧缘翘起为特征的“翼状肩”体征。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Nerve to the subclavius(C05,C06),R",
                                                            "c": "锁骨下肌神经Nerve to the subclavius (C05,C06),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "锁骨下肌神经：发自颈5、6神经根，支配锁骨下肌的神经。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Suprascapular(C04-C06),R",
                                                            "c": "肩胛上神经Suprascapular (C04-C06),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肩胛上神经：发自臂丛上干，向后进入冈上窝、冈下窝，分布于冈上肌、冈下肌和肩关节的神经。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "06Infraclavicular branches of cords,R",
                                                    "c": "右锁骨下分支Infraclavicular branches of cords,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Branches of lateral cord,R",
                                                            "c": "右外侧束分支Branches of lateral cord,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Anterior interosseous,R",
                                                                    "c": "骨间前神经Anterior interosseous,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "骨间前神经：正中神经在前臂深层的分支。分布于指深屈肌桡侧半、拇长屈肌、旋前方肌及和附近关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Common palmar digital,R",
                                                                    "c": "正中神经指掌侧总神经Common palmar digital,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "正中神经指掌侧总神经：正中神经在掌部的终支。有3条，其分支主要分布于第一、二蚓状肌，桡侧3个半指掌面的皮肤及食指、中指末节指背面皮肤。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Lateral pectoral(C05-C07),R",
                                                                    "c": "胸外侧神经Lateral pectoral (C05-C07),R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "胸外侧神经：(C5-C7)自臂丛外侧束发出，跨过腋动、静脉的前方，穿锁胸筋膜后行于胸大肌深面，并分布至该肌。在走行过程中，此神经尚发出一支与胸内侧神经汇合，分布于胸小肌。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Median(C06-T01),R",
                                                                    "c": "正中神经Median (C06-T01),R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "正中神经：(C6-T1)臂丛内侧束的内侧根和臂丛外侧束的外侧根在腋动脉前方汇合为正中神经主干后，先于肱动脉的外侧下行，至喙肱肌止点处，斜越动脉浅面或深面转至动脉的内侧，继而伴随同名血管一起降至肘窝。经肘窝向下至前臂，穿旋前圆肌和指浅屈肌腱弓在前臂正中下行，于指浅、深屈肌之间到达腕部。在腕部正中神经于桡侧腕屈肌腱和掌长肌键之间穿经腕管，在掌腱膜深面分支分布于手掌。\r\n                                                                    正中神经在臂部不发出分支，在肘部及前臂发出较多肌支，其中骨间前神经较粗大，行程较长，沿前臂骨间膜前面下行。正中神经主干在前臂发支支配除肱桡肌、尺侧腕屈肌和指深屈肌尺侧半以外的所有前臂屈肌和旋前肌。在手部屈肌支持带的下方正中神经发出一粗短的返支，于桡动脉掌浅支外侧进入鱼际，支配除拇收肌以外的鱼际肌群。在手掌区，正中神经发出数条指掌侧总神经，每一条指掌侧总神经下行至掌骨头附近又分为两支指掌侧固有神经，后者沿手指的相对缘行至指尖。正中神经在手部的分布可概括为：运动纤维支配第1、2蚓状肌和鱼际肌（拇收肌除外）；感觉纤维则分布于桡侧半手掌、桡侧三个半手指掌面皮肤及其中节和远节指背皮肤。\r\n                                                                    前臂和腕部外伤时常累及正中神经，此时出现该神经分布区的功能障碍。旋前肌综合征表现为该神经所支配的肌收缩无力和手掌感觉障碍；腕管综合征表现为鱼际肌萎缩，手掌变平呈“猿掌”，同时桡侧三个半手指掌面皮肤及桡侧半手掌出现感觉障碍。 在肱二头肌内侧沟上端肱动脉的搏动处确定一点，在肘部肱骨内、外上髁间连线中点稍内侧确定另一点，此二点之间的连线即为正中神经在臂部的投影线。将此投影线延至腕部桡侧腕屈肌腱与掌长肌腱连线的中点，即为正中神经在前臂的投影线。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Median,lateral root,R",
                                                                    "c": "正中神经外侧根Median,lateral root,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "正中神经外侧根：发自臂丛外侧束的正中神经纤维。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Musculocutaneous(C05-C07),R",
                                                                    "c": "肌皮神经Musculocutaneous (C05-C07),R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "肌皮神经：(C5-C7)发自臂丛外侧束，向外下方走行斜穿喙肱肌，后于肱二头肌与肱肌之间下行，沿途发支支配以上三肌。在肘关节稍下方，部分纤维从肱二头肌下端外侧穿出深筋膜，分布于前臂外侧份的皮肤，称为前臂外侧皮神经。肱骨上中段骨折时可导致该神经的损伤，表现为屈肘无力以及前臂外侧部皮肤感觉的减弱。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Palmar digital(median),R",
                                                                    "c": "正中神经指掌侧固有神经Palmar digital (median),R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "正中神经指掌侧固有神经：指掌侧总神经在掌骨头处分出的终支。一般分布于相邻两指相对缘的皮肤，尚分布于末节指背面皮肤。"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Branches of medial cord,R",
                                                            "c": "右内侧束分支Branches of medial cord,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Deep branch of ulnar,R",
                                                                    "c": "尺神经深支Deep branch of ulnar,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "尺神经深支：尺神经终支之一。支配小鱼际肌、拇收肌、第三、四蚓状肌和全部骨间肌。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Dorsal digital(ulnar),R",
                                                                    "c": "尺神经指背神经Dorsal digital (ulnar),R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "尺神经指背神经：尺神经的终支。分布于尺侧2个半指背面的皮肤（中指远节除外）。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Medial antebrachial cutaneous(C08,T01),R",
                                                                    "c": "前臂内侧皮神经Medial antebrachial cutaneous (C08,T01),R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "前臂内侧皮神经：发自臂丛内侧束的神经。分前、后两支。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Medial brachial cutaneous(T01),R",
                                                                    "c": "臂内侧皮神经Medial brachial cutaneous (T01),R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "臂内侧皮神经：发自臂丛内侧束，分布于臂前内侧面皮肤的神经。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Medial pectoral(C08,T01),R",
                                                                    "c": "胸内侧神经Medial pectoral (C08,T01),R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "胸内侧神经：发自臂丛内侧束，常与胸外侧神经分支联合，分布于胸小肌和部分胸大肌的神经。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Median,medial root,R",
                                                                    "c": "正中神经内侧根Median,medial root,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "正中神经内侧根：发自臂丛内侧束的正中神经纤维。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Palmar digital(ulnar),R",
                                                                    "c": "尺神经指掌侧固有神经Palmar digital (ulnar),R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "尺神经指掌侧固有神经：尺神经的浅支。共有3条，分布于第四、五指的相对缘和第五指尺侧缘皮肤。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Ulnar(C08,T01),R",
                                                                    "c": "尺神经Ulnar (C08,T01),R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "尺神经：自臂丛内侧束发出后，经腋动、静脉之间出腋窝，先在肱二头肌内侧沟内肱动脉内侧下行至臂中份，继而穿内侧肌间隔至臂后区内侧继续下行入肱骨内上髁后方的尺神经沟。在此尺神经由后向前穿过尺侧腕屈肌的起点，行至前臂前内侧份，伴随尺动脉于尺侧腕屈肌与指深屈肌之间下行至桡腕关节上方发出手背支，主干在豌豆骨桡侧，屈肌支持带浅面分为浅支和深支。这些分支在掌腱膜深面、腕横韧带浅面进入手掌。\r\n                                                                    尺神经在臂部不发出分支，于前臂上部发肌支支配尺侧腕屈肌和指深屈肌尺侧半。其手背支从腕部伸肌支持带浅面转行至手背部，发支分布于手背尺侧半和小指、环指及中指尺侧半背面皮肤。浅支分布于小鱼际表面的皮肤、小指掌面皮肤和环指尺侧半掌面皮肤。深支分布于小鱼际肌、拇收肌、骨间掌侧肌、骨间背侧肌及第3、4蚓状肌。\r\n                                                                    尺神经在肘部肱骨内上髁后方、尺侧腕屈肌起点处和豌豆骨外侧较易受到损伤。尺神经在上两个部位受到损伤时，运动障碍主要表现为屈腕力减弱，环指和小指远节指关节不能屈曲，小鱼际肌和骨间肌萎缩，拇指不能内收，各指不能相互靠拢。同时，各掌指关节过伸，掌骨间呈现深凹，表现为“爪形手”。感觉障碍则表现为手掌和手背内侧缘皮肤感觉丧失。在豌豆骨处受损后主要表现为骨间肌的运动障碍。\r\n                                                                    自胸大肌下缘肱动脉搏动点开始，向下内侧到肱骨内上髁与鹰嘴之间的连线为尺神经在臂部的投影线。将此线在前臂的尺侧延至豌豆骨的外侧，则为尺神经在前臂的投影线。尺神经在肱骨内上髁后方的尺神经沟内位置最浅，容易触及。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Ulnar,communicating branch,R",
                                                                    "c": "尺神经交通支Ulnar,communicating branch,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": ""
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Ulnar,dorsal branch,R",
                                                                    "c": "尺神经手背支Ulnar,dorsal branch,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "尺神经手背支：在桡腕关节上方发出的尺神经分支。分布于手背尺侧，并分出3条指背神经。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Ulnar,superficial branch,R",
                                                                    "c": "尺神经浅支Ulnar,superficial branch,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "尺神经浅支：尺神经的皮支。分出1支指掌侧总神经和1支指掌侧固有神经。"
                                                                }
                                                            }]
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Branches of posterior cord,R",
                                                            "c": "右后束分支Branches of posterior cord,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Axillary(C05,C06),R",
                                                                    "c": "腋神经Axillary (C05,C06),R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "腋神经：(C5、C6)从臂丛后束发出，伴旋肱后血管向后外方向走行，穿过四边孔后，绕肱骨外科颈至三角肌深面，发支支配三角肌和小圆肌。部分纤维自三角肌后缘浅出后延为皮神经，分布于肩部和臂外侧区上部的皮肤，称为臂外侧上皮神经。肱骨外科颈骨折、肩关节脱位和使用腋杖不当所致的重压，常造成腋神经的损伤，体征为臂不能外展，臂部旋外力减弱，肩部和臂外上部皮肤感觉障碍。神经损伤致三角肌萎缩，患者肩部亦失去圆隆的外形。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Deep branch of radial,R",
                                                                    "c": "桡神经深支Deep branch of radial,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "桡神经深支：又称“骨间后神经”。桡神经终支之一。穿旋后肌至前臂后，分布于前臂后群肌及附近关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Dorsal digital(radial),R",
                                                                    "c": "桡神经指背神经Dorsal digital (radial),R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "桡神经指背神经：桡神经浅支手背区的4-5条分支。分布于桡侧2个半指近、中节背面的皮肤。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Lower subscapular(C05-C06),R",
                                                                    "c": "下肩胛下神经Lower subscapular (C05-C06),R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "肩胛下神经：发自臂丛的后束，常分为上支和下支，分别进入肩胛下肌和大圆肌，支配该二肌的运动。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Posterior interosseous,R",
                                                                    "c": "骨间后神经Posterior interosseous,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "骨间后神经：桡神经终支之一。穿旋后肌至前臂后，分布于前臂后群肌及附近关节。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Radial(C05-T01),R",
                                                                    "c": "桡神经Radial (C05-T01),R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "桡神经：发自臂丛后束，始位于腋动脉的后方，与肱深动脉伴行，经肱三头肌长头和内侧头之间下行，沿桡神经沟绕肱骨中段后面旋行向外下，至肱骨外上髁稍上方穿过外侧肌间隔达肱肌与肱桡肌之间，后继续于肱桡肌与桡侧腕长伸肌之间在前臂下行。桡神经在臂部发出较多分支，其中肌支主要分布于肱三头肌、肘肌、肱桡肌和桡侧腕长伸肌。关节支分布于肘关节。皮支共有三支：臂后皮神经在腋窝发出后分布于臂后区的皮肤；臂外侧下皮神经在三角肌止点远侧浅出，分布于臂下外侧部的皮肤；前臂后皮神经自臂中份外侧浅出下行至前臂后面，直达腕部，沿途分支分布于前臂后面皮肤。\r\n                                                                    在肱骨外上髁前方桡神经分为浅支和深支两终末支。桡神经浅支为皮支，自肱骨外上髁前外侧向下沿桡动脉外侧下行，在前臂中、下1/3交界处转向背侧，继续下行至手背部，分为4-5支指背神经，分布于手背桡侧半皮肤和桡侧三个半手指近节背面的皮肤。深支较浅支粗大，主要为肌支。该支在桡骨颈外侧穿过旋后肌至前臂后面，在前臂浅、深伸肌群之间下行达腕关节背面，沿途发支分布于前臂伸肌群、桡尺远侧关节、桡腕关节和掌骨间关节。因其走行及分布的特点，深支又被称为骨间后神经。\r\n                                                                    桡神经在肱骨中段紧贴桡神经沟骨面走行，肱骨中段或中、下1/3交界处骨折容易合并桡神经的损伤，导致前臂伸肌群的瘫痪，表现为抬前臂时呈“垂腕”状，同时第1、2掌骨间背面皮肤感觉障碍明显。桡骨颈骨折时，可损伤桡神经深支，出现伸腕无力，不能伸指等症状。 自腋后襞下缘外侧端与臂相交处斜向外下连于肱骨外上髁，此连线即为桡神经在臂背侧面的投影。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Radial,superficial branch,R",
                                                                    "c": "桡神经浅支Radial,superficial branch,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "桡神经浅支：桡神经的终皮支。分出指背神经并与尺神经手背支的分支间有交通。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Thoracodorsal(middle subscapular,long subscapular)(C06-C08),R",
                                                                    "c": "胸背神经Thoracodorsal (C06-C08),R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "胸背神经(C6-C8)自臂丛后束发出，后沿肩胛骨外侧缘伴肩胛下血管下行，分支分布于背阔肌。乳腺癌根治术过程中清除淋巴结时，应注意勿伤及此神经。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Upper subscapular(C05-C06),R",
                                                                    "c": "上肩胛下神经Upper subscapular(C05-C06),R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "肩胛下神经：发自臂丛的后束，常分为上支和下支，分别进入肩胛下肌和大圆肌，支配该二肌的运动。"
                                                                }
                                                            }]
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Posterior branch(C5-C8),R",
                                                    "c": "右臂丛后支Posterior branch(C5-C8),R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C05 Dorsal ramus,lateral branch,R",
                                                            "c": "C05后支外侧支C05 Dorsal ramus,lateral branch,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支外侧支：颈神经后支的分支。主要分布于项背外侧区深层肌及皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C05 Dorsal ramus,medial branch,R",
                                                            "c": "C05后支内侧支C05 Dorsal ramus,medial branch,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支内侧支：颈神经后支的分支。主要分布于项背内侧区深层肌及皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C05 Dorsal ramus,R",
                                                            "c": "C05后支C05 Dorsal ramus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支：颈神经出椎间孔向后的分支。主要分布于项背部深层肌及该区皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C06 Dorsal ramus,lateral branch,R",
                                                            "c": "颈神经后支外侧支C06 Dorsal ramus,lateral branch,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支外侧支：颈神经后支的分支。主要分布于项背外侧区深层肌及皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C06 Dorsal ramus,medial branch,R",
                                                            "c": "C06后支内侧支C06 Dorsal ramus,medial branch,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支内侧支：颈神经后支的分支。主要分布于项背内侧区深层肌及皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C06 Dorsal ramus,R",
                                                            "c": "C06后支C06 Dorsal ramus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支：颈神经出椎间孔向后的分支。主要分布于项背部深层肌及该区皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C07 Dorsal ramus,lateral branch,R",
                                                            "c": "C07后支外侧支C07 Dorsal ramus,lateral branch,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支外侧支：颈神经后支的分支。主要分布于项背外侧区深层肌及皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C07 Dorsal ramus,medial branch,R",
                                                            "c": "C07后支内侧支C07 Dorsal ramus,medial branch,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支内侧支：颈神经后支的分支。主要分布于项背内侧区深层肌及皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C07 Dorsal ramus,R",
                                                            "c": "C07后支C07 Dorsal ramus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支：颈神经出椎间孔向后的分支。主要分布于项背部深层肌及该区皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C08 Dorsal ramus,lateral branch,R",
                                                            "c": "C08后支外侧支C08 Dorsal ramus,lateral branch,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支外侧支：颈神经后支的分支。主要分布于项背外侧区深层肌及皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C08 Dorsal ramus,medial branch,R",
                                                            "c": "C07后支内侧支C08 Dorsal ramus,medial branch,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支内侧支：颈神经后支的分支。主要分布于项背内侧区深层肌及皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "C08 Dorsal ramus,R",
                                                            "c": "C08后支C08 Dorsal ramus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "颈神经后支：颈神经出椎间孔向后的分支。主要分布于项背部深层肌及该区皮肤。"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "03Thoracic nerves",
                                    "c": "胸神经Thoracic nerves"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Thoracic nerves,L",
                                            "c": "左胸神经Thoracic nerves,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Root,L",
                                                    "c": "左根Root,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T01 Root,L",
                                                            "c": "T01左根T01 Root"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T02 Root,L",
                                                            "c": "T02左根T02 Root,L"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T03 Root,L",
                                                            "c": "T03左根T03 Root,L"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T04 Root,L",
                                                            "c": "T04左根T04 Root,L"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T05 Root,L",
                                                            "c": "T05左根T05 Root,L"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T06 Root,L",
                                                            "c": "T06左根T06 Root,L"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T07 Root,L",
                                                            "c": "T07左根T07 Root,L"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T08 Root,L",
                                                            "c": "T08左根T08 Root,L"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T09 Root,L",
                                                            "c": "T09左根T09 Root,L"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T10 Root,L",
                                                            "c": "T10左根T10 Root,L"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T11 Root,L",
                                                            "c": "T11左根T11 Root,L"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T12 Root,L",
                                                            "c": "T12左根T12 Root,L"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Intercostal nerve,L",
                                                    "c": "左肋间神经Intercostal nerve,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T01 Intercostal nerve,L",
                                                            "c": "T01肋间神经T01 Intercostal nerve,L"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T02 Intercostal nerve,L",
                                                            "c": "T02肋间神经T02 Intercostal nerve,L"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T03 Intercostal nerve,L",
                                                            "c": "T03肋间神经T03 Intercostal nerve,L"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T04 Intercostal nerve,L",
                                                            "c": "T04肋间神经T04 Intercostal nerve,L"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T05 Intercostal nerve,L",
                                                            "c": "T05肋间神经T05 Intercostal nerve,L"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T06 Intercostal nerve,L",
                                                            "c": "T06肋间神经T06 Intercostal nerve,L"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T07 Intercostal nerve,L",
                                                            "c": "T07肋间神经T07 Intercostal nerve,L"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T08 Intercostal nerve,L",
                                                            "c": "T08肋间神经T08 Intercostal nerve,L"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T09 Intercostal nerve,L",
                                                            "c": "T09肋间神经T09 Intercostal nerve,L"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T10 Intercostal nerve,L",
                                                            "c": "T10外侧皮支T10 Intercostal nerve,L"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T11 Intercostal nerve,L",
                                                            "c": "T11外侧皮支T11 Intercostal nerve,L"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "03Subcostal nerve,L",
                                                    "c": "左肋下神经Subcostal nerve,L"
                                                },
                                                "ch":
                                                {
                                                    "sub":
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_T12(subcostal) Spinal nerve(ventral ramus),L",
                                                            "c": "肋下神经前支T12(subcostal) Spinal nerve(ventral ramus),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肋下神经：第十二对胸神经的前支。沿第十二肋下向前下行，分布于腹壁肌、腹壁皮肤及相应区腹膜壁层。"
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "04Posterior branch of thoracic nerve,L",
                                                    "c": "左胸神经后支Posterior branch of thoracic nerve,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T01 Dorsal ramus,L",
                                                            "c": "T01后支T01 Dorsal ramus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸神经后支：胸神经向后的分支。多贴关节突后行，为混合性，一般分为内侧支和外侧支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T02 Dorsal ramus,L",
                                                            "c": "T02后支T02 Dorsal ramus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸神经后支：胸神经向后的分支。多贴关节突后行，为混合性，一般分为内侧支和外侧支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T03 Dorsal ramus,L",
                                                            "c": "T03后支T03 Dorsal ramus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸神经后支：胸神经向后的分支。多贴关节突后行，为混合性，一般分为内侧支和外侧支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T04 Dorsal ramus,L",
                                                            "c": "T04后支T04 Dorsal ramus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸神经后支：胸神经向后的分支。多贴关节突后行，为混合性，一般分为内侧支和外侧支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T05 Dorsal ramus,L",
                                                            "c": "T05后支T05 Dorsal ramus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸神经后支：胸神经向后的分支。多贴关节突后行，为混合性，一般分为内侧支和外侧支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T06 Dorsal ramus,L",
                                                            "c": "T06后支T06 Dorsal ramus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸神经后支：胸神经向后的分支。多贴关节突后行，为混合性，一般分为内侧支和外侧支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T07 Dorsal ramus,L",
                                                            "c": "T07后支T07 Dorsal ramus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸神经后支：胸神经向后的分支。多贴关节突后行，为混合性，一般分为内侧支和外侧支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T08 Dorsal ramus,L",
                                                            "c": "T08后支T08 Dorsal ramus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸神经后支：胸神经向后的分支。多贴关节突后行，为混合性，一般分为内侧支和外侧支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T09 Dorsal ramus,L",
                                                            "c": "T09后支T09 Dorsal ramus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸神经后支：胸神经向后的分支。多贴关节突后行，为混合性，一般分为内侧支和外侧支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T10 Dorsal ramus,L",
                                                            "c": "T10后支T10 Dorsal ramus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸神经后支：胸神经向后的分支。多贴关节突后行，为混合性，一般分为内侧支和外侧支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T11 Dorsal ramus,L",
                                                            "c": "T11后支T11 Dorsal ramus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸神经后支：胸神经向后的分支。多贴关节突后行，为混合性，一般分为内侧支和外侧支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T12 Dorsal ramus,L",
                                                            "c": "T12后支T12 Dorsal ramus,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸神经后支：胸神经向后的分支。多贴关节突后行，为混合性，一般分为内侧支和外侧支。"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Thoracic nerves,R",
                                            "c": "右胸神经Thoracic nerves,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "01Root,R",
                                                    "c": "右根Root,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T01 Root,R",
                                                            "c": "T01右根Root,R"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T02 Root,R",
                                                            "c": "T02右根T02 Root,R"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T03 Root,R",
                                                            "c": "T03右根T03 Root,R"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T04 Root,R",
                                                            "c": "T04右根T04 Root,R"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T05 Root,R",
                                                            "c": "T05右根T05 Root,R"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T06 Root,R",
                                                            "c": "T06右根T06 Root,R"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T07 Root,R",
                                                            "c": "T07右根T07 Root,R"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T08 Root,R",
                                                            "c": "T08右根T08 Root,R"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T09 Root,R",
                                                            "c": "T09右根T09 Root,R"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T10 Root,R",
                                                            "c": "T10右根T10 Root,R"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T11 Root,R",
                                                            "c": "T11右根T11 Root,R"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T12 Root,R",
                                                            "c": "T12前根T12 Root,R"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "02Intercostal nerve,R",
                                                    "c": "右肋间神经Intercostal nerve,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T01 Intercostal nerve,R",
                                                            "c": "T01前支T01 Intercostal nerve,R"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T02 Intercostal nerve,R",
                                                            "c": "T02前支T02 Intercostal nerve,R"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T03 Intercostal nerve,R",
                                                            "c": "T03前支T03 Intercostal nerve,R"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T04 Intercostal nerve,R",
                                                            "c": "T04前支T04 Intercostal nerve,R"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T05 Intercostal nerve,R",
                                                            "c": "T05前支T05 Intercostal nerve,R"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T06 Intercostal nerve,R",
                                                            "c": "T06前支T06 Intercostal nerve,R"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T07 Intercostal nerve,R",
                                                            "c": "T07前支T07 Intercostal nerve,R"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T08 Intercostal nerve,R",
                                                            "c": "T08前支T08 Intercostal nerve,R"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T09 Intercostal nerve,R",
                                                            "c": "T09前支T09 Intercostal nerve,R"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T10 Intercostal nerve,R",
                                                            "c": "T10外侧皮支T10 Intercostal nerve,R"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T11 Intercostal nerve,R",
                                                            "c": "T11外侧皮支T11 Intercostal nerve,R"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "03Subcostal nerve,R",
                                                    "c": "右肋下神经Subcostal nerve,R"
                                                },
                                                "ch":
                                                {
                                                    "sub":
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_T12(subcostal) Spinal nerve(ventral ramus),R",
                                                            "c": "肋下神经前支T12(subcostal) Spinal nerve(ventral ramus),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肋下神经：第十二对胸神经的前支。沿第十二肋下向前下行，分布于腹壁肌、腹壁皮肤及相应区腹膜壁层。"
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "04Posterior branch of thoracic nerve,R",
                                                    "c": "右胸神经后支Posterior branch of thoracic nerve,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T01 Dorsal ramus,R",
                                                            "c": "T01后支T01 Dorsal ramus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸神经后支：胸神经向后的分支。多贴关节突后行，为混合性，一般分为内侧支和外侧支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T02 Dorsal ramus,R",
                                                            "c": "T02后支T02 Dorsal ramus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸神经后支：胸神经向后的分支。多贴关节突后行，为混合性，一般分为内侧支和外侧支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T03 Dorsal ramus,R",
                                                            "c": "T03后支T03 Dorsal ramus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸神经后支：胸神经向后的分支。多贴关节突后行，为混合性，一般分为内侧支和外侧支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T04 Dorsal ramus,R",
                                                            "c": "T04后支T04 Dorsal ramus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸神经后支：胸神经向后的分支。多贴关节突后行，为混合性，一般分为内侧支和外侧支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T05 Dorsal ramus,R",
                                                            "c": "T05后支T05 Dorsal ramus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸神经后支：胸神经向后的分支。多贴关节突后行，为混合性，一般分为内侧支和外侧支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T06 Dorsal ramus,R",
                                                            "c": "T06后支T06 Dorsal ramus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸神经后支：胸神经向后的分支。多贴关节突后行，为混合性，一般分为内侧支和外侧支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T07 Dorsal ramus,R",
                                                            "c": "T07后支T07 Dorsal ramus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸神经后支：胸神经向后的分支。多贴关节突后行，为混合性，一般分为内侧支和外侧支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T08 Dorsal ramus,R",
                                                            "c": "T08后支T08 Dorsal ramus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸神经后支：胸神经向后的分支。多贴关节突后行，为混合性，一般分为内侧支和外侧支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T09 Dorsal ramus,R",
                                                            "c": "T09后支T09 Dorsal ramus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸神经后支：胸神经向后的分支。多贴关节突后行，为混合性，一般分为内侧支和外侧支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T10 Dorsal ramus,R",
                                                            "c": "T10后支T10 Dorsal ramus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸神经后支：胸神经向后的分支。多贴关节突后行，为混合性，一般分为内侧支和外侧支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T11 Dorsal ramus,R",
                                                            "c": "T11后支T11 Dorsal ramus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸神经后支：胸神经向后的分支。多贴关节突后行，为混合性，一般分为内侧支和外侧支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "T12 Dorsal ramus,R",
                                                            "c": "T12后支T12 Dorsal ramus,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胸神经后支：胸神经向后的分支。多贴关节突后行，为混合性，一般分为内侧支和外侧支。"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "04Lumbosacral plexus and lower limb",
                                    "c": "腰骶丛Lumbosacral plexus and lower limb"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Lumbosacral plexus and lower limb,L",
                                            "c": "左腰骶丛及其分支Lumbosacral plexus and lower limb,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "L01 Spinal nerve,L",
                                                    "c": "L01腰神经L01 Spinal nerve,L"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "L02 Spinal nerve,L",
                                                    "c": "L02腰神经L02 Spinal nerve,L"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "L03 Spinal nerve,L",
                                                    "c": "L03腰神经L03 Spinal nerve,L"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Lumbar plexus,L",
                                                    "c": "左腰丛Lumbar plexus,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Genitofemoral,femoral branch,L",
                                                            "c": "生殖股神经股支Genitofemoral,femoral branch,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "生殖股神经股支：于腹股沟韧带深面穿股鞘分布于股三角区皮肤的生殖股神经分支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Genitofemoral,L",
                                                            "c": "生殖股神经Genitofemoral,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "生殖股神经：发自腰丛，自腰大肌前面穿出后分成生殖支和股支的神经。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Anterior scrotal(branch of ilioinguinal),L",
                                                            "c": "阴囊前神经Anterior scrotal (branch of ilioinguinal),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "阴囊前神经：自髂腹股沟神经分出，分布于股内侧上部、阴茎根、阴囊上部皮肤的神经。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Femoral,L",
                                                            "c": "股神经Femoral,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "股神经：自腰大肌外侧缘发出后，在腰大肌和髂肌之间下行到达腹股沟区，在腹股沟韧带中点稍外侧从深面穿经该韧带，于股动脉的外侧进入大腿的股三角区，发出数条肌支分布于髂肌、耻骨肌、股四头肌和缝匠肌。股神经皮支中有行程较短的股中间皮神经和股内侧皮神经，分布于大腿和膝关节前面的皮肤区；皮支中最长的隐神经，伴随股动脉进入收肌管下行，于膝关节内侧缝匠肌下端的深面浅出至皮下，随后与大隐静脉伴行沿小腿内侧面下行至足内侧缘，沿途发支分布于膝关节、髌下、小腿内侧面及足内侧缘的皮肤。\r\n                                                            股神经受损后主要表现有：屈髋无力，坐位时不能伸膝，行走困难，膝跳反射消失，股四头肌萎缩，髌骨突出。大腿前面和小腿内侧面皮肤感觉障碍。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Genitofemoral,genital branch,L",
                                                            "c": "生殖股神经生殖支Genitofemoral,genital branch,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "生殖股神经生殖支：于腹股沟管深环处进入该管，分布于提睾肌和阴囊（女性随子宫圆韧带分布于大阴唇）的生殖股神经分支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Iliohypogastric,L",
                                                            "c": "髂腹下神经Iliohypogastric,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "髂腹下神经：自腰大肌外侧缘潜出，从肾和腰方肌之间行向外下方，在髂嵴后份上方开始由深向浅逐次穿经腹横肌、腹内斜肌和腹外斜肌，最后在腹股沟管浅环上方约3cm处穿腹外斜肌腱膜达皮下。沿途发支分布于腹前外侧肌群下份，亦有皮支分布于臀外侧区、腹股沟区及下腹部的皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Ilioinguinal,L",
                                                            "c": "髂腹股沟神经Ilioinguinal,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "髂腹股沟神经：在髂腹下神经下方从腰大肌外侧缘潜出，斜行跨过腰方肌和髂肌上部，在髂嵴前端附近穿腹横肌浅出，于腹横肌与腹内斜肌之间，继续前行入腹股沟管，与精索（子宫圆韧带）伴行，从腹股沟管浅环穿出。该支较髂腹下神经细小，其肌支沿途分布于附近的腹壁肌，皮支则分布于腹股沟部、阴囊或大阴唇的皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Lateral femoral cutaneous,L",
                                                            "c": "股外侧皮神经Lateral femoral cutaneous,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "股外侧皮神经：从腰大肌外侧缘穿出后，向前外侧走行，横过髂肌表面至髂前上棘稍内侧，经腹股沟韧带深面进入股部。在髂前上棘下方约5-6cm处，该神经支穿出深筋膜分布于大腿前外侧份的皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Obturator,L",
                                                            "c": "闭孔神经Obturator,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "闭孔神经：自腰大肌内侧缘潜出后下行人盆腔，紧贴盆腔侧壁前行，与闭孔血管伴行穿闭膜管出盆腔，至股内侧区分为前、后两支，分别在短收肌的前、后方浅出。闭孔神经发出的肌支主要支配闭孔外肌、长收肌、短收肌、大收肌和股薄肌，偶见发支至耻骨肌；其皮支主要分布于大腿内侧份皮肤。闭孔神经亦有细小分支分布于髋关节和膝关节。 闭孔神经损伤后体征为大腿不能内收，患肢不能置于健侧腿上，股内侧区皮肤感觉不明显。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Saphenous,L",
                                                            "c": "隐神经Saphenous,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "隐神经：股神经发出的最长皮支。穿收肌管，伴大隐静脉，分布于膝下、小腿前内侧及足内侧缘皮肤。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Anococcygeal,L",
                                                    "c": "肛尾神经Anococcygeal,L"
                                                },
                                                "t":
                                                {
                                                    "s": "肛尾神经：由尾丛发出，分布于尾骨附近皮肤的神经。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Coccygeal,L",
                                                    "c": "尾神经Coccygeal,L"
                                                },
                                                "t":
                                                {
                                                    "s": "尾神经：最下一对脊神经。出骶管裂孔，与第四、五骶神经有交通。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_L04 Spinal nerve,L",
                                                    "c": "L04腰神经L04 Spinal nerve,L"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_L05 Spinal nerve,L",
                                                    "c": "L05腰神经L05 Spinal nerve,L"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Medial clunial(cluneal),L",
                                                    "c": "臀内侧皮神经Medial clunial(cluneal),L"
                                                },
                                                "t":
                                                {
                                                    "s": "臀内侧皮神经：为1-3骶神经后支，较细小，在髂后上棘至尾骨尖连线的中段穿出，分布于骶骨表面和臀内侧皮肤。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Nerve to levator ani,L",
                                                    "c": "肛提肌神经Nerve to levator ani,L"
                                                },
                                                "t":
                                                {
                                                    "s": ""
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_S01 Spinal nerve,L",
                                                    "c": "S01骶神经S01 Spinal nerve,L"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_S02 Spinal nerve,L",
                                                    "c": "S02骶神经S02 Spinal nerve,L"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_S03 Spinal nerve,L",
                                                    "c": "S03骶神经S03 Spinal nerve,L"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_S04 Spinal nerve,L",
                                                    "c": "S04骶神经S04 Spinal nerve,L"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_S05 Spinal nerve,L",
                                                    "c": "S05骶神经S05 Spinal nerve,L"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Superior clunial(cluneal),L",
                                                    "c": "臀上皮神经Superior clunial (cluneal),L"
                                                },
                                                "t":
                                                {
                                                    "s": "臀上皮神经：由第1-3腰神经后支的外侧支组成，在第3、4腰椎棘突平面穿出竖脊肌外缘，行与竖脊肌与髂嵴交点处的骨纤维管后至臀部皮下。臀上皮神经一般有3支，以中支最长，有时可达臀沟。腰部急性扭伤或神经在骨纤维管处受压时，可引起腰腿疼痛。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Sacral plexus,L",
                                                    "c": "骶丛Sacral plexus,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Inferior clunial(cluneal),L",
                                                            "c": "臀下皮神经Inferior clunial (cluneal),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "臀下皮神经：发自股后皮神经，绕臀大肌下缘至臀下部皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Lumbosacral trunk,L",
                                                            "c": "腰骶干Lumbosacral trunk,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腰骶干：由第4腰神经前支的部分纤维和第5腰神经前支的所有纤维在腰丛下方合成，随后下行进入小骨盆，加入骶丛。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Dorsal penile nerve(branch of pudendal),L",
                                                            "c": "阴茎背神经Dorsal penile nerve (branch of pudendal),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "阴茎背神经：阴部神经的终支。向前行至阴茎背面和阴茎头包皮及阴茎海绵体。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Inferior gluteal,L",
                                                            "c": "臀下神经Inferior gluteal,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "臀下神经:骶丛的分支。经梨状肌下孔出骨盆，分布于臀大肌及髋关节。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Inferior rectal,L",
                                                            "c": "直肠下神经Inferior rectal,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肛神经:又称“直肠下神经”。阴部神经的分支。分布于肛门外括约肌、肛管下部和肛门周围的皮肤"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Perineal,L",
                                                            "c": "会阴神经Perineal,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "会阴神经：阴部神经的分支。向前行分支分布于会阴诸肌和外生殖器。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Posterior femoral cutaneous,L",
                                                            "c": "股后皮神经Posterior femoral cutaneous,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "股后皮神经：骶丛的分支。经梨状肌下孔出骨盆，分布于臀下部、股后区及腘窝处的皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Posterior scrotal,L",
                                                            "c": "阴囊后神经Posterior scrotal,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "阴囊后神经：会阴神经的皮支。分布于阴囊皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Pudendal,L",
                                                            "c": "阴部神经Pudendal,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "阴部神经：从骶丛发出后伴随阴部内血管穿梨状肌下孔至臀部，绕坐骨棘经坐骨小孔进入会阴部的坐骨肛门窝。在阴部管内紧贴坐骨肛门窝外侧壁前行，由后向前穿过肛三角和尿生殖三角，沿途发支分布于会阴部的肌群和皮肤以及外生殖器的皮肤。该神经干在会阴部的主要分支有：肛神经（直肠下神经）、会阴神经和阴茎（阴蒂）背神经。肛神经分布于肛门外括约肌和肛门部皮肤；会阴神经与阴部血管伴行分布于会阴诸肌以及阴囊或大阴唇的皮肤；阴茎背神经或阴蒂背神经行于阴茎或阴蒂的背侧，分布于阴茎或阴蒂的海绵体及皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Superior gluteal,L",
                                                            "c": "臀上神经Superior gluteal,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "臀上神经：离开骶丛后，伴臀上血管经梨状肌上孔出盆腔至臀部，行于臀中、小肌之间，其主干分为上、下两支，分布于臀中肌、臀小肌和阔筋膜张肌。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Nerve to quadratus femoris,L",
                                                            "c": "股方肌神经Nerve to quadratus femoris,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "股方肌神经：骶丛直接分出至股方肌的神经。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Sciatic nerve and branches,L",
                                                            "c": "左坐骨神经及其分支Sciatic nerve and branches,L"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Sciatic,L",
                                                                    "c": "坐骨神经Sciatic,L"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "坐骨神经：为全身最粗大，行程最长的神经。坐骨神经经梨状肌下孔出盆腔至臀大肌深面，在坐骨结节与大转子连线的中点深面下行入股后区，继而行于股二头肌长头的深面，达腘窝上角处分为胫神经和腓总神经两大终支。坐骨神经在股后区发肌支支配股二头肌、半腱肌和半膜肌，同时也有分支至髋关节。 从坐骨结节与大转子连线的中点开始，向下至股骨内、外侧髁连线的中点作一直线，此两点间连线的上2/3段即为坐骨神经在股后区的投影线。坐骨神经痛时，此连线常出现压痛。\r\n                                                                    坐骨神经的变异较常见。根据国人的统计资料，坐骨神经以单干形式从梨状肌下孔出盆腔者占66.3%，为最常见的形式，而以其他形式出盆腔者则占33.7%。所谓其他形式，包括；①以单干穿梨状肌出盆腔者；②神经干分为两支，一支穿梨状肌，另一支穿梨状肌下孔出盆腔者；③神经干分为两支，一支穿梨状肌上孔，另一支穿梨状肌下孔出盆腔者。在以上三种变异形式中，单干穿梨状肌出盆腔者，对坐骨神经的不利影响最大。坐骨神经长年受梨状肌收缩的压迫，神经干的血液供应因此受到影响，最后出现功能障碍，临床称为“梨状肌综合征”。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Tibial nerve,L",
                                                                    "c": "胫神经Tibial nerve,L"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "5th Dorsal digital,L",
                                                                            "c": "第五趾背神经5th Dorsal digital,L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": ""
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Commom plantar digital,L",
                                                                            "c": "趾足底总神经Commom plantar digital,L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": ""
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Lateral plantar,L",
                                                                            "c": "足底外侧神经Lateral plantar,L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "足底外侧神经：胫神经在足底的又一终支。行向足底前外侧，分为浅支和深支。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Medial plantar,L",
                                                                            "c": "足底内侧神经Medial plantar,L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "足底内侧神经：由胫神经穿分裂韧带深面时发出的分支。前行入足底，分布于拇展肌、趾短屈肌、短屈肌、第一蚓状肌及足底内侧半皮肤。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Medial sural cutaneous,L",
                                                                            "c": "腓肠内侧皮神经Medial sural cutaneous,L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "腓肠内侧皮神经：胫神经的皮支。沿腓肠肌两头间的沟内下行，参与构成腓肠神经。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Proper plantar digital,L",
                                                                            "c": "趾足底固有神经Proper plantar digital,L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": ""
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Sural,L",
                                                                            "c": "腓肠神经Sural,L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "腓肠神经：多由腓肠内侧皮神经和腓神经交通支于小腿后区下部吻合而成，穿出深筋膜后，经外踝后方达足背外侧，分布于小腿后区下部及足背外侧的皮肤。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Tibial,L",
                                                                            "c": "胫神经Tibial,L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "胫神经(L4、L5、S1-S3)：为坐骨神经本干的延续，下行进入腘窝，与位于深面的腘血管相伴继续下行至小腿后区、比目鱼肌深面，后伴随胫后血管行至内踝后方，最后在屈肌支持带深面的踝管内分为足底内侧神经和足底外侧神经，两终支进入足底。足底内侧神经在拇展肌深面、趾短屈肌内侧前行，分支分布于足底内侧肌群，足底内侧半皮肤及内侧三个半足趾跖面皮肤。足底外侧神经在拇展肌和趾短屈肌深面行至足底外侧，发支分布于足底中间群肌和外侧群肌，以及足底外侧半皮肤和外侧一个半趾跖面皮肤。\r\n                                                                            胫神经在腘窝和小腿后区尚发出许多分支：其中肌支分布于小腿后群诸肌；皮支主要为腓肠内侧皮神经，该皮支伴小隐静脉下行，沿途分支分布于相应区域的皮肤，并在小腿下部与来自腓总神经的腓肠外侧皮神经吻合为腓肠神经。腓肠神经经外踝后方至足的外侧缘前行，分布于足背及小趾外侧缘皮肤；关节支则分布于膝关节和踝关节。\r\n                                                                            从股骨内、外侧髁连线中点向下连至内踝后方的下行直线可作为胫神经的体表投影线。胫神经损伤后主要表现为足不能跖屈，不能以足尖站立，内翻力减弱，伴发足底及足外侧缘皮肤感觉障碍。由于小腿后群肌功能障碍，收缩无力，结果导致小腿前外侧群肌的过度牵拉，使足呈背屈和外翻位，出现所谓“钩状足”畸形。"
                                                                        }
                                                                    }]
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Common peroneal nerve,L",
                                                                    "c": "左腓总神经Common peroneal nerve,L"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Common fibular(peroneal),L",
                                                                            "c": "腓总神经Common fibular (peroneal),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "腓总神经(L4、L5、S1、S2)：在腘窝上角由坐骨神经发出后，沿股二头肌肌腱内侧向外下走行，至小腿上段外侧绕腓骨颈向前穿腓骨长肌后，分为腓浅神经和腓深神经。腓总神经在腓骨颈处的位置非常表浅，易受损伤。受伤后表现为足不能背屈，趾不能伸，足下垂且内翻，呈“马蹄内翻足”畸形，行走时呈“跨阈步态”。同时小腿前、外侧面及足背区出现明显的感觉障碍。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Deep fibular(peroneal),L",
                                                                            "c": "腓深神经Deep fibular (peroneal),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "腓深神经：在足背区多数行于足背动脉的内侧，分成内、外两终支，分布于足背肌、足关节及第1、2趾相对侧背面的皮肤。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Deep fibular(peroneal),lateral branch,L",
                                                                            "c": "腓深神经外侧支Deep fibular (peroneal),lateral branch,L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "腓深神经：在足背区多数行于足背动脉的内侧，分成内、外两终支，分布于足背肌、足关节及第1、2趾相对侧背面的皮肤。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Deep fibular(peroneal),medial branch,L",
                                                                            "c": "腓深神经内侧支Deep fibular (peroneal),medial branch,L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "腓深神经：在足背区多数行于足背动脉的内侧，分成内、外两终支，分布于足背肌、足关节及第1、2趾相对侧背面的皮肤。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Dorsal digital,L",
                                                                            "c": "趾背神经Dorsal digital,L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": ""
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Lateral sural cutaneous,L",
                                                                            "c": "腓肠外侧皮神经Lateral sural cutaneous,L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "腓肠外侧皮神经：腓总神经在腘窝处的分支。分布于小腿外侧面皮肤。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Superficial fibular(peroneal),intermediate dorsal cutaneous branch,L",
                                                                            "c": "腓浅神经足背中间皮神经Superficial fibular(peroneal),intermediate dorsal cutaneous branch,L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "腓浅神经足背中间皮神经：由腓浅神经分出的皮神经。分布于足背外侧、第三至第五趾背相对缘的皮肤。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Superficial fibular(peroneal),L",
                                                                            "c": "腓浅神经Superficial fibular (peroneal),L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "腓浅神经：腓总神经终支之一。在腓骨长、短肌间下行。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Superficial fibular(peroneal),medial dorsal cutaneous branch,L",
                                                                            "c": "腓浅神经足背内侧皮神经Superficial fibular(peroneal),medial dorsal cutaneous branch,L"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "腓浅神经足背内侧皮神经：腓浅神经的分支。分布于拇指内侧、足内侧面、第二至第三趾背相对缘的皮肤。"
                                                                        }
                                                                    }]
                                                                }
                                                            }]
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Lumbosacral plexus and lower limb,R",
                                            "c": "右腰骶丛及其分支Lumbosacral plexus and lower limb,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "L01 Spinal nerve,R",
                                                    "c": "L01腰神经L01 Spinal nerve,R"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "L02 Spinal nerve,R",
                                                    "c": "L02腰神经L02 Spinal nerve,R"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "L03 Spinal nerve,R",
                                                    "c": "L03腰神经L03 Spinal nerve,R"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Lumbar plexus,R",
                                                    "c": "右腰丛Lumbar plexus,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Genitofemoral,femoral branch,R",
                                                            "c": "生殖股神经股支Genitofemoral,femoral branch,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "生殖股神经股支：于腹股沟韧带深面穿股鞘分布于股三角区皮肤的生殖股神经分支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Genitofemoral,R",
                                                            "c": "生殖股神经Genitofemoral,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "生殖股神经：发自腰丛，自腰大肌前面穿出后分成生殖支和股支的神经。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Anterior scrotal(branch of ilioinguinal),R",
                                                            "c": "阴囊前神经Anterior scrotal (branch of ilioinguinal),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "阴囊前神经：自髂腹股沟神经分出，分布于股内侧上部、阴茎根、阴囊上部皮肤的神经。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Femoral,R",
                                                            "c": "股神经Femoral,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "股神经：自腰大肌外侧缘发出后，在腰大肌和髂肌之间下行到达腹股沟区，在腹股沟韧带中点稍外侧从深面穿经该韧带，于股动脉的外侧进入大腿的股三角区，发出数条肌支分布于髂肌、耻骨肌、股四头肌和缝匠肌。股神经皮支中有行程较短的股中间皮神经和股内侧皮神经，分布于大腿和膝关节前面的皮肤区；皮支中最长的隐神经，伴随股动脉进入收肌管下行，于膝关节内侧缝匠肌下端的深面浅出至皮下，随后与大隐静脉伴行沿小腿内侧面下行至足内侧缘，沿途发支分布于膝关节、髌下、小腿内侧面及足内侧缘的皮肤。\r\n                                                            股神经受损后主要表现有：屈髋无力，坐位时不能伸膝，行走困难，膝跳反射消失，股四头肌萎缩，髌骨突出。大腿前面和小腿内侧面皮肤感觉障碍。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Genitofemoral,genital branch,R",
                                                            "c": "生殖股神经生殖支Genitofemoral,genital branch,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "生殖股神经生殖支：于腹股沟管深环处进入该管，分布于提睾肌和阴囊（女性随子宫圆韧带分布于大阴唇）的生殖股神经分支。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Iliohypogastric,R",
                                                            "c": "髂腹下神经Iliohypogastric,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "髂腹下神经：自腰大肌外侧缘潜出，从肾和腰方肌之间行向外下方，在髂嵴后份上方开始由深向浅逐次穿经腹横肌、腹内斜肌和腹外斜肌，最后在腹股沟管浅环上方约3cm处穿腹外斜肌腱膜达皮下。沿途发支分布于腹前外侧肌群下份，亦有皮支分布于臀外侧区、腹股沟区及下腹部的皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Ilioinguinal,R",
                                                            "c": "髂腹股沟神经Ilioinguinal,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "髂腹股沟神经：在髂腹下神经下方从腰大肌外侧缘潜出，斜行跨过腰方肌和髂肌上部，在髂嵴前端附近穿腹横肌浅出，于腹横肌与腹内斜肌之间，继续前行入腹股沟管，与精索（子宫圆韧带）伴行，从腹股沟管浅环穿出。该支较髂腹下神经细小，其肌支沿途分布于附近的腹壁肌，皮支则分布于腹股沟部、阴囊或大阴唇的皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Lateral femoral cutaneous,R",
                                                            "c": "股外侧皮神经Lateral femoral cutaneous,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "股外侧皮神经：从腰大肌外侧缘穿出后，向前外侧走行，横过髂肌表面至髂前上棘稍内侧，经腹股沟韧带深面进入股部。在髂前上棘下方约5-6cm处，该神经支穿出深筋膜分布于大腿前外侧份的皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Obturator,R",
                                                            "c": "闭孔神经Obturator,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "闭孔神经：自腰大肌内侧缘潜出后下行人盆腔，紧贴盆腔侧壁前行，与闭孔血管伴行穿闭膜管出盆腔，至股内侧区分为前、后两支，分别在短收肌的前、后方浅出。闭孔神经发出的肌支主要支配闭孔外肌、长收肌、短收肌、大收肌和股薄肌，偶见发支至耻骨肌；其皮支主要分布于大腿内侧份皮肤。闭孔神经亦有细小分支分布于髋关节和膝关节。 闭孔神经损伤后体征为大腿不能内收，患肢不能置于健侧腿上，股内侧区皮肤感觉不明显。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Saphenous,R",
                                                            "c": "隐神经Saphenous,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "隐神经：股神经发出的最长皮支。穿收肌管，伴大隐静脉，分布于膝下、小腿前内侧及足内侧缘皮肤。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Anococcygeal,R",
                                                    "c": "肛尾神经Anococcygeal,R"
                                                },
                                                "t":
                                                {
                                                    "s": "肛尾神经：由尾丛发出，分布于尾骨附近皮肤的神经。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Coccygeal,R",
                                                    "c": "尾神经Coccygeal,R"
                                                },
                                                "t":
                                                {
                                                    "s": "尾神经：最下一对脊神经。出骶管裂孔，与第四、五骶神经有交通。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_L04 Spinal nerve,R",
                                                    "c": "L04腰神经L04 Spinal nerve,R"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_L05 Spinal nerve,R",
                                                    "c": "L05腰神经L05 Spinal nerve,R"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Medial clunial(cluneal),R",
                                                    "c": "臀内侧皮神经Medial clunial (cluneal),R"
                                                },
                                                "t":
                                                {
                                                    "s": "臀内侧皮神经：为1-3骶神经后支，较细小，在髂后上棘至尾骨尖连线的中段穿出，分布于骶骨表面和臀内侧皮肤。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Nerve to levator ani,R",
                                                    "c": "肛提肌神经Nerve to levator ani,R"
                                                },
                                                "t":
                                                {
                                                    "s": ""
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_S01 Spinal nerve,R",
                                                    "c": "S01骶神经S01 Spinal nerve,R"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_S02 Spinal nerve,R",
                                                    "c": "S02骶神经S02 Spinal nerve,R"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_S03 Spinal nerve,R",
                                                    "c": "S03骶神经S03 Spinal nerve,R"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_S04 Spinal nerve,R",
                                                    "c": "S04骶神经S04 Spinal nerve,R"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_S05 Spinal nerve,R",
                                                    "c": "S05骶神经S05 Spinal nerve,R"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Superior clunial(cluneal),R",
                                                    "c": "臀上皮神经Superior clunial (cluneal),R"
                                                },
                                                "t":
                                                {
                                                    "s": "臀上皮神经：由第1-3腰神经后支的外侧支组成，在第3、4腰椎棘突平面穿出竖脊肌外缘，行与竖脊肌与髂嵴交点处的骨纤维管后至臀部皮下。臀上皮神经一般有3支，以中支最长，有时可达臀沟。腰部急性扭伤或神经在骨纤维管处受压时，可引起腰腿疼痛。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Sacral plexus,R",
                                                    "c": "骶丛Sacral plexus,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Inferior clunial(cluneal),R",
                                                            "c": "臀下皮神经Inferior clunial (cluneal),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "臀下皮神经：发自股后皮神经，绕臀大肌下缘至臀下部皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Lumbosacral trunk,R",
                                                            "c": "腰骶干Lumbosacral trunk,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "腰骶干：由第4腰神经前支的部分纤维和第5腰神经前支的所有纤维在腰丛下方合成，随后下行进入小骨盆，加入骶丛。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Dorsal penile nerve(branch of pudendal),R",
                                                            "c": "阴茎背神经Dorsal penile nerve (branch of pudendal),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "阴茎背神经：阴部神经的终支。向前行至阴茎背面和阴茎头包皮及阴茎海绵体。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Inferior gluteal,R",
                                                            "c": "臀下神经Inferior gluteal,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "臀下神经:骶丛的分支。经梨状肌下孔出骨盆，分布于臀大肌及髋关节。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Inferior rectal,R",
                                                            "c": "直肠下神经Inferior rectal,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肛神经:又称“直肠下神经”。阴部神经的分支。分布于肛门外括约肌、肛管下部和肛门周围的皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Perineal,R",
                                                            "c": "会阴神经Perineal,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "会阴神经：阴部神经的分支。向前行分支分布于会阴诸肌和外生殖器。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Posterior femoral cutaneous,R",
                                                            "c": "股后皮神经Posterior femoral cutaneous,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "股后皮神经：骶丛的分支。经梨状肌下孔出骨盆，分布于臀下部、股后区及腘窝处的皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Posterior scrotal,R",
                                                            "c": "阴囊后神经Posterior scrotal,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "阴囊后神经：会阴神经的皮支。分布于阴囊皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Pudendal,R",
                                                            "c": "阴部神经Pudendal,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "阴部神经：从骶丛发出后伴随阴部内血管穿梨状肌下孔至臀部，绕坐骨棘经坐骨小孔进入会阴部的坐骨肛门窝。在阴部管内紧贴坐骨肛门窝外侧壁前行，由后向前穿过肛三角和尿生殖三角，沿途发支分布于会阴部的肌群和皮肤以及外生殖器的皮肤。该神经干在会阴部的主要分支有：肛神经（直肠下神经）、会阴神经和阴茎（阴蒂）背神经。肛神经分布于肛门外括约肌和肛门部皮肤；会阴神经与阴部血管伴行分布于会阴诸肌以及阴囊或大阴唇的皮肤；阴茎背神经或阴蒂背神经行于阴茎或阴蒂的背侧，分布于阴茎或阴蒂的海绵体及皮肤。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "M_Superior gluteal,R",
                                                            "c": "臀上神经Superior gluteal,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "臀上神经：离开骶丛后，伴臀上血管经梨状肌上孔出盆腔至臀部，行于臀中、小肌之间，其主干分为上、下两支，分布于臀中肌、臀小肌和阔筋膜张肌。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Nerve to quadratus femoris,R",
                                                            "c": "股方肌神经Nerve to quadratus femoris,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "股方肌神经：骶丛直接分出至股方肌的神经。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Sciatic nerve and branches,R",
                                                            "c": "右坐骨神经及其分支Sciatic nerve and branches,R"
                                                        },
                                                        "ch":
                                                        {
                                                            "sub": [
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Sciatic,R",
                                                                    "c": "坐骨神经Sciatic,R"
                                                                },
                                                                "t":
                                                                {
                                                                    "s": "坐骨神经：为全身最粗大，行程最长的神经。坐骨神经经梨状肌下孔出盆腔至臀大肌深面，在坐骨结节与大转子连线的中点深面下行入股后区，继而行于股二头肌长头的深面，达腘窝上角处分为胫神经和腓总神经两大终支。坐骨神经在股后区发肌支支配股二头肌、半腱肌和半膜肌，同时也有分支至髋关节。 从坐骨结节与大转子连线的中点开始，向下至股骨内、外侧髁连线的中点作一直线，此两点间连线的上2/3段即为坐骨神经在股后区的投影线。坐骨神经痛时，此连线常出现压痛。\r\n                                                                    坐骨神经的变异较常见。根据国人的统计资料，坐骨神经以单干形式从梨状肌下孔出盆腔者占66.3%，为最常见的形式，而以其他形式出盆腔者则占33.7%。所谓其他形式，包括；①以单干穿梨状肌出盆腔者；②神经干分为两支，一支穿梨状肌，另一支穿梨状肌下孔出盆腔者；③神经干分为两支，一支穿梨状肌上孔，另一支穿梨状肌下孔出盆腔者。在以上三种变异形式中，单干穿梨状肌出盆腔者，对坐骨神经的不利影响最大。坐骨神经长年受梨状肌收缩的压迫，神经干的血液供应因此受到影响，最后出现功能障碍，临床称为“梨状肌综合征”。"
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Tibial nerve,R",
                                                                    "c": "胫神经Tibial nerve,R"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "5th Dorsal digital,R",
                                                                            "c": "第五趾背神经5th Dorsal digital,R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": ""
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Commom plantar digital,R",
                                                                            "c": "趾足底总神经Commom plantar digital,R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": ""
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Lateral plantar,R",
                                                                            "c": "足底外侧神经Lateral plantar,R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "足底外侧神经：胫神经在足底的又一终支。行向足底前外侧，分为浅支和深支。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Medial plantar,R",
                                                                            "c": "足底内侧神经Medial plantar,R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "足底内侧神经：由胫神经穿分裂韧带深面时发出的分支。前行入足底，分布于拇展肌、趾短屈肌、短屈肌、第一蚓状肌及足底内侧半皮肤。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Medial sural cutaneous,R",
                                                                            "c": "腓肠内侧皮神经Medial sural cutaneous,R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "腓肠内侧皮神经：胫神经的皮支。沿腓肠肌两头间的沟内下行，参与构成腓肠神经。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Proper plantar digital,R",
                                                                            "c": "趾足底固有神经Proper plantar digital,R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": ""
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Sural,R",
                                                                            "c": "腓肠神经Sural,R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "腓肠神经：多由腓肠内侧皮神经和腓神经交通支于小腿后区下部吻合而成，穿出深筋膜后，经外踝后方达足背外侧，分布于小腿后区下部及足背外侧的皮肤。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Tibial,R",
                                                                            "c": "胫神经Tibial,R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "胫神经(L4、L5、S1-S3)：为坐骨神经本干的延续，下行进入腘窝，与位于深面的腘血管相伴继续下行至小腿后区、比目鱼肌深面，后伴随胫后血管行至内踝后方，最后在屈肌支持带深面的踝管内分为足底内侧神经和足底外侧神经，两终支进入足底。足底内侧神经在拇展肌深面、趾短屈肌内侧前行，分支分布于足底内侧肌群，足底内侧半皮肤及内侧三个半足趾跖面皮肤。足底外侧神经在拇展肌和趾短屈肌深面行至足底外侧，发支分布于足底中间群肌和外侧群肌，以及足底外侧半皮肤和外侧一个半趾跖面皮肤。\r\n                                                                            胫神经在腘窝和小腿后区尚发出许多分支：其中肌支分布于小腿后群诸肌；皮支主要为腓肠内侧皮神经，该皮支伴小隐静脉下行，沿途分支分布于相应区域的皮肤，并在小腿下部与来自腓总神经的腓肠外侧皮神经吻合为腓肠神经。腓肠神经经外踝后方至足的外侧缘前行，分布于足背及小趾外侧缘皮肤；关节支则分布于膝关节和踝关节。\r\n                                                                            从股骨内、外侧髁连线中点向下连至内踝后方的下行直线可作为胫神经的体表投影线。胫神经损伤后主要表现为足不能跖屈，不能以足尖站立，内翻力减弱，伴发足底及足外侧缘皮肤感觉障碍。由于小腿后群肌功能障碍，收缩无力，结果导致小腿前外侧群肌的过度牵拉，使足呈背屈和外翻位，出现所谓“钩状足”畸形。"
                                                                        }
                                                                    }]
                                                                }
                                                            },
                                                            {
                                                                "$":
                                                                {
                                                                    "o": "Common peroneal nerve,R",
                                                                    "c": "右腓总神经Common peroneal nerve,R"
                                                                },
                                                                "ch":
                                                                {
                                                                    "sub": [
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Common fibular(peroneal),R",
                                                                            "c": "腓总神经Common fibular (peroneal),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "腓总神经(L4、L5、S1、S2)：在腘窝上角由坐骨神经发出后，沿股二头肌肌腱内侧向外下走行，至小腿上段外侧绕腓骨颈向前穿腓骨长肌后，分为腓浅神经和腓深神经。腓总神经在腓骨颈处的位置非常表浅，易受损伤。受伤后表现为足不能背屈，趾不能伸，足下垂且内翻，呈“马蹄内翻足”畸形，行走时呈“跨阈步态”。同时小腿前、外侧面及足背区出现明显的感觉障碍。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Deep fibular(peroneal),lateral branch,R",
                                                                            "c": "腓深神经外侧支Deep fibular(peroneal),lateral branch,R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "腓深神经：在足背区多数行于足背动脉的内侧，分成内、外两终支，分布于足背肌、足关节及第1、2趾相对侧背面的皮肤。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Deep fibular(peroneal),medial branch,R",
                                                                            "c": "腓深神经内侧支Deep fibular(peroneal),medial branch,R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "腓深神经：在足背区多数行于足背动脉的内侧，分成内、外两终支，分布于足背肌、足关节及第1、2趾相对侧背面的皮肤。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Deep fibular(peroneal),R",
                                                                            "c": "腓深神经Deep fibular (peroneal),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "腓深神经：在足背区多数行于足背动脉的内侧，分成内、外两终支，分布于足背肌、足关节及第1、2趾相对侧背面的皮肤。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Dorsal digital,R",
                                                                            "c": "趾背神经Dorsal digital,R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": ""
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Lateral sural cutaneous,R",
                                                                            "c": "腓肠外侧皮神经Lateral sural cutaneous,R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "腓肠外侧皮神经：腓总神经在腘窝处的分支。分布于小腿外侧面皮肤。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Superficial fibular(peroneal),intermediate dorsal cutaneous branch,R",
                                                                            "c": "腓浅神经足背中间皮神经Superficial fibular (peroneal),intermediate dorsal cutaneous branch,R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "腓浅神经足背中间皮神经：由腓浅神经分出的皮神经。分布于足背外侧、第三至第五趾背相对缘的皮肤。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Superficial fibular(peroneal),medial dorsal cutaneous branch,R",
                                                                            "c": "腓浅神经足背内侧皮神经Superficial fibular (peroneal),medial dorsal cutaneous branch,R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "腓浅神经足背内侧皮神经：腓浅神经的分支。分布于拇指内侧、足内侧面、第二至第三趾背相对缘的皮肤。"
                                                                        }
                                                                    },
                                                                    {
                                                                        "$":
                                                                        {
                                                                            "o": "Superficial fibular(peroneal),R",
                                                                            "c": "腓浅神经Superficial fibular (peroneal),R"
                                                                        },
                                                                        "t":
                                                                        {
                                                                            "s": "腓浅神经：腓总神经终支之一。在腓骨长、短肌间下行。"
                                                                        }
                                                                    }]
                                                                }
                                                            }]
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "05Cranial nerves",
                                    "c": "脑神经Cranial nerves"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Cranial nerves,L",
                                            "c": "左脑神经Cranial nerves,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "CN 01(l) Olfactory nerve,L",
                                                    "c": "左嗅神经CN 01(l) Olfactory nerve,L"
                                                },
                                                "t": ""
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "CN 02(ll) Optic nerve,L",
                                                    "c": "视神经CN 02(ll) Optic nerve,L"
                                                },
                                                "t":
                                                {
                                                    "s": "视神经：由特殊躯体感觉纤维组成，传导视觉冲动。视网膜节细胞的轴突在视神经盘处聚集，穿过巩膜筛板后形成视神经。视神经在眶内长2.5-3cm，行向后内，穿经视神经管入颅中窝，颅内段长约1-1.2cm，向后内走行至垂体前方连于视交叉，再经视束连于间脑。由于视神经是胚胎发生时，间脑向外突出形成视器的一部分，故视神经外面包有三层由脑膜延续而来的被膜，脑的蛛网膜下隙也随之延伸至视神经周围。因此当颅内压增高时，常出现视神经盘水肿。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "CN 03(lll) Oculomotor nerve,L",
                                                    "c": "动眼神经CN 03(lll) Oculomotor nerve,L"
                                                },
                                                "t":
                                                {
                                                    "s": "动眼神经：为运动性脑神经，含有一般躯体运动和一般内脏运动两种纤维。一般躯体运动纤维起于中脑动眼神经核，一般内脏运动纤维起于中脑的动眼神经副核(E-W核）。动眼神经自中脑腹侧脚间窝出脑，紧贴小脑幕切迹缘和后床突侧面前行进于海绵窦外侧壁上部，经眶上裂入眶，分成上、下两支。上支细小，支配上睑提肌和上直肌；下支粗大，支配下直肌、内直肌和下斜肌。\r\n                                                    动眼神经中的内脏运动纤维（副交感）由下斜肌支单独以小支分出，称睫状神经节短根，进入睫状神经节交换神经元，节后纤维进入眼球，支配睫状肌和瞳孔括约肌，参与瞳孔对光反射和调节反射。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "CN 04(lV) Trochlear nerve,L",
                                                    "c": "滑车神经CN 04(lV) Trochlear nerve,L"
                                                },
                                                "t":
                                                {
                                                    "s": "滑车神经：为运动性脑神经，起于中脑下丘平面对侧的滑车神经核，自中脑下丘下方出脑，绕过大脑脚外侧前行，穿经海绵窦外侧壁向前，经眶上裂入眶，越过上直肌和上睑提肌向前内侧行，支配上斜肌。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "CN 05(V) Trigeminal nerve,L",
                                                    "c": "左三叉神经CN 05(V) Trigeminal nerve,L"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "CN 05(V) Mandibular,L",
                                                            "c": "左下颌神经CN 05(V) Mandibular,L"
                                                        },
                                                        "t": ""
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "CN 05(V) Maxillary,L",
                                                            "c": "左上颌神经CN 05(V) Maxillary,L"
                                                        },
                                                        "t": ""
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "CN 05(V) Ophthalmic,L",
                                                            "c": "左眼神经CN 05(V) Ophthalmic,L"
                                                        },
                                                        "t": ""
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "CN 05(V) Trigeminal,L",
                                                            "c": "三叉神经节CN 05(V) Trigeminal,L"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "CN 06(Vl) Abducent nerve,L",
                                                    "c": "展神经CN 06(Vl) Abducent nerve,L"
                                                },
                                                "t":
                                                {
                                                    "s": "展神经：属运动性神经，由一般躯体运动纤维组成，起于脑桥的展神经核，自延髓脑桥沟中线两侧出脑，前行至颞骨岩部尖端，穿入海绵窦，在窦内沿颈内动脉外下方前行，经眶上裂入眶，支配外直肌。展神经损伤可引起外直肌瘫痪，产生内斜视。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "CN 07(Vll) Facial nerve,L",
                                                    "c": "左面神经CN 07(Vll) Facial nerve,L"
                                                },
                                                "t": ""
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "CN 08(Vlll) Vestibulocochlear nerve,L",
                                                    "c": "前庭蜗神经CN 08(Vlll) Vestibulocochlear nerve,L"
                                                },
                                                "t":
                                                {
                                                    "s": "前庭蜗神经（又称位听神经）是特殊感觉性脑神经。由传导平衡觉的前庭神经和传导听觉的蜗神经两部分组成。 前庭神经传导平衡觉。位于内耳道底的前庭神经节，由双极感觉神经元组成，其周围突穿内耳道底，分布于内耳球囊斑、椭圆囊斑和壶腹嵴中的毛细胞，中枢突组成前庭神经，经内耳门入颅，在脑桥小脑三角处，经延髓脑桥沟外侧部入脑，终止于前庭神经核群和小脑等部。\r\n                                                    蜗神经传导听觉。位于耳蜗的蜗轴内的蜗神经节（或称螺旋神经节），也由双极感觉神经元组成，其周围突分布于内耳螺旋器（或称Corti器）的毛细胞，中枢突形成蜗神经，经内耳门入颅；伴前庭神经入脑，终止于蜗神经蜗腹侧、背侧核。前庭蜗神经损伤后表现为伤侧耳聋和平衡功能障碍；并伴有恶心、呕吐等症状。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "CN 09(lX) Glossopharyngeal nerve,L",
                                                    "c": "左舌咽神经CN 09(lX) Glossopharyngeal nerve,L"
                                                },
                                                "t": ""
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "CN 10(X) Vagus nerve,L",
                                                    "c": "左迷走神经CN 10(X) Vagus nerve,L"
                                                },
                                                "t": ""
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "CN 11(Xl) Accessory nerve,L",
                                                    "c": "左副神经CN 11(Xl) Accessory nerve,L"
                                                },
                                                "t": ""
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "CN 12(Xll) Hypoglossal nerve,L",
                                                    "c": "左舌下神经CN 12(Xll) Hypoglossal nerve,L"
                                                },
                                                "t": ""
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Cranial nerves,R",
                                            "c": "右脑神经Cranial nerves,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "CN 01(l) Olfactory nerve,R",
                                                    "c": "右嗅神经CN 01(l) Olfactory nerve,R"
                                                },
                                                "t": ""
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "CN 02(ll) Optic nerve,R",
                                                    "c": "视神经CN 02(ll) Optic nerve,R"
                                                },
                                                "t":
                                                {
                                                    "s": "视神经：由特殊躯体感觉纤维组成，传导视觉冲动。视网膜节细胞的轴突在视神经盘处聚集，穿过巩膜筛板后形成视神经。视神经在眶内长2.5-3cm，行向后内，穿经视神经管入颅中窝，颅内段长约1-1.2cm，向后内走行至垂体前方连于视交叉，再经视束连于间脑。由于视神经是胚胎发生时，间脑向外突出形成视器的一部分，故视神经外面包有三层由脑膜延续而来的被膜，脑的蛛网膜下隙也随之延伸至视神经周围。因此当颅内压增高时，常出现视神经盘水肿。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "CN 03(lll) Oculomotor nerve,R",
                                                    "c": "动眼神经CN 03(lll) Oculomotor nerve,R"
                                                },
                                                "t":
                                                {
                                                    "s": "动眼神经：为运动性脑神经，含有一般躯体运动和一般内脏运动两种纤维。一般躯体运动纤维起于中脑动眼神经核，一般内脏运动纤维起于中脑的动眼神经副核(E-W核）。动眼神经自中脑腹侧脚间窝出脑，紧贴小脑幕切迹缘和后床突侧面前行进于海绵窦外侧壁上部，经眶上裂入眶，分成上、下两支。上支细小，支配上睑提肌和上直肌；下支粗大，支配下直肌、内直肌和下斜肌。\r\n                                                    动眼神经中的内脏运动纤维（副交感）由下斜肌支单独以小支分出，称睫状神经节短根，进入睫状神经节交换神经元，节后纤维进入眼球，支配睫状肌和瞳孔括约肌，参与瞳孔对光反射和调节反射。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "CN 04(lV) Trochlear nerve,R",
                                                    "c": "滑车神经CN 04(lV) Trochlear nerve,R"
                                                },
                                                "t":
                                                {
                                                    "s": "滑车神经：为运动性脑神经，起于中脑下丘平面对侧的滑车神经核，自中脑下丘下方出脑，绕过大脑脚外侧前行，穿经海绵窦外侧壁向前，经眶上裂入眶，越过上直肌和上睑提肌向前内侧行，支配上斜肌。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "CN 05(V) Trigeminal nerve,R",
                                                    "c": "右三叉神经CN 05(V) Trigeminal nerve,R"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "CN 05(V) Mandibular,R",
                                                            "c": "右下颌神经CN 05(V) Mandibular,R"
                                                        },
                                                        "t": ""
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "CN 05(V) Maxillary,R",
                                                            "c": "右上颌神经CN 05(V) Maxillary,R"
                                                        },
                                                        "t": ""
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "CN 05(V) Ophthalmic,R",
                                                            "c": "右眼神经CN 05(V) Ophthalmic,R"
                                                        },
                                                        "t": ""
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "CN 05(V) Trigeminal,R",
                                                            "c": "三叉神经节CN 05(V) Trigeminal,R"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "CN 06(Vl) Abducent nerve,R",
                                                    "c": "展神经CN 06(Vl) Abducent nerve,R"
                                                },
                                                "t":
                                                {
                                                    "s": "展神经：属运动性神经，由一般躯体运动纤维组成，起于脑桥的展神经核，自延髓脑桥沟中线两侧出脑，前行至颞骨岩部尖端，穿入海绵窦，在窦内沿颈内动脉外下方前行，经眶上裂入眶，支配外直肌。展神经损伤可引起外直肌瘫痪，产生内斜视。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "CN 07(Vll) Facial nerve,R",
                                                    "c": "右面神经CN 07(Vll) Facial nerve,R"
                                                },
                                                "t": ""
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "CN 08(Vlll) Vestibulocochlear nerve,R",
                                                    "c": "前庭蜗神经CN 08(Vlll) Vestibulocochlear nerve,R"
                                                },
                                                "t":
                                                {
                                                    "s": "前庭蜗神经（又称位听神经）是特殊感觉性脑神经。由传导平衡觉的前庭神经和传导听觉的蜗神经两部分组成。 前庭神经传导平衡觉。位于内耳道底的前庭神经节，由双极感觉神经元组成，其周围突穿内耳道底，分布于内耳球囊斑、椭圆囊斑和壶腹嵴中的毛细胞，中枢突组成前庭神经，经内耳门入颅，在脑桥小脑三角处，经延髓脑桥沟外侧部入脑，终止于前庭神经核群和小脑等部。\r\n                                                    蜗神经传导听觉。位于耳蜗的蜗轴内的蜗神经节（或称螺旋神经节），也由双极感觉神经元组成，其周围突分布于内耳螺旋器（或称Corti器）的毛细胞，中枢突形成蜗神经，经内耳门入颅；伴前庭神经入脑，终止于蜗神经蜗腹侧、背侧核。前庭蜗神经损伤后表现为伤侧耳聋和平衡功能障碍；并伴有恶心、呕吐等症状。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "CN 09(lX) Glossopharyngeal nerve,R",
                                                    "c": "右舌咽神经CN 09(lX) Glossopharyngeal nerve,R"
                                                },
                                                "t": ""
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "CN 10(X) Vagus nerve,R",
                                                    "c": "右迷走神经CN 10(X) Vagus nerve,R"
                                                },
                                                "t": ""
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "CN 11(Xl) Accessory nerve,R",
                                                    "c": "右副神经CN 11(Xl) Accessory nerve,R"
                                                },
                                                "t": ""
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "CN 12(Xll) Hypoglossal nerve,R",
                                                    "c": "右舌下神经CN 12(Xll) Hypoglossal nerve,R"
                                                },
                                                "t": ""
                                            }]
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "07Eye",
                                    "c": "眼Eye"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Eye,L",
                                            "c": "左眼Eye,L"
                                        },
                                        "t":
                                        {
                                            "s": "眼球的功能是接受光波的刺激，将感受的光波刺激转变为神经冲动，经视觉传导通路传至大脑视觉中枢，产生视觉。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Eye,R",
                                            "c": "右眼Eye,R"
                                        },
                                        "t":
                                        {
                                            "s": "眼球的功能是接受光波的刺激，将感受的光波刺激转变为神经冲动，经视觉传导通路传至大脑视觉中枢，产生视觉。"
                                        }
                                    }]
                                }
                            }]
                        }
                    }]
                }
            },
            {
                "$":
                {
                    "o": "011Lymphatic system",
                    "c": "淋巴系统Lymphatic system"
                },
                "ch":
                {
                    "sub": [
                    {
                        "$":
                        {
                            "o": "01Thoracic duct",
                            "c": "胸导管Thoracic duct"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "04Jugular trunk and nodes drained,L",
                                    "c": "左颈干及其淋巴结Jugular trunk and nodes drained,L"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "jugular trunk,L",
                                            "c": "颈干jugular trunk,L"
                                        },
                                        "t":
                                        {
                                            "s": "颈干：由颈浅淋巴结、颈外侧浅淋巴结和颈外侧上深淋巴结和下深淋巴结的输出淋巴管合成。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Lymph nodes of head and neck,L",
                                            "c": "左头颈部淋巴结Lymph nodes of head and neck,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Anterior deep cervical lymph nodes,L",
                                                    "c": "颈前深淋巴结Anterior deep cervical lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "颈前深淋巴结：包括喉前淋巴结、甲状腺淋巴结、气管前淋巴结和气管旁淋巴结四组。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Anterior deep cervical(pertracheal and thyroid) lymph nodes,L",
                                                    "c": "气管前和甲状腺淋巴结Anterior deep cervical (pertracheal and thyroid) lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": ""
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Anterior superficial cervical(anterior jugular) lymph nodes,L",
                                                    "c": "颈前浅淋巴结Anterior superficial cervical (anterior jugular) lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "颈前浅淋巴结：又称“颈前静脉淋巴结”。沿颈前静脉排列的淋巴结。引流颈前部浅层各结构的淋巴，其输出淋巴管注入颈外侧下深淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Buccinator lymph node,L",
                                                    "c": "颊肌淋巴结Buccinator lymph node,L"
                                                },
                                                "t":
                                                {
                                                    "s": "颊肌淋巴结：位于颊肌浅面的淋巴结。引流面部淋巴至下颌下淋巴结，不恒定。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Deep parotid lymph nodes,L",
                                                    "c": "腮腺深淋巴结Deep parotid lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "腮腺深淋巴结：位于腮腺实质内，引流额部、颅顶、颞区、耳郭、外耳道、颊部和腮腺等处的淋巴的淋巴结群。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Jugulodigastric lymph node,L",
                                                    "c": "颈内静脉二腹肌淋巴结Jugulodigastric lymph node,L"
                                                },
                                                "t":
                                                {
                                                    "s": "颈内静脉二腹肌淋巴结：位于面静脉、颈内静脉和二腹肌后腹之间的淋巴结称颈内静脉二腹肌淋巴结，引流鼻咽部、腭扁桃体和舌根的淋巴。鼻咽癌和舌根癌常首先转移至该淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Superior deep lateral cervical lymph nodes,L",
                                                    "c": "颈外侧上深淋巴结Superior deep lateral cervical lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "颈外侧上深淋巴结：沿颈内静脉上段排列，位于面静脉、颈内静脉和二腹肌后腹之间的淋巴结。引流鼻咽部、腭扁桃体和舌根部的淋巴。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Juguloomohyoid lymph node,L",
                                                    "c": "颈内静脉肩胛舌骨肌淋巴结Juguloomohyoid lymph node,L"
                                                },
                                                "t":
                                                {
                                                    "s": "颈内静脉肩胛舌骨肌淋巴结：位于颈内静脉与肩胛舌骨肌中间腱交叉处的淋巴结称颈内静脉肩胛舌骨肌淋巴结，引流舌尖的淋巴。舌尖癌常首先转移至该淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Mandibular lymph nodes,L",
                                                    "c": "下颌淋巴结Mandibular lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "下颌淋巴结：伴随面静脉排列的淋巴结。输出淋巴至下颌下淋巴结，不恒定。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Nasolabial lymph node,L",
                                                    "c": "鼻唇淋巴结Nasolabial lymph node,L"
                                                },
                                                "t":
                                                {
                                                    "s": "鼻唇淋巴结：位于眶下孔附近。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Occipital lymph nodes,L",
                                                    "c": "枕淋巴结Occipital lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "枕淋巴结：分浅、深两群，分别位于斜方肌起点表面和头夹肌深面，引流枕部和项部的淋巴。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Palatine tonsil,L",
                                                    "c": "腭扁桃体Palatine tonsil,L"
                                                },
                                                "t":
                                                {
                                                    "s": "腭扁桃体位于口咽部侧壁的扁桃体窝内，是淋巴上皮器官，具有防御功能。腭扁桃体呈椭圆形，其内侧面朝向咽腔，表面覆以黏膜，并有许多深陷的小凹称扁桃体小窝,细菌易在此存留繁殖，成为感染病灶。腭扁桃体的外侧面及前、后面均被结缔组织形成的扁桃体囊包绕。此外，扁桃体窝上份未被腭扁桃体充满的空间称扁桃体上窝，异物常易停留于此处。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Posterior lateral superficial cervical(spinal accessory) lymph nodes,L",
                                                    "c": "副神经淋巴结Posterior lateral superficial cervical (spinal accessory) lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "副神经淋巴结：沿副神经排列的淋巴结称副神经淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Retroauricular(mastoid,posterior auricular) lymph nodes,L",
                                                    "c": "耳后淋巴结Retroauricular (mastoid,posterior auricular) lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "乳突淋巴结又称耳后淋巴结，位于胸锁乳突肌止点表面，引流颅顶部、颞区和耳廓后面的淋巴。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Retropharyngeal lymph nodes,L",
                                                    "c": "咽后淋巴结Retropharyngeal lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "咽后淋巴结：位于咽后壁和椎前筋膜之间，引流鼻腔后部、鼻旁窦、鼻咽部和喉咽部的淋巴，输出淋巴管注入颈外侧上深淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Sternocleidomastoid lymph nodes,L",
                                                    "c": "胸锁乳突肌淋巴结Sternocleidomastoid lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": ""
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Submandibular(submaxillary) lymph nodes,L",
                                                    "c": "下颌下淋巴结Submandibular lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "下颌下淋巴结：位于下颌下腺的附近和下颌下腺实质内，引流面部和口腔器官的淋巴。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Submental lymph nodes,L",
                                                    "c": "颏下淋巴结Submental lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "颏下淋巴结：位于颏下部，引流舌尖、下唇中部和颏部的淋巴。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Superficial parotid lymph nodes,L",
                                                    "c": "腮腺浅淋巴结Superficial parotid lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "腮腺浅淋巴结：位于腮腺表面和腮腺实质内，由浅、深两群组成，引流额部、颅顶、颞区、耳郭、外耳道、颊部和腮腺等处的淋巴的淋巴结群。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Inferior deep lateral cervical lymph nodes,L",
                                                    "c": "颈外侧下深淋巴结Inferior deep lateral cervical lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "颈外侧下深淋巴结：沿颈内静脉下段排列的淋巴结。引流颈根部、胸壁上部和乳房上部的淋巴，收纳颈前淋巴结等的输出淋巴结，合成颈干。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Superficial lateral cervical lymph node,L",
                                                    "c": "颈外侧浅淋巴结Superficial lateral cervical lymph node,L"
                                                },
                                                "t":
                                                {
                                                    "s": "颈外侧浅淋巴结：沿颈外静脉排列，引流颈外侧浅层结构的淋巴，并收纳枕淋巴结、乳突淋巴结和腮腺淋巴结的输出淋巴管，其输出淋巴管注入颈外侧深淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Superior thyroid lymph nodes,L",
                                                    "c": "甲状腺上淋巴结Superior thyroid lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": ""
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Supraclavicular lymph nodes,L",
                                                    "c": "锁骨上淋巴结Supraclavicular lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "锁骨上淋巴结：沿颈横血管分布的淋巴结。食管癌和胃癌后期，癌细胞可沿胸导管或颈干逆流转移至左锁骨上淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Suprahyoid lymph node,L",
                                                    "c": "舌骨上淋巴结Suprahyoid lymph node,L"
                                                },
                                                "t":
                                                {
                                                    "s": ""
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Transverse cervical chain of lymph nodes,L",
                                                    "c": "颈横淋巴结Transverse cervical chain of lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": ""
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Virchow lymph node,L",
                                                    "c": "菲尔绍淋巴结Virchow lymph node,L"
                                                },
                                                "t":
                                                {
                                                    "s": "菲尔绍淋巴结：位于左静脉角处的淋巴结。"
                                                }
                                            }]
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "05Subclavian trunk and nodes drained,L",
                                    "c": "左锁骨下干及其淋巴结Subclavian trunk and nodes drained,L"
                                },
                                "ch":
                                {
                                    "sub":
                                    {
                                        "$":
                                        {
                                            "o": "Lymph nodes of upper limb,L",
                                            "c": "左上肢淋巴结Lymph nodes of upper limb,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Anterior axillary(pectoral) lymph nodes,L",
                                                    "c": "胸肌淋巴结Anterior axillary (pectoral) lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "胸肌淋巴结：位于胸小肌下缘，沿胸外侧血管排列的淋巴结。引流腹前外侧壁、胸外侧壁以及乳房外侧部等处的淋巴，其输出淋巴管注入中央淋巴结合尖淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Apical(medial,subclavicular) lymph nodes,L",
                                                    "c": "尖淋巴结Apical (medial,subclavicular) lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "尖淋巴结：沿腋静脉近侧段排列的淋巴结。引流乳腺上部的淋巴，并收纳中央淋巴结、胸肌淋巴结、外侧淋巴结和肩胛下淋巴结输出淋巴管，合成锁骨下干。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Lateral lymph nodes,L",
                                                    "c": "外侧淋巴结Lateral lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "外侧淋巴结：沿腋静脉排列的淋巴结。收纳除注入锁骨下淋巴以外的上肢浅、深淋巴管。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Central axillary(intermediate) lymph nodes,L",
                                                    "c": "中央淋巴结Central axillary (intermediate) lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "中央淋巴结：位于腋窝中央疏松结缔组织中的淋巴结。收纳胸肌淋巴结、外侧淋巴结和肩胛下淋巴结输出淋巴管，输出淋巴管注入尖淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Cubital lymph nodes,L",
                                                    "c": "肘淋巴结Cubital lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "肘淋巴结：分浅、深两群，分别位于肱骨内上髁上方和肘窝深血管周围。浅群又称滑车上淋巴结。肘淋巴结通过浅、深淋巴管引流手尺侧半和前臂尺侧半的淋巴，其输出淋巴管沿肱血管注入腋淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Deltopectoral(infraclavicular) lymph nodes,L",
                                                    "c": "锁骨下淋巴结Deltopectoral (infraclavicular) lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "锁骨下淋巴结：又称“三角胸肌淋巴结”。位于锁骨下、三角肌与胸大肌间沟内，沿头静脉排列，收纳沿头静脉上行的浅淋巴管。其输出管主要注入腋淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Paramammary lymph nodes,,L",
                                                    "c": "乳房旁淋巴结Paramammary lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "乳房旁淋巴结：位于乳腺外侧的几个淋巴结。接受乳腺淋巴输入，其输出淋巴管汇入腋淋巴结前群，通常被认为是腋淋巴结前群的一部分。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Parasternal lymph nodes,L",
                                                    "c": "胸骨旁淋巴结Parasternal lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "胸骨旁淋巴结：沿胸廓内血管排列，引流胸腹前壁和乳房内侧部的淋巴，并收纳膈上淋巴结的输出淋巴管，其输出淋巴管参与合成支气管纵隔干。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Subscapular(posterior) axillary lymph nodes,L",
                                                    "c": "肩胛下淋巴结Subscapular (posterior) axillary lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "肩胛下淋巴结：沿肩胛下血管排列的淋巴结。引流背部和颈后部的淋巴，其输出淋巴管注入中央淋巴结和尖淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Supratrochlear lymph nodes,L",
                                                    "c": "滑车上淋巴结Supratrochlear lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "肘浅淋巴结：又称“滑车上淋巴结”。位于肱骨内上髁的上方，贵要静脉内侧，引流手尺侧半和前臂尺侧半淋巴的淋巴结。其输出淋巴管注入肱淋巴结或者腋淋巴结外侧群。"
                                                }
                                            }]
                                        }
                                    }
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "06Bronchomediastinal trunk and nodes drained,L",
                                    "c": "左支气管纵膈干及其淋巴结Bronchomediastinal trunk and nodes drained,L"
                                },
                                "ch":
                                {
                                    "sub":
                                    {
                                        "$":
                                        {
                                            "o": "Lymph nodes of thorax,L",
                                            "c": "左胸淋巴结Lymph nodes of thorax,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Anterior deep cervical(paratracheal) lymph nodes,L",
                                                    "c": "气管旁淋巴结Anterior deep cervical (paratracheal) lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "气管旁淋巴结：位于气管和食管之间的侧沟内，沿喉返神经排列，引流喉、甲状腺、气管和食管的淋巴，输出淋巴管注入颈外侧下深淋巴结。感染或肿瘤转移可引起气管旁淋巴结肿大，压迫喉返神经，出现声音嘶哑。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Brachiocephalic lymph nodes,L",
                                                    "c": "头臂淋巴结Brachiocephalic lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": ""
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Inferior tracheobronchial lymph nodes",
                                                    "c": "气管支气管下淋巴结Inferior tracheobronchial lymph nodes"
                                                },
                                                "t":
                                                {
                                                    "s": "气管支气管下淋巴结：位于气管分叉处下方的淋巴结。引流肺和支气管的淋巴。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Juxtaesophageal lymph nodes,L",
                                                    "c": "肺食管旁淋巴结Juxtaesophageal lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "肺食管旁淋巴结：位于食管胸部侧方，肺内侧面的淋巴结。主要引流食管、心包后部和膈后淋巴，收纳膈上淋巴结外侧群与后群的输出淋巴管。其输出淋巴管注入胸导管，部分注入气管旁淋巴结和气管支气管淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Juxtaesophageal lymph nodes,R",
                                                    "c": "肺食管旁淋巴结Juxtaesophageal lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "肺食管旁淋巴结：位于食管胸部侧方，肺内侧面的淋巴结。主要引流食管、心包后部和膈后淋巴，收纳膈上淋巴结外侧群与后群的输出淋巴管。其输出淋巴管注入胸导管，部分注入气管旁淋巴结和气管支气管淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Lateral pericardial lymph nodes",
                                                    "c": "心包外侧淋巴结Lateral pericardial lymph nodes"
                                                },
                                                "t":
                                                {
                                                    "s": "心包外侧淋巴结：位于心包与纵隔胸膜之间，沿心包膈血管排列，收集心包和纵隔胸膜的淋巴，输出淋巴管主要注入胸骨旁淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Node of ligamentum arteriosum(inconstant)",
                                                    "c": "动脉韧带淋巴结Node of ligamentum arteriosum"
                                                },
                                                "t":
                                                {
                                                    "s": "动脉韧带淋巴结：位于主动脉弓前下壁、动脉韧带左侧的淋巴结。引流左肺部分淋巴，并收纳左气管支气管上淋巴结的输出管淋巴，其输出淋巴管注入主动脉弓淋巴结，不恒定。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Paraesophageal lymph nodes,L",
                                                    "c": "食管旁淋巴结Paraesophageal lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": ""
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Prepericardial lymph nodes",
                                                    "c": "心包前淋巴结Prepericardial lymph nodes"
                                                },
                                                "t":
                                                {
                                                    "s": "心包前淋巴结：又称“纵隔前下淋巴结”、“纵隔前淋巴下群”。位于前纵隔、心包前面的淋巴结。引流心包和胸腺的淋巴，其输出淋巴管注入胸骨旁淋巴结，或纵隔前淋巴结上群，部分汇入支气管纵隔干。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Superior phrenic lymph nodes",
                                                    "c": "膈上淋巴结Superior phrenic lymph nodes"
                                                },
                                                "t":
                                                {
                                                    "s": "膈上淋巴结：位于膈的胸腔面，分前、中、后3群，引流膈、壁胸膜、心包和肝上面的淋巴，其输出淋巴管注入胸骨旁淋巴结和纵隔前、后淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Superior tracheobronchial lymph nodes,L",
                                                    "c": "左气管支气管上淋巴结Superior tracheobronchial lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "左气管支气管上淋巴结：位于气管下部和左主支气管左侧的淋巴结。引流左肺上叶和左半心的部分淋巴，并收纳左支气管肺淋巴结和气管支气管下淋巴结的输出淋巴管，注入两侧气管旁淋巴结。"
                                                }
                                            }]
                                        }
                                    }
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "07Intercostal trunk and nodes,L",
                                    "c": "左肋间干及其淋巴结Intercostal trunk and nodes,L"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Intercostal(thoracic) lymph nodes,L",
                                            "c": "肋间淋巴结Intercostal (thoracic) lymph nodes,L"
                                        },
                                        "t":
                                        {
                                            "s": "肋间淋巴结：多位于肋头附近，沿肋间后血管排列，引流胸后壁的淋巴，其输出淋巴管注入胸导管。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Prevertebral lymph nodes,L",
                                            "c": "椎前淋巴结Prevertebral lymph nodes,L"
                                        },
                                        "t":
                                        {
                                            "s": "椎前淋巴结：位于胸主动脉后的淋巴结。"
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "08Left lumbar and nodes drained",
                                    "c": "左腰干及其淋巴结Left lumbar and nodes drained"
                                },
                                "ch":
                                {
                                    "sub":
                                    {
                                        "$":
                                        {
                                            "o": "Lymph nodes of pelvis and lower limb,L",
                                            "c": "左盆部和下肢淋巴结Lymph nodes of pelvis and lower limb,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Anterior tibial lymph node,L",
                                                    "c": "胫前淋巴结Anterior tibial lymph node,L"
                                                },
                                                "t":
                                                {
                                                    "s": "胫前淋巴结：沿胫前动脉排列的淋巴结。其输出淋巴管注入腹股沟深淋巴结，不恒定。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Deep inguinal lymph nodes,L",
                                                    "c": "腹股沟深淋巴结Deep inguinal lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "腹股沟深淋巴结：位于股静脉周围和股管内的淋巴结。引流大腿和会阴深部结构的淋巴，并收纳腘淋巴结深群和腹股沟浅淋巴结的输出淋巴管，其输出淋巴管注入髂外淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "External iliac lymph nodes,L",
                                                    "c": "髂外淋巴结External iliac lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "髂外淋巴结：沿髂外血管排列，引流腹前壁下部、膀胱、前列腺（男）或子宫颈和阴道上部（女）的淋巴，并收纳腹股沟浅、深淋巴结的输出淋巴管，其输出淋巴管注入髂总淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Common iliac lymph nodes,L",
                                                    "c": "髂总淋巴结Common iliac lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "髂总淋巴结：沿髂总血管排列，收纳上述3群淋巴结的输出淋巴管，其输出淋巴管注入腰淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Intermediate lacunar lymph node,L",
                                                    "c": "腔隙中间淋巴结Intermediate lacunar lymph node,L"
                                                },
                                                "t":
                                                {
                                                    "s": "腔隙中间淋巴结：髂外侧组的1个淋巴结。位于血管腔隙的髂外动、静脉之间，不恒定。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Intermediate lumbar lymph nodes",
                                                    "c": "中间腰淋巴结Intermediate lumbar lymph nodes"
                                                },
                                                "t":
                                                {
                                                    "s": "中间腰淋巴结：位于主动脉和下腔静脉之间的淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Internal iliac(epigastric) lymph nodes,L",
                                                    "c": "髂内淋巴结Internal iliac (epigastric) lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "髂内淋巴结：沿髂内动脉及其分支和髂内静脉及其属支排列，引流大部分盆壁、盆腔脏器、会阴深部、臀部和大腿后部深层结构的淋巴，其输出淋巴管注入髂总淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Lateral sacral lymph nodes,L",
                                                    "c": "骶外侧淋巴结Lateral sacral lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "骶淋巴结：沿骶正中血管和骶外侧血管排列，引流盆后壁、直肠、前列腺或子宫等处的淋巴，其输出淋巴管注入髂内淋巴结或髂总淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Left lateral aortic lymph nodes",
                                                    "c": "主动脉外侧淋巴结Left lateral aortic lymph nodes"
                                                },
                                                "t":
                                                {
                                                    "s": "主动脉外侧淋巴结：位于腹主动脉左侧的淋巴结。是左腰淋巴结的一部分。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Node of Cloquet or Rosenmuller,L",
                                                    "c": "克洛凯淋巴结或罗森苗勒氏淋巴结Node of Cloquet or Rosenmuller,L"
                                                },
                                                "t":
                                                {
                                                    "s": ""
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Obturator lymph nodes,L",
                                                    "c": "闭孔淋巴结Obturator lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "闭孔淋巴结：位于闭膜管内口，沿闭孔动脉根部排列的淋巴结。引流子宫颈、阴道上部、膀胱以及阴蒂或阴茎头的淋巴，输出淋巴管注入髂外淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Preaortic lymph nodes",
                                                    "c": "主动脉前淋巴结Preaortic lymph nodes"
                                                },
                                                "t":
                                                {
                                                    "s": "主动脉前淋巴结：位于腹主动脉前面的淋巴结。是左腰淋巴结的一部分。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Superficial inguinal lymph nodes (upper group),L",
                                                    "c": "腹股沟浅淋巴结上群Superficial inguinal lymph nodes (upper group),L"
                                                },
                                                "t":
                                                {
                                                    "s": "腹股沟浅淋巴结：位于腹股沟韧带下方，分上、下两群。上群与腹股沟韧带平行排列，引流腹前外侧壁下部、臀部、会阴和子宫底的淋巴。下群沿大隐静脉末端分布，收纳除足外侧缘和小腿后外侧部外的下肢浅淋巴管。腹股沟浅淋巴结的输出淋巴管注入腹股沟深淋巴结或髂外淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Popliteal lymph nodes,L",
                                                    "c": "腘淋巴结Popliteal lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "腘淋巴结：分浅、深两群，分别沿小隐静脉末端和腘血管排列，收纳足外侧缘和小腿后外侧部的浅淋巴管以及足和小腿的深淋巴管，其输出淋巴管沿股血管上行，注入腹股沟深淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Retroaortic(postaortic) lymph nodes",
                                                    "c": "主动脉后淋巴结Retroaortic (postaortic) lymph nodes"
                                                },
                                                "t":
                                                {
                                                    "s": "主动脉后淋巴结:位于腹主动脉的后面的淋巴结。是左腰淋巴结的一部分。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Superficial inguinal lymph nodes (lower group),L",
                                                    "c": "腹股沟浅淋巴结下群Superficial inguinal lymph nodes (lower group),L"
                                                },
                                                "t":
                                                {
                                                    "s": "腹股沟浅淋巴结：位于腹股沟韧带下方，分上、下两群。上群与腹股沟韧带平行排列，引流腹前外侧壁下部、臀部、会阴和子宫底的淋巴。下群沿大隐静脉末端分布，收纳除足外侧缘和小腿后外侧部外的下肢浅淋巴管。腹股沟浅淋巴结的输出淋巴管注入腹股沟深淋巴结或髂外淋巴结。"
                                                }
                                            }]
                                        }
                                    }
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "09Right lumbar and nodes drained",
                                    "c": "右腰干及其淋巴结Right lumbar and nodes drained"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Lymph nodes of pelvis and lower limb,R",
                                            "c": "右盆部和下肢淋巴结Lymph nodes of pelvis and lower limb,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Anterior tibial lymph node,R",
                                                    "c": "胫前淋巴结Anterior tibial lymph node,R"
                                                },
                                                "t":
                                                {
                                                    "s": "胫前淋巴结：沿胫前动脉排列的淋巴结。其输出淋巴管注入腹股沟深淋巴结，不恒定。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Deep inguinal lymph nodes,R",
                                                    "c": "腹股沟深淋巴结Deep inguinal lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "腹股沟深淋巴结：位于股静脉周围和股管内的淋巴结。引流大腿和会阴深部结构的淋巴，并收纳腘淋巴结深群和腹股沟浅淋巴结的输出淋巴管，其输出淋巴管注入髂外淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "External iliac lymph nodes,R",
                                                    "c": "髂外淋巴结External iliac lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "髂外淋巴结：沿髂外血管排列，引流腹前壁下部、膀胱、前列腺（男）或子宫颈和阴道上部（女）的淋巴，并收纳腹股沟浅、深淋巴结的输出淋巴管，其输出淋巴管注入髂总淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Inferior phrenic lymph nodes",
                                                    "c": "膈下淋巴结Inferior phrenic lymph nodes"
                                                },
                                                "t":
                                                {
                                                    "s": "膈下淋巴结：沿膈下静脉排列的小淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Common iliac lymph nodes,R",
                                                    "c": "髂总淋巴结Common iliac lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "髂总淋巴结：沿髂总血管排列，收纳上述3群淋巴结的输出淋巴管，其输出淋巴管注入腰淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Intermediate lacunar lymph node,R",
                                                    "c": "腔隙中间淋巴结Intermediate lacunar lymph node,R"
                                                },
                                                "t":
                                                {
                                                    "s": "腔隙中间淋巴结：髂外侧组的1个淋巴结。位于血管腔隙的髂外动、静脉之间，不恒定。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Internal iliac(epigastric) lymph nodes,R",
                                                    "c": "髂内淋巴结Internal iliac lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "髂内淋巴结：沿髂内动脉及其分支和髂内静脉及其属支排列，引流大部分盆壁、盆腔脏器、会阴深部、臀部和大腿后部深层结构的淋巴，其输出淋巴管注入髂总淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Lateral caval lymph nodes,R",
                                                    "c": "腔静脉外侧淋巴结Lateral caval lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "腔静脉外侧淋巴结：位于下腔静脉右侧的淋巴结。是右腰淋巴结的一部分。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Lateral sacral lymph nodes,R",
                                                    "c": "骶外侧淋巴结Lateral sacral lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "骶淋巴结：沿骶正中血管和骶外侧血管排列，引流盆后壁、直肠、前列腺或子宫等处的淋巴，其输出淋巴管注入髂内淋巴结或髂总淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Node of Cloquet or Rosenmuller,R",
                                                    "c": "克洛凯淋巴结或罗森苗勒氏淋巴结Node of Cloquet or Rosenmuller,R"
                                                },
                                                "t":
                                                {
                                                    "s": ""
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Obturator lymph nodes,R",
                                                    "c": "闭孔淋巴结Obturator lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "闭孔淋巴结：位于闭膜管内口，沿闭孔动脉根部排列的淋巴结。引流子宫颈、阴道上部、膀胱以及阴蒂或阴茎头的淋巴，输出淋巴管注入髂外淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Precaval(right lateral aortic) lymph nodes",
                                                    "c": "腔静脉前淋巴结Precaval (right lateral aortic) lymph nodes"
                                                },
                                                "t":
                                                {
                                                    "s": "腔静脉前淋巴结：位于下腔静脉前面的淋巴结。是右腰淋巴结的一部分。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Promontory lymph node",
                                                    "c": "骶岬淋巴结Promontory lymph node"
                                                },
                                                "t":
                                                {
                                                    "s": "骶岬淋巴结：位于骶骨岬附近的淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Retrocaval(posterior caval) lymph nodes",
                                                    "c": "腔静脉后淋巴结Retrocaval (posterior caval) lymph nodes"
                                                },
                                                "t":
                                                {
                                                    "s": "腔静脉后淋巴结：位于下腔静脉后面的淋巴结。是右腰淋巴结的一部分。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "M_Superficial inguinal lymph nodes(upper group),R",
                                                    "c": "腹股沟浅淋巴结上群Superficial inguinal lymph nodes (upper group),R"
                                                },
                                                "t":
                                                {
                                                    "s": "腹股沟浅淋巴结：位于腹股沟韧带下方，分上、下两群。上群与腹股沟韧带平行排列，引流腹前外侧壁下部、臀部、会阴和子宫底的淋巴。下群沿大隐静脉末端分布，收纳除足外侧缘和小腿后外侧部外的下肢浅淋巴管。腹股沟浅淋巴结的输出淋巴管注入腹股沟深淋巴结或髂外淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Popliteal lymph nodes,R",
                                                    "c": "腘淋巴结Popliteal lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "腘淋巴结：分浅、深两群，分别沿小隐静脉末端和腘血管排列，收纳足外侧缘和小腿后外侧部的浅淋巴管以及足和小腿的深淋巴管，其输出淋巴管沿股血管上行，注入腹股沟深淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Superficial inguinal lymph nodes (lower group),R",
                                                    "c": "Superficial inguinal lymph nodes (lower group),R"
                                                },
                                                "t":
                                                {
                                                    "s": "腹股沟浅淋巴结：位于腹股沟韧带下方，分上、下两群。上群与腹股沟韧带平行排列，引流腹前外侧壁下部、臀部、会阴和子宫底的淋巴。下群沿大隐静脉末端分布，收纳除足外侧缘和小腿后外侧部外的下肢浅淋巴管。腹股沟浅淋巴结的输出淋巴管注入腹股沟深淋巴结或髂外淋巴结。"
                                                }
                                            }]
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "10Intestinal trunk and nodes drained",
                                    "c": "肠干及其淋巴结Intestinal trunk and nodes drained"
                                },
                                "ch":
                                {
                                    "sub":
                                    {
                                        "$":
                                        {
                                            "o": "Lymph nodes of abdomen",
                                            "c": "腹部淋巴结Lymph nodes of abdomen"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Celiac(preaortic) lymph nodes",
                                                    "c": "腹腔淋巴结Celiac lymph nodes"
                                                },
                                                "t":
                                                {
                                                    "s": "腹腔淋巴结：腹腔动脉及其分支的周围排列的淋巴结。收集腹腔干各分支供应区的淋巴，其输出淋巴管参与组成肠干。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Cystic lymph node",
                                                    "c": "胆囊淋巴结Cystic lymph node"
                                                },
                                                "t":
                                                {
                                                    "s": "胆囊淋巴结：位于肝总管与胆囊管汇合处，胆囊颈左前方的淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Gastric(cardiac nodes of stomach) lymph nodes",
                                                    "c": "贲门淋巴结Gastric (cardiac nodes of stomach) lymph nodes"
                                                },
                                                "t":
                                                {
                                                    "s": "贲门淋巴结常归入胃左淋巴结内，位于贲门周围，收集贲门附近的淋巴，注入腹腔淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Gastroepiploic(gastro-omental) lymph nodes,L",
                                                    "c": "胃网膜左淋巴结Gastroepiploic (gastroomental) lymph nodes,L"
                                                },
                                                "t":
                                                {
                                                    "s": "胃网膜左淋巴结:沿胃网膜左动脉排列的淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Gastroepiploic(gastro-omental) lymph nodes,R",
                                                    "c": "胃网膜右淋巴结Gastroepiploic (gastroomental) lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "胃网膜右淋巴结：沿胃网膜右动脉排列的淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Hepatic lymph nodes",
                                                    "c": "肝淋巴结Hepatic lymph nodes"
                                                },
                                                "t":
                                                {
                                                    "s": "肝淋巴结：位于小网膜的两层腹膜之间，沿肝动脉、胆总管和门静脉排列的淋巴结。包括肝固有淋巴结和肝总淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Inferior pancreatic lymph nodes",
                                                    "c": "胰下淋巴结Inferior pancreatic lymph nodes"
                                                },
                                                "t":
                                                {
                                                    "s": "胰下淋巴结:沿胰下动脉排列的淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Left gastric lymph nodes",
                                                    "c": "胃左淋巴结Left gastric lymph nodes"
                                                },
                                                "t":
                                                {
                                                    "s": "胃左淋巴结：沿胃左动脉排列的淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Pancreaticoduodenal lymph nodes",
                                                    "c": "胰十二指肠淋巴结Pancreaticoduodenal lymph nodes"
                                                },
                                                "t":
                                                {
                                                    "s": "胰十二指肠淋巴结：位于胰头与十二指肠之间，沿胰十二指肠上、下血管排列的淋巴结。可分为胰十二指肠上、下淋巴结两群，引流胰和十二指肠的淋巴以及肝右叶和胆囊的部分淋巴，并收集幽门下淋巴结的输出淋巴管，其输出淋巴管注入肠系膜上淋巴结和腰淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Preaortic(inferior mesenteric) lymph nodes",
                                                    "c": "肠系膜下淋巴结Preaortic (inferior mesenteric) lymph nodes"
                                                },
                                                "t":
                                                {
                                                    "s": "肠系膜下淋巴结：位于肠系膜下动脉根部周围的淋巴结。收纳结肠左曲、乙状结肠和直肠上淋巴结的输出淋巴管，其输出淋巴管参与合成肠干。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Preaortic(superior mesenteric) lymph nodes",
                                                    "c": "肠系膜上淋巴结Preaortic (superior mesenteric) lymph nodes"
                                                },
                                                "t":
                                                {
                                                    "s": "肠系膜上淋巴结：位于肠系膜上动脉根部周围的淋巴结。收纳肠系膜淋巴结和回结肠、右结肠、中结肠淋巴结的输出淋巴管，其输出淋巴管参与合成肠干。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Retropyloric lymph node",
                                                    "c": "幽门后淋巴结Retropyloric lymph node"
                                                },
                                                "t":
                                                {
                                                    "s": "幽门后淋巴结：位于幽门后面，沿十二指肠血管排列的淋巴结。引流幽门后壁的淋巴，并收集幽门下淋巴结的输出淋巴管，其输出淋巴管注入幽门上淋巴结或腹腔淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Splenic(lienal) lymph nodes",
                                                    "c": "脾淋巴结Splenic (lienal) lymph nodes"
                                                },
                                                "t":
                                                {
                                                    "s": "脾淋巴结：在脾门附近排列的淋巴结。收纳胃底部和胃网膜左淋巴结的淋巴，通过沿胰上缘脾动脉分布的胰上淋巴结汇入腹腔淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Subpyloric lymph nodes",
                                                    "c": "幽门下淋巴结Subpyloric lymph nodes"
                                                },
                                                "t":
                                                {
                                                    "s": "幽门下淋巴结：位于幽门下方排列的淋巴结。引流胃幽门部的大弯侧、十二指肠上部和胰头等处的淋巴，并收集胃网膜右淋巴结的输出淋巴管，其输出淋巴管注入幽门后淋巴结、肝淋巴结、肠系膜上淋巴结或腹腔淋巴结，不恒定。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Superior pancreatic lymph nodes",
                                                    "c": "胰上淋巴结Superior pancreatic lymph nodes"
                                                },
                                                "t":
                                                {
                                                    "s": "胰上淋巴结：位于脾动脉胰支起始处的附近淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Suprapyloric lymph nodes",
                                                    "c": "幽门上淋巴结Suprapyloric lymph nodes"
                                                },
                                                "t":
                                                {
                                                    "s": "幽门上淋巴结：位于幽门上方排列的淋巴结。引流胃幽门部小弯侧、十二指肠上部的部分淋巴，并收集幽门后淋巴结的输出淋巴管，其输出淋巴管注入肝总淋巴结或腹腔淋巴结，不恒定。"
                                                }
                                            }]
                                        }
                                    }
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "11Presymphyseal lymph node",
                                    "c": "耻骨联合前淋巴结Presymphyseal lymph node"
                                },
                                "t":
                                {
                                    "s": ""
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_Middle sacral lymph nodes",
                                    "c": "骶正中淋巴结Middle sacral lymph nodes"
                                },
                                "t":
                                {
                                    "s": "骶淋巴结：沿骶正中血管和骶外侧血管排列，引流盆后壁、直肠、前列腺或子宫等处的淋巴，其输出淋巴管注入髂内淋巴结或髂总淋巴结。"
                                }
                            }]
                        }
                    },
                    {
                        "$":
                        {
                            "o": "02Right lymphatic duct",
                            "c": "右淋巴导管Right lymphatic duct"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "02Jugular trunk and nodes drained,R",
                                    "c": "右颈干及其淋巴结Jugular trunk and nodes drained,R"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Jugular trunk,R",
                                            "c": "颈干Jugular trunk,R"
                                        },
                                        "t":
                                        {
                                            "s": "颈干：由颈浅淋巴结、颈外侧浅淋巴结和颈外侧上深淋巴结和下深淋巴结的输出淋巴管合成。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Lymph nodes of head and neck,R",
                                            "c": "右头颈部淋巴结Lymph nodes of head and neck,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Anterior deep cervical lymph nodes,R",
                                                    "c": "颈前深淋巴结Anterior deep cervical lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "颈前深淋巴结：包括喉前淋巴结、甲状腺淋巴结、气管前淋巴结和气管旁淋巴结四组。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Anterior deep cervical(pertracheal and thyroid) lymph nodes,R",
                                                    "c": "气管前和甲状腺淋巴结Anterior deep cervical (pertracheal and thyroid) lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": ""
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Anterior superficial cervical(anterior jugular) lymph nodes,R",
                                                    "c": "颈前浅淋巴结Anterior superficial cervical (anterior jugular) lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "颈前浅淋巴结：又称“颈前静脉淋巴结”。沿颈前静脉排列的淋巴结。引流颈前部浅层各结构的淋巴，其输出淋巴管注入颈外侧下深淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Buccinator lymph node,R",
                                                    "c": "颊肌淋巴结Buccinator lymph node,R"
                                                },
                                                "t":
                                                {
                                                    "s": "颊肌淋巴结：位于颊肌浅面的淋巴结。引流面部淋巴至下颌下淋巴结，不恒定。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Deep parotid lymph nodes,R",
                                                    "c": "腮腺深淋巴结Deep parotid lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "腮腺深淋巴结：位于腮腺实质内，引流额部、颅顶、颞区、耳郭、外耳道、颊部和腮腺等处的淋巴的淋巴结群。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Jugulodigastric lymph node,R",
                                                    "c": "颈内静脉二腹肌淋巴结Jugulodigastric lymph node,R"
                                                },
                                                "t":
                                                {
                                                    "s": "颈内静脉二腹肌淋巴结：位于面静脉、颈内静脉和二腹肌后腹之间的淋巴结称颈内静脉二腹肌淋巴结，引流鼻咽部、腭扁桃体和舌根的淋巴。鼻咽癌和舌根癌常首先转移至该淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Superior deep lateral cervical lymph nodes,R",
                                                    "c": "颈外侧上深淋巴结Superior deep lateral cervical lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "颈外侧上深淋巴结：沿颈内静脉上段排列，位于面静脉、颈内静脉和二腹肌后腹之间的淋巴结。引流鼻咽部、腭扁桃体和舌根部的淋巴。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Juguloomohyoid lymph node,R",
                                                    "c": "颈内静脉肩胛舌骨肌淋巴结Juguloomohyoid lymph node,R"
                                                },
                                                "t":
                                                {
                                                    "s": "颈内静脉肩胛舌骨肌淋巴结：位于颈内静脉与肩胛舌骨肌中间腱交叉处的淋巴结称颈内静脉肩胛舌骨肌淋巴结，引流舌尖的淋巴。舌尖癌常首先转移至该淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Mandibular lymph nodes,R",
                                                    "c": "下颌淋巴结Mandibular lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "下颌淋巴结：伴随面静脉排列的淋巴结。输出淋巴至下颌下淋巴结，不恒定。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Nasolabial lymph node,R",
                                                    "c": "鼻唇淋巴结Nasolabial lymph node,R"
                                                },
                                                "t":
                                                {
                                                    "s": "鼻唇淋巴结：位于眶下孔附近。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Occipital lymph nodes,R",
                                                    "c": "枕淋巴结Occipital lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "枕淋巴结：分浅、深两群，分别位于斜方肌起点表面和头夹肌深面，引流枕部和项部的淋巴。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Palatine tonsil,R",
                                                    "c": "腭扁桃体Palatine tonsil,R"
                                                },
                                                "t":
                                                {
                                                    "s": "腭扁桃体位于口咽部侧壁的扁桃体窝内，是淋巴上皮器官，具有防御功能。腭扁桃体呈椭圆形，其内侧面朝向咽腔，表面覆以黏膜，并有许多深陷的小凹称扁桃体小窝,细菌易在此存留繁殖，成为感染病灶。腭扁桃体的外侧面及前、后面均被结缔组织形成的扁桃体囊包绕。此外，扁桃体窝上份未被腭扁桃体充满的空间称扁桃体上窝，异物常易停留于此处。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Posterior lateral superficial cervical(spinal accessory) lymph nodes,R",
                                                    "c": "副神经淋巴结Posterior lateral superficial cervical (spinal accessory) lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "副神经淋巴结：沿副神经排列的淋巴结称副神经淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Retroauricular(mastoid,posterior auricular) lymph nodes,R",
                                                    "c": "耳后淋巴结Retroauricular (mastoid,posterior auricular) lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "乳突淋巴结又称耳后淋巴结，位于胸锁乳突肌止点表面，引流颅顶部、颞区和耳廓后面的淋巴。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Retropharyngeal lymph nodes,R",
                                                    "c": "咽后淋巴结Retropharyngeal lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "咽后淋巴结：位于咽后壁和椎前筋膜之间，引流鼻腔后部、鼻旁窦、鼻咽部和喉咽部的淋巴，输出淋巴管注入颈外侧上深淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Scalene lymph node,R",
                                                    "c": "斜角肌淋巴结Scalene lymph node,R"
                                                },
                                                "t":
                                                {
                                                    "s": "斜角肌淋巴结：位于前斜角肌前方的淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Sternocleidomastoid lymph nodes,R",
                                                    "c": "胸锁乳突肌淋巴结Sternocleidomastoid lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": ""
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Submandibular(submaxillary) lymph nodes,R",
                                                    "c": "下颌下淋巴结Submandibular lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "下颌下淋巴结：位于下颌下腺的附近和下颌下腺实质内，引流面部和口腔器官的淋巴。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Submental lymph nodes,R",
                                                    "c": "颏下淋巴结Submental lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "颏下淋巴结：位于颏下部，引流舌尖、下唇中部和颏部的淋巴。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Superficial parotid lymph nodes,R",
                                                    "c": "腮腺浅淋巴结Superficial parotid lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "腮腺浅淋巴结：位于腮腺表面和腮腺实质内，由浅、深两群组成，引流额部、颅顶、颞区、耳郭、外耳道、颊部和腮腺等处的淋巴的淋巴结群。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Inferior deep lateral cervical lymph nodes,R",
                                                    "c": "颈外侧下深淋巴结Inferior deep lateral cervical lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "颈外侧下深淋巴结：沿颈内静脉下段排列的淋巴结。引流颈根部、胸壁上部和乳房上部的淋巴，收纳颈前淋巴结等的输出淋巴结，合成颈干。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Superficial lateral cervical lymph node,R",
                                                    "c": "颈外侧浅淋巴结Superficial lateral cervical lymph node,R"
                                                },
                                                "t":
                                                {
                                                    "s": "颈外侧浅淋巴结：沿颈外静脉排列，引流颈外侧浅层结构的淋巴，并收纳枕淋巴结、乳突淋巴结和腮腺淋巴结的输出淋巴管，其输出淋巴管注入颈外侧深淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Superior thyroid lymph nodes,R",
                                                    "c": "甲状腺上淋巴结Superior thyroid lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": ""
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Supraclavicular lymph nodes,R",
                                                    "c": "锁骨上淋巴结Supraclavicular lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "锁骨上淋巴结：沿颈横血管分布的淋巴结。食管癌和胃癌后期，癌细胞可沿胸导管或颈干逆流转移至左锁骨上淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Suprahyoid lymph node,R",
                                                    "c": "舌骨上淋巴结Suprahyoid lymph node,R"
                                                },
                                                "t":
                                                {
                                                    "s": ""
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Transverse cervical chain of lymph nodes,R",
                                                    "c": "颈横淋巴结Transverse cervical chain of lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": ""
                                                }
                                            }]
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "03Subclavian trunk and nodes drained,R",
                                    "c": "右锁骨下干及其淋巴结Subclavian trunk and nodes drained,R"
                                },
                                "ch":
                                {
                                    "sub":
                                    {
                                        "$":
                                        {
                                            "o": "Lymph nodes of upper limb,R",
                                            "c": "右上肢淋巴结Lymph nodes of upper limb,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Anterior axillary(pectoral) lymph nodes,R",
                                                    "c": "胸肌淋巴结Anterior axillary (pectoral) lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "胸肌淋巴结：位于胸小肌下缘，沿胸外侧血管排列的淋巴结。引流腹前外侧壁、胸外侧壁以及乳房外侧部等处的淋巴，其输出淋巴管注入中央淋巴结合尖淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Apical(medial,subclavicular) lymph nodes,R",
                                                    "c": "尖淋巴结Apical (medial,subclavicular) lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "尖淋巴结：沿腋静脉近侧段排列的淋巴结。引流乳腺上部的淋巴，并收纳中央淋巴结、胸肌淋巴结、外侧淋巴结和肩胛下淋巴结输出淋巴管，合成锁骨下干。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Lateral lymph nodes,R",
                                                    "c": "外侧淋巴结Lateral lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "外侧淋巴结：沿腋静脉排列的淋巴结。收纳除注入锁骨下淋巴以外的上肢浅、深淋巴管。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Central axillary(intermediate) lymph nodes,R",
                                                    "c": "中央淋巴结Central axillary (intermediate) lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "中央淋巴结：位于腋窝中央疏松结缔组织中的淋巴结。收纳胸肌淋巴结、外侧淋巴结和肩胛下淋巴结输出淋巴管，输出淋巴管注入尖淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Cubital lymph nodes,R",
                                                    "c": "肘淋巴结Cubital lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "肘淋巴结：分浅、深两群，分别位于肱骨内上髁上方和肘窝深血管周围。浅群又称滑车上淋巴结。肘淋巴结通过浅、深淋巴管引流手尺侧半和前臂尺侧半的淋巴，其输出淋巴管沿肱血管注入腋淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Deltopectoral(infraclavicular) lymph nodes,R",
                                                    "c": "锁骨下淋巴结Deltopectoral (infraclavicular) lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "锁骨下淋巴结：又称“三角胸肌淋巴结”。位于锁骨下、三角肌与胸大肌间沟内，沿头静脉排列，收纳沿头静脉上行的浅淋巴管。其输出管主要注入腋淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Paramammary lymph nodes,R",
                                                    "c": "乳房旁淋巴结Paramammary lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "乳房旁淋巴结：位于乳腺外侧的几个淋巴结。接受乳腺淋巴输入，其输出淋巴管汇入腋淋巴结前群，通常被认为是腋淋巴结前群的一部分。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Parasternal lymph nodes,R",
                                                    "c": "胸骨旁淋巴结Parasternal lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "胸骨旁淋巴结：沿胸廓内血管排列，引流胸腹前壁和乳房内侧部的淋巴，并收纳膈上淋巴结的输出淋巴管，其输出淋巴管参与合成支气管纵隔干。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Subscapular(posterior) axillary lymph nodes,R",
                                                    "c": "肩胛下淋巴结Subscapular (posterior) axillary lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "肩胛下淋巴结：沿肩胛下血管排列的淋巴结。引流背部和颈后部的淋巴，其输出淋巴管注入中央淋巴结和尖淋巴结。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Supratrochlear lymph nodes,R",
                                                    "c": "滑车上淋巴结Supratrochlear lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "肘浅淋巴结：又称“滑车上淋巴结”。位于肱骨内上髁的上方，贵要静脉内侧，引流手尺侧半和前臂尺侧半淋巴的淋巴结。其输出淋巴管注入肱淋巴结或者腋淋巴结外侧群。"
                                                }
                                            }]
                                        }
                                    }
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "04Bronchomediastinal trunk and nodes drained,R",
                                    "c": "右支气管纵膈干及其淋巴结Bronchomediastinal trunk and nodes drained,R"
                                },
                                "ch":
                                {
                                    "sub":
                                    {
                                        "$":
                                        {
                                            "o": "Lymph nodes of thorax,R",
                                            "c": "右胸淋巴结Lymph nodes of thorax,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Anterior deep cervical(paratracheal) lymph nodes,R",
                                                    "c": "气管旁淋巴结Anterior deep cervical (paratracheal) lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "气管旁淋巴结：位于气管和食管之间的侧沟内，沿喉返神经排列，引流喉、甲状腺、气管和食管的淋巴，输出淋巴管注入颈外侧下深淋巴结。感染或肿瘤转移可引起气管旁淋巴结肿大，压迫喉返神经，出现声音嘶哑。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Brachiocephalic lymph nodes,R",
                                                    "c": "头臂淋巴结Brachiocephalic lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": ""
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Paraesophageal lymph nodes,R",
                                                    "c": "食管旁淋巴结Paraesophageal lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": ""
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Superior tracheobronchial lymph nodes,R",
                                                    "c": "右气管支气管上淋巴结Superior tracheobronchial lymph nodes,R"
                                                },
                                                "t":
                                                {
                                                    "s": "右气管支气管上淋巴结：位于气管下部和右主支气管右侧的淋巴结。引流右肺上叶部分淋巴，并收纳左、右支气管肺淋巴结和气管支气管下淋巴结的输出淋巴管，其输出淋巴管主要注入右气管旁淋巴结，部分注入静脉前淋巴结。"
                                                }
                                            }]
                                        }
                                    }
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "05Intercostal trunk and nodes,R",
                                    "c": "右肋间干及其淋巴结Intercostal trunk and nodes,R"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Intercostal(thoracic) lymph nodes,R",
                                            "c": "肋间淋巴结Intercostal (thoracic) lymph nodes,R"
                                        },
                                        "t":
                                        {
                                            "s": "肋间淋巴结：多位于肋头附近，沿肋间后血管排列，引流胸后壁的淋巴，其输出淋巴管注入胸导管。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Prevertebral lymph nodes,R",
                                            "c": "椎前淋巴结Prevertebral lymph nodes,R"
                                        },
                                        "t":
                                        {
                                            "s": "椎前淋巴结：位于胸主动脉后的淋巴结。"
                                        }
                                    }]
                                }
                            }]
                        }
                    }]
                }
            },
            {
                "$":
                {
                    "o": "012Organ",
                    "c": "器官Digestive system"
                },
                "ch":
                {
                    "sub": [
                    {
                        "$":
                        {
                            "o": "01Reproductive system",
                            "c": "生殖系统Reproductive system"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "M_External genitalia",
                                    "c": "外生殖器External genitalia"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "M_Corpus cavernosum",
                                            "c": "阴茎海绵体Corpus cavernosum"
                                        },
                                        "t":
                                        {
                                            "s": "阴茎海绵体：为两端细的圆柱体，位于阴茎的背侧，左右各一，两者紧密相连，前端变细，嵌入阴茎头后面的凹陷内。阴茎海绵体后端左、右分离称为阴茎脚，附于两侧的耻骨下支和坐骨支。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Corpus spongiosum",
                                            "c": "尿道海绵体Corpus spongiosum"
                                        },
                                        "t":
                                        {
                                            "s": "尿道海绵体：位于阴茎海绵体的腹侧，尿道贯穿其全长，呈圆柱形；前端膨大为阴茎头，后端膨大称为尿道球，位于两侧阴茎脚之间，表面包绕球海绵体肌，使其固定在尿生殖膈下面。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Glans penis",
                                            "c": "阴茎头Glans penis"
                                        },
                                        "t":
                                        {
                                            "s": "阴茎为男性的性交器官，可分为头、体和根3部分。后端为阴茎根，藏于阴囊和会阴部皮肤的深面，固定于耻骨下支和坐骨支，为固定部。中部为阴茎体，呈圆柱形，以韧带悬于耻骨联合的前下方，为可动部。阴茎前端膨大，称阴茎头，头的尖端有较狭窄的尿道外口，呈矢状位。头后较细的部分称阴茎颈。"
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "M_Internal genitalia",
                                    "c": "内生殖器Internal genitalia"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "M_Ejaculatory duct,L",
                                            "c": "射精管Ejaculatory duct,L"
                                        },
                                        "t":
                                        {
                                            "s": "射精管：由输精管的末端与精囊的排泄管汇合而成，长约2cm，向前下穿前列腺实质，开口于尿道的前列腺部。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Ejaculatory duct,R",
                                            "c": "射精管Ejaculatory duct,R"
                                        },
                                        "t":
                                        {
                                            "s": "射精管：由输精管的末端与精囊的排泄管汇合而成，长约2cm，向前下穿前列腺实质，开口于尿道的前列腺部。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Epididymis,L",
                                            "c": "附睾Epididymis,L"
                                        },
                                        "t":
                                        {
                                            "s": "附睾：呈新月形，由睾丸输出小管和迂曲的附睾管组成，紧贴睾丸的上端和后缘。附睾管长约6m。附睾分为上端膨大的附睾头，中部的附睾体和下端的附睾尾。附睾尾向上弯曲移行为输精管。附睾暂时储存精子，分泌附睾液营养精子，促进精子进一步成熟。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Epididymis,R",
                                            "c": "附睾Epididymis,R"
                                        },
                                        "t":
                                        {
                                            "s": "附睾：呈新月形，由睾丸输出小管和迂曲的附睾管组成，紧贴睾丸的上端和后缘。附睾管长约6m。附睾分为上端膨大的附睾头，中部的附睾体和下端的附睾尾。附睾尾向上弯曲移行为输精管。附睾暂时储存精子，分泌附睾液营养精子，促进精子进一步成熟。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Prostate",
                                            "c": "前列腺Prostate"
                                        },
                                        "t": ""
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Seminal vesicle,L",
                                            "c": "精囊Seminal vesicle,L"
                                        },
                                        "t":
                                        {
                                            "s": "精囊：又称精囊腺，位于膀胱底后方，输精管壶腹外侧，表面凹凸不平，长约10-l5cm，呈长椭圆形，由迂曲的管道组成，其排泄管与输精管末端汇合成射精管。精囊分泌黄色黏稠液体，参与组成精液。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Seminal vesicle,R",
                                            "c": "精囊Seminal vesicle,R"
                                        },
                                        "t":
                                        {
                                            "s": "精囊：又称精囊腺，位于膀胱底后方，输精管壶腹外侧，表面凹凸不平，长约10-l5cm，呈长椭圆形，由迂曲的管道组成，其排泄管与输精管末端汇合成射精管。精囊分泌黄色黏稠液体，参与组成精液。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Testis,L",
                                            "c": "左睾丸Testis,L"
                                        },
                                        "t": ""
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Testis,R",
                                            "c": "右睾丸Testis,R"
                                        },
                                        "t": ""
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Vas deferens,L",
                                            "c": "输精管Vas deferens,L"
                                        },
                                        "t":
                                        {
                                            "s": "输精管：是附睾管的直接延续，长度约50cm，一般左侧较右侧稍长；肌层发达，管壁较厚；管腔细小，直径约3mm；活体触膜时，呈坚实的圆索状。\r\n                                            输精管依行程分为四部：①睾丸部：起自附睾尾，最短，迂曲，沿睾丸后缘、附睾内侧上行至睾丸上端。②精索部：介于睾丸上端与腹股沟管皮下环之间，在精索内位于其他结构的后内侧。此段位置表浅，易于触知，为输精管结扎的理想部位。③腹股沟管部：全程位于腹股沟管的精索内。④盆部：为输精管最长的一段，经腹股沟管腹环出腹股沟管，弯向内下，越过髂外动、静脉，沿盆侧壁行向后下，跨过输尿管末端前内方至膀胱底的后面，两侧输精管在此逐渐接近，并膨大成输精管壶腹。壶腹下端变细，两侧并列穿过前列腺，与精囊的排泄管汇合成射精管。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Vas deferens,R",
                                            "c": "输精管Vas deferens,R"
                                        },
                                        "t":
                                        {
                                            "s": "输精管：是附睾管的直接延续，长度约50cm，一般左侧较右侧稍长；肌层发达，管壁较厚；管腔细小，直径约3mm；活体触膜时，呈坚实的圆索状。\r\n                                            输精管依行程分为四部：①睾丸部：起自附睾尾，最短，迂曲，沿睾丸后缘、附睾内侧上行至睾丸上端。②精索部：介于睾丸上端与腹股沟管皮下环之间，在精索内位于其他结构的后内侧。此段位置表浅，易于触知，为输精管结扎的理想部位。③腹股沟管部：全程位于腹股沟管的精索内。④盆部：为输精管最长的一段，经腹股沟管腹环出腹股沟管，弯向内下，越过髂外动、静脉，沿盆侧壁行向后下，跨过输尿管末端前内方至膀胱底的后面，两侧输精管在此逐渐接近，并膨大成输精管壶腹。壶腹下端变细，两侧并列穿过前列腺，与精囊的排泄管汇合成射精管。"
                                        }
                                    }]
                                }
                            }]
                        }
                    },
                    {
                        "$":
                        {
                            "o": "02Respiratory system",
                            "c": "呼吸系统Respiratory system"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "01Upper respiratory tract",
                                    "c": "上呼吸道Upper respiratory tract"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Larynx",
                                            "c": "喉Larynx"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Laryngeal cartilage",
                                                    "c": "喉软骨Laryngeal cartilage"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Corniculate cartilage,L",
                                                            "c": "小角软骨Corniculate cartilage,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "小角软骨：一对椭圆形小纤维软骨块。位于杓状软骨尖的上方，为杓状软骨向后内方的延续。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Corniculate cartilage,R",
                                                            "c": "小角软骨Corniculate cartilage,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "小角软骨：一对椭圆形小纤维软骨块。位于杓状软骨尖的上方，为杓状软骨向后内方的延续。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Cricoid cartilage",
                                                            "c": "环状软骨Cricoid cartilage"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "环状软骨：是喉与气管环中唯一完整的环形软骨，是喉支架的基础，对支持喉腔通畅，保证呼吸甚为重要。若因外伤缺损，常致喉狭窄。环状软骨位于甲状软骨之下，下接气管，前部较窄，称环状软骨弓，后部向上延展而较宽阔，称环状软骨板。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Cricotracheal ligament",
                                                            "c": "环状软骨气管韧带Cricotracheal ligament"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "环状软骨气管韧带：连于环状软骨下缘与第一气管软骨环上缘之间的结缔组织膜。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Hyoepiglottic ligament",
                                                            "c": "舌骨会厌韧带Hyoepiglottic ligament"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "舌骨会厌韧带：连结于舌骨下缘和会厌软骨舌面之间，呈水平位的韧带。与甲状舌骨膜之间被脂肪组织所分离。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Median circothyroid ligament",
                                                            "c": "环甲正中韧带Median circothyroid ligament"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "环甲正中韧带：弹性圆锥中部的纤维组织增厚形成，呈垂直方向，系于甲状软骨下缘与环状软骨弓之间的韧带。急性喉阻塞时，常在此处穿刺，以建立暂时通气道。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Thyroid cartilage",
                                                            "c": "甲状软骨Thyroid cartilage"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "甲状软骨：喉支架中最大的一块软骨，形状如同竖立的向后半开的书，两侧由左右对称的甲状软骨翼板在颈前正中线汇合形成一定的角度，男性夹角较小且上端向前突出，称为喉结，女性近似钝角，喉结不明显。两侧甲状软骨翼板后缘向上、下端延伸，呈小柱状突起，分别称为上角和下角，上角较长，借韧带与舌骨大角相连；下角较短，其内侧面与环状软骨后外侧面的小凹形成环甲关节。甲状软骨上缘正中有一“V”形凹陷，称甲状软骨切迹，为识别颈正中线的标志。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Thyrohyoid membrane",
                                                            "c": "甲状舌骨膜Thyrohyoid membrane"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "甲状舌骨膜：位于舌骨与甲状软骨上缘间结缔组织膜。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Laryngeal cavity",
                                                    "c": "喉腔Laryngeal cavity"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Elastic conus",
                                                            "c": "弹性圆锥Elastic conus"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "弹性圆锥：又称“环甲膜”。圆锥形的弹性纤维膜。尖附着于甲状软骨前角内面，底附着于环状软骨上缘和杓状软骨声带突，上缘游离增厚，为声襞的支架。前部的纤维组织增厚，系于甲状软骨下缘与环状软骨弓之间。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Vestibular fold",
                                                            "c": "前庭襞Vestibular fold"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "前庭襞：又称“室襞”。连于甲状软骨前角后面与杓状软骨声带突上方的前内侧缘，是呈矢状位、粉红色的黏膜皱襞。两侧前庭襞之间的裂隙称前庭裂，较声门裂宽。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Muscle of larynx",
                                                    "c": "喉肌Muscle of larynx"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Cricothyroid(straight part),L",
                                                            "c": "环甲肌直部Cricothyroid (straight part),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "环甲肌直部：环甲肌的上部肌纤维。倾斜度较小，向后至甲状软骨板下缘后部。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Cricothyroid(straight part),R",
                                                            "c": "环甲肌直部Cricothyroid (straight part),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "环甲肌直部：环甲肌的上部肌纤维。倾斜度较小，向后至甲状软骨板下缘后部。"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Nose",
                                            "c": "鼻Nose"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "02Nasal cavity",
                                                    "c": "鼻腔Nasal cavity"
                                                },
                                                "ch":
                                                {
                                                    "sub":
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Nasal cavity",
                                                            "c": "鼻腔Nasal cavity"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "鼻腔：是由骨和软骨及其表面被覆的黏膜和皮肤构成。鼻腔内衬黏膜并被鼻中隔分成两半，向前通外界处称鼻孔，向后通鼻咽部称鼻后孔。每侧鼻腔又分鼻前庭和固有鼻腔，两者以鼻阈为界。鼻阚是皮肤和黏膜的交界处，鼻前庭壁由皮肤覆盖，生有鼻毛，有滤过和净化空气的功能；鼻前庭富有皮脂腺和汗腺，是疖肿的好发部位；且因其缺少皮下组织，故在发生疖肿时疼痛剧烈。"
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "03Paranasal sinuses",
                                                    "c": "鼻旁窦Paranasal sinuses"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Ethmoid sinuses (membranes)",
                                                            "c": "筛窦（膜）Ethmoid sinuses (membranes)"
                                                        },
                                                        "t": ""
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Frontal sinuses (membranes),L",
                                                            "c": "额窦（膜）Frontal sinuses (membranes),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "额窦：位于额骨额鳞下部内的腔洞。数目、大小与形状不一，一般为三角形，多左、右各一。开口于中鼻道。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Frontal sinuses (membranes),R",
                                                            "c": "额窦（膜）Frontal sinuses (membranes),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "额窦：位于额骨额鳞下部内的腔洞。数目、大小与形状不一，一般为三角形，多左、右各一。开口于中鼻道。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Maxillary sinuses (menbranes),L",
                                                            "c": "上颌窦（膜）Maxillary sinuses (menbranes),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "上颌窦：鼻旁窦中最大者，位于上颌骨体内，近似三角形的腔洞。以鼻腔外侧壁为基底，顶向颧骨突，大小与形状个体之间相差很大。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Maxillary sinuses (menbranes),R",
                                                            "c": "上颌窦（膜）Maxillary sinuses (menbranes),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "上颌窦：鼻旁窦中最大者，位于上颌骨体内，近似三角形的腔洞。以鼻腔外侧壁为基底，顶向颧骨突，大小与形状个体之间相差很大。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Sphenoid sinuses (membranes),L",
                                                            "c": "蝶窦（膜）Sphenoid sinuses (membranes),L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "蝶窦：位于蝶骨体内、鼻腔上后方的窦腔，邻近后筛窦。多被蝶窦中隔分为左、右二腔，开口于同侧鼻腔的蝶筛隐窝。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Sphenoid sinuses (membranes),R",
                                                            "c": "蝶窦（膜）Sphenoid sinuses (membranes),R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "蝶窦：位于蝶骨体内、鼻腔上后方的窦腔，邻近后筛窦。多被蝶窦中隔分为左、右二腔，开口于同侧鼻腔的蝶筛隐窝。"
                                                        }
                                                    }]
                                                }
                                            }]
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "02Lower respiratory tract",
                                    "c": "下呼吸道Lower respiratory tract"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Bronchi and subdivisions,L",
                                            "c": "左支气管及分支Bronchi and subdivisions,L"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Bronchus,L",
                                                    "c": "左支气管Bronchus,L"
                                                },
                                                "t":
                                                {
                                                    "s": "左支气管：连接呼吸道内将空气输往肺部的通道"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Primary cartilaginous rings,L",
                                                    "c": "左主支气管软骨环Primary cartilaginous rings,L"
                                                },
                                                "t":
                                                {
                                                    "s": ""
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Secondary cartilaginous rings,L",
                                                    "c": "左次级支气管软骨环Secondary cartilaginous rings,L"
                                                },
                                                "t":
                                                {
                                                    "s": ""
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Bronchi and subdivisions,R",
                                            "c": "右支气管及分支Bronchi and subdivisions,R"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Bronchus,R",
                                                    "c": "右支气管Bronchus,R"
                                                },
                                                "t":
                                                {
                                                    "s": "右支气管：连接呼吸道内将空气输往肺部的通道"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Primary cartilaginous rings,R",
                                                    "c": "右主支气管软骨环Primary cartilaginous rings,R"
                                                },
                                                "t":
                                                {
                                                    "s": ""
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Secondary cartilaginous rings,R",
                                                    "c": "右次级支气管软骨环Secondary cartilaginous rings,R"
                                                },
                                                "t":
                                                {
                                                    "s": ""
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Trachea",
                                            "c": "气管Trachea"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Trachea",
                                                    "c": "气管Trachea"
                                                },
                                                "t":
                                                {
                                                    "s": "气管：位于喉与气管杈之间，成人男、女性平均长10.31cm和9.71cm；气管起自环状软骨下缘约平第6颈椎体下缘，向下至胸骨角平面约平第4胸椎体下缘处，分叉形成左、右主支气管气管全长以胸廓上口为界，分为颈部和胸部。在气管权的内面，有一矢状位向上的半月状嵴称气管隆嵴，略偏向左侧，是支气管镜检查时判断气管分叉的重要标志。\r\n                                                    气管由气管软骨、平滑肌和结缔组织构成。气管软骨由14-17个呈“C”形缺口向后的透明软骨环构成。气管软骨后壁缺口由气管的膜壁封闭，该膜壁由弹性纤维以及平滑肌构成的气管肌构成。甲状腺峡多位于第2-4气管软骨环前方，气管切开术常在第3-5气管软骨环处施行。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Tracheal cartilaginous rings",
                                                    "c": "气管软骨环Tracheal cartilaginous rings"
                                                },
                                                "t":
                                                {
                                                    "s": "气管软骨由14-17个呈“C”形缺口向后的透明软骨环构成。气管软骨后壁缺口由气管的膜壁封闭，该膜壁由弹性纤维以及平滑肌构成的气管肌构成。"
                                                }
                                            }]
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "03Lung1",
                                    "c": "肺Lung1"
                                },
                                "ch":
                                {
                                    "sub":
                                    {
                                        "$":
                                        {
                                            "o": "Lung",
                                            "c": "肺Lung"
                                        }
                                    }
                                }
                            }]
                        }
                    },
                    {
                        "$":
                        {
                            "o": "03Thymus",
                            "c": "胸腺Thymus"
                        },
                        "t":
                        {
                            "s": "胸腺：是中枢淋巴器官，培育、选择和向周围淋巴器官（淋巴结、脾和扁桃体）和淋巴组织（淋巴小结）输送T淋巴细胞。胸腺还有内分泌功能。"
                        }
                    },
                    {
                        "$":
                        {
                            "o": "04Digestive system",
                            "c": "消化系统Digestive system"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "01Alimentary canal",
                                    "c": "消化管Alimentary canal"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "01Oral cavity",
                                            "c": "口腔Oral cavity"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Gingiva",
                                                    "c": "牙龈Gingiva"
                                                },
                                                "t":
                                                {
                                                    "s": "牙龈：包绕在上、下颌骨牙槽突及牙颈部的口腔黏膜。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Hard palate",
                                                    "c": "硬腭Hard palate"
                                                },
                                                "t":
                                                {
                                                    "s": "硬腭：位于腭的前2/3，主要由骨腭（由上颌骨的腭突和腭骨的水平板构成）表面覆以黏膜构成。黏膜厚而致密，与骨膜紧密相贴。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Oral cavity",
                                                    "c": "口腔Oral cavity"
                                                },
                                                "t":
                                                {
                                                    "s": "口腔是消化管的起始部，其前壁为上、下唇，侧壁为颊，上壁为腭，下壁为口腔底。口腔向前经口唇围成的口裂通向外界，向后经咽峡与咽相通。 整个口腔借上、下牙弓（包括牙槽突和牙列）和牙龈分为前外侧部的口腔前庭和后内侧部的固有口腔。前者是上、下唇和颊与上、下牙弓和牙龈之间的狭窄间隙；后者位于上、下牙弓和牙龈所围成的空间，其顶为腭，底由黏膜、肌和皮肤组成。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Soft palate",
                                                    "c": "软腭Soft palate"
                                                },
                                                "t":
                                                {
                                                    "s": "软腭：位于腭的后1/3，主要由肌、肌腱和黏膜构成。软腭的前份呈水平位；后份斜向后下称腭帆。腭帆后缘游离，其中部有垂向下方的突起称腭垂或悬雍垂。自腭帆两侧各向下方分出两条黏膜皱襞，前方的一对为腭舌弓，延续于舌根的外侧，后方的一对为腭咽弓，向下延至咽侧壁。两弓间的三角形凹陷区称扁桃体窝，窝内容纳腭扁桃体。腭垂、腭帆游离缘、两侧的腭舌弓及舌根共同围成咽峡，它是口腔和咽之间的狭窄部，也是两者的分界。软腭在静止状态时垂向下方，当吞咽或说话时，软腭上提，贴近咽后壁，从而将鼻咽与口咽隔离开来。\r\n                                                    软腭肌均为骨骼肌，有腭帆张肌、腭帆提肌、腭垂肌、腭舌肌和腭咽肌。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Tongue",
                                                    "c": "舌Tongue"
                                                },
                                                "ch":
                                                {
                                                    "sub":
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Tongue",
                                                            "c": "舌Tongue"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "舌：位于口腔底的肌性器官。由纵、横和垂直三种不同方向的骨骼肌交织而成，表面被覆黏膜，有协助咀嚼、吞咽、感受味觉和发音等功能。"
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Uvula",
                                                    "c": "腭垂Uvula"
                                                },
                                                "t":
                                                {
                                                    "s": "腭垂：又称“悬雍垂”。腭帆后缘游离，其中部垂向下方的突起。"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "02Pharynx",
                                            "c": "咽Pharynx"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Eustachian tube,L",
                                                    "c": "咽鼓管Eustachian tube,L"
                                                },
                                                "t":
                                                {
                                                    "s": "咽鼓管又称欧氏管，在鼓室前壁的偏上部有一很重要的暗通道。它的一端由前壁进入鼓室，另一端则进入鼻咽部，是沟通鼓室与鼻咽部的通道。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Eustachian tube,R",
                                                    "c": "咽鼓管Eustachian tube,R"
                                                },
                                                "t":
                                                {
                                                    "s": ""
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Laryngopharynx",
                                                    "c": "喉咽Laryngopharynx"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Corniculate tubercles",
                                                            "c": "小角结节Corniculate tubercles"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "小角结节：小角软骨上结节状的小隆起。位于杓状软骨尖内上方，被杓状会厌襞所包裹。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Cuneiform tubercles",
                                                            "c": "楔状结节Cuneiform tubercles"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "楔状结节：楔状软骨上小隆起。位于小角结节前外侧，被杓状会厌襞所包裹。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Laryngopharynx",
                                                            "c": "喉咽Laryngopharynx"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "喉咽是咽的最下部，稍狭窄，上起自会厌上缘平面，下至第6颈椎体下缘平面与食管相续。喉咽部的前壁上份有喉口通入喉腔。在喉口的两侧各有一深窝称梨状隐窝，为异物常滞留之处。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Piriform recess",
                                                            "c": "梨状隐窝Piriform recess"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "梨状隐窝：喉口两侧的深窝。左、右各一。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Nasopharynx",
                                                    "c": "鼻咽Nasopharynx"
                                                },
                                                "t":
                                                {
                                                    "s": "鼻咽：咽的上部，位于鼻腔后方，上达颅底，下至腭帆游离缘平面续口咽部，向前经鼻后孔通鼻腔。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Oropharynx",
                                                    "c": "口咽Oropharynx"
                                                },
                                                "t":
                                                {
                                                    "s": "口咽：位于腭帆游离缘与会厌上缘平面之间，向前经咽峡与口腔相通，上续鼻咽部，下通喉咽部。"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "03Esophagus",
                                            "c": "食管Esophagus"
                                        },
                                        "t":
                                        {
                                            "s": "食管是一前后扁平的肌性管状器官，是消化管各部中最狭窄的部分，长约25cm。食管上端在第6颈椎体下缘平面与咽相接，下端约平第11胸椎体高度与胃的贲门连接。食管可分为颈部、胸部和腹部。颈部长约5cm，自食管起始端至平对胸骨颈静脉切迹平面的一段，前面借疏松结缔组织附于气管后壁上。胸部最长，约18-20cm，位于胸骨颈静脉切迹平面至膈的食管裂孔之间。腹部最短，仅1-2cm，自食管裂孔至贲门，其前方邻近肝左叶。\r\n                                            食管全长除沿脊柱的颈、胸曲相应地形成前后方向上的弯曲之外，在左右方向上亦有轻度弯曲。但在形态上食管最重要的特点是有3处生理性狭窄。第一狭窄为食管的起始处，相当于第6颈椎体下缘水平，距中切牙约l5cm；第二狭窄为食管在左主支气管的后方与其交叉处，相当于第4、5胸椎体之间水平，距中切牙约25cm；第三狭窄为食管通过膈的食管裂孔处，相当于第10胸椎水平，距中切牙约40cm。上述狭窄部是食管异物易滞留和食管癌的好发部位。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "04Stomach",
                                            "c": "胃Stomach"
                                        },
                                        "ch":
                                        {
                                            "sub":
                                            {
                                                "$":
                                                {
                                                    "o": "Stomach",
                                                    "c": "胃Stomach"
                                                },
                                                "t":
                                                {
                                                    "s": "胃：胃上接食道，下接十二指肠。位置大约位于人体的左上腹，肋骨以下。"
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "05Small intestine",
                                            "c": "小肠Small intestine"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Duodenum,sectioned",
                                                    "c": "十二指肠切部Duodenum,sectioned"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Ileum",
                                                    "c": "回肠Ileum"
                                                },
                                                "t":
                                                {
                                                    "s": "空肠和回肠上端起自十二指肠空肠曲，下端接续盲肠。空肠和回肠一起被肠系膜悬系于腹后壁，合称为系膜小肠，有系膜附着的边缘称系膜缘，其相对缘称游离缘或对系膜缘。\r\n                                                    空肠和回肠的形态结构不完全一致，但变化是逐渐发生的，故两者间无明显界限。一般是将系膜小肠的近侧2/5称空肠，远侧3/5称回肠。从位置上看，空肠常位于左腰区和脐区；回肠多位于脐区、右腹股沟区和盆腔内。从外观上看，空肠管径较大，管壁较厚，血管较多，颜色较红，呈粉红色；而回肠管径较小，管壁较薄，血管较少，颜色较浅，呈粉灰色。此外，肠系膜的厚度从上向下逐渐变厚，脂肪含量越来越多。肠系膜内血管的分布也有区别，空肠的动脉弓级数较少（有1-2级），直血管较长；而回肠的动脉弓级数较多（可达4-5级），直血管较短。从组织结构上看，空、回肠都具有消化管典型的四层结构。其黏膜除形成环状襞外，内表面还有密集的绒毛，这些结构极大地增加了肠黏膜的表面积，有利于营养物质的消化和吸收。在黏膜固有层和黏膜下组织内含有淋巴滤泡。淋巴滤泡分孤立淋巴滤泡和集合淋巴滤泡两种，前者分散存在于空肠和回肠的黏膜内，后者多见于回肠下部。集合淋巴滤泡又称Peyer斑，有20-30个，呈长椭圆形，其长轴与肠管的长轴一致，常位于回肠下部对肠系膜缘的肠壁内。肠伤寒的病变发生于集合淋巴滤泡，可并发肠穿孔或肠出血。\r\n                                                    此外，约2%的成人，在距回肠末端0.3-lm范围的回肠对系膜缘上，有长2-5cm的囊状突起，自肠壁向外突出称Meckel憩室，此为胚胎时期卵黄囊管未完全消失形成的。Meckel憩室易发炎或合并溃疡穿孔，因其位置靠近阑尾，故症状与阑尾炎相似。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Jejunum",
                                                    "c": "空肠Jejunum"
                                                },
                                                "t":
                                                {
                                                    "s": "空肠和回肠上端起自十二指肠空肠曲，下端接续盲肠。空肠和回肠一起被肠系膜悬系于腹后壁，合称为系膜小肠，有系膜附着的边缘称系膜缘，其相对缘称游离缘或对系膜缘。\r\n                                                    空肠和回肠的形态结构不完全一致，但变化是逐渐发生的，故两者间无明显界限。一般是将系膜小肠的近侧2/5称空肠，远侧3/5称回肠。从位置上看，空肠常位于左腰区和脐区；回肠多位于脐区、右腹股沟区和盆腔内。从外观上看，空肠管径较大，管壁较厚，血管较多，颜色较红，呈粉红色；而回肠管径较小，管壁较薄，血管较少，颜色较浅，呈粉灰色。此外，肠系膜的厚度从上向下逐渐变厚，脂肪含量越来越多。肠系膜内血管的分布也有区别，空肠的动脉弓级数较少（有1-2级），直血管较长；而回肠的动脉弓级数较多（可达4-5级），直血管较短。从组织结构上看，空、回肠都具有消化管典型的四层结构。其黏膜除形成环状襞外，内表面还有密集的绒毛，这些结构极大地增加了肠黏膜的表面积，有利于营养物质的消化和吸收。在黏膜固有层和黏膜下组织内含有淋巴滤泡。淋巴滤泡分孤立淋巴滤泡和集合淋巴滤泡两种，前者分散存在于空肠和回肠的黏膜内，后者多见于回肠下部。集合淋巴滤泡又称Peyer斑，有20-30个，呈长椭圆形，其长轴与肠管的长轴一致，常位于回肠下部对肠系膜缘的肠壁内。肠伤寒的病变发生于集合淋巴滤泡，可并发肠穿孔或肠出血。\r\n                                                    此外，约2%的成人，在距回肠末端0.3-lm范围的回肠对系膜缘上，有长2-5cm的囊状突起，自肠壁向外突出称Meckel憩室，此为胚胎时期卵黄囊管未完全消失形成的。Meckel憩室易发炎或合并溃疡穿孔，因其位置靠近阑尾，故症状与阑尾炎相似。"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "06Large intestine1",
                                            "c": "大肠Large intestine1"
                                        },
                                        "ch":
                                        {
                                            "sub":
                                            {
                                                "$":
                                                {
                                                    "o": "Large intestine",
                                                    "c": "大肠Large intestine"
                                                },
                                                "t":
                                                {
                                                    "s": "大肠：大肠居于腹中，其上口在阑门处接小肠，其下端连接肛门。"
                                                }
                                            }
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "02Alimentary gland",
                                    "c": "消化腺Alimentary gland"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "01Salivary glands",
                                            "c": "唾液腺Salivary glands"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Submandibular duct,L",
                                                    "c": "下颌下腺管Submandibular duct,L"
                                                },
                                                "t":
                                                {
                                                    "s": "下颌下腺管：下颌下腺的导管。自腺体内侧面发出，沿口底黏膜深面前行，开口于舌下阜。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Submandibular duct,R",
                                                    "c": "下颌下腺管Submandibular duct,R"
                                                },
                                                "t":
                                                {
                                                    "s": "下颌下腺管：下颌下腺的导管。自腺体内侧面发出，沿口底黏膜深面前行，开口于舌下阜。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Submandibular gland,L",
                                                    "c": "下颌下腺Submandibular gland,L"
                                                },
                                                "t":
                                                {
                                                    "s": "下颌下腺：呈扁椭圆形，重约15g。位于下颌体下缘及二腹肌前、后腹所围成的下颌下三角内。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Submandibular gland,R",
                                                    "c": "下颌下腺Submandibular gland,R"
                                                },
                                                "t":
                                                {
                                                    "s": "下颌下腺：呈扁椭圆形，重约15g。位于下颌体下缘及二腹肌前、后腹所围成的下颌下三角内。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Parotid duct,L",
                                                    "c": "腮腺管Parotid (stensen's) duct,L"
                                                },
                                                "t":
                                                {
                                                    "s": "腮腺管：自腮腺浅部前缘发出，于颧弓下一横指处向前横越咬肌表面，至咬肌前缘处弯向内侧，斜穿颊肌，开口于平对上颌第2磨牙牙冠颊黏膜上的腮腺管乳头。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Parotid duct,R",
                                                    "c": "腮腺管Parotid (stensen's) duct,R"
                                                },
                                                "t":
                                                {
                                                    "s": "腮腺管：自腮腺浅部前缘发出，于颧弓下一横指处向前横越咬肌表面，至咬肌前缘处弯向内侧，斜穿颊肌，开口于平对上颌第2磨牙牙冠颊黏膜上的腮腺管乳头。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Parotid gland,L",
                                                    "c": "腮腺Parotid gland,L"
                                                },
                                                "t":
                                                {
                                                    "s": "腮腺：最大的唾液腺，重15-30g，形状不规则，可分浅部和深部。浅部略呈三角形，上达颧弓，下至下颌角，前至咬肌后1/3的浅面，后续腺的深部。深部伸入下颌支与胸锁乳突肌之间的下颌后窝内。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Parotid gland,R",
                                                    "c": "腮腺Parotid gland,R"
                                                },
                                                "t":
                                                {
                                                    "s": "腮腺：最大的唾液腺，重15-30g，形状不规则，可分浅部和深部。浅部略呈三角形，上达颧弓，下至下颌角，前至咬肌后1/3的浅面，后续腺的深部。深部伸入下颌支与胸锁乳突肌之间的下颌后窝内。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Sublingual gland,L",
                                                    "c": "舌下腺Sublingual gland,L"
                                                },
                                                "t":
                                                {
                                                    "s": "舌下腺：较小，重约2-3g。位于口腔底舌下襞的深面。舌下腺导管有大、小两种，大管有一条，与下颌下腺管共同开口于舌下阜，小管约有5-15条，短而细，直接开口于舌下襞黏膜表面。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Sublingual gland,R",
                                                    "c": "舌下腺Sublingual gland,R"
                                                },
                                                "t":
                                                {
                                                    "s": "舌下腺：较小，重约2-3g。位于口腔底舌下襞的深面。舌下腺导管有大、小两种，大管有一条，与下颌下腺管共同开口于舌下阜，小管约有5-15条，短而细，直接开口于舌下襞黏膜表面。"
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "02Liver",
                                            "c": "肝Liver"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Gall bladder",
                                                    "c": "胆囊Gall bladder"
                                                },
                                                "ch":
                                                {
                                                    "sub": [
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Common bile duct",
                                                            "c": "胆总管Common bile duct"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胆总管：由肝总管与胆囊管汇合而成，胆总管的长度取决于两者汇合部位的高低，一般长约4-8cm，直径0.6-0.8cm。若超过1.Ocm，可视为病理状态。胆总管壁内含有大量的弹性纤维，有一定的舒缩能力，当胆总管下端梗阻时（如胆总管结石或胆道蛔虫症等），管腔可随之扩张到相当粗的程度，甚至达肠管粗细，而不致破裂。胆总管在肝十二指肠韧带内下行于肝固有动脉的右侧、肝门静脉的前方，向下经十二指肠上部的后方，降至胰头后方，再转向十二指肠降部中份，在此处韵十二指肠后内侧壁内与胰管汇合，形成一略膨大的共同管道称肝胰壶腹（或称Vater壶腹），开口于十二指肠大乳头，少数情况，胆总管未与胰管汇合而单独开口于十二指肠腔。在肝胰壶腹周围有肝胰壶腹括约肌包绕，在胆总管末段及胰管末段周围亦有少量平滑肌包绕，以上三部分括约肌统称为Oddi括约肌。Oddi括约肌平时保持收缩状态，由肝分泌的胆汁，经肝左、右管、肝总管、胆囊管进入胆囊内贮存。进食后，尤其进高脂肪食物，在神经体液因素调节下，胆囊收缩，Oddi括约肌舒张，使胆汁自胆囊经胆囊管、胆总管、肝胰壶腹、十二指肠大乳头，排入十二指肠腔内。\r\n                                                            根据胆总管的经过，可将其分为4段：即十二指肠上段、十二指肠后段、胰腺段和十二指肠壁段。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Common hepatic duct",
                                                            "c": "肝总管Common hepatic duct"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肝总管：长约3cm,下行于肝十二指肠韧带内，并在韧带内与胆囊管以锐角结合成胆总管。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Cystic duct",
                                                            "c": "胆囊管Cystic duct"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胆囊管：比胆囊颈稍细，长约3-4cm，直径0.2-0.3cm，在肝十二指肠韧带内与其左侧的肝总管汇合，延续为胆总管。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Gall bladder",
                                                            "c": "胆囊Gall bladder"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "胆囊：为贮存和浓缩胆汁的囊状器官，呈梨形，长8-12cm，宽3-5cm，容量40-60ml。胆囊位于肝下面的胆囊窝内，其上面借疏松结缔组织与肝相连，易于分离；下面覆以浆膜，并与结肠右曲和十二指肠上曲相邻。胆囊的位置有的较深，甚至埋在肝实质内；有的胆囊各方面均覆以浆膜，并借系膜连于胆囊窝，可以活动。\r\n                                                            胆囊分底、体、颈、管四部分，胆囊底是胆囊突向前下方的盲端，常在肝前缘的胆囊切迹处露出。当胆汁充满时，胆囊底可贴近腹前壁。胆囊底的体表投影位于右腹直肌外缘或右锁骨中线与右肋弓交点附近。胆囊发炎时，该处可有压痛。胆囊体是胆囊的主体部分，与底之间无明显界限。胆囊体向后逐渐变细，约在肝门右端附近移行为胆囊颈。胆囊颈狭细，在肝门右端常以直角起于胆囊体，略作“s\"状扭转，即开始向前上方弯曲，继而转向后下方续为胆囊管。胆囊颈与胆囊管相延续处较狭窄。胆囊颈借疏松结缔组织连于肝，胆囊动脉通过该疏松结缔组织分布于胆囊。在胆囊颈的右侧壁常有一突向后下方的小囊，朝向十二指肠，称为囊，胆囊结石常在此处存留。较大的囊可与胆囊管产生粘连，手术中分离、结扎切断胆囊管时易将此囊包入而损伤。胆囊管比胆囊颈稍细，长约3-4cm，直径0.2-0.3cm，在肝十二指肠韧带内与其左侧的肝总管汇合，延续为胆总管。\r\n                                                            胆囊内面衬以黏膜，其中底和体部的黏膜呈蜂窝状，而衬于颈和管部的黏膜呈螺旋状突人腔内，形成螺旋襞（或称Heister瓣），可控制胆汁的流入和流出。有时较大的结石，也常由于螺旋襞的阻碍而嵌顿于此。 胆囊管、肝总管和肝的脏面围成的三角形区域称胆囊三角（或称Calot三角），三角内常有胆囊动脉通过，因此该三角是胆囊手术中寻找胆囊动脉的标志。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Hepatic duct,L",
                                                            "c": "左肝管Hepatic duct,L"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肝左、右管分别由左、右半肝内的毛细胆管逐渐汇合而成，走出肝门之后即合成肝总管。"
                                                        }
                                                    },
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Hepatic duct,R",
                                                            "c": "右肝管Hepatic duct,R"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肝左、右管分别由左、右半肝内的毛细胆管逐渐汇合而成，走出肝门之后即合成肝总管。"
                                                        }
                                                    }]
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Liver1",
                                                    "c": "肝Liver1"
                                                },
                                                "ch":
                                                {
                                                    "sub":
                                                    {
                                                        "$":
                                                        {
                                                            "o": "Liver",
                                                            "c": "肝脏Liver"
                                                        },
                                                        "t":
                                                        {
                                                            "s": "肝脏：肝脏位于右上腹，隐藏在右侧膈下和肋骨深面，大部分肝为肋弓所覆盖，仅在腹上区、右肋弓间露出并直接接触腹前壁，肝上面则与膈及腹前壁相接。"
                                                        }
                                                    }
                                                }
                                            }]
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "03Pancreas",
                                            "c": "胰Pancreas"
                                        },
                                        "ch":
                                        {
                                            "sub": [
                                            {
                                                "$":
                                                {
                                                    "o": "Pancreas",
                                                    "c": "胰Pancreas"
                                                },
                                                "t":
                                                {
                                                    "s": "胰体：胰的中间部，即胰颈与胰尾之间的部分，。位于第一腰椎前方，呈三棱柱形。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Pancreatic duct,accessory",
                                                    "c": "副胰管Pancreatic duct,accessory"
                                                },
                                                "t":
                                                {
                                                    "s": "副胰管：胰头上部的小胰管。引流胰头前上部分泌的胰液，开口于十二指肠小乳头。"
                                                }
                                            },
                                            {
                                                "$":
                                                {
                                                    "o": "Pancreatic duct,main",
                                                    "c": "胰管Pancreatic duct,main"
                                                },
                                                "t":
                                                {
                                                    "s": "胰管：胰液的主要排泄管。位于胰实质内，从胰尾到胰头，最后与胆总管汇合成肝胰壶腹，开口于十二指肠大乳头。"
                                                }
                                            }]
                                        }
                                    }]
                                }
                            }]
                        }
                    },
                    {
                        "$":
                        {
                            "o": "05Spleen",
                            "c": "脾Spleen"
                        },
                        "t":
                        {
                            "s": "脾：是人体最大的淋巴器官，具有储血、造血、清除衰老红细胞和进行免疫应答的功能。 脾位于左季肋部，胃底与膈之间，第9-11肋的深面，长轴与第10肋一致。正常时在左肋弓下触不到脾。脾的位置可随呼吸和因体位不同而变化，站立比平卧时低2.5cm。脾由胃脾韧带、脾肾韧带、膈脾韧带和脾结肠韧带支持固定。\r\n                            脾呈暗红色，质软而脆。脾可分为膈、脏两面，前、后两端和上、下两缘：膈面光滑隆凸，对向膈。脏面凹陷，中央处有脾门，是血管、神经和淋巴管出入之处。在脏面，脾与胃底、左肾、左肾上腺、胰尾和结肠左曲相毗邻。前端较宽，朝向前外方，达腋中线。后端钝圆，朝向后内方，距离正中线4-5cm。上缘较锐，朝向前上方，前部有2-3个脾切迹。脾肿大时，脾切迹是触诊脾的标志。下缘较钝，朝向后下方。\r\n                            在脾的附近，特别在胃脾韧带和大网膜中存在副脾，出现率为10%-40%。副脾的位置，大小和数目不定。因脾功能亢进而作脾切除术时，应同时切除副脾。"
                        }
                    },
                    {
                        "$":
                        {
                            "o": "06Endocrine system",
                            "c": "内分泌系统Endocrine system"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "Adrenal gland,L",
                                    "c": "肾上腺Adrenal gland,L"
                                },
                                "t":
                                {
                                    "s": "肾上腺：位于肾的上方，淡黄色，与肾共同包被在肾筋膜内。肾上腺的前面有不太明显的肾上腺门，是血管、神经和淋巴管进出之处。肾上腺实质分为皮质和髓质两部分。左肾上腺近似半月形，男性重7.71g、女性7.20g；右肾上腺呈三角形，男性重7.11g、女性6.86g。 肾上腺皮质分泌盐皮质激素、糖皮质激素和性激素。肾上腺髓质可分泌肾上腺素和去甲肾上腺素。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Adrenal gland,R",
                                    "c": "肾上腺Adrenal gland,R"
                                },
                                "t":
                                {
                                    "s": "肾上腺：位于肾的上方，淡黄色，与肾共同包被在肾筋膜内。肾上腺的前面有不太明显的肾上腺门，是血管、神经和淋巴管进出之处。肾上腺实质分为皮质和髓质两部分。左肾上腺近似半月形，男性重7.71g、女性7.20g；右肾上腺呈三角形，男性重7.11g、女性6.86g。 肾上腺皮质分泌盐皮质激素、糖皮质激素和性激素。肾上腺髓质可分泌肾上腺素和去甲肾上腺素。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Parathyroid gland,inferior,L",
                                    "c": "左下甲状旁腺Parathyroid gland,inferior,L"
                                },
                                "t":
                                {
                                    "s": "甲状旁腺：是两对棕黄色、黄豆大小的扁椭圆形腺体，位于甲状腺背面，纤维囊外，通常有上、下两对。每个甲状旁腺的重量约为50mg。上甲状旁腺位置恒定，在甲状腺侧叶后缘上、中1/3交界处；下甲状旁腺位置变异较大，多位于甲状腺侧叶后缘近下端甲状腺下动脉处。甲状旁腺也可埋入腺实质中或在鞘外。甲状旁腺分泌甲状旁腺素，调节钙磷代谢，维持血钙平衡。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Parathyroid gland,inferior,R",
                                    "c": "右下甲状旁腺Parathyroid gland,inferior,R"
                                },
                                "t":
                                {
                                    "s": "甲状旁腺：是两对棕黄色、黄豆大小的扁椭圆形腺体，位于甲状腺背面，纤维囊外，通常有上、下两对。每个甲状旁腺的重量约为50mg。上甲状旁腺位置恒定，在甲状腺侧叶后缘上、中1/3交界处；下甲状旁腺位置变异较大，多位于甲状腺侧叶后缘近下端甲状腺下动脉处。甲状旁腺也可埋入腺实质中或在鞘外。甲状旁腺分泌甲状旁腺素，调节钙磷代谢，维持血钙平衡。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Parathyroid gland,superior,L",
                                    "c": "左上甲状旁腺Parathyroid gland,superior,L"
                                },
                                "t":
                                {
                                    "s": "甲状旁腺：是两对棕黄色、黄豆大小的扁椭圆形腺体，位于甲状腺背面，纤维囊外，通常有上、下两对。每个甲状旁腺的重量约为50mg。上甲状旁腺位置恒定，在甲状腺侧叶后缘上、中1/3交界处；下甲状旁腺位置变异较大，多位于甲状腺侧叶后缘近下端甲状腺下动脉处。甲状旁腺也可埋入腺实质中或在鞘外。甲状旁腺分泌甲状旁腺素，调节钙磷代谢，维持血钙平衡。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Parathyroid gland,superior,R",
                                    "c": "右上甲状旁腺Parathyroid gland,superior,R"
                                },
                                "t":
                                {
                                    "s": "甲状旁腺：是两对棕黄色、黄豆大小的扁椭圆形腺体，位于甲状腺背面，纤维囊外，通常有上、下两对。每个甲状旁腺的重量约为50mg。上甲状旁腺位置恒定，在甲状腺侧叶后缘上、中1/3交界处；下甲状旁腺位置变异较大，多位于甲状腺侧叶后缘近下端甲状腺下动脉处。甲状旁腺也可埋入腺实质中或在鞘外。甲状旁腺分泌甲状旁腺素，调节钙磷代谢，维持血钙平衡。"
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Thyroid gland",
                                    "c": "甲状腺Thyroid gland"
                                },
                                "t":
                                {
                                    "s": "甲状腺：红褐色，呈\"H\"形，分左、右两个侧叶，中间的甲状腺峡组成。甲状腺平均重量成年男性为26.71g.女性25.34g。甲状腺侧叶位于喉下部与气管上部的两侧面。左、右叶分为前后缘、上下端及前外侧面与内侧面；上达甲状软骨中部，下至第6气管软骨环，后方平对第5-7颈椎高度。甲状腺峡位于第2-4气管软骨环前方，连接左、右叶。约有半数人自甲状腺峡向上伸出一锥状叶，长者可达舌骨平面。\r\n                                    甲状腺有两层被膜，内层为纤维囊（临床上称真被膜），包裹甲状腺表面，伸入腺实质，将腺体分为若干个大小不等的小叶。外层为甲状腺鞘（临床上称外科囊），有气管前筋膜包绕而成。甲状腺侧叶与甲状软骨、环状软骨之间有韧带相连，故吞咽时，甲状腺可随喉上下移动。 甲状腺分泌甲状腺素，调节机体基础代谢并影响生长和发育等。"
                                }
                            }]
                        }
                    },
                    {
                        "$":
                        {
                            "o": "07Urinary system",
                            "c": "泌尿系统Urinary system"
                        },
                        "ch":
                        {
                            "sub": [
                            {
                                "$":
                                {
                                    "o": "Bladder",
                                    "c": "膀胱Bladder"
                                },
                                "t": ""
                            },
                            {
                                "$":
                                {
                                    "o": "Kidney1,L",
                                    "c": "左肾Kidney1,L"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Kidney,L",
                                            "c": "左肾Kidney,L"
                                        },
                                        "t":
                                        {
                                            "s": "肾：是实质性器官，左、右各一，位于腹后壁，形似蚕豆。因受肝的挤压，右肾低于左肾约1-2cm。肾分内、外侧两缘、前、后两面及上、下两端。内侧缘中部呈四边形的凹陷称肾门，为肾的血管、神经、淋巴管及肾盂出入的门户。出入肾门诸结构为结缔组织所包裹称肾蒂。因下腔静脉靠近右肾故右肾蒂较左肾蒂短。肾蒂内各结构的排列关系，自前向后顺序为肾静脉、肾动脉和肾盂末端；自上向下顺序为：肾动脉、肾静脉和肾盂。由肾门伸入肾实质的凹陷称肾，为肾血管、肾小盏、肾大盏、肾盂和脂肪等所占据。肾窦是肾门的延续，肾门是肾窦的开口。肾的前面凸向前外侧，后面紧贴腹后壁，上端宽而薄，下端窄而厚，肾长约9.9cm(8-14cm)、宽5.9cm(5-7cm、厚4cm(3-5cm)，重量134-148g。\r\n                                            肾位于脊柱两侧，腹膜后间隙内，为腹膜外位器官。肾的高度：左肾在第11胸椎椎体下缘至第2-3腰椎椎间盘之间；右肾则在第12胸椎椎体上缘至第3腰椎椎体上缘之间。两肾上端相距较近，距正中线平均为3.8cm；下端相距较远，距正中线平均为7.2cm。左、右两侧的第12肋分别斜过左肾后面中部和右肾后面上部。肾门约在第1腰椎椎体平面，相当于第9肋软骨前端高度，在正中线外侧约5cm。肾门的体表投影点位于腰背部竖脊肌外侧缘与第12肋的夹角处，称肾区。肾病患者触压或叩击该处可引起疼痛。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Renal pelvis,L",
                                            "c": "肾盂Renal pelvis,L"
                                        },
                                        "t":
                                        {
                                            "s": "肾盂：由肾大盏汇合形成的大腔。离开肾门向下弯行，约在第二腰椎上缘水平逐渐变细与输尿管相移行。"
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Kidney1,R",
                                    "c": "右肾Kidney1,R"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "Kidney,R",
                                            "c": "右肾Kidney,R"
                                        },
                                        "t":
                                        {
                                            "s": "肾：是实质性器官，左、右各一，位于腹后壁，形似蚕豆。因受肝的挤压，右肾低于左肾约1-2cm。肾分内、外侧两缘、前、后两面及上、下两端。内侧缘中部呈四边形的凹陷称肾门，为肾的血管、神经、淋巴管及肾盂出入的门户。出入肾门诸结构为结缔组织所包裹称肾蒂。因下腔静脉靠近右肾故右肾蒂较左肾蒂短。肾蒂内各结构的排列关系，自前向后顺序为肾静脉、肾动脉和肾盂末端；自上向下顺序为：肾动脉、肾静脉和肾盂。由肾门伸入肾实质的凹陷称肾，为肾血管、肾小盏、肾大盏、肾盂和脂肪等所占据。肾窦是肾门的延续，肾门是肾窦的开口。肾的前面凸向前外侧，后面紧贴腹后壁，上端宽而薄，下端窄而厚，肾长约9.9cm(8-14cm)、宽5.9cm(5-7cm、厚4cm(3-5cm)，重量134-148g。\r\n                                            肾位于脊柱两侧，腹膜后间隙内，为腹膜外位器官。肾的高度：左肾在第11胸椎椎体下缘至第2-3腰椎椎间盘之间；右肾则在第12胸椎椎体上缘至第3腰椎椎体上缘之间。两肾上端相距较近，距正中线平均为3.8cm；下端相距较远，距正中线平均为7.2cm。左、右两侧的第12肋分别斜过左肾后面中部和右肾后面上部。肾门约在第1腰椎椎体平面，相当于第9肋软骨前端高度，在正中线外侧约5cm。肾门的体表投影点位于腰背部竖脊肌外侧缘与第12肋的夹角处，称肾区。肾病患者触压或叩击该处可引起疼痛。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "Renal pelvis,R",
                                            "c": "肾盂Renal pelvis,R"
                                        },
                                        "t":
                                        {
                                            "s": "肾盂：由肾大盏汇合形成的大腔。离开肾门向下弯行，约在第二腰椎上缘水平逐渐变细与输尿管相移行。"
                                        }
                                    }]
                                }
                            },
                            {
                                "$":
                                {
                                    "o": "Ureter",
                                    "c": "输尿管Ureter"
                                },
                                "ch":
                                {
                                    "sub": [
                                    {
                                        "$":
                                        {
                                            "o": "M_Ureter,L",
                                            "c": "输尿管Ureter,L"
                                        },
                                        "t":
                                        {
                                            "s": "输尿管：是位于腹膜外位的肌性管道。平第2腰椎上缘起自肾盂末端，终于膀胱。长约20-30cm，管径平均0.5-1.0cm，最窄处口径只有0.2-0.3cm。全长可分为输尿管腹部、输尿管盆部和输尿管壁内部。 输尿管全程有3处狭窄：①上狭窄位于肾盂输尿管移行处；②中狭窄位于小骨盆上口，输尿管跨过髂血管处；③下狭窄位于输尿管的壁内部。狭窄处口径只有0.2-0.3cm。"
                                        }
                                    },
                                    {
                                        "$":
                                        {
                                            "o": "M_Ureter,R",
                                            "c": "输尿管Ureter,R"
                                        },
                                        "t":
                                        {
                                            "s": "输尿管：是位于腹膜外位的肌性管道。平第2腰椎上缘起自肾盂末端，终于膀胱。长约20-30cm，管径平均0.5-1.0cm，最窄处口径只有0.2-0.3cm。全长可分为输尿管腹部、输尿管盆部和输尿管壁内部。 输尿管全程有3处狭窄：①上狭窄位于肾盂输尿管移行处；②中狭窄位于小骨盆上口，输尿管跨过髂血管处；③下狭窄位于输尿管的壁内部。狭窄处口径只有0.2-0.3cm。"
                                        }
                                    }]
                                }
                            }]
                        }
                    }]
                }
            }]
        }
    }
}

export default objlist


// WEBPACK FOOTER //
// ./src/pages/webgl/src/treeData.js